var ctrlminwidth = 1030;
var rowclicked = false;
var gridHeight = 276;
var unblock_count = 0;
var show_block_ui = true;
var tabsPadding = 0;
var ANALYSIS_RED = '#F8696B';
var ANALYSIS_BLUE = '#3EAE63';
var GROWTHTYPES = "GrowthTypes";
var TREND = "Trend";
var NOTES_API_DIMENSIONS  = ['period',  'parameter']
var ROW_DIM_ORDER = ['lineitems','links','Revisions','Sources','GrowthTypes'];
dataHasArrived = false;
whatIsTheReloadFlag = true;
var source_participation_in_consensus = [];
window.gGrowthTypeValues = "";
var halfYearlyReportingFreqId = 2;
/*All WebService calling related functionality(Begin)*/
var ajaxCount = 0;
var ajaxCalls = {};
var sourceLevelData={};
var isFYDataEmpty = true;
var revisionTypeChanged = false;
var growthTypeChanged = false;
var currentYrPg = {};
var hasSecondPgCall = false;
var WebServiceCall = function () {
};
var isGridFirstLoad = false;
window.peerTickerList = [];
var peersRowInfo = [];
var isFirstLoad = true;
var actualPlusFuturePeriods = [];
var periodDimensions = {};
var fromCallGrid = false;
var extraSize = 33;
var cPlusConst = ['Consensus+','consensus+','consensusplus'];
var selectedLineStdAndCompDict = {};
window.dsmObj = {
    dapValues: [],
    valuesSet: false
  };
window.hasDsmAccess = null;
window.addEventListener('dsmAccessSet', get_research_snippets);
// functions transferred from utils.js---------------------------------
Array.prototype.getValues = function(type,value){
    return $.grep(this,function(i){ return (i[type] == value); });
};

Array.prototype.getKeyValues = function(type){
    var new_a = [];
    $.each(this,function(i,el){ new_a.push(el[type]); });
    return new_a;
};

//datagrid set width
$.extend($.fn.datagrid.methods,{
	resizeColumn:function(jq,param){
		return jq.each(function(){
			var dg = $(this);
            var col = dg.datagrid('getColumnOption', param.field);
            if(col){
                col.boxWidth = param.width;
                col.width = param.width;
                dg.datagrid('fixColumnSize', param.field);
            }
		})
	}
});

$.ajaxSetup({
    statusCode: {
        401: function (data, textStatus, jqxhr) {
            console.error("UnAuthorized");
            if (data.responseJSON.force_logout) {
                window.location.href = '/homepage/?force_logout=true';
            } else if (data.responseJSON.imitate_logout) {
                window.location.href = '/login';
            } else if (!data.responseJSON.accessible) {
                window.location.href = '/homepage';
            } else {
                window.location.href = '/login/';
            }
        },
        403: function (data, textStatus, jqxhr) {
            window.location.href = '/login/';
        }
    }
});
//---------------------------------------------------------------------------

//Maintain a track of which was the last selected line,
//so that it can be accessed after a grid reload(on applying anything from the right panel)
currentSelectedLineId = '';
isYoyTheLastSelection = false;
asyncCallUrls=['get_deep_semantic_dapparameters','getAllNotes','gridpanelshistory/','get_links_to_nmv_sch','get_usliids_for_dapparameterids','deletegridpanelshistory/']
WebServiceCall.prototype = {
    dataToReturn: "",
    Call: function (options) {
        // if((options.url.mainUrl && options.url.mainUrl != window.apiUrl + '/api/getAllNotes?') || (options.url && options.url != window.apiUrl + "/api/gridpanelshistory/")) {
        //     debouncedBlock(true);
        // }
            
        options.url = escaping(options.url);
        if (editVariantMode)
            options.url += "&edit_variant=true";
        if (editScenarioMode)
            options.url += "&edit_scenario=true";
        if (window.compositeEdit)
            options.url = options.url + "&edit=true";
        var ajaxCall = $.ajax({
            type: options.type == undefined ? "GET" : options.type,
            async: options.async != undefined,
            url: options.url, // + ws,
            data: options.data == undefined ? {} : options.data,
            contentType: (options.type == undefined || options.type == "GET") ? "application/json; charset=utf-8" : "application/x-www-form-urlencoded; charset=UTF-8",
            dataType: "json",
            headers: options.headers == undefined ? {} : options.headers,
            parameter: options.parameter == undefined ? {} : options.parameter,
            beforeSend: function () {
                //Adding condition to make callCount consistent with debouncedBlock calling logic
                let apiUrl = options.url.split(window.apiUrl + '/api/')[1];
                apiUrl = apiUrl.split('?')[0];
                if(!asyncCallUrls.includes(apiUrl)) {
                    callCount += 1;
                }
            },
            complete: function () { 
                let apiUrl = options.url.split(window.apiUrl + '/api/')[1];
                apiUrl = apiUrl.split('?')[0];
                if(!asyncCallUrls.includes(apiUrl)) {
                    callCount -= 1;
                    if(callCount == 0) {
                        debouncedBlock(false);
                    }                
                }
                //web call to get the data
                if (callCount == 0) {
                    if (rowDimension.length > 2 && getCommonSizeData) {
                        getCommonSizeData = false;
                        // Here we initiate an extra param2 call to set the base parameter
                        // value which is used in percentage calculation tab
                        //Commented as we do not need this by default anymore
                        //getBaseParamData("", {}, []);
                    }
                }
                if (callCount == 0 && expandAllFlag) {
                    expandAllFlag = false;
                }
                if(window.highlightDp){
                    highlightCell("lineitem");
                }
            },
            success: options.success,
            error: options.error
        });
        if (options.inspector) {
            if (!ajaxCalls.inspectorCalls)
                ajaxCalls.inspectorCalls = [];
            ajaxCalls.inspectorCalls.push(ajaxCall);
        }
        ajaxCount = ajaxCount + 1;
        ajaxCalls["ajax" + ajaxCount] = ajaxCall;
    },
    postSaveSettings: function (Data, token) {
        var objWS = this;
        this.Call({
            url: "/api/savesettings",
            type: "POST",
            async: true,
            data: Data,
            success: function (msg) {
                if (msg.status == 'success') {
                    cut = msg.view
                    //[TODO:]We should update favorites here.
                    //console.log(msg.status);
                    // createLog("", msg.status);
                    var ObjWebServiceCall = new WebServiceCall();
                    // ObjWebServiceCall.getFavourites();
                }
                else {
                    if (msg.message == "view exist")
                        viewOverWrite(true, "");
                    else if (msg.message == "main cut")
                        alert('it is standard viewname give another name ');
                    else
                        viewOverWrite(false, msg.view);

                }
            },
            headers: {"X-CSRFToken": token},
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    postHistorySettings: function (Data, token) {
        var objWS = this;
        this.Call({
            url: "/api/userhistory",
            type: "POST",
            async: true,
            data: Data,
            success: function (msg) {
                if (msg.status == 'success') {
                    //console.log(msg.status);
                    // createLog("", msg.status);
                }
                else {
                    //console.log(msg.message);
                    createLog("", msg.message);
                }
            },
            headers: {"X-CSRFToken": token},
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    sendUserRequest: function (Data, token) {
        var objWS = this;
        this.Call({
            url: "/userRequest/",
            type: "POST",
            async: true,
            data: Data,
            success: function (msg) {
                if (msg.status == 'success') {
                    //console.log(msg.status);
                    // createLog("", msg.status);
                    var div = $('#container');
                    if ($("#msgDialog").length < 1) {
                        $("<div id='msgDialog' title='User Request'>&nbsp;&nbsp;&nbsp;" + msg.message + "</div>").appendTo(div);
                        $("#msgDialog").dialog({
                            draggable: true, resizable: false, modal: true, dialogClass: "prompt", minHeight: 300,
                            buttons: [{text: "Ok"}]
                        });
                        $('#msgDialog .l-btn').unbind('click').bind('click', function () {
                            $('#msgDialog').dialog('close');
                            //url change required
                            // var Url = "/app/mex/IS/NMV/" + msg.ticker;
                            var Url = window.projectArkUrl+"/mex/"+msg.ticker+"NMV/IS";
                            window.location = escaping(Url);
                        }).removeClass('.l-btn');
                    }
                    else {
                        $('#msgDialog').dialog('open');
                    }
                }
                else {
                    //console.log(msg.message);
                    createLog("", msg.message);
                }
            },
            headers: {"X-CSRFToken": token},
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    getFavourites: function () {
        var objWS = this;
        this.Call({
            url: "/fav/?",
            async: true,
            success: function (msg) {
                saveFavourites(msg);

            },
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    addFavourites: function () {
        var objWS = this;
        var Url = {"mainUrl": "/fav/add/?"};
        //var Url = "/fav/add/?cut=" + cut + "&pg=" + escape(pg) + "&ticker=" + company;
        Url = makeUrl(Url, window.gSource);
        Url['action'] = 'addFavourites'
        //heap_tracking(company, Url);
        this.Call({
            url: Url,
            sync: true,
            success: function (msg) {
                saveFavourites(msg);
            },
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    LoadScheduleCache: function () {
        var objWS = this;
        var Url = {"mainUrl": window.apiUrl +"/api/load_cache?"};
        if (excl_sources.length > 0) {
            Url['excl_sources'] = excl_sources;
        }
        if (incl_sources.length > 0) {
            Url['incl_sources'] = incl_sources;
        }
        Url['companyid'] = [window.MEData.companyid];
        Url['source'] = 'Custom';
        Url['publish_type'] = ['schedule'];
        //heap_tracking(company, Url);
        this.Call({
            url: Url,
            async: true,
            success: function (msg) {
                //objME = new ModelExplorer();
                //objME.LoadDataGrid(window.MEData, false);
            },
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    getAllNotes: function (ticker, dimension) {
        var url = {"mainUrl": window.apiUrl + "/api/getAllNotes?"};
        url['ticker'] = ticker;
        url['cut'] = cut;
        url['variant'] = window.gVariant;
        url['tab'] = window.pg;

        if (dimension) {
            url['dimension'] = dimension;
            callNoteApi(url, this, true, url['dimension']);
        } else {
            var notesAPIDimLen = NOTES_API_DIMENSIONS.length;
            for (var eachDimInd = 0; eachDimInd < notesAPIDimLen; eachDimInd++) {
                url['dimension'] = NOTES_API_DIMENSIONS[eachDimInd];
                callNoteApi(url, this, false, url['dimension'] );
                if(eachDimInd === notesAPIDimLen - 1){
                    callNotesNow = true;
                }
            }
        }

        $(expandColumnOnNavigate).each(function (index, value) {
            // fire events as soon as the expand icon is loaded|| changed this to the containing td since we moved this a while back
            var expImgEl = $("#" + getJQId(value)).closest('td').find('div[clickBinding=true]');
            // the below logic will only handle expand icons which are visible on page load.
            if (expImgEl.length > 0) {
                expImgEl.trigger("click");
            } else {
                // this will handle the expansions which are secondary as in they happen after the first level has expanded.
                // this uses a custom event ExpColLoaded.
                var imgElId = getJQId(value);                
                $(".datagrid-header").one("ExpColLoaded", "#" + imgElId, function (event) {
                    event.target.click();
                });
            }
        });
    },
    getSelectedGroupData: function (financialYear, objParameter) {
        ajaxCallCount++;
        var objWS = this;
        if (Array.isArray(financialYear) == true) {
            fySource = objParameter;
        }else{
            var periodObj = window.MEData.column_dimensions[0].values.filter( function (n) {
                return (n.period.toLowerCase() == financialYear.toLowerCase());
            })[0];
            var sourceObj = window.MEData.column_dimensions.filter( function (n) {
                return (n.name.toLowerCase() == 'sources');
            });

            if (periodObj.forecast || sourceObj.length == 0) {
                fySource = gSourceFuture;
            }else {
                if (window.gSourceActual != 'Filings' && window.gSourceActual != 'VA Actuals' && !checkIfFoucsConseusHasData(financialYear, company)) {
                    fySource = 'Filings';
                } else {
                    fySource = window.gSourceActual;
                }
            }
        }

        /*Url = "/api/pg?pg=" + escape(pg) + "&cut=" + cut + "&ticker=" + company;
         Url = Url + ((financialYear != "") ? ("&period=" + financialYear): "");*/
        var Url = {"mainUrl": window.apiUrl + "/api/pg?"};
        if(Array.isArray(financialYear) == true){
            Url['period'] = financialYear;
        }else{
            if (financialYear != "")
                Url['period'] = financialYear;
        }
        //call notes for this period set
        getPeriodWiseDataPointNotes(financialYear);

        if((window.cut === "STD" || window.cut === 'NMV') && window.MEData.selectedCurrency != undefined && window.MEData.selectedCurrency != "Base"){
            Url['currency'] = window.MEData.selectedCurrency;
        }

        if (fySource == 'Custom') {

            var sourcePanelObj = window.MEData.panels.filter( function (n) {
                return (n.name.toLowerCase() == 'sources');
            })[0];
            
            
            if(sourcePanelObj && !sourcePanelObj.date_custom_consensus && !sourcePanelObj.relative_days){
                excl_sources = getExcludedBrokers();
                Url['excl_sources'] = excl_sources;
                incl_sources = getIncludedBrokers();
                Url['incl_sources'] = incl_sources;
                if(sourcePanelObj.sources_in_progress_excluded.length > 0 && sourcePanelObj.selected_excl_cc_not_entitled == true){
                    for(var i = 0; i < sourcePanelObj.sources_in_progress_excluded.length; i++) {
                        Url['incl_sources'].push(sourcePanelObj.sources_in_progress_excluded[i]);
                    }
                }
                else if(sourcePanelObj.sources_in_progress_excluded.length > 0 && sourcePanelObj.selected_excl_cc_not_entitled == false){
                    for(var i = 0; i < sourcePanelObj.sources_in_progress_excluded.length; i++) {
                        Url['excl_sources'].push(sourcePanelObj.sources_in_progress_excluded[i]);
                    }
                }

                if(sourcePanelObj.sources_in_progress_included.length > 0 && sourcePanelObj.selected_cc_not_entitled == true){
                    for(var i = 0; i < sourcePanelObj.sources_in_progress_included.length; i++) {
                        Url['incl_sources'].push(sourcePanelObj.sources_in_progress_included[i]);
                    }
                }
                else if(sourcePanelObj.sources_in_progress_included.length > 0 && sourcePanelObj.selected_cc_not_entitled == false){
                    for(var i = 0; i < sourcePanelObj.sources_in_progress_included.length; i++) {
                        Url['excl_sources'].push(sourcePanelObj.sources_in_progress_included[i]);
                    }
                }

            }
        }
        Url = makeUrl(Url, fySource);
        const summonFBar = new CustomEvent('SummonFBar', {detail: {data:{}}})
        window.dispatchEvent(summonFBar); 
        this.Call({
            url: Url,
            async: true,
            parameter: objParameter,
            success: function (msg) {
                makeFiscalyearPeriodDict(msg);
                var objMe = new ModelExplorer();
                if (this.parameter.appendAtBegin == undefined)
                    objMe.LoadDatagridData(msg, this.parameter);
                else
                    objMe.onSuccessAppendFinancialYear(msg, this.parameter);
                analystTitle(msg);
                if(window.highlightDp){
                    //check if annual and change it to the required format
                    if (window.highlightPeriod.startsWith("FY")){
                        for(baseValue in fiscal_period_dict){
                            if (fiscal_period_dict[baseValue] == window.highlightPeriod){
                                 window.highlightPeriod = baseValue;
                                 break;
                            }
                        };
                    }
                }
                if(window.highlightDp && financialYear == window.highlightPeriod) {
                    highlightCell();
                } else {
                    showFormulaForFirstCell(financialYear);
                }
                if (high || low || high_low_src != "") {
                    highlightHighLowValue(msg.data);
                }
                if (surprise != "") {
                    highlightSurpriseValue(msg.data);
                }
                if (cva != "" || crdrevision != "") {
                    variationColoring(msg.data);
                }
                first_forecast_period = '';
                $.each(window.MEData.column_dimensions[0].values, function(index, period_obj) {
                    if (period_obj.forecast ) {
                        // get the first period with forecast
                        first_forecast_period = period_obj;
                        return false;
                    }
                });
                if(first_forecast_period!= '') {
                    var first_forecast_img = first_forecast_period.period.replace('-', '').toLowerCase();
                    if($("#" + first_forecast_img).length){
                        if (Array.isArray(financialYear) == true) {
                            for (var i = 0; i < financialYear.length; i++) {
                                var fYear = financialYear[i];
                                if (fYear == first_forecast_period.period) {
                                    $(".datagrid-body").animate({scrollLeft: $("#" + first_forecast_img).offset().left});
                                }
                            }
                        } else {
                            if (financialYear == first_forecast_period.period) {
                                $(".datagrid-body").animate({scrollLeft: $("#" + first_forecast_img).offset().left});
                            }
                        }
                    }
                }

                ajaxCallCount--;
                var variant = ''
                if(cut == 'CPT'){
                    variant = window.gVariant;
                } else {
                    variant = null;
                }

                // This code is executed once all the ajax calls which are part of page load are finished.
                if (ajaxCallCount == 0) {
                    clickToAddEvent();
                    debouncedBlock(false)
                    $(expandAcrossTabs).each(function (index, value) {
                        expImgEl = $("[id='" + getJQId(value['objimgCtrl']) + "']").closest('td').find('div[clickBinding=true]');
                        if (expImgEl.length > 0) {
                            if(!$(expImgEl).hasClass('current-change'))
                                $(expImgEl).trigger("click");
                        } else {
                            // this will handle the expansions which are secondary as in they happen after the first level has expanded.
                            // this uses a custom event ExpColLoaded.
                            var imgElId = getJQId(value['objimgCtrl']);
                            $(".datagrid-header").one("ExpColLoaded", "[id='" + imgElId + "']", function (event) {
                                $(event.target).closest('td').click();
                            });
                        }
                    });

                    if(isFirstLoad) {
                        isFirstLoad = false;
                        //Moving the calls here to prevent it interrupting the expansion pg call, and has to get triggered once
                        var ObjWebServiceCall = new WebServiceCall();
                        ObjWebServiceCall.getAllNotes(window.MEData.ticker, null);
                    }
                    //This check gives if notes api call is done or not, if done append notes,
                    // else bind event to be triggered when api returns notes
                    // if (notes['datapoint'] !== undefined && notes['datapoint'].datapoint_level_dict) {
                    //     addNotesOnSuccessOfPg(msg);
                    // } else {
                    //     $(window).off('notes-data-set').on('notes-data-set',function () {
                    //         addNotesOnSuccessOfPg(msg);
                    //     });
                    // }
                    
                    // This will load unique sli ids for all dapparameter ids
                    const activatePeers = new CustomEvent('activatePeers', { detail: { data: msg} })
                    window.dispatchEvent(activatePeers);

                    if ($.inArray('ticker', colDimension) > -1) {
                        loadUncachedScheduleData();
                    }
                    var revisionPanel = $.grep(window.MEData.panels, function (n) {
                        if (n.name == "Revisions") {
                            return n;
                        }
                    })[0];
                    //auto expand on revisiontype changed
                    if(revisionTypeChanged){
                        if(revisionPanel.type == 'row'){
                            setTimeout(function () {
                                var cell2Expand = $('.datagrid-btable').find('[field=Revisions] img').eq(0).closest('td');
                                if(cell2Expand[0]){
                                    cell2Expand[0].click();
                                }
                            }, 1000);
                        } else {
                            var headerCols = $('.datagrid-view2 .datagrid-header');
                            var field = firstEstimatedYear.toLowerCase() + 'current';
                            headerCols.find('[field=' + field + ']').trigger('click');
                        }
                         //set timeout for 5 seconds to remove yellow accent for analytics
                        setTimeout(function () {
                            if(revisionPanel.type != 'row') {
                                $.each($('td.current-change.revision img'), function (i, el) {
                                    if($(el).attr('title-class')) {
                                        var titleClass = $(el).attr('title-class').split('current-change')[1];
                                        $(el).attr('title-class', titleClass);
                                    }
                                });
                            }
                            $('td.current-change.revision').removeClass('current-change');
                            revisionTypeChanged = false;
                        }, 5000);
                    }
                    //auto expand analytics
                    // if(expandAcrossTabs.length === 0){
                    //     setTimeout( function(){ autoExpandAnalytics() }, 1500);
                    // }

                    var linkColumnWidth = "";
                    if(cut == "NMV" || cut == "STD") {
                        $('td[field="links"]').css("width", "105px")
                        $('td[field="links"] div').css("width", "105px")
                        linkColumnWidth = "105px"
                    }
                    else{
                        $('td[field="links"]').css("width", "58px")
                        $('td[field="links"] div').css("width", "58px")
                        linkColumnWidth = "58px"
                    }
                    // setTimeout(function(){
                    //     // resize to linkColumnWidth
                    //     $('#tt').datagrid('resizeColumn', {
                    //         // adding this because link column somehow gets less width SOMETIMES
                    //         field: "link",
                    //         width: linkColumnWidth
                    //     });
                    // },1000)
                    $(window).trigger('resize');
                }
            },
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
        //return this.dataToReturn;

    },
    getPgData: function (URLdata, objParameter, event, colExpansion) {
        var objWS = this;
        var url = GetUrl(URLdata, objParameter);
        if (url == "")
            return;
        if (!objParameter.tickerResponse && objParameter.quarterType)
            objParameter["URLdata"] = URLdata;
        if (objParameter.source)
            objParameter.quarterType = "";
        //if(objParameter.colType === "revision" && url.source === "VA Actuals"){
        //    url.source = "Consensus";
        //}
        
        if(event)
            var keyboard_event = event.data;
        else
            var keyboard_event = {};
        //call notes for this period set
        getPeriodWiseDataPointNotes(url.period);

        var notchunked = url.source;
        if(typeof url.source === typeof "string") {
            notchunked = [url.source];
        }
        var chunks = createChunksFromArray(notchunked, 5);
        var chunksLoaded = 0;
        var sourceExpansionLogged = false;
        if(!colExpansion) {
            const summonFBar = new CustomEvent('SummonFBar', { detail: { data: {}} })
            window.dispatchEvent(summonFBar); 
        }
        chunks.forEach(function(chunk, chunkIdx) {
            var url_copy = Object.assign({}, url);
            url_copy['source'] = chunks[chunkIdx]; 
            this.Call({
                url: url_copy,
                async: true,
                parameter: objParameter,
                success: function (msg) {
                    if(msg.status == 'error'){
                        csv_string = msg;
                        return;
                    }
                    chunksLoaded += 1;
    
                    if (objParameter.qData.past && objParameter.qData.past.length > 0
                        && objParameter.qData.future && objParameter.qData.future.length > 0
                        && objParameter.qData.all == 'past' && hasSecondPgCall) {
                        currentYrPg = $.extend( true, {}, msg);
                        var ObjWebServiceCall = new WebServiceCall();
                        objParameter.qData.all = 'future';
                        ObjWebServiceCall.getPgData(URLdata, objParameter, event);
                        return;
                    }
                    if (objParameter.qData.past && objParameter.qData.past.length > 0
                        && objParameter.qData.future && objParameter.qData.future.length > 0
                        && objParameter.qData.all == 'future'){
                        //set order based on response of second call
                        hasSecondPgCall = false;
                        var periodPanel = $.grep(window.MEData.panels, function (n) {
                            return (n.name.toLowerCase() == "periods");
                        });
                        var periodExpansion = $.grep(periodPanel[0].all_period_expansion_list, function (n) {
                            return (n.period == objParameter.rootName.toUpperCase());
                        })[0].expansion_lst;
                        var combinedResponse = {
                            data:[],
                            status: msg.status
                        };
                        $.each(periodExpansion,function (i, value) {
                            var objVal = $.grep(currentYrPg.data, function (n) {
                                return (n.period == Object.keys(value)[0]);
                            })[0];
                            if(!objVal){
                                objVal = $.grep(msg.data, function (n) {
                                return (n.period == Object.keys(value)[0]);
                                })[0];
                            }
                            var copyVal = jQuery.extend(true, {}, objVal);
                            combinedResponse.data.push(copyVal);
                        });
                        msg = jQuery.extend(true, {}, combinedResponse);
                    }
    
                    makeFiscalyearPeriodDict(msg);
                    var pData = this.parameter;
                    if (pData.quarterType == "past" || pData.quarterType == "future") {
                        if (!pData.tickerResponse) {
                            pData.tickerResponse = msg.data;
                            //pData.quarterType = "future";
                            var ObjWebServiceCall = new WebServiceCall();
                            ObjWebServiceCall.getPgData(pData.URLdata, pData, event);
                            return;
                        }
                        else {
                            msg.data = pData.tickerResponse.concat(msg.data);
                        }
                    }
                    event.data = keyboard_event;
                    var sourceOrder = notchunked.slice() //cloning the array
                    var searchS = ['filings','va actuals','consensus', 'consensus+'];
                    var staticSources = [];
                    //Removing above objects from the main response object
                    for(var i = 0; i < searchS.length; i++){
                        var index = sourceOrder.findIndex(function(item){
                            return item.toLowerCase() === searchS[i];
                        })
                        if(index !== -1) {
                            var temp = sourceOrder.splice(index, 1)[0];
                            staticSources.push(temp);
                        }
                    }
                    //Reversing the left over objects, which now contain only broker data
                    sourceOrder = sourceOrder.reverse();
                    //Pushing the spliced static sources in the same original order
                    for(var i = 0 ; i < staticSources.length; i++){
                        sourceOrder.push(staticSources[i]);
                    }

                    
                    if(!sourceExpansionLogged) {
                        logSourceColExpansion(msg, this.parameter, event, sourceOrder);
                        sourceExpansionLogged = true;
                    }
                    OnSuccessOfExpandColumn(msg, this.parameter, event, sourceOrder);
                    // if(rowDimension.length > 1 && chunksLoaded >= chunks.length){
                    //     autoExpandAnalytics();
                    //     getExpandedRowData(objParameter);
                    // }
                    if(window.highlightDp && window.highlightPeriod) { // added for case of quarter's cell highlighting
                        highlightCell();
                    }
                    if (high || low || high_low_src != "") {
                        highlightHighLowValue(msg.data);
                    }
                    if (surprise != "") {
                        highlightSurpriseValue(msg.data);
                    }
                    if (cva != "" || crdrevision != "") {
                        variationColoring(msg.data);
                    }
                    if ($('#tblIns').is(":visible") == false) {
                        clearRevisionColoringInspector();
                    }
                    if(msg.ticker_list && msg.ticker_list.length > 0){
                        alert('We are still processing data for ' + msg.ticker_list.join(', ') + ". please re-load the page after few minutes.");
                    }
                    if(msg.computing_revision) {
                        alert('We are still processing revision data, please re-load the page after few minutes.');
                    }
                },
                error: function (msg) {
                    csv_string = msg;
                }
            });
        }, this);

    },
    getPgParamData: function (objParameter) {
        var objWS = this;
        var url = GetUrl(objParameter.data, objParameter);
        const summonFBar = new CustomEvent('SummonFBar', { detail: { data: {}} })
        window.dispatchEvent(summonFBar);
        this.Call({
            url: url,
            async: true,
            parameter: objParameter,
            success: function (msg) {
                var pData = this.parameter;
                if (pData.quarterType == "past" || pData.quarterType == "future") {
                    if (!pData.tickerResponse) {
                        pData.tickerResponse = msg.data;
                        pData.quarterType = "future";
                        var ObjWebServiceCall = new WebServiceCall();
                        ObjWebServiceCall.getPgParamData(pData);
                        return;
                    }
                    else {
                        msg.data = pData.tickerResponse.concat(msg.data);
                    }
                }
                OnSuccessPgParamData(msg.data, this.parameter);
            },
            error: function (msg) {
                csv_string = msg;
            }
        });
    },
    getparameterData: function (param_id, period, rowParameter, colParameter, expanded, objParameter) {
        var objWS = this;
        urlParams = getParamUrl(param_id, period, rowParameter, colParameter, expanded, objParameter);

        if (urlParams == "")
            return;
        this.Call({
            url: urlParams.Url,
            async: true,
            parameter: urlParams.objParameter,
            success: function (msg) {
                var pData = this.parameter;
                if (pData.quarterType == "past" || pData.quarterType == "future") {
                    if (!pData.tickerResponse) {
                        pData.tickerResponse = msg.data;
                        var ObjWebServiceCall = new WebServiceCall();
                        ObjWebServiceCall.getparameterData(pData.callParams.param_id, pData.callParams.period, pData.callParams.rowParameter, pData.callParams.colParameter, pData.callParams.expanded, pData);
                        return;
                    }
                    else {
                        msg.data = pData.tickerResponse.concat(msg.data);
                        //for sorting data according to expansions
                        var rowType = pData.RowObjectName.substring(0, expanded.length - 1).toLowerCase();
                        var rowExpansions = FindExpansions(rowType + 's', period);
                        var rowData = [];
                        $.each(rowExpansions, function (index, value) {
                            $.each(msg.data, function (i, el) {
                                if (el[rowType] == value)
                                    rowData.push(el);
                            });
                        });
                        msg.data = rowData;
                    }
                }
                OnSuccessShowHiderow(msg, this.parameter);
                if (high || low || high_low_src != "") {
                    highlightHighLowValue(msg.data);
                }
                if (surprise != "") {
                    highlightSurpriseValue(msg.data);
                }
                //                objWS.dataToReturn = msg;
            },
            error: function (msg) {
                return msg.responseText;
            }
        });
        return this.dataToReturn;
    },

    loadDefaultDataFromPg:function(msg) {
        makeFiscalyearPeriodDict(msg);
        periodDimensions = window.MEData.column_dimensions.filter(function(data){
            return data.name == 'periods'
        })[0];
    
        var actualPeriods = [], futurePeriods = [];
        for(var p=0; p<periodDimensions.values.length; p++){
            var val = periodDimensions.values[p];
            if(val.forecast == false){
                actualPeriods.push(val.period);
            }else if(val.forecast == true){
                futurePeriods.push(val.period);
            }
        }
    
        actualPlusFuturePeriods["list"] = [actualPeriods, futurePeriods];
        financialYear =  [...actualPeriods, ...futurePeriods];
        var objMe = new ModelExplorer();
        objMe.LoadDatagridData(msg, MEData.gSourceActual);
      
        analystTitle(msg);
        if(window.highlightDp){
            //check if annual and change it to the required format
            if (window.highlightPeriod.startsWith("FY")){
                for(baseValue in fiscal_period_dict){
                    if (fiscal_period_dict[baseValue] == window.highlightPeriod){
                         window.highlightPeriod = baseValue;
                         break;
                    }
                };
            }
        }

        if(window.highlightDp && financialYear == window.highlightPeriod) {
            highlightCell();
        } else {
            showFormulaForFirstCell(financialYear);
        }
        if(window.highlightDp){
            highlightCell("lineitem");
         }
        if (high || low || high_low_src != "") {
            highlightHighLowValue(msg.data);
        }
        if (surprise != "") {
            highlightSurpriseValue(msg.data);
        }
        if (cva != "" || crdrevision != "") {
            variationColoring(msg.data);
        }
        first_forecast_period = '';
        $.each(window.MEData.column_dimensions[0].values, function(index, period_obj) {
            if (period_obj.forecast ) {
                // get the first period with forecast
                first_forecast_period = period_obj;
                return false;
            }
        });
        
        if(first_forecast_period!= '') {
            var first_forecast_img = first_forecast_period.period.replace('-', '').toLowerCase();
            if($("#" + first_forecast_img).length){
                if (Array.isArray(financialYear) == true) {
                    setTimeout(()=>{
                        const leftVal = $("#" + first_forecast_img).offset().left
                        $(".datagrid-body").eq(1).animate({scrollLeft: parseInt(leftVal,10)});
                    },10)
                   
                } else {
                    if (financialYear == first_forecast_period.period) {
                        $(".datagrid-body").eq(1).animate({scrollLeft: $("#" + first_forecast_img).offset().left});
                    }
                }
            }
        }
    
        ajaxCallCount =0;
        var variant = ''
        if(cut == 'CPT'){
            variant = window.gVariant;
        } else {
            variant = null;
        }
    
        // This code is executed once all the ajax calls which are part of page load are finished.
        if (ajaxCallCount == 0) {
            clickToAddEvent();
            // remove periods from this for auto expansion
            //expandAcrossTabs = expandAcrossTabs.filter((val)=>val.colType !== 'period')
            expandAcrossTabs.forEach(function (value) {
                if(value.colType !== 'period' && (cut ==="NMV" || cut === "STD")){
                     
                
                expImgEl = $("[id='" + getJQId(value['objimgCtrl']) + "']").closest('td').find('div[clickBinding=true]');
                if (expImgEl.length > 0) {
                    if(!$(expImgEl).hasClass('current-change'))
                        $(expImgEl).trigger("click");
                } else {
                    // this will handle the expansions which are secondary as in they happen after the first level has expanded.
                    // this uses a custom event ExpColLoaded.
                    var imgElId = getJQId(value['objimgCtrl']);
                    $(".datagrid-header").one("ExpColLoaded", "[id='" + imgElId + "']", function (event) {
                        $(event.target).closest('td').click();
                    });
                }
                }
            });
    
            if(isFirstLoad) {
                isFirstLoad = false;
                //Moving the calls here to prevent it interrupting the expansion pg call, and has to get triggered once
                this.getAllNotes(window.MEData.ticker, null);
            }
            
            // This will load unique sli ids for all dapparameter ids
            const activatePeers = new CustomEvent('activatePeers', { detail: { data: msg} })
            window.dispatchEvent(activatePeers);
    
            if ($.inArray('ticker', colDimension) > -1) {
                loadUncachedScheduleData();
            }
            var revisionPanel = $.grep(window.MEData.panels, function (n) {
                if (n.name == "Revisions") {
                    return n;
                }
            })[0];
            //auto expand on revisiontype changed
            if(revisionTypeChanged){
                if(revisionPanel.type != 'row'){ 
                    var headerCols = $('.datagrid-view2 .datagrid-header');
                    var field = firstEstimatedYear.toLowerCase() + 'current';
                    headerCols.find('[field=' + field + ']').trigger('click');
                }
                 //set timeout for 5 seconds to remove yellow accent for analytics
                setTimeout(function () {
                    if(revisionPanel.type != 'row') {
                        $.each($('td.current-change.revision img'), function (i, el) {
                            if($(el).attr('title-class')) {
                                var titleClass = $(el).attr('title-class').split('current-change')[1];
                                $(el).attr('title-class', titleClass);
                            }
                        });
                    }
                    $('td.current-change.revision').removeClass('current-change');
                    revisionTypeChanged = false;
                }, 5000);
            }
            setTimeout("RowCreation();", 100);
            //auto expand analytics
            //setTimeout( function(){ autoExpandAnalytics() }, 500);
    
            var linkColumnWidth = "";
            if(cut == "NMV" || cut == "STD") {
                $('td[field="links"]').css("width", "105px")
                $('td[field="links"] div').css("width", "105px")
                linkColumnWidth = "105px"
            }
            else{
                $('td[field="links"]').css("width", "58px")
                $('td[field="links"] div').css("width", "58px")
                linkColumnWidth = "58px"
            }
            $(window).trigger('resize');
        }
        setTimeout(()=>{debouncedBlock(false)},10)

    },
    getFooterRowData: function (param_id, period, type, filterData, parameter, objParameter, featurePeriods, actualPeriods, count) {
        var objWS = this;
        var Url = {"mainUrl": window.apiUrl + "/api/param3?"};
        if (type == "Peers") {
            Url['param'] = [filterData[1]];
            Url['revision'] = [filterData[3]];
        }
        else {
            Url['param'] = [param_id];
        }

        period = period.replace(/period=/gi, "").split("&");
        Url['period'] = [];
        if(objParameter.callFor == "Peers"){
            if(count == 0){
                // Actuals periods
                if(actualPeriods.length == 0){
                    return false;
                }
                Url['source'] = [window.gSourceActual];
                Url['period'] = actualPeriods;
            }else{
                if(featurePeriods.length == 0){
                    return false;
                }
                // Feature periods
                Url['source'] = [gSourceFuture];
                Url['period'] = featurePeriods;
            }
        }else{
            $.each(period, function (i, el) {
                Url['period'].push(el);
            });
        }

        if((window.cut === "STD" || window.cut === "NMV") && window.MEData.selectedCurrency != undefined && window.MEData.selectedCurrency != "Base"){
            Url['currency'] = window.MEData.selectedCurrency;
        }
        // check and delete
        // if (filterData.length == 0 && (!objParameter.chartData))
        //     return;
        if (parameter != undefined && parameter != "") {

            $.each(parameter.split("|"), function (index, value) {
                if (!Url.hasOwnProperty(colDimension[index]))
                    Url[colDimension[index]] = [];
                if (colDimension[index] != "period" && type.toLowerCase().indexOf(colDimension[index]) == -1) {
                    if (!(colDimension[index] == 'source' && (value.toLowerCase() == window.gSourceActual.toLowerCase() || value.toLowerCase() == gSourceFuture.toLowerCase())))
                        Url[colDimension[index]].push(value);
                }
            });
        }
        if (!Url.hasOwnProperty('source') || ( Url.hasOwnProperty('source') && Url['source'].length == 0)) {
             if (!Url.hasOwnProperty('source') && objParameter.callFor != "peers")
                    Url['source'] = [];

            if (type == "Sources") {
                    $.each(filterData, function (index, value) {
                        Url['source'].push(value);
                    });
            }
            else if (type == "Peers") {
              // if brokers are selected but not included in columns, i.e. they are included in rows,
              // then set source as gSourceFuture
              if(colDimension.findIndex((col) => col === 'source') === -1
                && rowDimension.findIndex((col) => col === 'source') !== -1) {
                Url['source'] = [gSourceFuture];
              } else {
                $.each(filterData[2], function (index, value) {
                    Url['source'].push(value);
                });
              }
            }
        }
        if (!Url.hasOwnProperty('ticker') || ( Url.hasOwnProperty('ticker') && Url['ticker'].length == 0)) {
            if (!Url.hasOwnProperty('ticker'))
                Url['ticker'] = [];
            if (type == "Peers") {
                if (!Url.hasOwnProperty('peerticker')){
                    Url['peerticker'] = [];
                }
                Url['peerticker'].push(filterData[0]);
                Url['ticker'] = company;
            }
            else {
                var defaultdata = $.grep(colPanels, function (n) {
                    return (n.name == "Company Comps");
                });
                if (defaultdata.length > 0) {
                    if (defaultdata[0]['default'] == undefined)
                        Url['ticker'].push(company);
                    else
                        Url['ticker'].push(defaultdata[0]['default']);
                } else {
                    Url['ticker'].push(company);
                }
            }
        }
        if (type == "Scenarios") {
            if (!Url.hasOwnProperty('scenario'))
                Url['scenario'] = [];
            $.each(filterData, function (index, value) {
                Url['scenario'].push(value);
            });
        }
        // commenting for param3 as baseparam not used in inspector
        // if (objParameter.baseData && (param_id != window.MEData.baseparameter.id) && (!(window.MEData.baseparameter.notAvail)))
        //     Url['param'].unshift(window.MEData.baseparameter.id);
        Url = makeUrl(Url, "");
        if (objParameter.chartData) {
            if (!Url.hasOwnProperty(type.toLowerCase().substr(0, type.length - 1)))
                Url[type.toLowerCase().substr(0, type.length - 1)] = [];
            Url[type.toLowerCase().substr(0, type.length - 1)].push(rowDefaults[type.toLowerCase().substr(0, type.length - 1)]);
        }

        objWS.Call({
            url: Url,
            async: true,
            parameter: objParameter,
            inspector: true,
            success: function (msg) {
                OnSucessLoadDatagridFooterData(msg, this.parameter);
                var ObjWebServiceCall = new WebServiceCall();
                if(type == 'Peers'){
                    peerCallCount--;
                    if(peerCallCount == 0){
                        $.each(Object.keys(note_dict_peer), function(index, value){
                            if(note_dict_peer[value] == undefined){
                                ObjWebServiceCall.getAllNotes(value, 'datapoint');
                            } else {
                                bindPeerNotes(note_dict_peer[value], value);
                            }
                        });
                    }
                }
                if (high || low || high_low_src != "") {
                    highlightHighLowValue(msg.data);
                }
                if (surprise != "") {
                    highlightSurpriseValue(msg.data);
                }
            },
            error: function (msg) {
                return msg.responseText;
            }
        });
               return this.dataToReturn;
    },
    getPeerCompanies: function (param_id, usliIds, selected) {
      if(window.peerTickerList && window.peerTickerList[param_id] && window.peerTickerList[param_id].length) {
        onSuccessLoadPeers(window.peerTickerList[param_id], selected);
      } else {
        var Url = window.apiUrl + "/api/get_peers_list";
        var objParameter = {
          'dapparameterid': param_id,
          'usli_list': usliIds,
          'ticker': company,
          'limit': 10 
        }
        var ObjWebServiceCall = new WebServiceCall();
        ObjWebServiceCall.Call({
          url: Url,
          type: 'POST',
          async: true,
          data: JSON.stringify(objParameter),
          inspector: true,
          success: function (response) {
            if(!window.peerTickerList) {
              window.peerTickerList = {};
            }
            window.peerTickerList[param_id]=response.peers_list;
            onSuccessLoadPeers(response.peers_list, selected);
          },
          error: function (msg) {
              return msg.responseText;
          }
        });
      }
    },
    callGrid: function (ReloadFlag, meData, variantFlag, initialCall) {
        whatIsTheReloadFlag = ReloadFlag;
        MEData.initialCall = initialCall;
        var successFunc = function (msg) {
                if (msg.status == 'error') {
                    const displayMetaError = new CustomEvent('displayMetaError', { detail:  {data:msg}})
                window.dispatchEvent(displayMetaError);
                    return;
                }
                //List to ascertain blurring logic based on valid periods
                isGridFirstLoad = true;
                expandAcrossTabs = msg.extras.expandedColumns ? msg.extras.expandedColumns : [];

                if(cut == 'SAR'){
                    window.gSourceActual = gSourceFuture = window.gSource;
                    sourcesExist = true;
                }
                if (msg.baseparameter == null)
                    msg.baseparameter = {"notAvail": true, "id": "0000"};

                if (window.gSchedule && !variantFlag && meData) {
                    for(var i=0; i< msg.column_dimensions.length; i++){
                        var el = msg.column_dimensions[i];
                        if (el.name == 'Tickers') {
                            delete meData.column_dimensions.splice(i, 1);
                            meData.column_dimensions.splice(i, 0, el);
                        }
                    }
                }
//check if
                if(cut == 'SAR' && meData){
                    meData.nmv_links = msg.nmv_links;
                }
                order_dimensions(msg);
                // if (variantFlag) {
                //     tabsAppend(msg.tabs);
                // }
                if (msg.row_dimensions != undefined) {
                    if (meData != null) {
                        meData.baseparameter = msg.baseparameter;
                        meData.row_dimensions[0] = msg.row_dimensions[0];
                        if (msg.disabledrivertoggle)
                            meData.disabledrivertoggle = msg.disabledrivertoggle;
                        else
                            meData.disabledrivertoggle = false;
                        msg = meData;
                    }
                    get_paramsByUnitnames(msg.row_dimensions[0], msg.baseparameter);
                }

                if (!rowclicked && !jQuery.isEmptyObject(msg.inspector))
                    inspectorType = msg.inspector['default'];
                if (jQuery.isEmptyObject(msg.inspector)) {
                    window.gVariant = msg.variant;
                    gSchedule = true;
                }

                reloadPanels(window.MEData);
                getChunkingPeriods();

                /*if (msg.panels != undefined)
                    searchBarPlaceholder(msg.panels);*/
                var objME = new ModelExplorer();
                if (variantFlag)
                    objME.LoadDataGrid(msg, ReloadFlag, true);
                else
                    objME.LoadDataGrid(msg, ReloadFlag);

                if (!ReloadFlag) {
                    if ($('.datagrid-footer').is(":visible") == false)
                        setTimeout(reziseGridPanel, 100);
                }
                getFirstEstimatedYear(msg);
              
                expandColumnOnNavigate = msg['imgObjIdList'];
            }

        successFunc(window.MEData);

        //commented this if condition as period type has changed to AI as default
        /*if (calendarYears)
            Url['is_calendar'] = true;*/
        /*this.Call({
            url: Url,
            async: true,
            success: {},
            error: function (jqXHR, textStatus, errorThrown) {
                csv_string = errorThrown;
            }
        });*/
    },
    basisMetaData: function () {
        var Url = '&basis='+ window.gBasis;
        // var mexScope = angular.element('[ng-controller=MexController]').scope();
        //     mexScope.loadGridCalled(true, 'All', Url);
        const callLoadGridEvt = new CustomEvent('CallLoadGrid', {detail:{url: Url, firstCall: true, sectionName: 'All'} })
        window.dispatchEvent(callLoadGridEvt); 

    },
    getBaseParamRelatedData: function (objParameter) { // todo : check this
        //Adding this for handling the sources_in_progress_excluded and/or sources_in_progress_included brokers
        var sourcePanelObj = $.grep(window.MEData.panels, function (n) {
            return (n.name.toLowerCase() == 'sources');
        })[0];

        if(!objParameter.Url['excl_sources']){
            objParameter.Url['excl_sources'] = [];
        }

        if(sourcePanelObj.sources_in_progress_excluded.length > 0 && sourcePanelObj.selected_excl_cc_not_entitled == true){
            for(var i = 0; i < sourcePanelObj.sources_in_progress_excluded.length; i++) {
                objParameter.Url['incl_sources'].push(sourcePanelObj.sources_in_progress_excluded[i]);
            }
        }
        else if(sourcePanelObj.sources_in_progress_excluded.length > 0 && sourcePanelObj.selected_excl_cc_not_entitled == false){
            for(var i = 0; i < sourcePanelObj.sources_in_progress_excluded.length; i++) {
                objParameter.Url['excl_sources'].push(sourcePanelObj.sources_in_progress_excluded[i]);
            }
        }

        if(sourcePanelObj.sources_in_progress_included.length > 0 && sourcePanelObj.selected_cc_not_entitled == true){
            for(var i = 0; i < sourcePanelObj.sources_in_progress_included.length; i++) {
                objParameter.Url['incl_sources'].push(sourcePanelObj.sources_in_progress_included[i]);
            }
        }
        else if(sourcePanelObj.sources_in_progress_included.length > 0 && sourcePanelObj.selected_cc_not_entitled == false){
            for(var i = 0; i < sourcePanelObj.sources_in_progress_included.length; i++) {
                objParameter.Url['excl_sources'].push(sourcePanelObj.sources_in_progress_included[i]);
            }
        }

        this.Call({
            url: objParameter.Url,
            async: false,
            parameter: objParameter,
            success: function (msg) {
                if (this.parameter.type == 'future' || (!this.parameter.type)) {
                    msg.data = msg.data.concat(this.parameter.Data);
                    functionToRecieveBaseParamData(msg.data);
                }
                else {
                    this.parameter.type = 'future';
                    getBaseParamData("", this.parameter, msg.data);
                }
            },
            error: function (msg) {
                return msg.responseText;
            }
        });
    },
    postScenarioChanges: function (refreshFlag, pageload) {
        var scenarioValue = window.gScenario;
        if (refreshFlag) {
            scenarioValue = $('#scenario-selection').val();
            editScenarioMode = false;
            customScenarioName = "Custom";
            scenarioChanges = {};
        }
        if (!pageload)
            pageload = false;
        var data = {'changes': scenarioChanges};
        var changeData = "data=" + JSON.stringify(data);
        var csrftoken = getCookie('csrftoken');
        var Url = {"mainUrl": "/composite/custom_scenario?"};
        Url = makeUrl(Url, "");
        Url['scenario'] = scenarioValue;
        Url['refresh'] = refreshFlag;
        if (pageload.editRefresh) {
            Url["edit_refresh"] = true;
            pageload = false;
        }
        //var Url = "/composite/custom_scenario?ticker=" + company + "&variant=" + window.gVariant + "&scenario=" + scenarioValue + "&refresh=" + refreshFlag;
        this.Call({
            url: Url,
            type: "POST",
            async: true,
            data: changeData,
            parameter: pageload,
            success: function (msg) {
                if (msg.status == 'success') {
                    if (this.parameter) {
                        $('#recal_button').hide();
                        var ObjWebServiceCall = new WebServiceCall();
                        if (this.parameter.savescenario) {
                            ObjWebServiceCall.saveScenarioByName();
                            return;
                        }
                        else if (this.parameter.savevariant) {
                            ObjWebServiceCall.saveVariantByName("", {noScenarioSaving: true});
                            return;
                        }
                    }
                    customScenarioMode = true;
                }
                else {
                    createLog("", msg.message);
                }
            },
            headers: {"X-CSRFToken": csrftoken},
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    saveScenarioByName: function (type) {
        var scenarioShortName = $('#saveScenarioDialog #dialog-name1').val();
        var scenarioName = $('#saveScenarioDialog #dialog-name').val();
        if (editScenarioMode) {
            scenarioName = window.gScenario;
            scenarioShortName = window.gScenario;
        }
        var Url = {"mainUrl": "/composite/savescenario?"};
        Url = makeUrl(Url, "");
        if (type == "selectionsExist" || type == 'scenarioExist')
            Url["flag"] = type;
        Url['scenario_name'] = scenarioName;
        Url['short_name'] = scenarioShortName;
        this.Call({
            url: Url,
            type: "GET",
            async: true,
            success: function (msg) {
                if (msg.status == 'success') {
                    //[TODO:]We should reload page with new scenario.
                    // createLog("", "scenario is saved");
                    customScenarioMode = false;
                    window.gScenario = msg.scenario;
                    $('#ptype').trigger('change');
                }
                else {
                    if (msg.message == "scenario exist")
                        scenarioOverWrite(true, "");
                    else if (msg.message == "main scenario")
                        alert('it is standard scenario give another name ');
                    else
                        scenarioOverWrite(false, msg.scenario);
                }
            },
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    saveVariantByName: function (type, parameters) {
        var variantName = $('#saveVariantDialog #dialog-name').val();
        var variantShortName = $('#saveVariantDialog #dialog-name1').val();
        if (editVariantMode) {
            variantName = window.gVariant;
            variantShortName = window.gVariant;
        }
        var Url = {"mainUrl": "/composite/savevariant?"};
        Url = makeUrl(Url, "");
        if (type == "selectionsExist" || type == 'scenarioExist')
            Url["flag"] = type;
        Url['variant_name'] = variantName;
        Url['short_name'] = variantShortName;
        this.Call({
            url: Url,
            type: "GET",
            async: true,
            parameter: parameters,
            success: function (msg) {
                if (msg.status == 'success') {
                    //[TODO:]We should reload page with new variant.
                    // createLog("", "variant is saved");
                    customScenarioMode = false;
                    window.compositeEdit = false;
                    window.gVariant = msg.variant;
                    if (!this.parameter.noScenarioSaving)
                        confirmationDialog("scenario", "save");
                    else
                        editVariantMode = false;
                }
                else {
                    if (msg.message == "variant exist")
                        variantOverWrite(true, "");
                    else if (msg.message == "main variant")
                        alert('it is standard variant model give another name ');
                    else
                        variantOverWrite(false, msg.variant);
                }
            },
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    edit_variant: function (obj) {
        var Url = {"mainUrl": "/composite/editvariant?"};
        Url = makeUrl(Url, "");
        Url['scenario'] = $('#scenario-selection').val();
        Url['variant'] = obj.variant;
        Url['action'] = obj.action;
        this.Call({
            url: Url,
            type: "GET",
            async: true,
            parameter: obj,
            success: function (msg) {
                if (msg.status == 'success') {
                    if (this.parameter.action != 'delete') {
                        editVariantMode = true;
                        customScenarioMode = false;
                        editScenarioMode = false;
                        window.compositeEdit = true;
                        window.gScenario = 'Custom';
                        window.gVariant = this.parameter.variant;
                    }
                    else {
                        var variantName = this.parameter.variant;
                        if (!$('#' + variantName).is(':checked')) {
                            var variantPanelValues = window.MEData.panels.getValues("name", "Variants")[0].values
                            $.each(variantPanelValues, function (i, el) {
                                if (el.name == variantName)
                                    var variantIndex = i;
                            });
                            variantPanelValues.values.splice(variantIndex, 1);
                            $(obj.element).closest('div').remove();
                            if (variantPanelValues.getValues("custom", true).length == 0)
                                $('#savedVariants').remove();
                            return;
                        }
                        window.gScenario = "";
                        window.gVariant = "";
                    }
                    //we have to check whether we want to load with specific scenario
                    $('#ptype').trigger('change');
                }
                else {
                    createLog("", "action on scenario is unsuccessful");
                }
            },
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    edit_scenario: function (obj) {
        var Url = {"mainUrl": "/composite/editscenario?"};
        Url = makeUrl(Url, "");
        Url['scenario'] = obj.scenario;
        Url['action'] = obj.action;
        //var Url = "/composite/editscenario?ticker=" + company + "&variant=" + window.gVariant + "&scenario=" + obj.scenario + "&action=" + obj.action ;
        this.Call({
            url: Url,
            type: "GET",
            async: true,
            parameter: obj,
            success: function (msg) {
                if (msg.status == 'success') {
                    if (this.parameter.action != 'delete') {
                        editScenarioMode = true;
                        customScenarioName = window.gScenario = this.parameter.scenario;
                    }
                    else {
                        if (!$('#' + this.parameter.scenario).is(':checked')) {
                            var variantObj = window.MEData.panels.getValues("name", "Scenarios")[0].values.getValues('variant', window.gVariant)[0];
                            var scenarioName = this.parameter.scenario;
                            $.each(variantObj.values, function (i, el) {
                                if (el.name == scenarioName)
                                    var scenarioIndex = i;
                            });
                            variantObj.values.splice(scenarioIndex, 1);
                            scenarioBySettings(window.MEData.panels.getValues("name", "Scenarios")[0], window.MEData, true);
                            return;
                        }
                        window.gScenario = "";
                    }
                    //we have to check whether we want to load with specific scenario
                    $('#ptype').trigger('change');
                }
                else {
                    createLog("", "action on scenario is unsuccessful");
                }
            },
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
    },
    storePanelSettings: function (Data, token) {
        var objWS = this;
        return new Promise(function (resolve, reject) {
        objWS.Call({
            url: window.apiUrl + "/api/gridpanelshistory/",
            type: "POST",
            async: true,
            data: Data,
            success: function (msg) {
                resolve(msg);
            },
            headers: {"X-CSRFToken": token},
            error: function (msg) {
                csv_string = msg.responseText;
            }
        });
        //return this.dataToReturn;
        });
    },
    DeletePanelSettings: function (Data, token, sectionName) {
        if(sectionName !== 'All') {
            Data["dimension"] = sectionName;
        }
        else{
            isClearAll = true;
            Data["dimension"] = '';
            window.MEData.user_dim_setting=gridLoadedMEData.user_dim_setting=false;
        }
        //Added a library to handle circular reference of json occuring while Clear All is clicked as per CA-4557
        var dataDel = "viewdata=" + CircularJSON.stringify(Data);
        var objWS = this;
        this.Call({
            url: window.apiUrl + "/api/deletegridpanelshistory/",
            type: "POST",
            async: false,
            data: dataDel,
            success: function (msg) {
                //window.MEData.user_dim_setting=gridLoadedMEData.user_dim_setting=false;
                //Load(pg);
                //reloadPanels(window.MEData,true);
                var objWebServiceCall = new WebServiceCall();
                window.gBasis = '';

                // This is done to fix bug CA-3103 in which if we have click on any Visualisation tab and without closing
                // it, click on any other tab like Source or Analytics and then click Default.
                // Previosuly clicked Visualisation tab status does not change to default
                $('.analysis_sections_selected').trigger( "click" );

                //Incase YoY% button is selected and the user clears it, it should remove the selected class
                if(sectionName === 'GrowthTypes' || sectionName === 'All'){
                    // $("#toggle-yoy").find(".miniButtonsUnselected").removeClass("miniButtonsSelected");
                    if($("#toggle-normal").length > 0){
                        $("#toggle-normal").find(".miniButtonsUnselected").addClass("miniButtonsSelected");
                    }
                    currentClickedCommonSizeName = null;
                }

                // var mexScope = angular.element('[ng-controller=MexController]').scope();
                // mexScope.loadGridCalled(false, sectionName);
                if(sectionName === 'All'){
                    const callLoadGridEvt = new CustomEvent('CallLoadGrid', { detail:   { firstCall: true, sectionName: sectionName, clearAllPreset: true } })
                    window.dispatchEvent(callLoadGridEvt);
                }else{
                    const callLoadGridEvt = new CustomEvent('CallLoadGrid', { detail:  { firstCall: true, sectionName: sectionName, clearAllPreset: false}})
                    window.dispatchEvent(callLoadGridEvt);
                   
                }
                return;
            },
            headers: {"X-CSRFToken": token},
            error: function (msg) {
                csv_string = msg.responseText;
                var objWebServiceCall = new WebServiceCall();
                window.gBasis = '';

                // This is done to fix bug CA-3103 in which if we have click on any Visualisation tab and without closing
                // it, click on any other tab like Source or Analytics and then click Default.
                // Previosuly clicked Visualisation tab status does not change to default
                $('.analysis_sections_selected').trigger( "click" );

                //Incase YoY% button is selected and the user clears it, it should remove the selected class
                if(sectionName === 'GrowthTypes' || sectionName === 'All'){
                    // $("#toggle-yoy").find(".miniButtonsUnselected").removeClass("miniButtonsSelected");
                    if($("#toggle-normal").length > 0){
                        $("#toggle-normal").find(".miniButtonsUnselected").addClass("miniButtonsSelected");
                    }
                    currentClickedCommonSizeName = null;
                }

                // var mexScope = angular.element('[ng-controller=MexController]').scope();
                // mexScope.loadGridCalled(false, sectionName);
                const callGrid = new CustomEvent('CallLoadGrid', 
                {detail: { firstCall: false, sectionName: sectionName }}
            )
                window.dispatchEvent(callGrid)
            }
        });
    }
}

/**
 * 
 * @param {array} inArray input array that is to be chunked
 * @param {int} chunkSize size of every chunk except the remainder chunk
 * @param {int} minCallCount length of inArray at/below which chunks will be of size 1
 * @returns array of arrays(where each array is a chunk of input array)
 */
function createChunksFromArray(inArray, chunkSize, minCallCount) {
    if(minCallCount !== undefined) {
        if(inArray.length <= minCallCount) {
            chunkSize = 1;
        }else{
            chunkSize = Math.min(chunkSize, Math.round(inArray.length / minCallCount));
        }
    }

    var chunks = [];
    var chunkCount = Math.ceil( inArray.length / chunkSize );
    for(var i = 0; i < chunkCount; i++) {
        var chunk = inArray.slice( i*chunkSize, Math.min(i*chunkSize + chunkSize, inArray.length) );
        chunks.push(chunk);
    }

    return chunks;
}

/**
 * function to auto expand 1st row and any previously expanded analytics rows
 */
function autoExpandAnalytics() {
    var expandedRowsParamIds = window.MEData.panels.filter(function(panel){
        return panel.name.toLowerCase() == "growthtypes"
    }).map(function(item){
        return item.expandedRows
    })[0];

    if(expandedRowsParamIds != undefined){
        expandedRowsParamIds.forEach(function(paramid){
            var td = $('.datagrid-btable').find('[field=GrowthTypes] img[id^='+ paramid +'][src*=datagrid_row_expand]');
            if(td.length){ td.get(0).click(); }
        });
    }

    var cell2Expand = $('.datagrid-btable').find('[field=GrowthTypes] img').eq(0).closest('td');
    //expand first row only if no other row is already expanded
    var expandedAnalyticsExists = $('.datagrid-btable').find('[field=GrowthTypes] img[src*=datagrid_row_collapse]');
    if(expandedAnalyticsExists.length === 0 && cell2Expand[0]){
        cell2Expand[0].click();
    }

    //set timeout for 5 seconds to remove yellow accent for analytics
    setTimeout(function () {
        /**
         * todo: check if below line removing a css class is redundant
         * with jquery elem.trigger('click') method there was a leftover yellow selection 
         * on all expanded line items. This does not happen with jquery's elem.click()
         */
        $('td.current-change.growth').removeClass('current-change');

        growthTypeChanged = false;
        if(window.highlightDp && fromCallGrid){
           highlightCell("lineitem");
           fromCallGrid = false;
        }

    }, 5000);
}

/*All WebService calling related functionality(End)*/
function getJQId( myid ) {
    return myid.replace("$$", "\\$\\$");
}

function prepareDpParams(cellid,cut,ticker,source,growthType,historicalFocus,period,param,currency,incl_sources,excl_sources,shouldLog,cellElement){
    var dpParams = {
        dp: cellid,
        cut: cut,
        ticker: ticker,
        source: replaceConsensusPlusOperator(source),
        growthType: growthType,
        shouldLog: shouldLog,
        historical_focus: historicalFocus,
        period: period,
        param: param,
        cellElement: cellElement[0]
    };



    if(currency.toLowerCase() !== "base" && (cut === "STD" || cut === "NMV")){
        dpParams["currency"] = window.MEData.selectedCurrency;
    }

    if(cut !== 'SAR'){
        excl_sources = getExcludedBrokers();
        incl_sources = getIncludedBrokers();
        var sourceObj = $.grep(window.MEData.panels, function (n) {
            return (n.name.toLowerCase() == "sources");
        })[0];
        const currentSource = source;
        if(sourceObj){
            if((typeof(currentSource) === 'string' && currentSource.toLowerCase() == 'custom') || ($.isArray(currentSource) && currentSource.indexOf("Custom") != -1)){
                if (sourceObj.sources_in_progress_excluded.length > 0 && sourceObj.selected_excl_cc_not_entitled == true) {
                    for (var i = 0; i < sourceObj.sources_in_progress_excluded.length; i++) {
                        incl_sources.push(sourceObj.sources_in_progress_excluded[i]);
                    }
                }
                else if (sourceObj.sources_in_progress_excluded.length > 0 && sourceObj.selected_excl_cc_not_entitled == false) {
                    for (var i = 0; i < sourceObj.sources_in_progress_excluded.length; i++) {
                        excl_sources.push(sourceObj.sources_in_progress_excluded[i]);
                    }
                }

                if (sourceObj.sources_in_progress_included.length > 0 && sourceObj.selected_cc_not_entitled == true) {
                    for (var i = 0; i < sourceObj.sources_in_progress_included.length; i++) {
                        incl_sources.push(sourceObj.sources_in_progress_included[i]);
                    }
                }
                else if (sourceObj.sources_in_progress_included.length > 0 && sourceObj.selected_cc_not_entitled == false) {
                    for (var i = 0; i < sourceObj.sources_in_progress_included.length; i++) {
                        excl_sources.push(sourceObj.sources_in_progress_included[i]);
                    }
                }
            }   
        }
    }
    
    if(source.toLowerCase() === "custom"){
        dpParams["incl_sources"] = incl_sources;
        dpParams["excl_sources"] = excl_sources;
        if(window.MEData.panels[1].custom_consensus_mode && window.MEData.panels[1].excl_reaffirm_broker_consensus !== "" && window.MEData.panels[1].excl_reaffirm_broker_consensus !== false){
            dpParams["excl_reaffirm_broker_consensus"] = true;
        }
    }
    if((window.MEData.panels[1].date_custom_consensus !== undefined 
        && window.MEData.panels[1].date_custom_consensus !== "")
        || window.MEData.panels[1].relative_days){

        var refdate = window.MEData.panels[1].date_custom_consensus;
        if(!refdate) {
            var reldays = window.MEData.panels[1].relative_days;
            var currDate = new Date();
            currDate.setDate(currDate.getDate() - Number(reldays));
            refdate = convertDateToString(currDate, "yyyymmdd");
        }
        
        dpParams['logic_based_consensus'] = true;
        dpParams['refdate'] = refdate;
        const inc_non_current_brokers = window.MEData.panels[1].inc_non_current_brokers;
        if(inc_non_current_brokers !== undefined && inc_non_current_brokers !== null){
            dpParams['earnings'] = inc_non_current_brokers;
        }
    }
    dpParams["pg"] = pg;
    const historicalRevision = $(cellElement[0]).attr('revision')
    if(historicalRevision !== undefined){
        dpParams['historical_revision'] = historicalRevision;
    }
    return dpParams;
}

function resizegridOnWindowResize() {
    var winh = $(window).height();
    var datagridTable = $('.datagrid-ftable');
    var datagridCustDivHeight = $('.datagrid-custom-div').height();
    var mainGridTable = $('#tt');
    var dataGridInspTableBody = $('.datagrid-ftable tbody');

    if (!datagridTable.is(':empty') && !dataGridInspTableBody.is(':empty')) {
        if ($('.datagrid-footer:hidden').length == 0) {
            gridHeight = datagridCustDivHeight + $('#secondaryHeader').height() + $("app-global-primary-header").height();
        } else {
            gridHeight = 238;
            if (!$('.datagrid-footer-inner').is(':empty')) {
                gridHeight = 229;
            }
        }
    } else {
        gridHeight = 227;
    }

    if ($('.datagrid-body-inner').is(':empty')) {
        gridHeight = 228;
    }
    var winW = setWidthForPanels(gridHeight);
    var mainGridHeight = winh - gridHeight - extraSize;

    mainGridTable.datagrid('resize', {width: winW, height: mainGridHeight})

    // Below lines of code are added for fixing zooming issue with inspector tab opened
    if ($('.datagrid-footer').is(":visible") && !dataGridInspTableBody.is(':empty')) {
        // mainGridTable.datagrid('resize', {width: winW, height: mainGridHeight + 20})


        $('.datagrid-body').height($('.datagrid-wrap').height() - $('.datagrid-header').height() -
            datagridCustDivHeight - $('.datagrid-footer').height());

    }

    //width handling for inspector's line item detail section
    var footerLeft = $('.datagrid-view1 .datagrid-footer-inner');
    var footerRight = $('.datagrid-view2 .datagrid-footer');
    var totalWidth = footerLeft.width() + footerRight.width();
    $('.line-item-details-parent-container').width(totalWidth);
    $('.comptable-parent-container').width(totalWidth);

    reziseGridPanel();
};
function reziseGridPanel(mode) {
    
    $('.datagrid-wrap').height($('.datagrid-wrap').height());
    $('.datagrid-view').height($('.datagrid-wrap').height());

    if($('#tblIns').is(':visible')) {
        $('.datagrid-body').height($('.datagrid-wrap').height() - $('.datagrid-header').height());
    }
    else{
       /*SAR check required as datagrid-custom-div has height even if its hidden*/
        if(typeof cut === 'string'){
            if ('SAR' === cut) {
                $('.datagrid-body').height($('.datagrid-wrap').height() - $('.datagrid-header').height());
            } else {
                $('.datagrid-body').height($('.datagrid-wrap').height() - $('.datagrid-header').height() - $('.datagrid-footer').height() - $('.datagrid-custom-div').height());
            }
        }
    }
    if($("#footerTypeDiv").is(':visible') && $("#tblIns #footerTypeDiv").is(":visible")) {
      $("#footerTypeDiv").css('left',$("#tblIns #footerTypeDiv").offset().left)
    }
}

function scroll_to_first_forecast_quarter(){
    /* scroll to first_forecast_quarter , need to convert it to lowercase because field is in lowercase */
    first_forecast_quarter = window.MEData.panels[0].first_estimated_fiscal.toLowerCase();
    if ($("td[field='" + first_forecast_quarter + "']").length) {
        $(".datagrid-body").animate({scrollLeft: $("td[field='" + first_forecast_quarter + "']").offset().left}, 500);
        first_lineitem_ele = $("td[period='"+first_forecast_quarter.toUpperCase()+"']");
        if(first_lineitem_ele.length){
            first_lineitem_ele =  first_lineitem_ele.eq(0);
            cellid = first_lineitem_ele.attr("id");
            field = first_lineitem_ele.attr("field");
            cut = window.MEData.base_cut;
            source = first_lineitem_ele.attr("source");
            /* triggering click event for first line item of first estimated fiscal */
            // const cellData = {
            //     id:first_lineitem_ele.getAttribute("id") || null,
            //     field:first_lineitem_ele.getAttribute("field")  || null,
            //     dapparam_id:first_lineitem_ele.getAttribute("dapparam_id") || null,
            //     revision:first_lineitem_ele.getAttribute("revision") || null

            // }
            var paramsForFbar = prepareDpParams(cellid,cut,window.MEData.ticker,source,"",window.MEData.panels[1]["actual-default"],first_lineitem_ele.attr('period'),first_lineitem_ele.attr('dapparam_id'),window.MEData.selectedCurrency,incl_sources,excl_sources, false,first_lineitem_ele)
            const summonFBar = new CustomEvent('SummonFBar', { detail: { data: paramsForFbar} })
            window.dispatchEvent(summonFBar);
            // datacellClick(cellid, field, first_lineitem_ele[0], cut, source, "col", "", $(first_lineitem_ele).trigger("click"), window.MEData.ticker);
        }
    }
}

function highlightCell(type) {
    if($("td[id^='"+window.highlightDp+"']").length > 0 ){
        window.highlightDp=window.highlightDp.replace('|', "\\|").replace(/\/+/g, '\\/');
        var cell = $($("td[id^='"+window.highlightDp+"']")[0]);
        if (cell.length == 0){
            return;
        }
        if(type == "lineitem"){
            firstEstimatedYear = "";
            cell.find('div').css({'border' : '2px solid blue','padding-right': '0px'});
            window.highlightDp = '';
        } else {
            setTimeout(function(){
                cell.trigger("click");
                cell.css({'border' : '2px solid blue'});
            }, 1000);
        }
        var top = cell.offset().top;
        setTimeout(function(){$('.datagrid-body').scrollTop(top - $('.datagrid-body').offset().top);}, 100);

        $('body').find('div').on("click", function (event) {
            // event.originalEvent == undefined means system trigger
            if (!event || (event && (!event.originalEvent && event.isTrigger))) {
                return;
            }

            if (type == "lineitem") {
                cell.find('div').css({'border': '', 'padding-right': '4px'});
            } else {
                cell.css({'border': ''});
            }
        });
        is_highlightdp = true;
        period_revision = "";
        expand_consensus = false;
    } else {
        console.error(window.highlightDp + " doesn't exist");
    }
}

/**
 * This method returns the color hex code after taking into account the luminosity passed.
 * the range for lum is 0 - 1.
 * 0 would return the same color, 1 would return lightest.
 * @param hex
 * @param lum
 * @returns {string}
 * @constructor
 */
function colorLuminance(hex, lum) {
	// validate hex string
	hex = String(hex).replace(/[^0-9a-f]/gi, '');
	if (hex.length < 6) {
		hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
	}
	lum = lum || 0;

	// convert to decimal and change luminosity
	var rgb = "#", c, i;
	for (i = 0; i < 3; i++) {
		c = parseInt(hex.substr(i*2,2), 16);
		c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
		rgb += ("00"+c).substr(c.length);
	}

	return rgb;
}


function analysisColor(cell, title, percentChange, peak, baseColor) {
    if(title!=undefined){
        cell.prop("title",setTooltipMsg(title));
    }else{
        cell.prop("title",title);
    }
	if(parseFloat(peak) == 0) {
		var relChange = 1;
	}
	else {
		var relChange = parseFloat(percentChange) / parseFloat(peak);
	}
	cell.prop("color_info", baseColor + '~' + relChange);
	relChange = 1 - Math.round(relChange * 10) / 10;
	cell.css({'background-color': colorLuminance(baseColor, relChange)});
    cell.addClass('revision-color');
}

function setTooltipMsg(title){
    /* Unit value is being sent from server side in title and based on that determining which message should be displayed.
       only for consensus values no unit is being sent from server side, so in that case length of title after splitting will be 2.
    */
    var msg = title.split(" ");
    var tooltipMsg;
    if(msg.length == 2){
        tooltipMsg = "Coefficient of variation : "+msg[0]+"\n    Standard deviation : "+msg[1];
    }else if(msg[2] == "%"){
        tooltipMsg = (window.isConsensusPlusUser ? "Difference from consensus+ : " : "Difference from consensus : ")+msg[1]+" bps";
    }else if(msg[0] == "previous:"){
        //handling for revision tooltip msg
        tooltipMsg = title;
    }else{
        tooltipMsg = (window.isConsensusPlusUser ? "Difference from consensus+ : " : "Difference from consensus : ") + msg[0]+ " ("+msg[1]+ ")";
    }
    return tooltipMsg;
}

function variationColoring(pgData) {
    for(var indexdata=0; indexdata<pgData.length; indexdata++){
        var valuedata = pgData[indexdata];
        // this if for Revision Deviation
        var fieldName = getFieldName(valuedata);
        // Adding this since consensus+ needs to be converted to consensusplus for the selector to find the td on line 1764
        fieldName = replaceConsensusPlusOperator(fieldName);
        if(valuedata.hasOwnProperty('highest_diff') && valuedata.hasOwnProperty('lowest_diff')) {
            for(var indexdp=0; indexdp<valuedata.data.length; indexdp++){
                var valuedp = valuedata.data[indexdp];
                var cellRecs = $( "td[id='" + valuedp.id + "'][field='" + fieldName + "']");
                // it can have multiple cells with same id, (its wrong but well !!!) if the same parameter is there in the view multiple times. so coloring all of them.
                if(cellRecs.length > 0) {
                    for(var indexCell=0; indexCell<cellRecs.length; indexCell++){
                        var cell = cellRecs[indexCell];
                        cell = $(cell);
                        if (valuedp.percentage_change < 0) {
                            analysisColor(cell, valuedp.title, valuedp.percentage_change, valuedata.lowest_diff, ANALYSIS_RED)
                            cell.addClass('dummyForSliderRevision');
                        }
                        else if (valuedp.percentage_change > 0) {
                            analysisColor(cell, valuedp.title, valuedp.percentage_change, valuedata.highest_diff, ANALYSIS_BLUE)
                            cell.addClass('dummyForSliderRevision');
                        }
                        else if(valuedata.highest_diff == 0 && valuedata.lowest_diff == 0) {
                            cell.css({'background-color': '#e0e0e0'});
                        }
                    };
                }
            };
            /*if(parseInt($("#revisionSlider" ).slider('value')) < -1) {
                $(".dummyForSliderRevision").trigger("revisionSliderMoved", parseInt($("#revisionSlider" ).slider('value')));
            }*/
        }
        else if (valuedata.hasOwnProperty('highest_stdev') && valuedata.hasOwnProperty('lowest_stdev')) {
            // for Variation analysis
            for(var indexdp=0; indexdp<valuedata.data.length; indexdp++){
                var valuedp = valuedata.data[indexdp];
                var cellRecs = $( "td[id='" + valuedp.id + "'][field='" + fieldName + "']" );
                // it can have multiple cells with same id, (its wrong but well !!!) if the same parameter is there in the view multiple times. so coloring all of them.
                if(cellRecs.length > 0) {
                    for(var indexCell=0; indexCell<cellRecs.length; indexCell++){
                        var cell= cellRecs[indexCell];
                        cell = $(cell);
                        cell.addClass('dummyForSliderVariation');
                        if (valuedp.stdev < 0) {
                            analysisColor(cell, valuedp.title, valuedp.stdev, valuedata.lowest_stdev, ANALYSIS_RED)
                        }
                        else if (valuedp.stdev > 0) {
                            analysisColor(cell, valuedp.title, valuedp.stdev, valuedata.highest_stdev, ANALYSIS_BLUE)
                        }
                    };
                }
            }
            /*if(parseInt($("#variationSlider" ).slider('value')) < -1) {
                $(".dummyForSliderVariation").trigger("variationSliderMoved", parseInt($("#variationSlider" ).slider('value')));
            }*/
        }
    };
}

var resizeTimer = null;
$(window).bind('resize', function () {
    if(window.location.pathname.indexOf('mex') == -1 || $(".grid-holder").css("visibility") === "hidden"){
        return;
    }
    
    resizegridOnWindowResize();
    if (this.resizeTO)
        clearTimeout(this.resizeTO);
    this.resizeTO = setTimeout(function () {
        $(this).trigger('resizeEnd');
    }, 500);
});


function resizeAll(mode) {
    if (mode == 1)
        resizegridOnWindowResize();
    if ($('.datagrid-footer').is(":visible") == false)
        setTimeout("reziseGridPanel(" + mode + ")", 100);
}


var clickedcellID = "";
var fchild = [];
window.gBasis, window.gVariant, window.gFocusSource, window.gSourceActual, window.gAdjust, window.gScenario, window.gRevision, window.highlightDp, window.highlightPeriod, window.fiscalEnd = "";
window.gSchedule, window.compositeEdit = false
var gSourceFuture = "";
var load_revision = "", period_revision = "", is_highlightdp = false, expand_consensus = false, is_revision_expanded = false;
var crdrevision = "", cva = "";
var tickerData = {}, sourcesExist = false;
var expandedColumn = [], baseParameterValues = [], dataInCommonsize = false, baseParamLineitems = [], emptyColumns = [], hideEmptyColumn = true;
var calendarYears = true;
var callCount = 0, rowDefaults = {}, getCommonSizeData = false, baseparamrows = [], baseFooterColumns = {};
var explicitRefresh = true, gridLoadedMEData = {}, basisMeta = "";
var expandAllFlag = false;
var gSchcptDefault = false;
var editScenarioMode = false, editVariantMode = false;
var paramsByUnitnames = {}, driverLines = [], highLevelDrivers = [];
var paramDisplayType = "";
var scenarioChanges = {}, defaultScenarioChanges = {}, customScenarioMode = false, customScenarioName = 'Custom';
var hideDisabled = true;
var ajaxCallCount = 0;
var notes = [], fiscal_period_dict = {}, period_fiscal_dict = {}, note_dict_peer = {};
var forecast_period_dict = {};
var expandAcrossTabs = [];
var expandAcrossRows = [];
var expandColumnOnNavigate = [];
var excl_sources = [], incl_sources = [], restrict_sources = [];
var firstEstimatedYear = "";
var high = false, low = false, high_low_src = "", surprise = '';
window.pinnedPanel;


function variationOrRevisionSliderMoved(event, obj) {
    obj = obj * -1;
    // var colorInfo = $(event.target).prop("color_info");
    var colorInfo = event.color_info;
    if (!colorInfo || typeof colorInfo !== 'string') {
        return;
    }
    var color = colorInfo.split('~')[0];
    var relChange = parseFloat(colorInfo.split('~')[1]);
    if (obj == 9) {
        relChange = relChange == 1 ? 0 : 2;
    }
    else {
        relChange = Math.pow(relChange, obj);
        relChange = 1 - Math.round(relChange * 10) / 10;
        relChange = obj == 1 ? relChange : (relChange * 1.5);
    }
    var bgColor = colorLuminance(color, relChange);
    // $(event.target).css({"background-color": bgColor});
    $(event).css({"background-color": bgColor});
}


function searchBarPlaceholder(panelsData){
    var placeholderText = company + " #" + cut + " ." + pg;
    var sourcePanel = $.grep(panelsData, function (n, i) {
        if (n.name == "Sources" && n.type == "filter") return i;
    });
    if (sourcePanel.length != 0)
        placeholderText = placeholderText + " !" + window.gSource.toUpperCase();
    $('#search').attr('placeholder', placeholderText);
    if (navigator.userAgent.indexOf("MSIE") != -1) {
        if ($('.placeholder').val() == undefined)
            $('#search').placeholder();
        else {
            $('#search').val("");
            $('#search').attr('placeholder', placeholderText);
            $('#search').placeholder();
        }
    }
}

function Load(pgData) {
    pgData = unescape(pgData);
    /* To remove unwanted qtip titles wich starts occuring repeatedly.*/
    if($('.qtip-active').length>0){
        $('.qtip-active').remove();
    }
	//heap_tracking(company, {'action':'Change_tab', 'Present_tab':pg, 'Changed_tab':pgData});
    showSarToNmvPanel = true;
    // change state of location bar
    var new_url = window.location.pathname + window.location.search;
    var stateObj = { foo: "bar" };
    var n_new_url = new_url.replace(pg, pgData);
    history.pushState(stateObj, "page 2", n_new_url);
    notes = [];
    abortAjaxCalls();
    explicitRefresh = false;
    clear_fbar();
    if(is_highlightdp){
        if(window.highlightPeriod.toLowerCase().indexOf('Qe') != -1){
            for(var period = 0 ; period < window.MEData.column_dimensions[0].values.length ; period++){
                if(window.window.MEData.column_dimensions[0].values[period].expanded){
                    window.window.MEData.column_dimensions[0].values[period].expanded = false;
                }
            }
            window.highlightPeriod = "";
        }
        load_revision = "";
    }
    firstEstimatedYear = "";
    expandColumnOnNavigate = window.MEData['imgObjIdList'] = [];
    if(cut == 'SAR'){
        hidePinnedPanels();
    }
    ////$('#tt').datagrid('clearSelections');
    expandAcrossTabs = [];
    if (window.gSchedule){
        var pivot_values = get_pivot_values(pg, pgData);
        if (pivot_values[pg] != pivot_values[pgData] || (pivot_values[pg] == false && pivot_values[pgData] == false)){
            location.reload();
            return;
        }
    }
    pg = pgData;
    dummyAjaxRequest(company, cut, 'EXPLORER_TAB_CHANGE', pg);
    if (window.gSchedule){
        window.gVariant=pgData;
        window.MEData.variant=window.gVariant;
    }
    window.MEData.tabs['default'] = pg;
    analytics_helper.add(ANALYTICS_EVENT_TYPES.PG_CHANGE,pg);
    //tabsAppend(window.MEData.tabs);
    var objME = new ModelExplorer();
    var objWebServiceCall = new WebServiceCall();
    // objWebServiceCall.getFavourites();
    if(window.gScenario == customScenarioName){
        objWebServiceCall.postScenarioChanges(false, true);
        return;
    }
    if ($('.datagrid-footer').is(":visible") == false)
        setTimeout(reziseGridPanel, 100);
    $('.tblInsSpan').html('');

}

/*
Function triggered from left panel
If the cut and the subheader is the same, it will do a tab level reload
Else a page redirect to the new cut/header level view
*/
function tablevelLoad(view, pg, header, url){
    if(view == window.MEData.view_code){
        //undefined check since NMV links don't have schheader attribute
        if(header == $('.right-panel-selected-tab').attr('schheader') || $('.right-panel-selected-tab').attr('schheader') == undefined) {
            if (url.indexOf('dpid') == -1){
                Load(pg);
            }
        }
    }
}

function get_pivot_values(old_pg, new_pg){
    var pivot_values = {};
    $.each(window.MEData.tabs.values, function(index, value){
        if(value.shortname == old_pg || value.shortname == new_pg){
            pivot_values[value.shortname] = value.pivot;
        }
    });
    return pivot_values
}


function escaping(urlObj) {
    if (typeof urlObj == 'string')
        return urlObj;
    var urlString = urlObj.mainUrl;
    for (urlItem in urlObj) {
        if (urlItem == 'mainUrl' || urlObj[urlItem] == undefined)
            continue;
        if (typeof urlObj[urlItem] == 'string' || typeof urlObj[urlItem] == 'boolean' || typeof urlObj[urlItem] == 'number')
            urlString += "&" + urlItem + "=" + encodeURIComponent(urlObj[urlItem]);
        else if($.isArray(urlObj[urlItem])){
            $.each(urlObj[urlItem], function (i, el) {
                urlString += "&" + urlItem + "=" + encodeURIComponent(el);
            });
        }
    }
    return urlString;
}

function GetUrl(URLData, objParameter) {
    var tickers = [];
    var Url = {"mainUrl": window.apiUrl + "/api/pg?"};
    if (objParameter.colType == 'scenario') {
        Url['scenario'] = [];
        $.each(FindExpansions('scenarios'), function (index, value) {
            Url['scenario'].push(value);
        });
    }
    if((window.cut == "STD" || window.cut === "NMV") && window.MEData.selectedCurrency != undefined && window.MEData.selectedCurrency != "Base"){
        Url['currency'] = window.MEData.selectedCurrency;
    }

    if (objParameter.colType == 'source') {
        Url['source'] = [];
        var sourceObj = $.grep(window.MEData.panels, function (n) {
            return (n.name.toLowerCase() == "sources");
        })[0];
        /*sourceValues = sourceObj[0][objParameter.data[$.inArray('source', colDimension)].replace('_cpt', '*')];
        $.each(FindExpansions('sources'), function (index, value) {
            if ($.inArray(value, sourceValues) > -1)
                Url['source'].push(value);
        });*/
        /*if ($.inArray('filings', objParameter.data) > -1){
            sourceValue = sourceObj[0][objParameter.data[$.inArray('source', colDimension)].replace('_cpt', '*')];
        } else {*/
        sourceValue = FindExpansions('sources', objParameter.data[0]);
        var indexNeeded = (colDimension.indexOf('source') !== - 1 ? colDimension.indexOf('source') : rowDimension.indexOf('source'))

        var updatedSourceValue = sourceValue.filter(function(val){
            return objParameter.data[indexNeeded].toLowerCase() !== val.toLowerCase();
        })
        Url['source'] = updatedSourceValue;
        if (Url['source'].length == 0)
            return "";

        //the below snippet
        //removes from sourcelist if sourcelist contains colm seperator
        //adds to the sourcelist gSourceActual if gSourceActual is not colm seperator
        var isForecast = whetherIsForecast(objParameter.data[0]);
        if(objParameter.data.length === 3 && !isForecast) { //length 3 => revisions applied and everything in column [period, revision, source]
            var sourceDimIdx = window.MEData.column_dimensions.findIndex(d => d.name.toLowerCase() === 'sources');
            var sourcePart = objParameter.data[sourceDimIdx]; //possible values => 'consensus', 'consensusplus', 'va actuals'

            //remove source if already in focus
            Url['source'] = Url['source'].filter(s => sourcePart !== replaceConsensusPlusOperator(s));

            //add actual focused source if displayed source(column sep) is different than focus_actual
            if (sourcePart !== replaceConsensusPlusOperator(window.gSourceActual)){
                //both focus and column seperator do not match. Add hist focus to sourcelist
                Url['source'].unshift(window.gSourceActual);
            }
        }

        
        if(sourceObj && (sourceObj.date_custom_consensus || sourceObj.relative_days)){
            if((typeof(Url.source) === 'string' && Url.source.toLowerCase() == 'custom') || ($.isArray(Url.source) && Url.source.indexOf("Custom") != -1)){

                var refdate = sourceObj.date_custom_consensus;
                if(!refdate) {
                    var reldays = sourceObj.relative_days;
                    var currDate = new Date();
                    currDate.setDate(currDate.getDate() - Number(reldays));
                    refdate = convertDateToString(currDate, "yyyymmdd");
                }

                Url['refdate'] = refdate;
                Url['logic_based_consensus'] = true;
                Url['earnings'] = sourceObj.inc_non_current_brokers;
            }
        }else{
            excl_sources = getExcludedBrokers();
            Url['excl_sources'] = excl_sources;
            incl_sources = getIncludedBrokers();
            Url['incl_sources'] = incl_sources;
            
            if(sourceObj){
                if((typeof(Url.source) === 'string' && Url.source.toLowerCase() == 'custom') || ($.isArray(Url.source) && Url.source.indexOf("Custom") != -1)){
                    if (sourceObj.sources_in_progress_excluded.length > 0 && sourceObj.selected_excl_cc_not_entitled == true) {
                        for (var i = 0; i < sourceObj.sources_in_progress_excluded.length; i++) {
                            Url['incl_sources'].push(sourceObj.sources_in_progress_excluded[i]);
                        }
                    }
                    else if (sourceObj.sources_in_progress_excluded.length > 0 && sourceObj.selected_excl_cc_not_entitled == false) {
                        for (var i = 0; i < sourceObj.sources_in_progress_excluded.length; i++) {
                            Url['excl_sources'].push(sourceObj.sources_in_progress_excluded[i]);
                        }
                    }

                    if (sourceObj.sources_in_progress_included.length > 0 && sourceObj.selected_cc_not_entitled == true) {
                        for (var i = 0; i < sourceObj.sources_in_progress_included.length; i++) {
                            Url['incl_sources'].push(sourceObj.sources_in_progress_included[i]);
                        }
                    }
                    else if (sourceObj.sources_in_progress_included.length > 0 && sourceObj.selected_cc_not_entitled == false) {
                        for (var i = 0; i < sourceObj.sources_in_progress_included.length; i++) {
                            Url['excl_sources'].push(sourceObj.sources_in_progress_included[i]);
                        }
                    }
                }   
            }
        }
    }
    else if (objParameter.colType == 'revision') {
        Url['revision'] = [];
        $.each(FindExpansions('revisions'), function (index, value) {
            Url['revision'].push(value);
        });
    }
    if (objParameter.qData.all) {
        if (objParameter.qData.all == "past") {
            tickers = objParameter.qData.past;
            source = window.gSourceActual;
        }
        else {
            tickers = objParameter.qData.future;
            source = gSourceFuture;
        }
    }
    else {
        if (objParameter.quarterType == "past") {
            tickers = objParameter.qData.past;
            source = window.gSourceActual;
        }
        else {
            tickers = objParameter.qData.future;
            source = gSourceFuture;
        }
    }
    if (!sourcesExist) {
        source = window.gSource;
        tickers = objParameter.qData.past.concat(objParameter.qData.future);
    }
    if (objParameter.source) {
        source = objParameter.source;
        tickers = objParameter.qData.past.concat(objParameter.qData.future);
    }
    if (objParameter.colType == 'source') {
        tickers = objParameter.qData.past.concat(objParameter.qData.future);
    }
    var urltype = (objParameter.colType == 'period') ? 'period' : "ticker";
    Url[urltype] = [];
    $.each(tickers, function (index, value) {
        Url[urltype].push(value);
    });
    var revisionPanelData = $.grep(window.MEData.panels, function (n) {
        return (n.name.toLowerCase() === 'revisions');
    })[0];
    $.each(URLData, function (index, value) {
        if (index == (URLData.length - 1)) {
            return;
        }
        if ((objParameter.colType == 'period') && (colDimension[index] == 'period')) {
        }
        else {
            if (!Url.hasOwnProperty(colDimension[index]))
                Url[colDimension[index]] = [];
            if (Url.hasOwnProperty(colDimension[index]) && typeof Url[colDimension[index]] != 'object')
                Url[colDimension[index]] = [Url[colDimension[index]]];
            if (colDimension[index] == "source")
                Url[colDimension[index]].push(source);
            else if( Url[colDimension[index]].length == 0)
                Url[colDimension[index]].push(value);

            var revisionList = $.extend(true ,[], Url['revision']);
            Url['revision'] = [];
            $.each(revisionList, function (index, value) {
                if (value.toLowerCase() !== 'preq') {
                    if(value.toLowerCase() === 'current') {
                        Url['revision'].push('Current');
                        return;
                    }
                    value = value.toUpperCase();
                    var actualPosition = revisionPanelData.values.indexOf(value);
                    var originalDate = new Date(revisionPanelData.revision_date_list[actualPosition]);
                    var formattedDate = $.datepicker.formatDate("mm-dd-yy", originalDate);
                    var concatRevValue = value + '|' + formattedDate;
                    Url['revision'].push(concatRevValue);
                }
                else {
                    Url['revision'].push('PreQ|PreQ');
                }
            })

            if(objParameter.hasOwnProperty("historicalRevDetails")){
                Url['revision'] = [];
                Url['revision'].push(objParameter.historicalRevDetails.revisionVal);
                source = objParameter.historicalRevDetails.sourceOfFocus;
            }
        }
    });
    Url = makeUrl(Url, source);
    /*if (rowDimension.length > 1) {
        $.each(rowDimension, function (index, value) {
            if (index > 0 && !(value == 'ticker')) {
                var rowExpansions = FindExpansions(value + 's');
                if (rowExpansions.length > 0) {
                    if (!Url.hasOwnProperty(rowDimension[index]))
                        Url[rowDimension[index]] = [];
                    if (Url.hasOwnProperty(rowDimension[index]) && typeof Url[rowDimension[index]] != 'object')
                        Url[rowDimension[index]] = [Url[rowDimension[index]]];
                    $.each(rowExpansions, function (i, el) {
                        Url[rowDimension[index]].push(el);
                    });
                }
            }
        });
    }*/
    return Url;
}

function getParamUrl(param_id, period, rowParameter, colParameter, expanded, objParameter) {
    //Pranav: Now periods is an array; Adding a for loop everywhere periods is being referrenced
    var Url = {"mainUrl": window.apiUrl + "/api/param3?"};
    if(typeof period === "string") {
        period = [period];
    }
    Url['period'] = [];
    var companies = [];
    var data = rowParameter.split("|");
    var coldata = colParameter.split("|");
    var rowType = expanded.substring(0, expanded.length - 1).toLowerCase();
    // To handle the constant column like links
    var rowDimensionWithOutLinks=$.grep(rowDimension, function (n) {
        return (n.toLowerCase() != "link");
    });
    if (!objParameter["quarterType"]) {
        for(var i = 0; i < period.length; i++) {
            var companies = [];
            var expandedDim = FindExpansions(expanded, period[i]);
            var noExpansions = (expandedDim != undefined && expandedDim.length == 0);
            if (expanded == 'tickers')
                companies = expandedDim;
            else if ($.inArray("ticker", rowDimensionWithOutLinks) > -1 && $.inArray("ticker", rowDimensionWithOutLinks) < $.inArray(rowType, rowDimensionWithOutLinks))
                companies.push(data[$.inArray("ticker", rowDimensionWithOutLinks)]);
            else if ($.inArray("ticker", colDimension) > -1 && coldata[$.inArray("ticker", colDimension)] != undefined)
                companies.push(coldata[$.inArray("ticker", colDimension)]);
            else
                companies.push(company);
            var qData = getCurrentQuarters(period[i], companies);
            objParameter.qData = qData;
            if ($.inArray("source", rowDimensionWithOutLinks) < (data.length - 1) && $.inArray("source", rowDimensionWithOutLinks) > -1) {
                //if(data[$.inArray("source",rowDimensionWithOutLinks)].toUpperCase() != window.gSourceActual.toUpperCase() && data[$.inArray("source",rowDimensionWithOutLinks)].toUpperCase() != gSourceFuture.toUpperCase())
                objParameter.source = data[$.inArray("source", rowDimensionWithOutLinks)];
            }
            // if (coldata[$.inArray("source", colDimension)] != undefined) {
            //     //if(coldata[$.inArray("source",colDimension)].toUpperCase() != window.gSourceActual.toUpperCase() && coldata[$.inArray("source",colDimension)].toUpperCase() != gSourceFuture.toUpperCase())
            //     objParameter.source = coldata[$.inArray("source", colDimension)];

            // }
            if (sourcesExist) {
                //commented this for VA Actuals story since sourcesExist is true now
                // if (qData.divide)
                // objParameter["quarterType"] = "past";
                objParameter.callParams = {
                    'param_id': param_id,
                    'period': period[i],
                    'rowParameter': rowParameter,
                    'colParameter': colParameter,
                    'expanded': expanded
                };
            }
            Url['period'].push(period[i]);
            if (noExpansions)
                return "";
        }
    }

    // url part
    var tickers = [];
    //var Url = {"mainUrl": "/api/param2?"};
    if (objParameter.expand && objParameter.expand !== 'period' &&  objParameter.expandedColData) {
        $.each(colDimension.slice(0, colDimension.length - 1), function (index, value) {
            Url[value] = objParameter.expandedColData[index];
        });
    }

    var revisionPanelData = $.grep(window.MEData.panels, function (n) {
        return (n.name.toLowerCase() === 'revisions');
    })[0];

    var sourcePanelObj = $.grep(window.MEData.panels, function (n) {
        return (n.name.toLowerCase() == 'sources');
    })[0];
    Url['param'] = [param_id];
    //Url['period'] = [period];
    Url['historical_focus'] = window.gSourceActual;
    Url['forecast_focus'] = window.gFocusSource;
    if((window.cut === "STD" || window.cut === "NMV") && window.MEData.selectedCurrency != undefined && window.MEData.selectedCurrency != "Base"){
        Url['currency'] = window.MEData.selectedCurrency;
    }
    if(objParameter.expand && objParameter.expand == 'source'){
        Url['source'] = [];
        objParameter.expand[0].toUpperCase();
        for(var i = 0; i < period.length; i++) {
            $.each(FindExpansions(objParameter.expand + 's', period[i]), function (index, value) {
                if(!Url['source'].includes(value)) {
                    Url['source'].push(value);
                }
            });
        }
    } else if(objParameter.expand && objParameter.expand == 'revision'){
        Url['revision'] = [];
        if(objParameter.revisionList){
            Url['revision'] = objParameter.revisionList.slice();
        } else {
            objParameter.expand[0].toUpperCase();
            $.each(FindExpansions(objParameter.expand + 's'), function (index, value) {
                Url['revision'].push(value);
            });
        }
    }
    if (rowType == 'source') {
        Url['source'] = [];
        for(var i = 0; i < period.length; i++) {
            $.each(FindExpansions(expanded, period[i]), function (index, value) {
                if(!Url['source'].includes(value)) {
                    Url['source'].push(value);
                }
            });
        }

    } else if (rowType == 'revision') {
        Url['revision'] = [];
        $.each(FindExpansions(expanded), function (index, value) {
            Url['revision'].push(value);
        });
    } else if (rowType == 'scenario') {
        Url['scenario'] = [];
        $.each(FindExpansions(expanded), function (index, value) {
            Url['scenario'].push(value);
        });
    } else if (rowType == 'growthtype') {
        Url['growthType'] = [];
        var rowdimensionData = $.grep(window.MEData.row_dimensions, function (n) {
            return (n.name == GROWTHTYPES);
        });

        if (rowdimensionData.length > 0) {
            $.each(rowdimensionData[0].expansions, function (index, value) {
                if(value == "%"){
                    var rowObj = window.MEData.row_dimensions.filter(function(dim){
                        return dim.name == "lineitems"
                    })[0].values.filter(function(row){
                        return (row.dapparameterid == param_id || row.id == param_id)
                    })[0];

                    if(rowObj.magnitude == window.MEData.baseparameter.magnitude && rowObj.unit == window.MEData.baseparameter.unit){
                        Url['growthType'].push(value);
                    }
                }else{
                    Url['growthType'].push(value);
                }

                if (value === TREND) {
                    Url['trendYear'] = rowdimensionData[0].trendYear;
                }
            });
        }

        if(Url.growthType.indexOf("%") > -1 && window.MEData.baseparameter.id){
            // added base lineitem id for % conversion.
            Url['baseparam'] = window.MEData.baseparameter.id;
        }
    }


    if (objParameter.qData.all) {
        if (objParameter.qData.all == "past") {
            tickers = objParameter.qData.past;
            source = window.gSourceActual;
            //if (source != 'VA Actuals' && source != 'Filings' && !checkIfFoucsConseusHasData(period, company)) {
            if (source != 'VA Actuals' && source != 'Filings' && !checkIfFoucsConseusHasData(period[0], company)) {
                source = 'Filings'
            }
        }
        else {
            tickers = objParameter.qData.future;
            source = gSourceFuture;
        }
    }
    else {
        if (objParameter.quarterType == "past") {
            tickers = objParameter.qData.past;
            source = window.gSourceActual;
            //if (source != 'VA Actuals' && source != 'Filings' && !checkIfFoucsConseusHasData(period, company)) {
            if (source != 'VA Actuals' && source != 'Filings' && !checkIfFoucsConseusHasData(period[0], company)) {
                source = 'Filings'
            }
        }
        else {
            tickers = objParameter.qData.future;
            source = gSourceFuture;
        }
    }
    if (!sourcesExist) {
        source = window.gSource;
        tickers = objParameter.qData.past.concat(objParameter.qData.future);
    }
    if (objParameter.source) {
        source = objParameter.source;
        tickers = objParameter.qData.past.concat(objParameter.qData.future);
    }

    //Uncoupling the custom related workflow since there are multi level expansions in rows and can't be handled in only rowType=source
    if((objParameter.source != undefined && objParameter.source.toLowerCase() == 'custom') ||
        (source && source.toLowerCase().includes("custom")) ||
        (Url["source"] !== undefined && (Url["source"].indexOf("Custom") > -1 || Url["source"].indexOf("custom") > -1))){
        // Added the main OR condition since if revisions were expanded in row and then we expand sources column which
        // contained Custom (not in focus), we have to send the incl-excl sources to  it
        for(var i = 0; i < period.length; i++) {
            $.each(FindExpansions(expanded, period[i]), function (index, value) {
                if(sourcePanelObj && !sourcePanelObj.date_custom_consensus && !sourcePanelObj.relative_days){
                    excl_sources = getExcludedBrokers();
                    Url['excl_sources'] = excl_sources;
                    incl_sources = getIncludedBrokers();
                    Url['incl_sources'] = incl_sources;

                    if (sourcePanelObj.sources_in_progress_excluded.length > 0 && sourcePanelObj.selected_excl_cc_not_entitled == true) {
                        for (var i = 0; i < sourcePanelObj.sources_in_progress_excluded.length; i++) {
                            Url['incl_sources'].push(sourcePanelObj.sources_in_progress_excluded[i]);
                        }
                    }
                    else if (sourcePanelObj.sources_in_progress_excluded.length > 0 && sourcePanelObj.selected_excl_cc_not_entitled == false) {
                        for (var i = 0; i < sourcePanelObj.sources_in_progress_excluded.length; i++) {
                            Url['excl_sources'].push(sourcePanelObj.sources_in_progress_excluded[i]);
                        }
                    }

                    if (sourcePanelObj.sources_in_progress_included.length > 0 && sourcePanelObj.selected_cc_not_entitled == true) {
                        for (var i = 0; i < sourcePanelObj.sources_in_progress_included.length; i++) {
                            Url['incl_sources'].push(sourcePanelObj.sources_in_progress_included[i]);
                        }
                    }
                    else if (sourcePanelObj.sources_in_progress_included.length > 0 && sourcePanelObj.selected_cc_not_entitled == false) {
                        for (var i = 0; i < sourcePanelObj.sources_in_progress_included.length; i++) {
                            Url['excl_sources'].push(sourcePanelObj.sources_in_progress_included[i]);
                        }
                    }
                }
            });
        }
    }

    
    Url['ticker'] = [];
    if(objParameter.expand == 'ticker' || (objParameter.ticker && objParameter.ticker.length != 0) ) {
        Url['ticker'] = [objParameter.ticker];
    } else {
        $.each(tickers, function (index, value) {
            Url['ticker'].push(value);
        });
    }

    $.each(data, function (index, value) {
        if (index == (data.length - 1) || index == 0) {
        }
        else {
            if (!Url.hasOwnProperty(rowDimensionWithOutLinks[index]))
                Url[rowDimensionWithOutLinks[index]] = [];
            if (Url.hasOwnProperty(rowDimensionWithOutLinks[index]) && typeof Url[rowDimensionWithOutLinks[index]] != 'object')
                Url[rowDimensionWithOutLinks[index]] = [Url[rowDimensionWithOutLinks[index]]];
            if (rowDimensionWithOutLinks[index] == "source")
                Url[rowDimensionWithOutLinks[index]].push(source);
            else
                Url[rowDimensionWithOutLinks[index]].push(value);
        }
    });
    $.each(coldata, function (index, value) {            
        if (colDimension[index] && !Url.hasOwnProperty(colDimension[index]))
            Url[colDimension[index]] = [];
        if (Url.hasOwnProperty(colDimension[index]) && typeof Url[colDimension[index]] != 'object')
            Url[colDimension[index]] = [Url[colDimension[index]]];
        if (colDimension[index] == "source")
            Url[colDimension[index]].push(source);
        else if (colDimension[index] && Url[colDimension[index]].length == 0 && value != "")
            Url[colDimension[index]].push(value);

        // CACHE-909 : while applying multiple historicalestimates along with all analytics revision is sent as string instead of list
        Url['revision'] = Url['revision'] !== undefined && typeof(Url['revision']) === 'string' ? [Url['revision']] : Url['revision'];
        var revisionList = $.extend(true ,[], Url['revision']);
        Url['revision'] = [];
        $.each(revisionList, function (index, value) {
            if (value.toLowerCase() !== 'preq') {
                //Adding this check since Current is capitalized differently in different cases
                if(value.toLowerCase() === 'current') {
                    Url['revision'].push('Current');
                    return;
                }
                //Adding this check to prevent already piped values to pass through the process again
                if(value.indexOf('|') > -1){
                    Url['revision'].push(value);
                    return;
                }
                value = value.toUpperCase();
                var actualPosition = revisionPanelData.values.indexOf(value);
                var originalDate = new Date(revisionPanelData.revision_date_list[actualPosition]);
                var formattedDate = $.datepicker.formatDate("mm-dd-yy", originalDate);
                var concatRevValue = value + '|' + formattedDate;
                Url['revision'].push(concatRevValue);
            }
            //check to skip preq as already called
            else if(!objParameter.skipPreq || value.toLowerCase() === "preq") {
                Url['revision'].push('PreQ|PreQ');
            }
        })
    });
    Url = makeUrl(Url, source);
    /*todo: add function to check whether base parameter value is present of not in baseParameterValues
     and then add the baseparameterid in the request */
    if ((param_id != window.MEData.baseparameter.id) && (!(window.MEData.baseparameter.notAvail)) && Url.growthType == "Analytics"){
        Url['param'].unshift(window.MEData.baseparameter.id);
    }
    return {'objParameter': objParameter, 'Url': Url};
}

function setURLObj(Url,source) {
    Url['pg'] = window.pg;
    Url['cut'] = window.cut;

    if (!Url.ticker) {
        Url['ticker'] = window.company;
    }

    if (source != '' && (!Url.hasOwnProperty("source") || (Url.hasOwnProperty('source') && Url['source'].length == 0))) {
        Url['source'] = source;
    }
    return Url
}
function makeUrl(url, source, notSetCut) {
    var Url = url;
    if (Url == "")
        Url = {};
    var fySource = source;
   /* if ((!Url.hasOwnProperty("pg") || ( Url.hasOwnProperty('pg') && Url['pg'].length == 0) ) && pg)
        Url['pg'] = pg;
    if ((!Url.hasOwnProperty("cut") || ( Url.hasOwnProperty('cut') && Url['cut'].length == 0) ) && cut)
        Url['cut'] = cut;
    if ((!Url.hasOwnProperty("source") || ( Url.hasOwnProperty('source') && Url['source'].length == 0) ) && fySource)
        Url['source'] = fySource;
    if ((!Url.hasOwnProperty("ticker") || ( Url.hasOwnProperty('ticker') && Url['ticker'].length == 0) ) && company)
        Url['ticker'] = company;
*/

    if(!notSetCut)
        Url = setURLObj(Url,source);

    if ((!Url.hasOwnProperty("growthType") || (Url.hasOwnProperty('growthType')
        && Url['growthType'].length == 0) ) && window.gGrowthTypeValues) {
        Url['growthType'] = window.gGrowthTypeValues;

    }
    if((!Url.hasOwnProperty('pinnedPanel')) || (Url.hasOwnProperty('pinnedPanel') && Url['pinnedPanel'].length == 0) && window.pinnedPanel){
        Url['pinnedPanel'] = window.pinnedPanel;
    }
    // if Revision variation is to be calculated then set that as crdrevision, add revision to list of revisions to be fetched. and set crd as true.
    if (cut && cut.toLowerCase() !== 'sar' && (!Url.hasOwnProperty("crdrevision") || ( Url.hasOwnProperty('crdrevision') && Url['crdrevision'].length == 0) ) && crdrevision != "") {
        Url['crdrevision'] = crdrevision;
    }
    if (Url.hasOwnProperty('crdrevision') && Url['crdrevision'].length > 0) {
        Url['crd'] = true;
    }
    if (cut && cut.toLowerCase() !== 'sar' && (!Url.hasOwnProperty("cva") || ( Url.hasOwnProperty('cva') && Url['cva'].length == 0) ) && cva != "") {
        Url['cva'] = cva;
    }

    //url parameters for high / low visiualization
    if ( cut && cut.toLowerCase() !== 'sar'){
        if ((!Url.hasOwnProperty("high") || (Url.hasOwnProperty('high') && Url['high'].length == 0)) && high) {
            Url['high'] = high;
        }
        if ((!Url.hasOwnProperty("low") || (Url.hasOwnProperty('low') && Url['low'].length == 0)) && low) {
            Url['low'] = low;
        }
        if ((!Url.hasOwnProperty("high_low_src") || (Url.hasOwnProperty('high_low_src') && Url['high_low_src'].length == 0)) && high_low_src != "") {
            Url['high_low_src'] = high_low_src;
        }
    }

    //url parameters for surprise visiualization
    if (cut !== 'SAR' && (!Url.hasOwnProperty("surprise") || (Url.hasOwnProperty('surprise') && Url['surprise'].length == 0)) && surprise != '') {
        Url['surprise'] = surprise;
    }

    if ((!Url.hasOwnProperty("revision") || ( Url.hasOwnProperty('revision') && Url['revision'].length == 0) ) && window.gRevision)
        Url['revision'] = window.gRevision;
    if ((!Url.hasOwnProperty("basis") || ( Url.hasOwnProperty('basis') && Url['basis'].length == 0) ) && window.gBasis)
        Url['basis'] = window.gBasis;
    if ((!Url.hasOwnProperty("depth") || ( Url.hasOwnProperty('depth') && Url['depth'].length == 0) ) && window.gAdjust)
        Url['depth'] = window.gAdjust;
    if ((!Url.hasOwnProperty("variant") || ( Url.hasOwnProperty('variant') && Url['variant'].length == 0) ) && window.gVariant)
        Url['variant'] = window.gVariant;
    if ((!Url.hasOwnProperty("scenario") || ( Url.hasOwnProperty('scenario') && Url['scenario'].length == 0) ) && window.gScenario)
        Url['scenario'] = window.gScenario;
    if ((!Url.hasOwnProperty("dpid") || ( Url.hasOwnProperty('dpid') && Url['dpid'].length == 0) ) && window.highlightDp)
        Url['dpid'] = window.highlightDp;
    if ((!Url.hasOwnProperty("period") || ( Url.hasOwnProperty('period') && Url['period'].length == 0) ) && window.highlightPeriod)
        Url['period'] = window.highlightPeriod;
    if ((!Url.hasOwnProperty("load_revision") || ( Url.hasOwnProperty('load_revision') && Url['load_revision'].length == 0) ) && load_revision)
        Url['load_revision'] = load_revision;
    if ((!Url.hasOwnProperty("period_revision") || ( Url.hasOwnProperty('period_revision') && Url['period_revision'].length == 0) ) && period_revision)
        Url['period_revision'] = period_revision;
    if ((!Url.hasOwnProperty("expand_consensus") || ( Url.hasOwnProperty('expand_consensus') && Url['expand_consensus'].length == 0) ) && expand_consensus)
        Url['expand_consensus'] = expand_consensus;
    var sourcePanelObj = window.MEData.panels.filter( function (n) {
        return (n.name.toLowerCase() == 'sources');
    })[0];
    
    if(sourcePanelObj){
        if(!sourcePanelObj.date_custom_consensus && !sourcePanelObj.relative_days){
            if (((typeof(Url.source) === 'string' && Url.source.toLowerCase() == 'custom') || (typeof(Url.source) === 'array' && Url.source[0].toLowerCase() == 'custom')) && (!Url.hasOwnProperty("excl_sources") || ( Url.hasOwnProperty('excl_sources') && Url['excl_sources'].length == 0) ) && excl_sources)
            Url['excl_sources'] = excl_sources;
            if (((typeof(Url.source) === 'string' && Url.source.toLowerCase() == 'custom') || (typeof(Url.source) === 'array' && Url.source[0].toLowerCase() == 'custom')) && (!Url.hasOwnProperty("incl_sources") || ( Url.hasOwnProperty('incl_sources') && Url['excl_sources'].length == 0) ) && incl_sources)
                Url['incl_sources'] = incl_sources;
            if (sourcePanelObj.excl_reaffirm_broker_consensus !== false && sourcePanelObj.excl_reaffirm_broker_consensus !== "") // If excl_reaffirm_broker_consensus === true
                Url['excl_reaffirm_broker_consensus'] = true;
        }else{
            //make this change for param 3 in footter
            if((typeof(Url.source) === 'string' && Url.source.toLowerCase() == 'custom') || (Url.forecast_focus && Url.forecast_focus.toLowerCase() === "custom") || ($.isArray(Url.source) && !$.isArray(Url.source[0]) && Url.source.map(function(s){ return s.toLowerCase()}).indexOf("custom") !== -1)){
                

                var refdate = sourcePanelObj.date_custom_consensus;
                if(!refdate) {
                    var reldays = sourcePanelObj.relative_days;
                    var currDate = new Date();
                    currDate.setDate(currDate.getDate() - Number(reldays));
                    refdate = convertDateToString(currDate, "yyyymmdd");
                }
                
                Url['refdate'] = refdate;
                Url['logic_based_consensus'] = true;
                Url['earnings'] = sourcePanelObj.inc_non_current_brokers;
            }
        }
    }
    
    return Url;
}

function abortAjaxCalls() {
    for (var i = 1; i <= ajaxCount; i++) {
        ajaxCalls['ajax' + i].abort();
    }
    abortInspctorCalls();
    // abortFormulaCalls(); TODO: removed this for now as formulabar.js is not side loaded
    //will see if required in future
    ajaxCount = 0;
    ajaxCalls = {};
}


var lines = null;
var LineItem;

function requestViewMail(ticker, source, cut) {
    var ObjW = new WebServiceCall();
    var csrftoken = getCookie('csrftoken');
    data = "company=" + ticker + "&source=" + source + "&cut=" + cut;
    ObjW.sendUserRequest(data, csrftoken);
}

function scrollDiv(columnCount, headercellPosition) {
    if (headercellPosition > 4) {
        if (columnCount > 5) columnCount = 4;
        var scrollwidth = 90 * columnCount;
        var scL = $('div.datagrid-body').eq(1)[0].scrollLeft;
        $('div.datagrid-body').eq(1).scrollLeft(scrollwidth + scL);
    }
}


function loadUncachedScheduleData(){
    var Url = '/api/loadUncachedScheduleContext' + "?ticker=" + window.MEData.column_dimensions[$.inArray('ticker', colDimension)].expansions[0];
    $.each(window.MEData.column_dimensions[$.inArray('ticker', colDimension)].expansions, function(index, value){
        if(index != 0){
            Url += "&ticker=" + value;
        }
    });
    $.ajax({
        type: "GET",
        async: true,
        url: Url,
        contentType: "application/json; charset=utf-8",
        dataType: dataType,
        success: function (msg) {
            if(msg.status != 'success'){
                console.error(msg.message)
            }
        },
        error: function (msg) {
            console.error(msg.responseText);
        }
    });
}

function makeFiscalyearPeriodDict(msg){
	$.each(msg.data, function(index, value){
        if (value.period != undefined && value.fiscalyear != undefined) {
            fiscal_period_dict[value.period] = value.fiscalyear;
            period_fiscal_dict[value.fiscalyear.toLowerCase()] = value.period.toLowerCase();
            //maintain forecast_period_dict so that forecast value is available and used from one place itself
            forecast_period_dict[value.period.toLowerCase()] = value.forecast;
        }
    });
}
function current_date(){
    var decoded_date
    var currentdate = new Date()
    var date_time = currentdate.getUTCFullYear() + "-" + (currentdate.getMonth()+1) + "-" + currentdate.getUTCDate() +
        ' ' + currentdate.getUTCHours() + ':' + currentdate.getUTCMinutes() + ":"
                + currentdate.getUTCSeconds();
    decoded_date = decodeURIComponent(date_time)
    return decoded_date
}


function get_parsed_date(unparsed_date){
 //added because giving problem in IE parse simple parse function returns NAN
    // changed beacuse of one weired behaviour it returns constant 1451606400000 value for some tickers so after
    // deactivating notes are still showing on clientapp
    var replaced_date = unparsed_date.replace(new RegExp('-', 'g'), '/')
    parsed_date = Date.parse(replaced_date);
    return parsed_date
}

function getExpandedRowData(objParameter) {
    var ObjWebServiceCall = new WebServiceCall();
    $.each(expandedRowList, function(index, value){
        var parts = value.rowParameter.split('&&');
        var sortorder = parts[1];
        parts = parts[0].split('|');
        var cellNo = window.MEData.row_dimensions.length;
        $.each(window.MEData.row_dimensions, function(ind, val){
            if($.inArray(value.rowType, rowDimension) > ind){
                cellNo--;
            }
        });
        value.expanded[0].toUpperCase();
        var start = $(value.objImg).closest('tr').index() + 1;
        var end = $(value.objImg).closest('tr').index() + GetRowLength(null, null, value.rowType) - 1;
        if(objParameter.colType == 'period'){
            var expansionArray = objParameter.qData.future.length > 0 ? objParameter.qData.future : [];
            if(objParameter.qData.past.length > 0){
                expansionArray = expansionArray.concat(objParameter.qData.past);
            }

            for(var i = 0; i < expansionArray.length; i++){
                dataExpandField.push(value.rowParameter + "-" + expansionArray[i]);
            }

            $.each(expansionArray, function(ind, val) {
                ObjWebServiceCall.getparameterData(parts[0], [val], value.rowParameter, '', value.expanded,
                {
                    "sortorder": sortorder,
                    "paramid": parts[0],
                    "start": start,
                    "end": end,
                    "cellNo": cellNo,
                    "RowObjectName": parts[0]
                });
            });
        } else if(objParameter.colType == 'source'){
            if($.inArray('ticker', colDimension) != -1) {
                ObjWebServiceCall.getparameterData(parts[0], objParameter.data[0], value.rowParameter, '', value.expanded,
                    {
                        "sortorder": sortorder,
                        "paramid": parts[0],
                        "start": start,
                        "end": end,
                        "cellNo": cellNo,
                        "RowObjectName": parts[0],
                        "expand": objParameter.colType,
                        "expandedColData": objParameter.data
                    });
                dataExpandField.push(value.rowParameter + "-" + objParameter.data[0]);
            } else {
                ObjWebServiceCall.getparameterData(parts[0], objParameter.data[0], value.rowParameter, '', value.expanded,
                    {
                        "sortorder": sortorder,
                        "paramid": parts[0],
                        "start": start,
                        "end": end,
                        "cellNo": cellNo,
                        "RowObjectName": parts[0],
                        "expand": objParameter.colType,
                        "ticker": objParameter.qData.future,
                        "expandedColData": objParameter.data
                    });
                dataExpandField.push(value.rowParameter + "-" + objParameter.data[0]);
            }
        } else if (objParameter.colType == 'revision') {
            //check if historical period, and call for param accordingly
            if($.inArray('ticker', colDimension) == -1) {
                var sendTicker =  objParameter.qData.future;
            }
            var objColParam = {
                "sortorder": sortorder,
                "paramid": parts[0],
                "start": start,
                "end": end,
                "cellNo": cellNo,
                "RowObjectName": parts[0],
                "expand": objParameter.colType,
                "expandedColData": objParameter.data,
                "skipPreq": true
            }
            if(sendTicker){
                objColParam.ticker = sendTicker;
            }
            var periodsObj = getPeriodQuarters('fy-'+objParameter.data[0].split('-')[1]);
            if(periodsObj.past.includes(objParameter.data[0].toUpperCase()) || periodsObj.all === 'past') {
                // check source and send param call accordingly
                var dataObj = {
                    paramid: parts[0],
                    period:objParameter.data[0],
                    parameter: value.rowParameter,
                    rowObjName: value.expanded,
                    key:"",
                    objColParameter:objColParam
                }

                checkHistoricalSourceForRevision(dataObj, ObjWebServiceCall);
            } else {
                ObjWebServiceCall.getparameterData(parts[0], objParameter.data[0], value.rowParameter, '', value.expanded,
                objColParam);
            }


            dataExpandField.push(value.rowParameter + "-" + objParameter.data[0]);
            
        }
        if(objParameter.colType == 'ticker'){
            var expansionArray = objParameter.qData.future.length > 0 ? objParameter.qData.future : objParameter.qData.past;
            $.each(expansionArray, function(ind, val) {
                ObjWebServiceCall.getparameterData(parts[0], objParameter.data[0], value.rowParameter, '', value.expanded,
                    {
                        "sortorder": sortorder,
                        "paramid": parts[0],
                        "start": start,
                        "end": end,
                        "cellNo": cellNo,
                        "RowObjectName": parts[0],
                        "expand": objParameter.colType,
                        "ticker": val,
                        "expandedColData": objParameter.data
                    });
                dataExpandField.push(value.rowParameter + "-" + objParameter.data[0]);
            });
        }
    });
}

function defaultPeriodExpansions(periodObj){
       const rootName = periodObj.parameter;
       const qData = getPeriodQuarters(periodObj.parameter);
       const parameterList = {
        "rootName": rootName,
        "data": [
            periodObj.parameter
        ],
        "headercellObj": [],
        "colType": 'period',
        "qData": qData
        };
        const sourceOrder = ['Consensus'];
        OnSuccessOfExpandColumn(periodObj.data, parameterList, {}, sourceOrder);
        var objSelectedColTd = $("[id='" + getJQId(periodObj['objimgCtrl']) + "']").closest('td').find("img[src*='datagrid_row_']")[0];
        objSelectedColTd.src = objSelectedColTd.src.replace('expand', 'collapse');
        dataExpandField.push( periodObj.parameter);
        const currentIndex = MEData.column_dimensions[0].values.findIndex((val)=>{return val.period.toLowerCase() === periodObj.parameter});
        const prevParameter =  MEData.column_dimensions[0].values[currentIndex -1] ?  MEData.column_dimensions[0].values[currentIndex -1].period : ''
        doDataGirdStyling(periodObj.parameter, prevParameter, "expend", 'period');
        $(".datagrid-cell-group").removeAttr("style");
}

// 
//Columns Expand Functionality
var dynamicGeneratedField = [];

function ExpandColumnProcess(event, colType, parameter, objimgCtrl, prevParameter) {
    textExpandedType = '';
    textExpandedValue = '';
    textExpandedType = colType;
    textExpandedValue = parameter;
    globalTimer = clearInterval(globalTimer);
    var firstExpandedColumn = "";
    var objME = new ModelExplorer();
    var table = $('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr');
    var data = parameter.split('|');
    var financialYear = data[$.inArray("period", colDimension)];
    var colfield = "", headercellObj = [], parentValue = "";
    var objSelectedColTd = $(objimgCtrl).find("img[src*='datagrid_row_']")[0]; //Searching for any image with the expand or collapse source
    var rootName = data.join().replace(/,/g, '');

    debouncedBlock(true)
    // if (objImg.src.indexOf('expand') > -1) {
    //         objImg.src = objImg.src.replace('expand', 'collapse');

    $.each(data, function (indexdata, valuedata) {
        colfield = colfield + valuedata;
        if (indexdata != $.inArray(colType, colDimension))
            headercellObj.push(table.eq(indexdata).find("td[field='" + colfield + "']"));
        if (indexdata < $.inArray(colType, colDimension))
            parentValue = parentValue + valuedata;
    });


    if ($.inArray(colfield, dataExpandField) == -1) {
        var expObj = {'colType': colType, 'parameter': parameter, 'objimgCtrl': objSelectedColTd.id};
        var existIdx = $.map(expandAcrossTabs, function(obj, index) {
            if(obj.parameter == expObj.parameter) {
                return index;
            }

        });
        // add only if the column is not there in the expandAcrossTabs list.
        if(existIdx.length == 0) {
            expandAcrossTabs.push(expObj);
            saveExtraPanelSetting();
        }

        //dummyAjaxRequest(company, cut, 'EXPLORER_COLUMN_EXPAND_SINGLE', colfield);

        analytics_helper.add(ANALYTICS_EVENT_TYPES.COLUMN_EXPAND.SINGLE, colfield);
        var ObjWebServiceCall = new WebServiceCall();
        var serviceResponse;
        var companys = [];
        if (FindExpansions(colType + "s", financialYear).length == 0)
            var Expansions = false;
        else
            var Expansions = true;
        if (colType == 'ticker')
            companys = FindExpansions(colType + "s", financialYear);
        else if ($.inArray("ticker", colDimension) > -1 && $.inArray("ticker", colDimension) < $.inArray(colType, colDimension))
            companys.push(data[$.inArray("ticker", colDimension)]);
        else
            companys.push(company.toUpperCase());
        if ($.inArray("ticker", rowDimension) > -1 && colType != 'period') {
            var Companys = FindExpansions("tickers", financialYear);
            companys = Companys.concat([company]);
        }
        if (colType != 'period')
            var qData = getCurrentQuarters(data[0], companys);
        else
            var qData = getPeriodQuarters(data[0], companys[0]);


        var parameterList = {
            "rootName": rootName,
            "data": data,
            "headercellObj": headercellObj,
            "colType": colType,
            "qData": qData
        };

        if ($.inArray("source", colDimension) < data.length && $.inArray("source", colDimension) > -1) {
            if (data[$.inArray("source", colDimension)].toUpperCase() != window.gSourceActual.toUpperCase()
                && data[$.inArray("source", colDimension)].toUpperCase() != gSourceFuture.toUpperCase())
                parameterList.source = data[$.inArray("source", colDimension)];
        }
        /* commented because multiple pg calls was triggering in case of 'revisions' when historical estimates was applied
         * based on discussion with sharvari.kapdi */
        // if (sourcesExist && colType != 'source') {
        //     if (qData.divide)
        //         parameterList["quarterType"] = "past";
        // }
        if (Expansions) {
            var revDateList = [];
            event.data = window.keyboard_event;

            $.each(FindExpansions('revisions'), function (index, value) {
                revDateList.push(value);
            });

            var revisionPanelData = $.grep(window.MEData.panels, function (n) {
                return (n.name.toLowerCase() === 'revisions');
            })[0];

            if (parameterList.qData.past && parameterList.qData.past.length > 0
                && parameterList.qData.future && parameterList.qData.future.length > 0) {
                //set flag to wait for 2nd call response and reset global object
                hasSecondPgCall = true;
                currentYrPg = {};
                parameterList.qData.all = 'past';
                ObjWebServiceCall.getPgData(data, parameterList, event, true);
            } else if (parameterList.qData.past && parameterList.qData.past.length > 0) {
                parameterList.qData.all = 'past';
                //Put the logic for RD>FD here
                if(colType === 'revision') {
                    for (var i = 0; i < revDateList.length; i++) {
                        //parameterList["historicalRevDetails"] = {};
                        delete parameterList["historicalRevDetails"];
                        var revisionDateToApply = revDateList[i];
                        var periodsFilingDate = new Date(filingsPerPeriodDict[financialYear.toUpperCase()]);
                        if(!isNaN(periodsFilingDate)) {
                            var actualPosition = revisionPanelData.values.indexOf(revisionDateToApply);
                            var originalRevisionDate = new Date(revisionPanelData.revision_date_list[actualPosition]);
                            var formattedDate = $.datepicker.formatDate("mm-dd-yy", originalRevisionDate);
                        }
                        if (revDateList[i].toLowerCase() !== 'preq' && revDateList[i].toLowerCase() !== 'current') {
                            if (!isNaN(periodsFilingDate) && originalRevisionDate > periodsFilingDate) {
                                parameterList["historicalRevDetails"] = {
                                    "revisionVal": revisionDateToApply + "|" + formattedDate,
                                    "sourceOfFocus": cut && cut.toLowerCase() == 'sar' ? window.gSource : "VA Actuals"
                                }
                                //source=VA Actuals
                                //ObjWebServiceCall.getPgData(data, parameterList, event);
                            }
                            else {
                                var sourceOfFocus = window.isConsensusPlusUser ? "Consensus+" : "Consensus";
                                parameterList["historicalRevDetails"] = {
                                    "revisionVal": revisionDateToApply + "|" + formattedDate,
                                    "sourceOfFocus": cut && cut.toLowerCase() == 'sar' ? window.gSource : sourceOfFocus
                                }
                                //source=Consensus
                                //ObjWebServiceCall.getPgData(data, parameterList, event);
                            }
                        }
                        else if (revDateList[i].toLowerCase() === 'preq') {
                            var sourceOfFocus = window.isConsensusPlusUser ? "Consensus+" : "Consensus";
                            parameterList["historicalRevDetails"] = {
                                "revisionVal": "PreQ|PreQ",
                                "sourceOfFocus": cut && cut.toLowerCase() == 'sar' ? window.gSource : sourceOfFocus
                            }
                        }
                        ObjWebServiceCall.getPgData(data, parameterList, event, true);
                    }
                }
                else{
                    ObjWebServiceCall.getPgData(data, parameterList, event, true);
                }

            } else {
                parameterList.qData.all = 'future';
                ObjWebServiceCall.getPgData(data, parameterList, event, true);
            }

        } else{
            debouncedBlock(false)
        }

        objSelectedColTd.src = objSelectedColTd.src.replace('expand', 'collapse');
        dataExpandField.push(colfield);

        doDataGirdStyling(parameter, prevParameter, "expend", colType);
        $(".datagrid-cell-group").removeAttr("style");
        //        GetLineItemsColsrelatedData();
        // console.log("individual_col_expanded : "+individual_col_expanded);
    }
    else {

        var colIndex = colDimension.length - 1;
        var table = $('#tt').datagrid("getPanel").find('table').eq(2 + 1);
        var filteredCells = [];
        var expandeddata = [];

        if (objSelectedColTd.src.indexOf('collapse') > -1) {
            //dummyAjaxRequest(company, cut, 'EXPLORER_COLUMN_COLLAPSE_SINGLE', colfield);
            GetExpandedData(expandeddata, rootName);
            var cpyexpandAcrossTabs = [];
            $(expandAcrossTabs).each(function (index, value) {
                if(value['parameter'] != parameter) {
                    cpyexpandAcrossTabs.push(value);
                }
            });
            expandAcrossTabs = cpyexpandAcrossTabs;
            saveExtraPanelSetting();
        } else {
            //dummyAjaxRequest(company, cut, 'EXPLORER_COLUMN_EXPAND_SINGLE', colfield);
            expandeddata = $.grep(dynamicGeneratedField, function (n) {
                return (n.RootName == rootName);
            });
            var expObj = {'colType': colType, 'parameter': parameter, 'objimgCtrl': objSelectedColTd.id};
            var existIdx = $.map(expandAcrossTabs, function(obj, index) {
                if(obj.parameter == expObj.parameter) {
                    return index;
                }
            })
            // add only if the column is not there in the expandAcrossTabs list.
            if(existIdx.length == 0) {
                expandAcrossTabs.push(expObj);
                saveExtraPanelSetting();
            }
        }
        var tablerow = $('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr').eq(colIndex);
        $(expandeddata).each(function (index, value) {
            if (tablerow.find("td[field='" + value.Field + "']").length > 0)
                filteredCells.push(tablerow.find("td[field='" + value.Field + "']"));
        });
        var parentcells = [];
        colIndex--;
        action = "";
        var includedExpansions = {};            //Object to push sources fro the expansion/collapse logging

        includedExpansions['Type'] = '';
        includedExpansions['Value'] = '';

        includedExpansions['IncludedValues'] = [];
        $(filteredCells).each(function (i, el) {
            //includedExpansions = [];
            if (objSelectedColTd.src.indexOf('collapse') > -1) {
                action = "hide";
                if ($(el).css('display') != 'none') {
                    var imgchange = $(el).find("img");
                    if (imgchange.length > 0) {
                        $.each(imgchange, function(imgIndex, imgValue){
                            if ($(imgValue).attr('class') == 'custcon' || $(imgValue).attr('class') == 'excluded_icon' || $(imgValue).attr('class') == 'conPlus_icon') {
                                return;
                            } else {
                                $(imgValue).attr('src', imgchange.attr('src').replace('collapse', 'expand'));
                            }
                        });
                    }
                    $('#tt').datagrid('hideColumn', $(el).attr('field'));
                    includedExpansions['IncludedValues'].push($(el).attr('field'));
                    // var eleText = $(el).text().toLowerCase().includes('+') ? $(el).text().toLowerCase().replace('+','plus') : $(el).text().toLowerCase();
                    var eleText = replaceConsensusPlusOperator($(el).text());
                    sliceIndex = $(el).attr('field').lastIndexOf($.trim(eleText));
                    parentcells.push($('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr').eq(colIndex).find("td[field='" + $(el).attr('field').substr(0, sliceIndex) + "']"));
                    doDataGirdStyling(parameter, prevParameter, "collapse", colType);
                    debouncedBlock(false);
                } else {
                    doDataGirdStyling(parameter, prevParameter, "collapse", colType);
                    debouncedBlock(false);
                }
            } else {
                action = "show";
                if ($(el).css('display') == 'none') {
                    if ($.inArray($(el).attr('field'), emptyColumns) > -1 && hideEmptyColumn){
                        doDataGirdStyling(parameter, prevParameter, "expend", colType);
                        debouncedBlock(false);
                        return;
                    }
                    if (firstExpandedColumn == "")
                        firstExpandedColumn = $(el).attr('field');
                    $('#tt').datagrid('showColumn', $(el).attr('field'));
                    //includedExpansions[i].push(firstExpandedColumn);
                    includedExpansions['IncludedValues'].push($(el).attr('field'));
                    // var eleText = $(el).text().toLowerCase().includes('+') ? $(el).text().toLowerCase().replace('+','plus') : $(el).text().toLowerCase();
                    var eleText = replaceConsensusPlusOperator($(el).text());
                    sliceIndex = $(el).attr('field').lastIndexOf($.trim(eleText));
                    parentcells.push($('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr').eq(colIndex).find("td[field='" + $(el).attr('field').substr(0, sliceIndex) + "']"));
                    doDataGirdStyling(parameter, prevParameter, "expend", colType);
                    debouncedBlock(false);
               } else {
                doDataGirdStyling(parameter, prevParameter, "expend", colType);
                debouncedBlock(false);
                }

            }
        });
        includedExpansions['Type'] = textExpandedType;
        includedExpansions['Value'] = textExpandedValue;
        ActionOnCloumns(parentcells, colIndex, action);
        var action_source ='';
        if(window.keyboard_event == true)
            action_source = 'KEYBOARD_SHORTCUT';
        else
            action_source = 'EXPLORER_COLUMN_EXPANSION_CLICK';
        if (action == 'hide') {
            expandCollapse(parentcells, colIndex, action);
            dummyAjaxRequest(company, cut, 'EXPLORER_COLUMN_COLLAPSE_SINGLE', includedExpansions,'',action_source);
        }
        else{
            if(colType == 'source') {
                //created this variable to get list of sources participating in custom consensus calculations
                var includedSourcesinCC = getIncludedBrokers();
                includedExpansions['IncludedinCC'] = [];
                includedExpansions['IncludedinCC'] = includedSourcesinCC;
                var unentitledSourceInfo = getUnentitledSourceInfo();
                $.extend(includedExpansions, unentitledSourceInfo);
            }
            if(window.keyboard_event == true)
                dummyAjaxRequest(company, cut, 'EXPLORER_COLUMN_EXPAND_SINGLE', includedExpansions, source, action_source);
            else
                callDummyAjaxRequest(event, company, cut, 'EXPLORER_COLUMN_EXPAND_SINGLE', includedExpansions, source, action_source);
        }
        if (objSelectedColTd.src.indexOf('collapse') > -1) {
            objSelectedColTd.src = objSelectedColTd.src.replace('collapse', 'expand');

            ModifydynamicGeneratedField(rootName);

            // grid styling
            doDataGirdStyling(parameter, prevParameter, "collapse", colType);
        } else {
            objSelectedColTd.src = objSelectedColTd.src.replace('expand', 'collapse');
            $(dynamicGeneratedField).each(function (index, value) {
                if (rootName == value.RootName) {
                    value.Flag = true;
                }
            });
        }
    }


    DivScrolling();
    if (firstExpandedColumn != "") {
        //Changed the scroll logic to figure out position of column closest to the Consensus column and move the scroll there
        var lastExpandedColumn = includedExpansions.IncludedValues[includedExpansions.IncludedValues.length-1];
        scrollPosition = $('[field="' + lastExpandedColumn + '"]').position().left;
        scrollOffset = $('[field="' + lastExpandedColumn + '"]').offset().left - $('#tt').datagrid("getPanel").find('table').eq(1).width();
        $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() + scrollPosition);
    }
    if (window.gSchedule)
        gridFormattingForSchedules();

    $(".datagrid-cell-group").removeAttr("style");
    //Added resize function here so that the grid height can be reset if the inspector has been expanded or collapsed
    reziseGridPanel();
}

function ExpandRowProcess(rowType, param_id, action){
    param_id = param_id.split("-")[0];
    if(action == "collapse"){
        window.MEData.panels = window.MEData.panels.map(function(panel){
            if(panel.name.toLowerCase() == "growthtypes"){
                if(panel.expandedRows == undefined){
                    panel.expandedRows = [];
                    return panel;
                }
                panel.expandedRows = panel.expandedRows.filter(function(id){
                    return id != param_id
                });
            }
            return panel;
        })
    }else{
        window.MEData.panels.map(function(panel){
            if(panel.name.toLowerCase() == "growthtypes"){
				if(panel.expandedRows == undefined){
					panel.expandedRows = [];
                }
                if(panel.expandedRows.indexOf(param_id) == -1){
                    panel.expandedRows.push(param_id);
                }
                
            }
        })
    }

    // var csrftoken = getCookie('csrftoken');
    // var ObjW = new WebServiceCall();
    // var data = rightPanelSettings("GrowthTypes");
    // ObjW.storePanelSettings(JSON.stringify(data), csrftoken);

}

function OnSuccessPgParamData(data, parameter) {
    if (data.length == 0)
        return;
    var rowObj = jQuery.extend(true, [], AlldgRows);
    var rowIndex = -1;
    rowObj = rowObj.getValues('RowAppend', true);
    var baseParamValue = {};
    $.each(data, function (index, valuedata) {
        if (!baseParamValue || !baseParamValue.column) {
            baseParamValue = {};
        }
        var objColField = "";
        var periodEstimate = whetherIsForecast(valuedata['period']);
        $.each(colDimension, function (indexcol, valuecol) {
            if (valuecol == 'source') {
                if (valuedata[valuecol].toUpperCase() == window.gSourceActual.toUpperCase() || valuedata[valuecol].toUpperCase() == gSourceFuture.toUpperCase()) {
                    if (periodEstimate)
                        objColField = objColField + gSourceFuture;
                    else
                        objColField = objColField + window.gSourceActual;
                }
                else
                    objColField = objColField + valuedata[valuecol];
            }
            else
                objColField = objColField + valuedata[valuecol];
        });
        objColField = objColField.toLowerCase();
        sortDataArray(valuedata.data);
        $.each(valuedata.data, function (indexrowdata, valuerowdata) {
            if (!baseParamValue || !baseParamValue.column) {
                baseParamValue = {};
            }
            var rowObject = {};
            var objRowField = "";
            $.each(rowDimension, function (indexRow, valueRow) {
                objRowField = (objRowField == "" ? objRowField : objRowField + "-") + (valueRow == 'lineitem' ? valuerowdata.param_id : (valuedata[valueRow].toLowerCase().indexOf(objRowField) == -1 ? valuedata[valueRow].toLowerCase() : ""));
            });
            objRowField = objRowField.replace(window.gSourceActual.toLowerCase(), gSourceFuture.toLowerCase());
            var rows = rowObj.getValues('id', objRowField);
            $.each(rows, function (indexValue, rowValue) {
                rowIndex = -1;
                var row = $.each(rowObj, function (i, el) {
                    if (el.id == objRowField && rowValue.sortorder == el.sortorder) {
                        rowIndex = i;
                        rowObject = el;
                    }
                });
                if ($.inArray(objRowField, baseparamrows) > -1) {
                    text = valuerowdata.value;
                    var baseDpId = valuerowdata.id;
                    if (text.indexOf('-') > -1) {
                        text = text.replace('-', '');
                        text = formatBaseValue(valuerowdata.value,baseDpId,objColField, {
                            'unit': valuerowdata.unit,
                            'precision': valuerowdata.precision
                        });
                        baseParameterValue = {"column": objColField, "text": text, 'negative': false, "dpid": baseDpId};
                    }
                    else{
                        text = formatBaseValue(valuerowdata.value,baseDpId,objColField, {
                            'unit': valuerowdata.unit,
                            'precision': valuerowdata.precision
                        });
                        baseParameterValue = {"column": objColField, "text": text, 'negative': false, "dpid": baseDpId};
                    }
                    baseColumns = $.grep(baseParameterValues, function (i, el) {
                        return (i.column == objColField);
                    });

                    if (baseColumns.length > 0)
                        baseColumns[0][objRowField] = baseParameterValue;
                    else {
                        obj = {
                            "column": objColField,
                            "text": text,
                            'negative': baseParameterValue.negative,
                            "dpid": baseDpId
                        };
                        obj[objRowField] = baseParameterValue;
                        baseParameterValues.push(obj);
                    }
                }
                if (rowIndex != -1) {
                    var panelCells = $('#tt').datagrid("getPanel").find("table").eq(3 + 1).find('tr').eq(rowIndex);
                    //To DO append value and formula bar etc etc...
                    var cell = $(panelCells[0]).find('td[field="' + objColField + '"]');
                    if (valuerowdata.dpnote) {//todo note change
                        $(cell).attr('note', valuerowdata.dpnote.split('\n').join('<br>'));
                        qtipSettings(cell, 'note');
                    }
                    if (valuerowdata.value != "") {
                        cellSource = (periodEstimate) ? gSourceFuture : window.gSourceActual;

                        $(cell).off('click.datacellClick').on('click.datacellClick', function (event, hideContextMenu) {
                            // const cellData = {
                            //     id:cell.attr("id") || null,
                            //     field:cell.getAttribute("field")  || null,
                            //     dapparam_id:cell.getAttribute("dapparam_id") || null,
                            //     revision:cell.getAttribute("revision") || null
                
                            // }
                            var paramsForFbar = prepareDpParams(valuerowdata.id,cut,window.MEData.ticker,cellSource,"",window.MEData.panels[1]["actual-default"],cell.attr('period'),cell.attr('dapparam_id'),window.MEData.selectedCurrency,incl_sources,excl_sources,true,cell)
                            const summonFBar = new CustomEvent('SummonFBar', { detail: { data: paramsForFbar} })
                            window.dispatchEvent(summonFBar);                         
                            // datacellClick(valuerowdata.id, objColField, this, cut, cellSource, "row", "", event, window.MEData.ticker)
                        })

                        if (!baseParamValue.column) {
                            baseColumnData = $.grep(baseParameterValues, function (baseValue, baseIndex) {
                                if (baseValue.column == objColField)
                                    return baseValue;
                            });
                            baseParamValue = baseColumnData[0];
                        }
                        //getting new baseparamvalues
                        if (rowDimension.length > 1 && (!(window.MEData.baseparameter.notAvail))) {
                            rowfield = objRowField.replace(valuerowdata.param_id, window.MEData.baseparameter.id);
                            if (baseParamValue)
                                baseParamValue = baseParamValue[rowfield];
                        }
                        var valueData = valuerowdata.value;
                        if (+valueData < 0)
                            valueData = "(" + valueData.replace('-', '') + ")";
                        if (dataInCommonsize) {
                            var baseParam = window.MEData.baseparameter;
                            if (rowObject.magnitude == baseParam.magnitude && rowObject.unit == baseParam.unit)
                                cellCommonsize(cell, true, baseParamValue, false, valueData + "");
                        }
                        else {
                            if (valuerowdata.unit)
                                $(cell).find('div').html(formatValue(valuerowdata.value, rowObject.id, objColField, {
                                    'unit': valuerowdata.unit,
                                    'precision': valuerowdata.precision
                                }));
                            else
                                $(cell).find('div').html(formatValue(valuerowdata.value, rowObject.id, objColField, {'precision': valuerowdata.precision}));
                        }
                        getCellStyling(valuerowdata.annotation, cell);
                    }
                }
            });
        });
        baseParamValue = {};
    });
    if (window.gSchedule)
        gridFormattingForSchedules();
}

function currentCheck(currentQuarter, companyName) {

    return forecast_period_dict[currentQuarter.toLowerCase()];

}

/**
 * find if the period is forecast or actual
 * @param {string} period period for which to find forecast or not
 * @returns {boolean} isForecast: period forcast or not
 */
function whetherIsForecast(period) {

    var panelIdx = window.MEData.panels.findIndex(p => p.name.toLowerCase() === 'periods');
    var periodsMEData = window.MEData.panels[panelIdx];

    var year = Number(period.match(/\d{4}/)[0]);
    var interim = period.toLowerCase().replace(`fy-${year}`, '');
    var firstEstYear = Number(periodsMEData.first_estimated_fiscal.match(/\d{4}/)[0]);

    var periodVals = periodsMEData.all_period_expansion_list;
    var periodObj = periodVals.find(periodObj => periodObj.year === year);

    if( (interim == "") || (year !== firstEstYear)) {
        if(!periodObj){
            return false
        }
        return periodObj.forecast;
    }

    var interimKey = `${interim.toUpperCase()}FY-${year}`;
    var isInterimForecast = periodsMEData.actual_estimates[interimKey];
    if(isInterimForecast === undefined) {
        isInterimForecast = true;
    }
    return isInterimForecast;

}

function checkIfFoucsConseusHasData(currentQuarter, companyName) {
    var finQuarter = "";
    var finYear = "";
    currentQuarter = currentQuarter.toUpperCase();
    var elYear = [];

    if (tickerData[companyName.toUpperCase()]) {
        if (currentQuarter.indexOf('Q') == -1 && currentQuarter.indexOf('H') == -1) {
            currentQuarter = "4Q" + currentQuarter;
        }

        finQuarter = currentQuarter.slice(0,1);
        finYear = currentQuarter.slice(5);
        elYear[0] = tickerData[companyName.toUpperCase()]['fiscal'].slice(0, 1);
        elYear[1] = tickerData[companyName.toUpperCase()]['fiscal'].slice(5);


        if (finYear >= elYear[1]) {
            if (finYear == elYear[1]) {
                return finQuarter > elYear[0];
            } else {
                return true;
            }
        } else {
            return false;
        }

    } else {
        return false;
    }
}

function doDataGirdStyling(parameter, prevParameter, flag, colType) {
    var prevparam = prevParameter;
    var param = parameter;
    if (flag == "expend") {
        $('#tt').datagrid("getPanel").find("table").eq(3).find("td[param='" + parameter.toLowerCase().replace(/\|/g, '') + "']").css("background", "#95A5A7").css("color", "#ffffff").css("border-top-color", "#909090");
        $('#tt').datagrid("getPanel").find("table").eq(3).find("td[field='" + parameter.toLowerCase().replace(/\|/g, '') + "']").css("background", "#95A5A7").css("color", "#ffffff").css("border-top-color", "#909090");

    } else {
        $('#tt').datagrid("getPanel").find("table").eq(3).find("td[param='" + parameter.toLowerCase().replace(/\|/g, '') + "']").css("background", "#fbfbfb").css("color", "#000000").css("border-top-color", "#fbfbfb");
        $('#tt').datagrid("getPanel").find("table").eq(3).find("td[field='" + parameter.toLowerCase().replace(/\|/g, '') + "']").css("background", "#fbfbfb").css("color", "#000000").css("border-top-color", "#fbfbfb");
    }
    if (prevParameter != undefined && parameter.split("|").length != colDimension.length) {
        $.each(window.MEData.column_dimensions, function (indexcol, valuecol) {
            //colfield = colfield + (parameterlist.data[indexcol] == undefined ? "" : parameterlist.data[indexcol]);
            if (indexcol > parameter.split("|").length - 1) {
                if(valuecol.name == 'Sources'){
                    var indexVal = forecast_period_dict[prevParameter] ? 1:0;
                } else {
                    var indexVal = 0;
                }
                prevParameter = prevParameter + valuecol.values[indexVal].name.toLowerCase();
                parameter = parameter + valuecol.values[indexVal].name.toLowerCase();

            }
        });
    }
    var panelHeader = $('#tt').datagrid("getPanel").find("table").eq(3).find("tr").find("td[field^='" + param.toLowerCase().replace(/\|/g, '') + "']:last");
    var headerIndex = $(panelHeader[panelHeader.length - 1]).index() + 1;
    var panelCells2 = $('#tt').datagrid("getPanel").find("table").eq(4).find("tr").find("td:nth-child("+headerIndex+")");
    var prevpanelCells2 = [];
    var prevheaderCells2 = [];
    if (prevParameter != undefined) {
        prevheaderCells2 = $('#tt').datagrid("getPanel").find("table").eq(3).find("tr").find("td[field^='" + prevparam.toLowerCase().replace(/\|/g, '') + "']:last");
        //var prevIndex = prevheaderCells2[1] ? prevheaderCells2[1]
        prevpanelCells2 = $('#tt').datagrid("getPanel").find("table").eq(4).find("td[field^='" + prevParameter.toLowerCase().replace(/\|/g, '') + "']");
        if (prevpanelCells2.length < 1)
            prevpanelCells2 = $('#tt').datagrid("getPanel").find("table").eq(4).find("td[field^='" + prevparam.toLowerCase().replace(/\|/g, '') + "']");



    }
    if (flag == "expend") {
        if (panelCells2.length > 0)
            panelCells2.addClass("datagrid_expendedcolumn");

        if (prevpanelCells2.length > 0)
            prevpanelCells2.css("border-right", "1px solid #ccc");

        if (prevheaderCells2.length > 0)
            prevheaderCells2.css("border-right", "1px solid #ccc");
        if(colType == 'period'){
            panelHeader.addClass('lastQ');
            panelCells2.addClass('lastQ');
            prevpanelCells2.addClass('lastQ');
            prevheaderCells2.addClass('lastQ');
            if ($('.datagrid-footer').is(":visible") == true) {
            //inspector rows
                $('div.datagrid-footer').find('table').eq(1).find("td[field^='" + param.toLowerCase() + "']").addClass('lastQ');
                $('div.datagrid-footer').find('table').eq(1).find("td[field^='" + prevParameter.toLowerCase() + "']").addClass('lastQ');
            }
        }

    }
    else {
        if (panelCells2.length > 0)
            panelCells2.removeClass("datagrid_expendedcolumn");

        if (prevpanelCells2.length > 0)
            prevpanelCells2.css("border-right", "1px dotted #ccc");

        if (prevheaderCells2.length > 0)
            prevheaderCells2.css("border-right", "1px dotted #ccc");
        if(colType == 'period'){

            var nextPeriodHeader = panelHeader.eq(0).next();
            if(nextPeriodHeader.length > 0 && (!nextPeriodHeader.is(':visible')
                || !nextPeriodHeader.hasClass('expanded_border_top'))
                || nextPeriodHeader.length == 0) {
                panelHeader.removeClass('lastQ');
                panelCells2.removeClass('lastQ');
            }

            var prevHeaderIndex = prevheaderCells2.eq(0).index();

            var prevPeriodHeader = prevheaderCells2.eq(0).prev();

            if(prevHeaderIndex == 0 || prevPeriodHeader.length > 0 && (!prevPeriodHeader.is(':visible')
                || !prevPeriodHeader.hasClass('expanded_border_top'))) {
                prevpanelCells2.removeClass('lastQ');
                prevheaderCells2.removeClass('lastQ');
            }

            if ($('.datagrid-footer').is(":visible") == true) {
            //inspector rows
                $('div.datagrid-footer').find('table').eq(1).find("td[field^='" + param.toLowerCase() + "']").removeClass('lastQ');
                $('div.datagrid-footer').find('table').eq(1).find("td[field^='" + prevParameter.toLowerCase() + "']").removeClass('lastQ');
            }
        }
    }

}

function brokerCountCalculator(id, available, total){
    if(available > total){
        //Handling the off case in historical periods
        $(id).css('width','100%');
    }
    else{
        var countExpandPercent = (available / total) * 100;
        $(id).css('width', countExpandPercent + '%');
    }
}


function logSourceColExpansion(serviceResponse, parameterlist, event, sourceOrder) {
    //Object created to log the expanded list of sources
    var sourcesToLog = {};
    sourcesToLog['IncludedValues'] =[];
    for(var i = 0; i < serviceResponse.data.length; i++){
        cutUsed = serviceResponse.data[i].cut.toLowerCase();
        columnType = parameterlist.colType;
        if((columnType == 'period' || columnType == 'revision') && (cutUsed === 'nmv' || cutUsed === 'sch' || cutUsed === 'std'))
            source_participation_in_consensus[(serviceResponse.data[i].period + serviceResponse.data[i].revision).toLowerCase()] = {'available_sources': serviceResponse.data[i].broker_count.available_sources, 'forecast' : serviceResponse.data[i].forecast};
        if(serviceResponse.data[i].data.length != 0){
            if(columnType == 'source') {
                //created this variable to get list of sources participating in custom consensus calculations
                var includedSourcesinCC = getIncludedBrokers();
                sourcesToLog['IncludedinCC'] = [];
                sourcesToLog['IncludedinCC'] = includedSourcesinCC;
                // sourcesToLog['IncludedValues'].push(serviceResponse.data[i].source);
                sourcesToLog['IncludedValues'] = sourceOrder;
            }
            else if(columnType == 'period'){
                sourcesToLog['IncludedValues'].push(serviceResponse.data[i].period);
            }
            else if(columnType == 'revision'){
                sourcesToLog['IncludedValues'].push(serviceResponse.data[i].revision);
            }
            else if(columnType == 'ticker'){
                sourcesToLog['IncludedValues'].push(serviceResponse.data[i].ticker);
            }
        }
    }
    sourcesToLog['Type'] = '';
    sourcesToLog['Value'] = '';
    sourcesToLog['Type'] = textExpandedType;
    sourcesToLog['Value'] = textExpandedValue;
    var unentitledSourceInfo = getUnentitledSourceInfo();
    $.extend(sourcesToLog, unentitledSourceInfo);
    if(event && event.data == true)
        dummyAjaxRequest(company, cut, 'EXPLORER_COLUMN_EXPAND_SINGLE', sourcesToLog, source, 'KEYBOARD_SHORTCUT');
    else
        callDummyAjaxRequest(event, company, cut, 'EXPLORER_COLUMN_EXPAND_SINGLE', sourcesToLog, source, 'EXPLORER_COLUMN_EXPANSION_CLICK');
    event = undefined
}

//var OnSuccessOfExpandColumnFlag = false;
function OnSuccessOfExpandColumn(serviceResponse, parameterlist, event, sourcesOrder) {
    //This function gets called for the first time any column is expanded
    if(parameterlist.colType === "source") {
        var sourcePanelData = window.MEData.panels.filter(function (item) {
            return item.name === "Sources";
        })[0]
        //Checking if sourcePanelData is undefined, since no source data is loaded for SAR views
        if (sourcePanelData && (sourcePanelData.sort_column === "modeldatetime" || sourcePanelData.sort_column === "modeldate")) {
            //List of sources which shouldn't be part of the reversing
            var searchS = ['filings','va actuals','consensus', 'consensus+'];
            var staticSources = [];
            //Removing above objects from the main response object
            for(var i = 0; i < searchS.length; i++){
                var index = serviceResponse.data.findIndex(function(item){
                    return item.source.toLowerCase() === searchS[i];
                })
                if(index !== -1) {
                    var temp = serviceResponse.data.splice(index, 1)[0];
                    staticSources.push(temp);
                }
            }
            
            //Reversing the left over objects, which now contain only broker data
            serviceResponse.data = serviceResponse.data.reverse();
            
            //Pushing the spliced static sources in the same original order
            for(var i = 0 ; i < staticSources.length; i++){
                serviceResponse.data.push(staticSources[i]);
            }
        }
    }
    
    var listToScroll = [];
    var firstExpandedColumn = "";
    var objME = new ModelExplorer();
    var cols = [];
    var preciseIndicesForSourceCols = [];
    $.each(colDimension, function (i, el) {
        cols.push([])
    });
    var rows = [];
    this.rows = jQuery.extend(true, [], AlldgRows); //GetRowsfordg(true, null, false);
    var rowObj;
    rowObj = this.rows;
    var table = $('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr');
    var colfield = "", quarterCellPosition = [];
    $.each(colDimension, function (indexcol, valuecol) {
        colfield = colfield + (parameterlist.data[indexcol] == undefined ? "" : parameterlist.data[indexcol]);
        if (indexcol >= $.inArray(parameterlist.colType, colDimension)) {
            quarterCellPosition.push(table.eq(indexcol).find("td[field^='" + colfield + "']").eq(0).index());
        } else {
            quarterCellPosition.push(-1);
        }
    });
    var rowSelector = "";
    $.each(rowDimension, function (indexRow, valueRow) {
        if (indexRow == 0) {
            rowSelector = rowSelector + window.MEData.baseparameter.id;
        } else if (cut != 'CPT' && indexRow == 1) {
        } else {
            rowSelector = rowSelector + "-" + rowDefaults[valueRow].toLowerCase();
        }
    });
    var datatable_cellindex = quarterCellPosition[colDimension.length - 1];
    if (serviceResponse.data != undefined) {
        var expColListlength = ExpandedColList[colDimension.length - 1].length;
        columnEmpty = [];
        $.each(serviceResponse.data, function (indexdata, valuedata) {
            var columnField = "", parameters = "";
            colSpanFlag = false;
            $.each(colDimension, function (indexcol, valuecol) {
                if (valuedata.status && valuedata.status.toLowerCase() == "error") {
                    console.error(valuedata.message);
                    return;
                }
                var data = valuedata[valuecol];
                if (parameterlist.colType == valuecol || indexcol >= parameterlist.data.length) {
                    // var val = valuedata[valuecol].toLowerCase().includes('+') ? valuedata[valuecol].toLowerCase().replace('+','plus') : valuedata[valuecol].toLowerCase();
                    var val = replaceConsensusPlusOperator(valuedata[valuecol]);
                    columnField = columnField + val;
                    data = data === 'consensus+' ? 'Consensus+' : data;
                }else {
                    columnField = columnField + parameterlist.data[indexcol].toLowerCase();
                }
                var existFlag = $.grep(dynamicGeneratedField, function (n) {
                    return (n.RootName == parameterlist.rootName && n.Field == columnField);
                });
                var appendCheck = false;
                if(parameterlist.colType == 'period') {
                    appendCheck = valuedata.ticker.toUpperCase() == company.toUpperCase();
                    if(valuecol === 'period') {
                        data = parameterlist.qData.displayQuarters[valuedata[valuecol]];
                    }
                }
                else if(parameterlist.data[0] == valuedata['period'].toLowerCase()) {
                    appendCheck = true ;
                }
                else {
                    appendCheck = false;
                }
                if (existFlag.length == 0 && (parameterlist.colType == 'ticker' || appendCheck)) {
                    parameters = parameters + (indexcol != 0 ? "|" : "") + (parameterlist.colType == valuecol || indexcol >= parameterlist.data.length ? valuedata[valuecol].toLowerCase() : parameterlist.data[indexcol].toLowerCase());
                    parameters = parameters.includes('+') ? parameters.replace('+','plus') : parameters;
                    if (indexcol >= $.inArray(parameterlist.colType, colDimension)) {
                        cols[indexcol].push({
                            field: columnField,
                            title: data,
                            width: 90,
                            parameter: parameters,
                            align: 'right',
                            color: 'red',
                            source:valuedata['source'],
                            sortable: false,
                            resizable: false,
                            forecast:valuedata.forecast
                        });
                        //                        ExpandedColList[indexcol].push({ ColField: columnField, parameter: parameters, cellPosition: parameterlist.quarterCellPosition[indexcol], appendAt: true });
                        ExpandedColList[indexcol].push({
                            ColField: columnField,
                            parameter: parameters,
                            cellPosition: quarterCellPosition[indexcol],
                            appendAt: true
                        });
                        var clickEvent = null;
                        var bindSourcelevelPopover = typeof valuedata.analyst != 'undefined' && valuedata.analyst;
                        if (indexcol != $.inArray(parameterlist.colType, colDimension)) {
                            clickEvent = "ExpandColumnProcess(event, \"" + valuecol + "\",\"" + parameters + "\",this);"
                        }
                        if (firstExpandedColumn == "")
                            firstExpandedColumn = columnField;

                        var revisionObj;
                        if (valuecol == 'source' && valuedata['source'].toLowerCase() != 'va actuals') {
                            revisionObj = {'revision': valuedata['revision'], 'revision_datetime': valuedata['revision_datetime']};
                        }

                        // why this condition ?? commenting as there is no difference
                        // if (indexcol == 0) {
                        //
                        //     objME.AppendHeaderCell(table.eq(indexcol), columnField, data, quarterCellPosition[indexcol], clickEvent, true, ((colDimension.length - 1) != indexcol ? 1 : 2), false, indexdata, valuedata['period'], revisionObj);
                        // } else {
                        //     objME.AppendHeaderCell(table.eq(indexcol), columnField,data, quarterCellPosition[indexcol], clickEvent, true, ((colDimension.length - 1) != indexcol ? 1 : 2), false, indexdata, valuedata['period'], revisionObj);
                        // }

                        if(parameterlist.colType === "source") {
                            var allSources = [];
                            var allSourcesSelector = jQuery.extend([], parameterlist.data);
                            allSourcesSelector.pop();
                            allSourcesSelector = allSourcesSelector.join('');
                            table.eq(indexcol).find("td[field^='" + allSourcesSelector + "']").each(function(idx, elem) {
                                allSources.push( {
                                    sourceElem: elem,
                                    sourceName: $(elem).attr('field').includes('consensusplus') ? "Consensus+" : elem.innerText.trim(),
                                    sourceIndex: table.eq(indexcol).find("td[field^='" + $(elem).attr('field') + "']").eq(0).index()
                                });
                            });
                            var currentSource = data;
                            //find next available
                            var shouldBeIdx = sourcesOrder.indexOf(currentSource);
                            var found = allSources[allSources.length - 1];
                            var isFound = null;
                            for(var i = shouldBeIdx + 1; i < sourcesOrder.length; i++) {
                                allSources.forEach(function(source) {
                                    if(isFound === null && source.sourceName === sourcesOrder[i]) {
                                        found = source;
                                        isFound = true;
                                    }

                                });
                                if(isFound) {
                                    break;
                                }
                            }

                            preciseIndicesForSourceCols.push(found.sourceIndex);
                            objME.AppendHeaderCell(table.eq(indexcol), columnField, data, found.sourceIndex, clickEvent, true, ((colDimension.length - 1) != indexcol ? 1 : 2), false, indexdata, valuedata['period'], revisionObj);
                        }else {
                            objME.AppendHeaderCell(table.eq(indexcol), columnField, data, quarterCellPosition[indexcol], clickEvent, true, ((colDimension.length - 1) != indexcol ? 1 : 2), false, indexdata, valuedata['period'], revisionObj);
                        }


                        if (valuedata.data.length == 0 && indexcol == $.inArray(parameterlist.colType, colDimension) && colDimension[colDimension.length - 1] == parameterlist.colType) {
                            columnEmpty.push(columnField);
                            emptyColumns.push(columnField);
                        }
                        //objME.AppendHeaderCell(table.eq(indexcol), columnField, data, -1, clickEvent, true, ((colDimension.length - 1) != indexcol ? 1 : 2));
                        if (valuedata.note && columnField.indexOf(valuedata.source.toLowerCase()) > -1) {
                            var note_str = "";
                            if ($('td[field="' + columnField + '"]').attr('note')) {
                                note_str = $('td[field="' + columnField + '"]').attr('note').split('<br/>')[0] + "<br/>";
                            }
                            $('td[field="' + columnField + '"]').attr('note', note_str + valuedata.note + "<br/>");
                            if(!bindSourcelevelPopover)
                            {
                                //todo note change
                                qtipSettings($('td[field="' + columnField + '"]'), 'note');
                            }
                            $('td[field="' + columnField + '"]').addClass('external_note');
                        }
                        dynamicGeneratedField.push({Field: columnField, Flag: true, RootName: parameterlist.rootName});
                        if (quarterCellPosition[indexcol] != -1)
                            quarterCellPosition[indexcol]++;
                    }
                }
                //Added here for calculating and setting the width of expanded consensus graph
                if(valuedata.source == 'Custom' || valuedata.source == 'Consensus' || valuedata.source == 'Consensus+') {
                    //In the off chance, to prevent the divide by zero error
                    if(valuedata.broker_count.total != 0) {
                        var escapedVal = '#countExpandedGraph_' + columnField.replace('$$', '-').replace(' ','_');
                        brokerCountCalculator(escapedVal,valuedata.broker_count.available,valuedata.broker_count.total);
                    }
                }
            });
            var baseParameterValue = {};

            //Creating a list of all the column field values, to figure out the last column to scroll till
            if(!($.inArray(parameterlist.colType,colDimension) == (colDimension.length - 1) && valuedata.data.length == 0)){
                listToScroll.push(columnField);
            }
            $.each(valuedata.data, function (indexrowdata, valuerowdata) {
                var objRowField = "";
                $.each(rowDimension, function (indexRow, valueRow) {
                    if (valueRow != 'link'){
                        objRowField = (objRowField == "" ? objRowField : objRowField + "-") + (valueRow == 'lineitem' ? valuerowdata.param_id : (valuedata[valueRow].toLowerCase().indexOf(objRowField) == -1 ? valuedata[valueRow].toLowerCase() : ""));
                    }
                });
                //objRowField = objRowField.replace(window.gSourceActual.toLowerCase(),gSourceFuture.toLowerCase());
                var row = $.grep(rowObj, function (n) {
					return (check_list_same(n.id,objRowField));
                    //return (n.id == objRowField);
                });
                if (sourcesExist && (row.length == 0)) {
                    objRowField = objRowField.replace(window.gSourceActual.toLowerCase(), gSourceFuture.toLowerCase());
                    var row = $.grep(rowObj, function (n) {
						return (check_list_same(n.id,objRowField));
                        //return (n.id == objRowField);
                    });
                }
                var objColField = columnField;
                if (valuerowdata.param_id == window.MEData.baseparameter.id && (rowSelector == objRowField || $.inArray(objRowField, baseparamrows) > -1)) {
                    //rowSelected = true;
                    text = valuerowdata.value;
                    var baseDpId = valuerowdata.id;
                    if (text.indexOf('-') > -1) {
                        text = text.replace('-', '');
                        text = formatBaseValue(valuerowdata.value,baseDpId,objColField, {
                            'unit': valuerowdata.unit,
                            'precision': valuerowdata.precision
                        });
                        baseParameterValue = {"column": objColField, "text": text, 'negative': true, "dpid": baseDpId};
                    }
                    else{
                        text = formatBaseValue(valuerowdata.value,baseDpId,objColField, {
                            'unit': valuerowdata.unit,
                            'precision': valuerowdata.precision
                        });
                        baseParameterValue = {"column": objColField, "text": text, 'negative': false, "dpid": baseDpId};
                    }


                    if (rowDimension.length > 1) {
                        baseColumns = $.grep(baseParameterValues, function (i, el) {
                            return (i.column == objColField);
                        });
                        if (baseColumns.length > 0)
                            baseColumns[0][objRowField] = baseParameterValue;
                        else {
                            if (rowSelector == objRowField)
                                obj = {
                                    "column": objColField,
                                    "text": text,
                                    'negative': baseParameterValue.negative,
                                    "dpid": baseDpId
                                };
                            else {
                                obj = {"column": objColField, "text": "", 'negative': false, "dpid": 0};
                                obj[rowSelector] = {"column": objColField, "text": "", 'negative': false, "dpid": 0};
                            }
                            obj[objRowField] = baseParameterValue;
                            baseParameterValues.push(obj);
                        }
                    }
                    else
                        baseParameterValues.push(baseParameterValue);
                }
                $.each(row, function (i, el) {
                    el[objColField] = {
                        value: valuerowdata.value,
                        CellId: valuerowdata.id,
                        type: valuerowdata.annotation,
                        precision: valuerowdata.precision,
                        revision: valuedata.revision,
                        revision_date: valuedata.revision_date,
                        revision_datetime: valuedata.revision_datetime,

                    }
                    //this loop updates the row data which is used to populate cols
                    //use objColField data to update column based data.
                    el["param_id"]=  valuerowdata.param_id;
                    el[objColField]["period"] = valuerowdata.period;
                    if (valuerowdata.max) {
                        el[objColField]['max'] = valuerowdata.max;
                    }
                    if(valuerowdata.min) {
                        el[objColField]['min'] = valuerowdata.min;
                    }
                    if (valuerowdata.surprise != undefined) {
                        el[objColField]['surprise'] = valuerowdata.surprise;
                        el[objColField]['title'] = valuerowdata.title;
                    }
                    if (valuerowdata.dpnote)
                        el[objColField]['dpnote'] = valuerowdata.dpnote;
                    if (valuerowdata.unit)
                        el[objColField]['unit'] = valuerowdata.unit;

                });
            });
        });
        if ($.inArray("ticker", rowDimension) > -1 && parameterlist.colType == 'period') {
            companys = FindExpansions("tickers");
            var ObjWebServiceCall = new WebServiceCall();
            $.each(companys, function (iCompany, elCompany) {
                qData = getPeriodQuarters(parameterlist.data[0], elCompany);
                var parameters = {"data": parameterlist.data, "colType": parameterlist.colType, "qData": qData};
                parameters.ticker = elCompany;
                if (sourcesExist) {
                    if (qData.divide)
                        parameters["quarterType"] = "past";
                }
                serviceResp = ObjWebServiceCall.getPgParamData(parameters);
            });
        }

        $.each(parameterlist.headercellObj, function (indexheaderCellObj, valueheaderCellObj) {
            valueheaderCellObj.prop('colspan', (parseInt(valueheaderCellObj.prop('colspan') ? valueheaderCellObj.prop('colspan') : 1) + (ExpandedColList[colDimension.length - 1].length - expColListlength)))
        });
        var datagridbodyRows = $('div.datagrid-body').find('table').eq(1).find('tr');
        columnType = parameterlist.colType;
        var preciseIdxs = columnType === "source" ? preciseIndicesForSourceCols : undefined;
        objME.AppendColumn(datagridbodyRows, this.rows, datatable_cellindex, cols[colDimension.length - 1], true,columnType, preciseIdxs);

        // if(isFirstLoad) {
        //     isFirstLoad = false;
        //     //Moving the calls here to prevent it interrupting the expansion pg call, and has to get triggered once
        //     var ObjWebServiceCall = new WebServiceCall();
        //     ObjWebServiceCall.getAllNotes(window.MEData.ticker, null);
        // }
        //This check gives if notes api call is done or not, if done append notes,
        // else bind event to be triggered when api returns notes
        // if (notes['datapoint'] !== undefined && notes['datapoint'].datapoint_level_dict) {
        //     addNotesOnSuccessOfPg(serviceResponse);
        // } else {
        //     $(window).on('notes-data-set',function () {
        //         addNotesOnSuccessOfPg(serviceResponse);
        //     });
        // }
        addPeriodLevelNote();

        var datagridbodyRows = $('div.datagrid-footer').find('table').eq(1).find('tr');
        objME.AppendFooterCell(datagridbodyRows, this.rows, datatable_cellindex, cols[colDimension.length - 1], true);
    }

    analystTitle(serviceResponse);

    if(firstExpandedColumn) {
        if(listToScroll.length !== 0) {
            //Changed the scroll logic to figure out position of column closest to the Consensus column and move the scroll there
            scrollPosition = $('[field="' + listToScroll[listToScroll.length - 1] + '"]').position().left;
            scrollOffset = ($('[field="' + listToScroll[listToScroll.length - 1] + '"]').offset().left + (cols[colDimension.length - 1].length * 90) - $('#tt').datagrid("getPanel").find('table').eq(1).width());
        }
        else{
            //Incase the columns are blank, we calculate the position from the consensus column
            scrollPosition = $('[field="' + parameterlist.rootName + '"]').position().left;
            scrollOffset = ($('[field="' + parameterlist.rootName + '"]').offset().left + (cols[colDimension.length - 1].length * 90) - $('#tt').datagrid("getPanel").find('table').eq(1).width());
        }
        $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() + scrollPosition);
    }

    if ($.inArray(parameterlist.colType, colDimension) == colDimension.length - 1 && columnEmpty.length > 0 && hideEmptyColumn) {
        $.each(columnEmpty, function (i, el) {
            showHideColumn('hide', el);

        });
    }

    var td = $('#tt').datagrid("getPanel").find('table').eq(3).find('tr').eq($.inArray(parameterlist.colType, colDimension)).find("td");

    var presenttd = $.grep(td, function (n) {
        return ($(n).find('img').length > 0 && $(n).css('display') != "none");
    });
    if (parameterlist.colType == 'period'){
        var coldimensionData = $.grep(window.MEData.column_dimensions[0].values, function (n) {
            return (n.period.toLowerCase() == parameterlist.data[0].toLowerCase());
        })[0].expansion_lst;
    } else {
        var coldimensionData = $.grep(window.MEData.column_dimensions, function (n) {
        return (n.name.toLowerCase().indexOf(parameterlist.colType) > -1);
        })[0].expansions;
    }


    var totalLength = (coldimensionData.length * presenttd.length) + presenttd.length;
    var totaltd = $.grep(td, function (n) {
        return ($(n).css('display') != "none");
    });
    //alert(totalLength+"---"+totaltd.length)
    if (totalLength == (totaltd.length + emptyColumns.length)) {
        clickToAddEvent();
        //alert('u')
    }

    //to disable expansions
    hideDisabledExpansions(window.MEData);
    if (window.gSchedule)
        gridFormattingForSchedules();

    $(".datagrid-cell-group").removeAttr("style");

    //Added resize function here on success of column expansion so that the grid sets its height in case the inspector was opened prior to expansion
    reziseGridPanel();
}

function showHideColumn(action, fieldName) {
    $('#tt').datagrid(action + 'Column', fieldName);
    tdColSpan = (action == 'show') ? 1 : -1;
    colIndex = colDimension.length - 1;
    $.each(colDimension, function (i, el) {
        cell = $('#tt').datagrid("getPanel").find('table').eq(3).find('tr').eq(colIndex - i).find("td[field='" + fieldName + "']");
        if (colIndex - i == -1)
            return;
        else {
            if (colIndex - i != colDimension.length - 1) {
                cell.prop('colspan', (parseInt(cell.prop('colspan')) + tdColSpan));
            }
            //eq(indexdata).find("td[field='" + colfield + "']")
            cellText = $.trim($(cell).text()).toLowerCase();
            var cellTextLen = !fieldName.includes('plus') ? cellText.length : cellText.length+4 ;//extra 4 for plus since we are replacing '+' with 'plus' and header shows '+' icon
            fieldName = fieldName.substr(0, fieldName.length - cellTextLen);
        }
    });
    if (action == 'show')
        $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() + 90);
    else
        $('div.datagrid-body').eq(1).scrollLeft($('div.datagrid-body').eq(1).scrollLeft() - 90);
}

function ModifydynamicGeneratedField(rootName) {
    $(dynamicGeneratedField).each(function (index, value) {
        if (rootName == value.RootName) {
            value.Flag = false;
            var data = $.grep(dynamicGeneratedField, function (n) {
                return (n.RootName == value.Field);
            });
            if (data.length > 0) {
                ModifydynamicGeneratedField(value.Field)
            }
        }
    });
}
function GetExpandedData(expandeddata, rootName) {
    $(dynamicGeneratedField).each(function (index, value) {
        if (rootName == value.RootName) {
            expandeddata.push(value);
            var data = $.grep(dynamicGeneratedField, function (n) {
                return (n.RootName == value.Field);
            });
            if (data.length > 0) {
                GetExpandedData(expandeddata, value.Field);
            }
        }
    });
}

var dataExpandField = [];
var colDimension = [], defaultcolDimension = [], rowDimension = [], defaultrowDimension = [], colPanels;
var periods = [];
function Intialization(metaData) {
    colDimension = [], rowDimension = [], ExpandedColList = [], dynamicGeneratedField = []
    periods = [], dataExpandField = [], baseParameterValues = [], emptyColumns = [], baseparamrows = [];
    baseFooterColumns = {};
    if (!jQuery.isEmptyObject(metaData.inspector))
        for(var i=0; i<metaData.inspector.values.length; i++){
            var el = metaData.inspector.values[i];
            baseFooterColumns[el.type] = []
        };
    basisMeta = "";
}

function MakeColsDynamically(columnData, index, totalLength, objectCols, objectcolField, expansionsList) {
    if (index == 0) {
        $.each(columnData, function (indexcolumnData, valuecolumnData) {
            name = valuecolumnData.label == undefined ? valuecolumnData.display_period : valuecolumnData.label;
            field = valuecolumnData.period.toLowerCase();
            parameter = valuecolumnData.period.toLowerCase();
            prevParameter = objectcolField[index][indexcolumnData - 1] != undefined ? objectcolField[index][indexcolumnData - 1].parameter : "";
            var colspan = getColSpan(index);
            /*if (calendarYears && !valuecolumnData.label)
                name = name.substr(0, 7) + name.substr(9, 50);*/
            if (valuecolumnData.forecast) {
                if(!firstEstimatedYear){
                    firstEstimatedYear = valuecolumnData.label == undefined ? valuecolumnData.period : valuecolumnData.label;
                }
                name = name.substring(0, name.length - 1)+ '<span class="tag">E</span>';
            }
            var colTitle = "";

            if (valuecolumnData.expansion_lst.length != 0){
                colTitle = "<div onclick=\"ExpandColumnProcess(event, '" + colDimension[index] + "','" + parameter + "',this,'" + prevParameter + "')\"><img id='" + field.replace('-', '') + "' src='"+window.assetUrl+"/datagrid_row_expand.png' style='cursor:pointer'/><b>" + name + "</b></div>";
            }else{
                colTitle = "<b>" + name + "</b>";
            }
 
            //var colTitle = "<img id='" + field.replace('-', '') + "' src='/static/images/datagrid_row_expand.png' style='cursor:pointer' onclick=\"ExpandColumnProcess('" + colDimension[index] + "','" + parameter  + "',this,'" + prevParameter + "');\"/>&nbsp;&nbsp;<b>" + name + "</b>";
            //for now we are not adding expand image in case of schedules. In Future we need to handle this.
            //if(valuecolumnData.label != undefined ){
            //colTitle = "&nbsp;&nbsp;<b>" + name + "</b>";
            //}
            objectCols[index].push({
                field: (totalLength - 1 == index) ? field : null,
                title: colTitle,
                width: 99, // changed width from 90 -> 99 for c+ row levels to match width of period header column
                align: 'right',
                sortable: false,
                resizable: false,
                colspan: colspan
            });
            objectcolField[index].push({field: field, parameter: parameter});
        });
    } else {
        $.each(objectcolField[index - 1], function (indexobjectcolField, valueobjectcolField) {

            $.each(columnData, function (indexcolumnData, valuecolumnData) {
                name = valuecolumnData.name;
                // name = name == "Consensus+" ? "Consensus" : name;
                if (name == window.gSourceActual || name == gSourceFuture) {

                    var prevObj = objectcolField[index][objectcolField[index].length -1];
                    var newField = valueobjectcolField.field + valuecolumnData.name.toLowerCase();
                    if (prevObj && prevObj.field == newField){
                        return;
                    }


                    colParameters = valueobjectcolField.parameter.split('|');

                    var financialYear = colParameters[$.inArray("period", colDimension)];

                    isConsensusPresent = checkIfFoucsConseusHasData(financialYear, company)

                    var periodObj = window.MEData.column_dimensions[0].values.filter( function (n) {
                        return (n.period.toLowerCase() == financialYear.toLowerCase());
                    })[0];

                    if (periodObj.forecast && name == window.gSourceActual && window.gSourceActual!= gSourceFuture){
                        return;

                    }
                    if (!periodObj.forecast && name == gSourceFuture && window.gSourceActual!= gSourceFuture){
                        return;
                    }
                    //Adding this for a bug where column was binding incorrect source
                    var doesParticularPeriodObjExist = objectcolField[index].filter(function(item){
                        return item.parameter.split('|')[0] == periodObj.period.toLowerCase()
                    })

                    if(indexcolumnData !=0  && doesParticularPeriodObjExist.length != 0){
                        return
                    }
                    if (name == window.gSourceActual && !periodObj.forecast) {
                        periodFound = 0;
                    }

                    if (name == gSourceFuture && periodObj.forecast) {
                        periodFound = 1;
                    }

                    if (!isConsensusPresent) {
                        if (!periodObj.forecast && name != 'VA Actuals' && name != 'Filings' && valuecolumnData.validity == 'actual') {
                            ValDataColumnName = 'Filings'
                            name = 'Filings'
                        }
                    }

                }
                if (!ValDataColumnName && valuecolumnData && valuecolumnData.name !== undefined) {
                    var ValDataColumnName = "";
                    if (valuecolumnData.name.indexOf('*') != -1) {
                        ValDataColumnName = valuecolumnData.name.replace('*', '_cpt');
                        gSchcptDefault = true;
                    } else {
                        ValDataColumnName = valuecolumnData.name.toLowerCase().includes('consensus+') ? valuecolumnData.name.slice(0,-1)+"plus" : valuecolumnData.name;
                    }
                }

                field = valueobjectcolField.field + ValDataColumnName.toLowerCase();
                parameter = valueobjectcolField.parameter + "|" + ValDataColumnName.toLowerCase();
                prevParameter = objectcolField[index][indexobjectcolField - 1] != undefined ? objectcolField[index][indexobjectcolField - 1].parameter : "";
                var colTitle = "";
                //Added the broker count chart html here
                var titleClass = '';
                var sourceClass ='';
                if (index == $.inArray('revision', colDimension) && revisionTypeChanged) {
                    titleClass = 'current-change revision';
                }
                if($.inArray("source",colDimension) == index){
                    sourceClass = 'ellipsis_source';
                    colTitle = "<div class='"+sourceClass+"'>";
                }
                if (expansionsList.length != 0) {
                    colTitle += "<span style='float:left;'><img id='" + field.replace('-', '') + "' src='"+window.assetUrl+"/datagrid_row_expand.png' style='cursor:pointer' title-class='"+titleClass+"' /></span>";
                } else {
                    colTitle += "<span style='float:left;'></span>";
                }
                if (showExcludedIcon(name)) {
                    colTitle += '<img src="'+window.assetUrl+'/icon-excluded.png" class="excluded_icon" style="display: none;"/>';
                }
                if (showCCicon(name)) {
                    colTitle += '<img src="'+window.assetUrl+'/custom_consensus.png" class="custcon"/>';
                }
                if(showConPlusIcon(name)){
                    colTitle += '<img src="'+window.assetUrl+'/consensus_plus_icon.png" class="conPlus_icon"/>';
                }
                
                colTitle += (!cPlusConst.includes(name)) ? (" <span><b>" + name + "</b></span>") : (" <span><b>" + name.slice(0,-1) + "</b> <span style='color: #f2883d;vertical-align: middle; font-size:13px; padding: 2px 0 2px 2px;' class='fa fa-plus'></span></span>");

                if($.inArray("source",colDimension) == index){
                    colTitle += "</div>";
                }

                if($.inArray("source",colDimension) == index && (name == 'Consensus' || name == 'Custom' || name == 'Consensus+')) {
                    //Do not remove the inline style here, since it breaks in IE!
                    colTitle += "<span style='height:5px;background-color:#E0E2E2;float:left;width:100%;margin-top:2px;'><span id='countGraph_" + field + "' class='brokerCountGraphSpan'></span></span>";

                } else {
                    colTitle += "<span style='height:5px;background-color:#E0E2E2;float:left;width:100%;margin-top:2px;display:none'><span class='brokerCountGraphSpan'></span></span>";
                }

                if (expansionsList.length != 0) {
                    colTitle = "<div onclick=\"ExpandColumnProcess(event, '" + colDimension[index] + "','" + parameter + "',this,'" + prevParameter + "' );\">" + colTitle + "</div>"
                }
                objectCols[index].push({
                    field: (totalLength - 1 == index) ? field : null,
                    title: colTitle,
                    width: 99,
                    align: 'right',
                    sortable: false,
                    sortable: false,
                    resizable: false
                }); //, colspan: colspan
                objectcolField[index].push({field: field, parameter: parameter});

            });
        });
    }
}

function getColSpan(index) {
    var colspan = 0;
    for(var indexcol_dimensions=0; indexcol_dimensions<window.MEData.column_dimensions.length; indexcol_dimensions++){
        var valuecol_dimensions = window.MEData.column_dimensions[indexcol_dimensions];
        if (indexcol_dimensions > index) {
            if (colspan == 0) {
                if (valuecol_dimensions.name != "Sources" || (!sourcesExist))
                    colspan = valuecol_dimensions.values.length;
                else
                    colspan = 1;
            }
            else {
                if (valuecol_dimensions.name != "Sources" || (!sourcesExist))
                    colspan = colspan * valuecol_dimensions.values.length;
            }
        }
    };

    return colspan;
}
function GetRowValue(valueobjectRows, valueRowData, name) {
    if(name == 'links'){
        return "";
    }
    if (valueobjectRows[name] == undefined) {
        if (name == 'lineitems') {
            return valueobjectRows['id'].split("-")[0];
        } else {
            return valueRowData.name;
        }
    } else if (name == 'lineitems') {
        return valueobjectRows['id'].split("-")[0];
    } else {
        if($(valueobjectRows[name]).find(".fa-plus").length > 0){
            // handling for consensus+
            return "Consensus+";
        }
        try {
            return $.trim($(valueobjectRows[name]).text());
        }
        catch (ex) {
            return $.trim(valueobjectRows[name]);
        }
    }
}
var AlldgRows;

function MakeRowsDynamically(RowData, index, objectRows, RowObjectName, expansionFlag) {
    if (index == 0) {
        if (RowObjectName == 'lineitems') {
            for(var indexRowData=0; indexRowData<RowData.length; indexRowData++){
                RowData[indexRowData][RowObjectName] = RowData[indexRowData].shortname;
                RowData[indexRowData]["RowAppend"] = true;
                objectRows.push(jQuery.extend(true, {}, RowData[indexRowData]));
            }
        } else {
        //add image for trends here
        }
    } else if(cut != 'CPT' && index == 1 && RowObjectName == 'links'){
        for(var indexRowData=0; indexRowData< objectRows.length; indexRowData++){
            if(cut == 'SAR'){
                if(window.MEData.nmv_links && window.MEData.nmv_links[0][objectRows[indexRowData].id] && (window.MEData.nmv_links[0][objectRows[indexRowData].id]['CAP'] || window.MEData.nmv_links[0][objectRows[indexRowData].id]['COM'])) {
                    objectRows[indexRowData][RowObjectName] = '<img id="link-'+ objectRows[indexRowData].id +'" src="'+window.assetUrl+'/link.png" class="link-img"/>';
                }
            } else if (cut== 'NMV'){
                // add icon with hidden visiblity 
                var iscomparetopeer = objectRows[indexRowData].ops_sli != undefined ? true : false;
                var researchIcon = '<span class="research-icon fa fa-book" dapparameterid="'+ objectRows[indexRowData].id +'" onclick="showresearchpopup(event)" style="visibility: hidden;"></span>'
                objectRows[indexRowData][RowObjectName] = researchIcon + '<img id="link-'+ objectRows[indexRowData].id +'" src="'+window.assetUrl+'/link.png" class="link-img" style="visibility: hidden;"/>' +
                '<span class="trend-icon fa fa-bar-chart" dapparameterid="'+ objectRows[indexRowData].id +'" iscomparetopeer="'+ iscomparetopeer +'" onclick="showTrendChart(event)"></span>'
                    // '<img src="'+ window.assetUrl +'/chart-bar.png" class="trend-icon" dapparameterid="'+ objectRows[indexRowData].id +'" iscomparetopeer="'+ iscomparetopeer +'" onclick="showTrendChart(event)"/>'
            } else {
                objectRows[indexRowData][RowObjectName] = '<img id="link-'+ objectRows[indexRowData].id +'" src="'+window.assetUrl+'/link.png" class="link-img" style="visibility: hidden;"/>';
            }

            var peerIconStyle = cut == "STD"
              ? "width: 25px; vertical-align:middle;"
              : "width: 25px; vertical-align:middle; display:none;";

            var compareToPeerIcon = '<img class="compareToPeer-icon compareToPeerIcon-'+ objectRows[indexRowData].id +'" src="'+window.assetUrl+'/compare_to_peer.png" onclick="InspectorClick(true, \'peers\', \'peers\')" style="'+peerIconStyle+'"/>';
            objectRows[indexRowData][RowObjectName] = (objectRows[indexRowData][RowObjectName] != undefined ? objectRows[indexRowData][RowObjectName] : "") + compareToPeerIcon;
        }
    } else {
        if (!expansionFlag) {
            for(var indexobjectRow=0; indexobjectRow< objectRows.length; indexobjectRow++){
                for(var indexRowData=0; indexRowData< RowData.length; indexRowData++){
                    var parameter = "";
                    for(var indexrow_dimensions=0; indexrow_dimensions< window.MEData.row_dimensions.length; indexrow_dimensions++){
                        try {
                            if (index >= indexrow_dimensions && window.MEData.row_dimensions[indexrow_dimensions].name != 'links')
                                parameter = (parameter == "" ? parameter : parameter + '|') + GetRowValue(objectRows[indexobjectRow], RowData[indexRowData], window.MEData.row_dimensions[indexrow_dimensions].name);
                        }
                        catch (ex) {
                            alert(ex)
                        }
                    }
                    var title = "", ex_cc_icon="";

                    var currentRowData = objectRows[indexobjectRow];
                    var growthTypeObj = window.MEData.row_dimensions.filter(function(val){
                        return val.name.toLowerCase() == "growthtypes"
                    })[0];
                    var growthTypeList = growthTypeObj ? growthTypeObj.expansions : [];
                    // added checks to remove As % of lines from view when base lineitem magnitude & unit doesnt match
                    if((growthTypeList.length == 1 && growthTypeList.indexOf("%") > -1) && RowData[indexRowData].name.toLowerCase() == "analytics"){
                        // only % growthtype selected
                        if(currentRowData.unit == window.MEData.baseparameter.unit && currentRowData.magnitude == window.MEData.baseparameter.magnitude){
                            // magnitude & unit match with base line item show expansions
                            var imgText = "<img id='" + parameter.toLowerCase().replace(' ', '-').replace(/[|,]/g, '-') + "--" + objectRows[indexobjectRow].sortorder + "'" + " src='"+window.assetUrl+"/datagrid_row_expand.png' style='float:left;cursor:pointer;padding-top:3px' click-link=\"ShowHiderow(event,'" + rowDimension[index] + "','" + objectRows[indexobjectRow].id + "',this,'" + RowObjectName + "','" + parameter.replace(/&nbsp;/g, '') + "&&" + objectRows[indexobjectRow].sortorder + "')\"/>";    
                        }else{
                            var imgText = "<img style='visibility:hidden; width: 15px;'></img>";
                        }
                    }else{
                        // other than % show expansion
                        var imgText = "<img id='" + parameter.toLowerCase().replace(' ', '-').replace(/[|,]/g, '-') + "--" + objectRows[indexobjectRow].sortorder + "'" + " src='"+window.assetUrl+"/datagrid_row_expand.png' style='float:left;cursor:pointer;padding-top:3px' click-link=\"ShowHiderow(event,'" + rowDimension[index] + "','" + objectRows[indexobjectRow].id + "',this,'" + RowObjectName + "','" + parameter.replace(/&nbsp;/g, '') + "&&" + objectRows[indexobjectRow].sortorder + "')\"/>";
                    }
                    var RowDataName = RowData[indexRowData].name;
                    var showCPlusIcon = showConPlusIcon(RowDataName);
                    var showCCIcon = showCCicon(RowDataName);
                    var showExIcon = showExcludedIcon(RowDataName);
                    
                    if (showExIcon) {
                        ex_cc_icon += "<img class='excluded_icon' src='"+window.assetUrl+"/icon-excluded.png' style='display:none'/>";
                    }
                    if (showCCIcon) {
                        ex_cc_icon += "<img class='custcon' src='"+window.assetUrl+"/custom_consensus.png'/>";
                    }
                    
                    if(showCPlusIcon){
                        ex_cc_icon += "<img class='conPlus_icon' src='"+window.assetUrl+"/consensus_plus_icon.png'/>";
                    }
                    if (showExIcon && showCCIcon ||
                        showExIcon && showCPlusIcon ||
                        showCCIcon && showCPlusIcon) {
                        title = "<span class='ellipsis_row2 ellipsis-td-span'><b>" + RowDataName + "</b></span>";
                    } else {
                        title = "<span><b>" + RowDataName + "</b></span>";
                    }

                    if(showCCIcon && showExIcon && showCPlusIcon){
                        // if 3 icons selected
                        ex_cc_icon = "<img class='excluded_icon' src='"+window.assetUrl+"/icon-excluded.png'/><img class='custcon' src='"+window.assetUrl+"/custom_consensus.png'/>"
                    }

                    if(RowDataName =='Consensus+') {
                       title = "<span><b>" + RowDataName.slice(0,-1) + "</b> <span style='color: #f2883d;vertical-align: middle; font-size:13px;    padding: 2px 0 2px 2px;' class='fa fa-plus'></span></span>";
                    }

                    if(!objectRows[indexobjectRow].header)
                        objectRows[indexobjectRow][RowObjectName] = '<div class="ellipsis_source">'+ imgText + title + "&nbsp;" + ex_cc_icon + '</div>';
                    else
                        objectRows[indexobjectRow][RowObjectName] = '';
                    var rowid = ""
                    //                    if (objectRows[indexobjectRow].id.split("-").length != index + 1) {
                    for(var indexrow_dimensions=0; indexrow_dimensions< window.MEData.row_dimensions.length; indexrow_dimensions++){
                        if (index >= indexrow_dimensions && window.MEData.row_dimensions[indexrow_dimensions].name != 'links')
                            rowid = (rowid == "" ? "" : rowid + "-")
                        if (index > indexrow_dimensions) {
                            if (window.MEData.row_dimensions[indexrow_dimensions].name == 'lineitems') {
                                rowid = rowid + objectRows[indexobjectRow]['id'].split("-")[0];
                            } else if (window.MEData.row_dimensions[indexrow_dimensions].name != 'links'){
                                try {
                                    rowid = rowid + window.MEData.row_dimensions[indexrow_dimensions].values[0].name; //$.trim($(valueobjectRows[window.MEData.row_dimensions[indexrow_dimensions].name]).text());
                                }
                                catch (ex) {
                                    console.error(ex)
                                }
                            }
                        }
                        else if (index == indexrow_dimensions) {
                            rowid = rowid + RowData[indexRowData].name;
                        }
                    }
                    objectRows[indexobjectRow]['id'] = rowid.replace(/&nbsp;/g, '').toLowerCase();
                    //                    alert(objectRows[indexobjectRow]['id'])
                    //                    }
                }
            }
        } else {
            var link_exist_flag=$.inArray("link",rowDimension)>0;
            var totalLength = objectRows.length;
            for (i = 0; i < totalLength; i++) {
                j = 0;
                if ($.inArray(objectRows[i][RowObjectName], RowData) == -1) {
                    for(var indexRowData=0; indexRowData< RowData.length; indexRowData++){
                        j++;
                        valueobjectRows = objectRows[i];
                        var rowid = ""
                        if (valueobjectRows.id.split("-").length != index + 1 && valueobjectRows.id.split("-").length < index + 1) {
                            for(var indexrow_dimensions=0; indexrow_dimensions< window.MEData.row_dimensions.length; indexrow_dimensions++){
                                if (index >= indexrow_dimensions && window.MEData.row_dimensions[indexrow_dimensions].name != 'links')
                                    rowid = (rowid == "" ? "" : rowid + "-")
                                //                                if (index > indexrow_dimensions) {
                                if (window.MEData.row_dimensions[indexrow_dimensions].name == 'lineitems') {
                                    rowid = rowid + valueobjectRows['id'].split("-")[0];
                                } else if(window.MEData.row_dimensions[indexrow_dimensions].name != 'links') {
                                    try {
                                        //todo check why text is used here
                                        //var rowIdPart = $.trim($(valueobjectRows[window.MEData.row_dimensions[indexrow_dimensions].name]).text()) || valueobjectRows.id.split('-')[1]
                                        var rowIdPart = valueobjectRows.id.split('-')[indexrow_dimensions-1];
                                        if(rowIdPart)
                                            rowid = rowid + rowIdPart;
                                    }
                                    catch (ex) {
                                        rowid = rowid + $.trim(valueobjectRows[window.MEData.row_dimensions[indexrow_dimensions].name]);
                                    }
                                }

                            }
                            rowid = rowid.replace(/&nbsp;/g, '');
                            
                            var growthTypeObj = window.MEData.row_dimensions.filter(function(val){
                                return val.name.toLowerCase() == "growthtypes"
                            })[0];

                            var growthTypeList = growthTypeObj ? growthTypeObj.expansions : [];

                            // added checks to remove As % of lines from view when base lineitem magnitude & unit doesnt match
                            if (valueobjectRows[RowObjectName].indexOf('img ') > -1) {
                                if(growthTypeList.length == 1 && growthTypeList.indexOf("%") > -1 && rowid.indexOf("analytics") > -1){
                                    if(valueobjectRows.unit == window.MEData.baseparameter.unit && valueobjectRows.magnitude == window.MEData.baseparameter.magnitude){
                                        valueobjectRows[RowObjectName] = "<img id='" + rowid.toLowerCase().replace(' ', '-').replace(/[|,]/g, '-') + "--" + valueobjectRows.sortorder + "'" + " src='"+window.assetUrl+"/datagrid_row_expand.png' style='float:left;cursor:pointer;padding-top:3px' click-link=\"ShowHiderow(event,'" + rowDimension[index] + "','" + valueobjectRows.id + "',this,'" + RowObjectName + "','" + rowid.replace(/-/g, '|') + "&&" + valueobjectRows.sortorder + "');\"/>&nbsp;<b>" + $.trim($(valueobjectRows[RowObjectName]).text()) + "</b>";
                                    }else{
                                        valueobjectRows[RowObjectName] = "<img style='visibility:hidden; width: 15px;'></img><b>" + $.trim($(valueobjectRows[RowObjectName]).text()) + "</b>";
                                    }
                                }else{
                                    var rowObj = "<img id='" + rowid.toLowerCase().replace(' ', '-').replace(/[|,]/g, '-') + "--" + valueobjectRows.sortorder + "'" + " src='" + window.assetUrl + "/datagrid_row_expand.png' style='float:left;cursor:pointer;padding-top:3px' click-link=\"ShowHiderow(event,'" + rowDimension[index] + "','" + valueobjectRows.id + "',this,'" + RowObjectName + "','" + rowid.replace(/-/g, '|') + "&&" + valueobjectRows.sortorder + "');\"/>";
                                    valueobjectRows[RowObjectName] = (valueobjectRows.id.includes('consensus+') && !valueobjectRows.id.includes('analytics')) ? rowObj+"&nbsp;<b>"+$.trim($(valueobjectRows[RowObjectName]).text())+"</b> <span style='color: #f2883d;vertical-align: middle;font-size:13px;    padding: 2px 0 2px 2px;' class='fa fa-plus'></span>" : rowObj+"<b>"+$.trim($(valueobjectRows[RowObjectName]).text())+"</b>";
                                }
                            }
                            valueobjectRows['id'] = rowid.toLowerCase();
                        }

                        objectRows.splice(i + j, 0, jQuery.extend(true, {}, objectRows[i]));
                        var rowData = objectRows[j + i];
                        rowData['id'] = rowData.id //+ "-" + valueRowData.toLowerCase();
                        var rowid = ""
                        //                        alert("before-->" + rowData.id);
                        //                        if (rowData.id.split("-").length != index + 1) {
                        var newid = $.grep(rowData.id.replace(/-/g,'|').replace('||','|-').split("|"),function(n){ return(n) });

                        for(var indx=0; indx< window.MEData.row_dimensions.length; indx++){
                            //                            if (index >= indexrow_dimensions)
                            if(window.MEData.row_dimensions[indx].name != 'links') {
                                rowid = (rowid == "" ? "" : rowid + "-")
                            }
                            if (index != indx) {
                                if (window.MEData.row_dimensions[indx].name == 'lineitems') {
                                    rowid = rowid + newid[indx];
                                }
                                else if(window.MEData.row_dimensions[indx].name != 'links'){
                                    if(link_exist_flag)
                                        var ind = indx - 1;
                                    // try {
                                        rowid = rowid + newid[ind]; //$.trim($(rowData[window.MEData.row_dimensions[indexrow_dimensions].name]).text());
                                    // }
                                    // catch (ex) {
                                    //     // rowid = rowid + newid[indx]//$.trim(rowData[window.MEData.row_dimensions[indexrow_dimensions].name]);
                                    // }
                                }

                            }
                            else if (index == indx) {
                                rowid = rowid + RowData[indexRowData];
                            }
                        }

                        var rowIdArray = rowid.split('-');
                        var revIndex = $.inArray("revision", rowDimension);

                        if(rowIdArray.indexOf("") != -1) {
                            revIndex = revIndex + 1;
                        }

                        var newRowDomId = rowIdArray.slice(0, revIndex).join('-').replace(' ', '-');
                        rowData["RowAppend"] = false;
                        rowData['id'] = rowid.replace(/&nbsp;/g, '').toLowerCase();

                        var displayRowValue;

                        if (GROWTHTYPES === RowObjectName) {
                            var growthTypeVal = (RowData[indexRowData] == "%") ? GrowthTypesEnum[RowData[indexRowData]] + " " + window.MEData.baseparameter.name : GrowthTypesEnum[RowData[indexRowData]];
                            var growthTypeEnumValue = growthTypeVal;
                            displayRowValue = RowData[indexRowData] == TREND ? growthTypeEnumValue() : growthTypeEnumValue
                        } else {
                            displayRowValue = RowData[indexRowData]
                        }

                        var titleText = (RowData[indexRowData] == "%") ? displayRowValue : '';
                        rowData[RowObjectName] = '<span id="' + newRowDomId.toLowerCase() + "--" + rowData.sortorder + '" title="'+ titleText +'">' + displayRowValue + '</span>';

                        for(var indexrow_dimensions=0; indexrow_dimensions< window.MEData.row_dimensions.length; indexrow_dimensions++){
                            if (index > indexrow_dimensions)
                                $(rowData).removeProp(window.MEData.row_dimensions[indexrow_dimensions].name)
                        }
                    }
                    i = i + j;
                    totalLength = objectRows.length;
                }
            }
        }
    }
}

function showresearchpopup(event) {
    
    var $target = $(event.currentTarget),
    dapparam_id = Number($target.attr('dapparameterid'));
    var dataObj = window.dsmObj.dapValues.filter((val)=>val.dapparameterid === dapparam_id)[0]
    const showResearchInsightPopup = new CustomEvent('showResearchInsightPopup', { detail:dataObj })
    window.dispatchEvent(showResearchInsightPopup);

}

function showTrendChart(event){
var $target = $(event.currentTarget),
     dapparam_id = $target.attr('dapparameterid'),
     source = 'Consensus',
    iscomparetopeer = $target.attr('iscomparetopeer'),
     periodsPanel = window.MEData.panels.filter(function(value) {
        return value.name == "periods" })[0];
     if(firstEstimatedYear == ''){
         getFirstEstimatedYear(window.MEData);
     }

     var sourcesList = [];
     var defaultData = window.MEData.panels.filter(function(n) {
            return (n.name == "Sources") })[0];
     $.each(defaultData.values, function (i, defaultSources) {
        var tempArr = defaultSources.values.map(function (n) {
              return {
                label: n.name,
                value: n.name,
                checked: source === n.name
              };
            });
        if (tempArr.length > 0 && defaultSources.name == 'Brokers') {
            sourcesList = sourcesList.concat(tempArr.reverse());

        }
     });
    var dataToUse = {};
    dataToUse["ticker"] = window.MEData.ticker;
    dataToUse["dapparamId"] = dapparam_id;
    dataToUse["period"] = firstEstimatedYear;
    dataToUse["currentQuarter"] = periodsPanel.currentquarter;
    dataToUse["companyFullName"] = window.MEData.company_name;
    dataToUse["source"] = source;
    dataToUse["sourceList"] = sourcesList;
    dataToUse["cut"] = window.cut;
    // dataToUse["peersList"] = pList;
    // dataToUse["tickerList"] = tickerList;
    // dataToUse["isPeers"] = iscomparetopeer == 'true';
    dataToUse["selectedCurrency"] = window.MEData.selectedCurrency;
    dataToUse["export"] = true;
    const showChart = new CustomEvent('showChart',{ detail: {dataToUse: dataToUse, type:"trend"} })
    window.dispatchEvent(showChart);
}

function GetSelectedExpansion(defaultData, PanelData) {
    if (PanelData.length > 0 && defaultData.length > 0) {
        //var newexpansionIndex = PanelData[0].values.length;
        defaultData[0].expansions = [];
        for(var index=0; index<PanelData[0].values.length; index++){
            var value = PanelData[0].values[index];
            if (value.selected == true && $.inArray(value.name, defaultData[0].expansions) == -1) {
                if (defaultData[0].name == 'Sources')
                    defaultData[0].expansions.push(value.name);
                else if (defaultData[0].values[0].name != value.name)
                    defaultData[0].expansions.push(value.name);
            }
            //            else
            //                newexpansionIndex--;
        };
    }
    /* if (defaultData.length > 0 && defaultData[0].expansions != undefined) {
     $.each(defaultData[0].expansions, function (index, value) {
     if ($('#' + value).is(':checked') == false && $.inArray(value, defaultData[0].expansions) != -1)
     defaultData[0].expansions.splice($.inArray(value, defaultData[0].expansions), 1)
     });
     }
     */
}

function MakeColDimensionSequenceSame(metaData) {
    colDimension = [];
    for(var indexcol_dimensions=0; indexcol_dimensions<metaData.column_dimensions.length; indexcol_dimensions++){
        var valuecol_dimensions = metaData.column_dimensions[indexcol_dimensions];
        var objColdimension = valuecol_dimensions.name.toLowerCase().substring(0, valuecol_dimensions.name.length - 1);
        if ($.inArray(objColdimension, colDimension) == -1)
            colDimension.push(objColdimension);
    };
}

function adjustInspectorTabs() {
  var footerInsTabs = $('.datagrid-view2 .datagrid-custom-div #footerTypeDiv');
  footerInsTabs.css('position', 'fixed');
  if($('#tblIns #footerTypeDiv').is(':visible')) {
    var distanceFromleft = $('#tblIns #footerTypeDiv').offset().left;
    footerInsTabs.css('left', distanceFromleft);
  }
}

window.MEData = {};
var globalTimer,notesInterval;
/*Model Explorer related functionality*/
var ModelExplorer = function () {
};
function expandAllLines(ev, type){
    setTimeout(function(){
        var featureSection, anyCollapsibleOnes, anyExpandableOnes;
        if(type === 'lineitems') {
            featureSection = $('#tt').datagrid("getPanel").find('table').eq(1).find('tbody td[field="lineitems"]');
            anyCollapsibleOnes = featureSection.find('img[src$="datagrid_row_collapse.png"]');
            anyExpandableOnes = featureSection.find('img[src$="datagrid_row_expand.png"]');
        }
        else if(type === 'analytics'){
            featureSection = $('#tt').datagrid("getPanel").find('table').eq(1).find('tbody td[field="GrowthTypes"]');
            anyCollapsibleOnes = featureSection.find('img[src$="datagrid_row_collapse.png"]').closest('td');
            anyExpandableOnes = featureSection.find('img[src$="datagrid_row_expand.png"]').closest('td');
        }
        if($(ev).find('img').attr('src').indexOf('collapse') > -1) {
            //Collapse All
            $(ev).find('img').attr('src', window.assetUrl + '/datagrid_row_expand.png');
            if (anyCollapsibleOnes.length > 0) {
                anyCollapsibleOnes.click()
            }
        }
        else{
            //Expand All
            $(ev).find('img').attr('src', window.assetUrl + '/datagrid_row_collapse.png');
            if (anyExpandableOnes.length > 0) {
                anyExpandableOnes.click()
            }
        }
    },150)
}

ModelExplorer.prototype = {
    //dataExpandField: [],
    rows: [],
    AddRows: function (objrow) {
        var objME = this;
        try {
            $.each(objrow, function (indexrow_dimensions, valuerow_dimensions) {
                if (valuerow_dimensions.children.length > 0) {
                    objME.AddRows(valuerow_dimensions.children);
                }
                objME.rows.push(valuerow_dimensions);
            });
        } catch (ex) {
        }
    },
    LoadDataGrid: function (rptdata, defaultLoading, panelsRefresh) {
		// heap_tracking(company, {'action':rptdata.base_cut, 'ticker':rptdata.ticker,'view':rptdata.base_cut,'tab': window.pg});
        if(explicitRefresh && !defaultLoading){
            return;
        }
        else {
            gridLoadedMEData = jQuery.extend(true, {}, rptdata);
        }
        isClearAll = false;
        isGridFirstLoad = false;
        isFirstLoad = true;
        explicitRefresh = true;
       // //$('#tt').datagrid('clearSelections');
        if (rptdata == null) {
            rptdata = window.MEData;
        }
        Intialization(rptdata);
        var colsfrozen = [[]];
        var cols = [];
        var colField = [];
        var rows = [];
        var mydata = [];

        var rowData;
        var objWebServiceCall = new WebServiceCall();
        /*Fill the panel(Begin)*/
        var startFY, EndFY;
        samplecolrow = rptdata;

        //Check if the revision is applied on row or column and then update the existing MEData object with the latest revision's expansion values
        // var revisionColumnData=rptdata.column_dimensions.filter( function (n) {
        //     return (n.name == 'Revisions');
        // });
        // if(revisionColumnData.length > 0){
        //     revisionColumnData = revisionColumnData[0];
        //     revisionColumnData.expansions = RevisionDimension().expansions;
        // }
        // var revisionRowData= rptdata.row_dimensions.filter( function (n) {
        //     return (n.name == 'Revisions');
        // });
        // if(revisionRowData.length > 0){
        //     revisionRowData = revisionRowData[0];
        //     revisionRowData.expansions = RevisionDimension().expansions;
        // }

        if (samplecolrow.panels != undefined) {
            window.MEData = rptdata;
            for(var i=0; i<window.MEData.row_dimensions.length; i++){
                var valueRowData = window.MEData.row_dimensions[i];
                if(valueRowData.name=='Revisions'){
					valueRowData.expansions = orderRevisions(valueRowData.expansions, true)
                }
            }
            if (defaultLoading == true) {
                intializeBaseValues(samplecolrow);
                colPanels = samplecolrow.panels;
                tickerData[samplecolrow.ticker] = samplecolrow['current-quarter'];
                tickerData['months'] = ["", "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

                reloadPanels(samplecolrow);
                if (samplecolrow.view_name != undefined) {
                    if (samplecolrow.source != undefined) {
                        $('#view').text("#" + samplecolrow.view_code + " - " + samplecolrow.source).attr("title", samplecolrow.view_name);
                    }
                    else {
                        $('#view').text("#" + samplecolrow.view_code).attr("title", samplecolrow.view_name);
                    }
                }

                // fix width for view name
                // if (samplecolrow.ticker != undefined) {

                //     //sourceN needed for dummyajax call
                //     if ($('#breadNav').is(':empty')) {
                //          if (window.MEData.view_code == 'SAR') {
                //             var sourceN = $('.right-panel-selected-tab').attr('schheader');
                //         }

                //     }
                // }

            }
            if(cut == 'SAR'){
                if(window.sarToNmvLinks) {
                    window.MEData.nmv_links = window.sarToNmvLinks;
                }
            }
            if (panelsRefresh || rptdata.coveragetypeid == 2)
                reloadPanels(samplecolrow);
            /*Fill the panel(End)*/
            /*Below code is based on sample data(Begin)*/
			order_dimensions(window.MEData);
            var colum_Dimension;
            // var currency = samplecolrow.currency == undefined ? "" : samplecolrow.currency;
            // var unit = samplecolrow.unit == undefined ? "" : samplecolrow.unit;
            // var magnitude = samplecolrow.magnitude == undefined ? "" : samplecolrow.magnitude;



            if (samplecolrow.column_dimensions != undefined) {
                colum_Dimension = samplecolrow.column_dimensions;
            } else {
                colum_Dimension = samplecolrow.col_dimensions;
            }

            GetExpansionsForAllPanels();
            MakeColDimensionSequenceSame(window.MEData);
            //todo check this
            for(var indexcol_dimensions=0; indexcol_dimensions<colum_Dimension.length; indexcol_dimensions++){
                var valuecol_dimensions = colum_Dimension[indexcol_dimensions];
                var objColdimension = valuecol_dimensions.name.toLowerCase().substring(0, valuecol_dimensions.name.length - 1);
                if ($.inArray(objColdimension, colDimension) == -1)
                    colDimension.push(objColdimension);
                cols.push([]);
                ExpandedColList.push([]);
                colField.push([]);
            }

            for(var indexrow_dimensions=0; indexrow_dimensions<window.MEData.row_dimensions.length; indexrow_dimensions++){
                var valuerow_dimensions = window.MEData.row_dimensions[indexrow_dimensions];
                var objRowdimension = valuerow_dimensions.name.toLowerCase().substring(0, valuerow_dimensions.name.length - 1);
                if ($.inArray(objRowdimension, rowDimension) == -1)
                    rowDimension.push(objRowdimension);
            };
            if ($.inArray('source', rowDimension) > -1) {
                window.MEData.row_dimensions[$.inArray('source', rowDimension)].expansions = getSourceExpansion();
            }
            if (defaultLoading) {
                defaultcolDimension = colDimension;
                defaultrowDimension = rowDimension;
            }
            //todo check this

            //Columns generation dynamically
            for(var indexcol_dimensions=0; indexcol_dimensions<colum_Dimension.length; indexcol_dimensions++){
                var valuecol_dimensions = colum_Dimension[indexcol_dimensions];
                MakeColsDynamically(valuecol_dimensions.values, indexcol_dimensions, colum_Dimension.length, cols, colField, valuecol_dimensions.expansions);
            };
            //Rows generation dynamically
            var col_width = 0, showResizebtn = true, longest_row = '', maxlen = 36;
            for(var rowindex=0; rowindex<samplecolrow.row_dimensions[0].values.length; rowindex++){
                var rowvalue = samplecolrow.row_dimensions[0].values[rowindex];
                var width = (rowvalue.shortname.length)*6 + (4 + (4 * rowvalue.indent))*3.8;
                if(Math.round(width) > col_width){
                    col_width = Math.round(width);
                    longest_row = rowvalue;
                }
            };
            if(longest_row.parameter_unit){
                col_width += longest_row.parameter_unit.length * 7;
            }
            if(col_width > 550){
                col_width = 550;
            }
            if(col_width <= 250){
                col_width = 250;
                showResizebtn = false;
            } else {
                showResizebtn = true;
            }
            if(rptdata.expandLineitem == 'false'){
                col_width = 250;
            }
            if(col_width > 250){
                maxlen = Math.round((maxlen * col_width) / 200);
            }
            for(var indexrow_dimensions=0; indexrow_dimensions<samplecolrow.row_dimensions.length; indexrow_dimensions++){
                var valuerow_dimensions = samplecolrow.row_dimensions[indexrow_dimensions];
                colsfrozen[0].push({
                    field: valuerow_dimensions.name,
                    title: "",
                    resizable: false,
                    width: (rowDimension[indexrow_dimensions] == 'lineitem' ? col_width : (rowDimension[indexrow_dimensions] == 'link' ? (window.MEData.global_sli == true ? 106 : 81) :108)), // globalSli check for compare to peer icon additional 9px for outer-padding // change width from 100 to 108 for C+ to show + icon
                    align: 'left',
                    sortable: false
                });
            };


            for(var indexrow_dimensions=0; indexrow_dimensions<samplecolrow.row_dimensions.length; indexrow_dimensions++){
                var valuerow_dimensions = samplecolrow.row_dimensions[indexrow_dimensions];
                MakeRowsDynamically(valuerow_dimensions.values, indexrow_dimensions, rows, valuerow_dimensions.name, false);
            }
            this.rows = rows;
            AlldgRows = jQuery.extend(true, [], rows);
            if(cut !== 'SAR'){
                excl_sources = getExcludedBrokers();
                incl_sources = getIncludedBrokers();
            }
            /*Below code is based on sample data(End)*/
            // $(function () {
                HideIns();
                var winH = $(window).height(); //window.screen.height;
                var winW =  setWidthForPanels(gridHeight);
                $('#tt').datagrid({
                    title: '',
                    //toolbar: '#tb',


                    onClickRow: function (index, field) {
                        if (index != undefined) {
                            $(".mex-grid-table-component #tblIns #footerTypeDiv").remove();
                            $(".datagrid-view2 #footerTypeDiv").css("visibility","visible");
                            if (!$('#tblIns').is(":visible") && $('.datagrid-footer').is(":visible")) {                                
                                LoadDatagridFooterData(index, inspectorType, true, "rowClick");                                
                            }
                            else{
                                $('.tblInsSpan').text(field.shortname + (field.parameter_unit ? field.parameter_unit : ""));
                            }

                            if(field.id.toLowerCase().startsWith("dummy")) {
                                cleanUpInspector();
                                return;
                            }

                            var leftGridWidth = $('.datagrid-view1').width();

                            //tabs should start exactly after 320px. 
                            //subtracting 22px; width of up/down arrow on inspector.
                            $('#tblIns .tblInsSpan').width(320 - 52);
                            $('#tblIns .tblInsSpan').after($(footerTypes()));
                            clickToAddEvent($('#tblIns #footerTypeDiv').eq(0));
                            $(".mex-grid-table-component #tblIns #footerTypeDiv").children().attr("class", "fstdInsp fstddiv");
                            if( $(".compareToPeerIcon-"+field.param_id).is(":visible")) {
                              $("#TdPeers").css("visibility","visible");
                              $("#footerTypeDiv #TdPeers").css('display', 'inherit');
                            }else{
                              $("#TdPeers").css("visibility","hidden");
                                $("#footerTypeDiv #TdPeers").css('display', 'none');
                            }
                            $("#footerTypeDiv #TdComptable").css('display','none');
                            // createLog("pid:", field.id);
                            adjustInspectorTabs();
                            
                            // footerInsTabs.css('margin-left', '-8px');
                            // footerInsTabs.css('margin-left', -1*(leftGridWidth - 366 +19));
                            
                            if(
                              window.cut === 'NMV' && selectedLineStdAndCompDict[window.pg + field.param_id]
                              && !selectedLineStdAndCompDict[window.pg + field.param_id].comptableMappings
                            ) {
                                window.dispatchEvent(
                                    new CustomEvent("nmvSliMapState", {
                                        detail: {
                                            state: false,
                                            hasPeers: false
                                        }
                                    })
                                );
                                    var sliMappingData = selectedLineStdAndCompDict[window.pg + field.param_id];
                                    setTimeout(function() {
                                        window.dispatchEvent(
                                            new CustomEvent("nmvSliMapState", {
                                                detail: {
                                                    state: true,
                                                    hasPeers: sliMappingData.hasPeers
                                                }
                                            })
                                        );
                                    }, 100);
                                    fetchComptableMappings(sliMappingData.stdMappings, field.param_id);
                            }else if (window.cut === 'NMV' && selectedLineStdAndCompDict[window.pg + field.param_id]
                              && selectedLineStdAndCompDict[window.pg + field.param_id].comptableMappings
                            ) {
                                window.dispatchEvent(
                                    new CustomEvent("nmvSliMapState", {
                                        detail: {
                                            state: true,
                                            hasPeers: selectedLineStdAndCompDict[window.pg + field.param_id].hasPeers
                                        }
                                    })
                                );
                                setComptableTabState(selectedLineStdAndCompDict[window.pg + field.param_id].comptableMappings, field.param_id);
                            }else if (window.cut === 'STD' && !selectedLineStdAndCompDict[window.pg + field.param_id] && field.param_id) {
                                var stdMappings = [[field.param_id]];
                                selectedLineStdAndCompDict[window.pg + field.param_id] = { stdMappings: stdMappings, comptableMappings: [] };
                                window.dispatchEvent(
                                    new CustomEvent("nmvSliMapState", {
                                        detail: {
                                            state: false,
                                            hasPeers: false
                                        }
                                    })
                                );
                                getCompanyPeers(window.MEData.ticker, field.param_id, function(peerRes) {
                                    selectedLineStdAndCompDict[window.pg + field.param_id].hasPeers = peerRes;
                                    setTimeout(function() {
                                        window.dispatchEvent(
                                            new CustomEvent("nmvSliMapState", {
                                                detail: {
                                                    state: true,
                                                    hasPeers: peerRes
                                                }
                                            })
                                        );
                                    }, 100);
                                });
                                fetchComptableMappings(stdMappings, field.param_id);
                            }else if (window.cut === 'STD' && selectedLineStdAndCompDict[window.pg + field.param_id]) {
                                window.dispatchEvent(
                                    new CustomEvent("nmvSliMapState", {
                                        detail: {
                                            state: true,
                                            hasPeers: selectedLineStdAndCompDict[window.pg + field.param_id].hasPeers
                                        }
                                    })
                                );
                                setComptableTabState(selectedLineStdAndCompDict[window.pg + field.param_id].comptableMappings, field.param_id);
                            }

                        }
                        //stop.propagation is being called in easyuigrid for click , hence triggering click here
                        //please verify and remove when version updated.
                        $(document).trigger('click');
                    },
                    idField: 'name',
                    height: winH - gridHeight - extraSize, //* .84,
                    width: winW,
                    fitColumns: false,
                    singleSelect: true,
                    nowrap: true,
                    fit: false,
                    rownumbers: false,
                    //pageSize: 20,
                    showFooter: true,
                    pagination: false,
                    striped: false,
                    frozenColumns: colsfrozen,
                    columns: cols
                });

            // });

            //inserting inspector settings div between body and footer
            if(cut !== 'SAR'){

            appendInspectorSettings(window.MEData.inspector);
            if (!jQuery.isEmptyObject(window.MEData.inspector))
                bindHideEventToFooter(window.MEData.inspector);
            displayInspectorInfo(window.MEData);
            }
            if (window.gScenario != "") {
                if ($('#editCompositeTd').length == 0) {
                    var lastTd = $('#topTab').find('td').last();
                    var editCompositeImg = '<td class="fstd_duplicate" id="editCompositeTd" qttitle="Create custom allows you to select a different broker for each assumption.\
					Once you are done, click save to store your custom assumptions." style="padding-right:5px"><input id="editCompositeImg" class="tab-buttons" type="button" value="edit" \
                    onclick="customScenarioMeta(this);"></td>';
                    $(editCompositeImg).insertAfter(lastTd);
                    qtipSettings($('#editCompositeTd'), 'qttitle', true);
                }
            }

            var lastTd = $('#topTab').find('td').last();
            if (window.MEData.editUserVariant)
                editVariantMode = true;
            if (window.MEData.editcomposite) {
                //$('#editCompositeTd').hide();
                $('#editCompositeImg').attr("onclick", "saveVariant()").attr("value", "save model");
                if ($('#hideDisabledTd').length == 0) {
                    var lastTd = $('#editCompositeTd');
                    var hideDisabledString = '<td class="fstd_duplicate" id="hideDisabledTd" style="padding-right:5px"><input id="hideDisabledImg"  class="tab-buttons" \
                     type="button" value="hide disabled" \
                    onclick="toggleDisabled();"></td>';
                    $(hideDisabledString).insertAfter(lastTd);
                }
            }
            
            //hide edit variant button if custom scenario mode or edit scenario mode
            if (window.gScenario == customScenarioName && !window.MEData.editcomposite)
                $('#editCompositeTd').hide();
            else if (window.gScenario != customScenarioName && !window.MEData.editcomposite)
                $('#editCompositeTd').show();
            if (window.MEData.disabledrivertoggle)
                $('#driverToggleTd').hide();
            // if (defaultLoading) {
            //     //check left panel state and trigger open if true
            //     if(window.MEData.panel_state.leftPanel && $('#openRightPanel').is(":visible")){
            //         $('#openRightPanel .right-panel-arrow').trigger('click');
            //     }

            // }
            $('#tt').datagrid('loadData', this.rows);
            italicRows();
            if ($('.datagrid-footer').is(":visible") == false) {
                setTimeout(reziseGridPanel, 100);
            }
            //setTimeout("RowCreation();", 1100);
            var rowObj;
            var objME = this;
            rowObj = this.rows;
            /*To append the field attribute*/
            var table = $('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr');
            $('#tt').datagrid("getPanel").find('table').eq(3 + 1).attr("class", "datasettable");
            for(var indexcolField=0; indexcolField<colField.length; indexcolField++){
                var valuecolField = colField[indexcolField];
                for(var indexColFData=0; indexColFData<valuecolField.length; indexColFData++){
                    var valueColFData = valuecolField[indexColFData];
                    table.eq(indexcolField).find('td').eq(indexColFData).attr('field', valueColFData.field).attr('param', valueColFData.parameter);
                };
            };

            //Append Currency details
            var currency_display_message = '';
            if (window.MEData.view_code == 'SAR')
                currency_display_message = "In units as reported by source";
            else
                currency_display_message = "All numbers in <b>" + window.MEData.currency + window.MEData.magnitude + "</b> unless stated otherwise"
            $('#tt').datagrid("getPanel").find('table').eq(0).find('tr').find('td').find(".datagrid-sort-icon").eq(0).prepend(currency_display_message).css({"font-size" : "x-small","color" : "#c8c8c8","float": "left"}); //prepend(currency + unit + magnitude)

            var sectionShow = $('#tt').datagrid("getPanel").find('table').eq(0).find('tr').find('td').find('div').eq(0);
            if(showResizebtn) {
                if (rptdata.expandLineitem == 'false')
                    sectionShow.prepend('<img align="left" src="'+window.assetUrl+'/expand.png" title="Show Full Name" class="expandlineitem" onclick="expandLineitemColumnProcess();">').prepend('<div id="exAllLineItems" class="exLineItemsClass" title="Expand/Collapse all lines" onclick="expandAllLines(this, \'lineitems\')"><img src="'+window.assetUrl+'/datagrid_row_collapse.png"/></div>');
                else if (rptdata.expandLineitem == 'true')
                    sectionShow.prepend('<img align="left" src="'+window.assetUrl+'/collapse.png" title="Show Trimmed Name" class="expandlineitem" onclick="expandLineitemColumnProcess();">').prepend('<div id="exAllLineItems" class="exLineItemsClass" title="Expand/Collapse all lines" onclick="expandAllLines(this,\'lineitems\')"><img src="'+window.assetUrl+'/datagrid_row_collapse.png"/></div>');
            }
            else{
                sectionShow.prepend('<div id="exAllLineItems" class="exLineItemsClass" title="Expand/Collapse all lines" onclick="expandAllLines(this,\'lineitems\')"><img src="'+window.assetUrl+'/datagrid_row_collapse.png"/></div>');
            }
            var analyticsExAll = '<div id="exAllAnalytics" class="exLineItemsClass" title="Expand/Collapse all Analytics" onclick="expandAllLines(this,\'analytics\')"><img src="'+window.assetUrl+'/datagrid_row_expand.png"/></div>'
            $('#tt').datagrid("getPanel").find('table').eq(0).find('tr').find('td[field="GrowthTypes"]').find('div span.datagrid-sort-icon').html(analyticsExAll);
            //Discussiom to do.
            //On based of columndimension what should be the service call could be the Problem
            getCommonSizeData = false;
            if (!(window.MEData.baseparameter.notAvail)) {
                getCommonSizeData = true;
            }

            // make pg callls
            if(!MEData.initialCall){
                if(cut !== "SAR" && cut !== 'SCH'){
                    const callAllPgCallEvt = new CustomEvent('GetAllPgData', {detail:{ onlyPgCall: true} })
                    window.dispatchEvent(callAllPgCallEvt); 
                } else {

                
                for(var i=0; i<actualPlusFuturePeriods.list.length; i++){
                    var periodList1 = actualPlusFuturePeriods.list[i];
                    if(periodList1.length != 0){
                        var source = (i == 0) ? window.gSourceActual : gSourceFuture;
                        var count = 0;
                        for(var j=0; j<actualPlusFuturePeriods.callsToMake[i]; j++){
                            if(actualPlusFuturePeriods.callsToMake != 0){
                                var periodsforCall = [];
                                periodsforCall = periodList1.slice(count, (count+actualPlusFuturePeriods.setOfPeriods[i]));
                                objWebServiceCall.getSelectedGroupData(periodsforCall, source);
                                count = count + actualPlusFuturePeriods.setOfPeriods[i];
                            }
                        }
                    }
                };
                }
            }else if(cut === "SAR" || cut === 'SCH'){

                
                for(var i=0; i<actualPlusFuturePeriods.list.length; i++){
                    var periodList1 = actualPlusFuturePeriods.list[i];
                    if(periodList1.length != 0){
                        var source = (i == 0) ? window.gSourceActual : gSourceFuture;
                        var count = 0;
                        for(var j=0; j<actualPlusFuturePeriods.callsToMake[i]; j++){
                            if(actualPlusFuturePeriods.callsToMake != 0){
                                var periodsforCall = [];
                                periodsforCall = periodList1.slice(count, (count+actualPlusFuturePeriods.setOfPeriods[i]));
                                objWebServiceCall.getSelectedGroupData(periodsforCall, source);
                                count = count + actualPlusFuturePeriods.setOfPeriods[i];
                            }
                        }
                    }
                };
                }
           




            /*below logicis used to put the collapse sign and indent logic of line item */
            var panel = $('#tt').datagrid("getPanel").find('table').eq(1);
            var table1 = $('#tt').datagrid("getPanel").find('table').eq(1);
            var table2 = $('#tt').datagrid("getPanel").find('table').eq(3 + 1);
            var datarows = $('#tt').datagrid("getRows");
            for(var indexrowdata=0; indexrowdata<datarows.length; indexrowdata++){
                var valuerowdata = datarows[indexrowdata];
                // set color to current if revision present
                if(revisionTypeChanged && $.inArray("revision", rowDimension) > -1){
                    panel.find('tr[datagrid-row-index=' + indexrowdata + ']').find('td').eq($.inArray("revision", rowDimension)).addClass('current-change revision');
                }
                // set color to current if analytics present
                if(growthTypeChanged && $.inArray("growthtype", rowDimension) > -1){
                    panel.find('tr[datagrid-row-index=' + indexrowdata + ']').find('td').eq($.inArray("growthtype", rowDimension)).addClass('current-change growth');
                }
                var rowCell = panel.find('tr[datagrid-row-index=' + indexrowdata + ']').find('td').eq($.inArray("lineitem", rowDimension));
                rowid = valuerowdata.id.split('-');
                rowCell.attr('id', rowid[0] + "--" + valuerowdata.sortorder);                
                if((cut == "NMV" || valuerowdata.ops_sli == true) && valuerowdata.id.toLowerCase().indexOf("dummy") != 0){ // for now we are supporting NMV for Monitoring we can change it later when needed
                    // context menu for line items - (Add to Line Item Monitor)
                    rowCell.attr('dapparam_id', valuerowdata.dapparameterid);
                    rowCell.attr('isLineItemContextMenu', true);
                    // if(valuerowdata.ops_sli == true){
                    //     rowCell.attr('isCompareToPeer', true);
                    // }
                    rowCell.attr('isCompareToPeer', false);
                    bindContextMenuEvent(rowCell, cut, undefined, undefined, valuerowdata);
                    //passing rowData here to bind lineitem context menu
                }
                if (valuerowdata.id.toLowerCase().indexOf("dummy") != 0) {
                    rowCell.attr('isLineItemContextMenu', true);
                    if (cut !== "SAR") {
                        rowCell.attr('lineItemName', valuerowdata.name); //Dont show copy line item name option for SAR
                    }
                    rowCell.attr('lineItemCode', valuerowdata.id.split("-")[0]);
                    bindContextMenuEvent(rowCell, cut, undefined, undefined, valuerowdata);
                }

                var MAX_CHARS_LEN = maxlen;
                MAX_CHARS_LEN -= 3 * valuerowdata.indent;
                var rowName = valuerowdata.shortname;
                if (valuerowdata.parameter_unit)
                    rowName = valuerowdata.shortname + valuerowdata.parameter_unit;

                //More than 36 characters doesn't seem to fit in 240 px.
                if (rowName.length > MAX_CHARS_LEN) {
                    rowCell.attr('qttitle', rowName);
                    qtipSettings(rowCell, "qttitle");
                }

                var rowCell = panel.find('tr[datagrid-row-index=' + indexrowdata + ']').find('.datagrid-cell').eq($.inArray("lineitem", rowDimension));
                if (rowCell.html() != "") {
                    var newhtml = rowCell.html();
                     if (valuerowdata.operator && valuerowdata.secondaryunit) {
                        if (valuerowdata.unit && valuerowdata.unit.toLowerCase() === "amount") {
                            newhtml = newhtml +"(per "+valuerowdata.secondaryunit+")";
                        } else {
                            newhtml = newhtml +"("+valuerowdata.primaryunit+valuerowdata.operator+valuerowdata.secondaryunit+")";
                        }
                    }
                    else if (valuerowdata.parameter_unit) {
                        var param_name_with_unit = valuerowdata.shortname + valuerowdata.parameter_unit;
                        newhtml = newhtml + valuerowdata.parameter_unit;
                    }


                    // commented to remove + icons for lineitems

                    if (valuerowdata.header) {
                        panel.find('tr[datagrid-row-index=' + indexrowdata + ']').bind('click', function () {
                            return false;
                        }).bind('dblclick', function () {
                            return true;
                        });
                    }
                    //we are not adding Expand and Collapse  image for schedule lines or for SAR lines
                    else if (datarows[indexrowdata - 1] != undefined && datarows[indexrowdata - 1].indent > valuerowdata.indent
                        && !window.gSchedule && window.MEData.view_code != 'SAR') {
                        newhtml = "<img id='" + valuerowdata.id + "' src='"+window.assetUrl+"/datagrid_row_collapse.png' style='cursor:pointer;' onclick=\"ShowHideLI(this,'" + valuerowdata.indent + "','" + valuerowdata.sortorder +"');\"/><b>" + newhtml + "</b>";
                    }
                    else
                        newhtml = "&nbsp;&nbsp;&nbsp;&nbsp;" + newhtml;
                    if (valuerowdata.indent != 0) {
                        var li_indent = valuerowdata.indent;
                        while (li_indent-- > 0) {
                            newhtml = "&nbsp;&nbsp;&nbsp;&nbsp;" + newhtml;
                        }
                    }
                    else if(valuerowdata.isbold){
                        newhtml = "<b>" + newhtml + "</b>";
                    }
                    else if(window.MEData.view_code == 'SAR') {
                         if(valuerowdata.header) {
                            newhtml = "<b>" + newhtml + "</b>";
                        }
                    }
                    else if (!window.gSchedule ) {
                        newhtml = "<b>" + newhtml + "</b>";
                    }
                    rowCell.html(newhtml);
                }
                else {
                    //Cells having blank lineitems should not be removed.
                    /*$(panel.find('tr[datagrid-row-index=' + indexrowdata + ']').find('td')).each(function (i, el) {
                     if ($(el).find('.datagrid-cell').html() == "") {
                     $(el).remove();
                     }
                     });*/
                }
            };

            //add notes call for panelsRefresh
            
            if(!defaultLoading){
                addParameterLevelNotes(notes.parameter);
            }
            if (!$('#tblIns').is(":visible")) {
                InspectorClick(false);
            }
            //custom scenario mode
            $('#saveScenarioTd').remove();
            if (window.MEData.row_dimensions[0].driver_types)
                addScenarioSelectionMode();
            //$('#tblIns').show();

            //to disable expansions
            hideDisabledExpansions(window.MEData);

            //to hide disabled lines
            showHideDisabledLines();
            if($('#tt').datagrid("getPanel").find('table').eq(1).find('tbody td[field="lineitems"]').find('img[src*="datagrid_row_"]').length == 0){
                $("#exAllLineItems").hide();
                $('.expandlineitem').css('margin-left','0px')
            }
            //if in edit composite hide custom scenario save button
            if (window.MEData.editcomposite)
                $('#saveScenarioTd').hide();
            // aligning td's if row dimensions length greater than 1
            if (rowDimension.length > 1)
                $('.datagrid-view1 .datagrid-body').find('tr').find('td:gt(0)').attr('width', '100px');

        }
        else {
            $(function () {
                if (!$('.datagrid-ftable').is(':empty') && !$('.datagrid-ftable tbody').is(':empty')) {
                    if ($('.datagrid-footer:hidden').length == 0) {
                        gridHeight = $('.datagrid-footer').height() + $('.datagrid-custom-div').height() - 60;
                    }else{
                        gridHeight = 276;
                    }
                }
                var winH = $(window).height(); //window.screen.height;
                var winW =  setWidthForPanels(gridHeight);
                $('#tt').datagrid({
                    title: 'No record found.',
                    //toolbar: '#tb',
                    onDblClickRow: function () {
                        var selected = $('#tt').datagrid('getSelected');
                        if (selected) {
                        }
                    },
                    idField: 'name',
                    height: winH - gridHeight - extraSize, //* .84,
                    width: winW,
                    fitColumns: false,
                    singleSelect: true,
                    nowrap: true,
                    fit: false,
                    rownumbers: false,
                    //pageSize: 20,
                    showFooter: false,
                    pagination: false,
                    striped: true,
                    frozenColumns: colsfrozen,
                    columns: cols
                });
            });
            $('#tt').datagrid('loadData', this.rows);
        }
/*
        var dimensionsData = rightPanelSettings().jsonData;
        var sourceData = {
            "sources": dimensionsData.Sources,
            "customSources": dimensionsData.Custom
        }

        dummyAjaxRequest(company, cut, "MEX_SOURCE_INFO", sourceData, sourceN);*/


        if ($(window).width() < 1340)
            $(window).trigger('resize');

        if (window.MEData != undefined) {
            for(var indexcolumn_dimensions=0; indexcolumn_dimensions<window.MEData.column_dimensions.length; indexcolumn_dimensions++){
                var valuecolumn_dimensions = window.MEData.column_dimensions[indexcolumn_dimensions];
                if(indexcolumn_dimensions == 0) {
                    for(var idxPeriods=0; idxPeriods<valuecolumn_dimensions.values.length; idxPeriods++){
                        var valPeriods = valuecolumn_dimensions.values[idxPeriods];
                        if(valPeriods.expanded) {
                            var periodName = valPeriods.name;
                            periodName = periodName.replace('-', '');
                            periodName = periodName.toLowerCase();
                            expandedColumn[idxPeriods] = $('#' + periodName)[0];
                            var columnType = "expandedColumn[" + idxPeriods + "]";
                            var curPeriod = (valPeriods.name).toLowerCase();
                            var a=curPeriod.split('-');
                            var prevPeriod=a[0]+'-'+(parseInt(a[1])-1);
                            globalTimer = setInterval("$.active==0 ? (ExpandColumnProcess(event, 'period', '" + (valPeriods.name).toLowerCase() + "', " + columnType + " , '"+ prevPeriod +"')) : ''", 1);
                        }
                        else {
                            expandedColumn[idxPeriods] = valPeriods.name + " not expanded";
                        }
                    };
                }
            };
        }

        /*Save User Setting related functionality*/
        var Settingdata = userSetting; //$.twFile.load("E:/GIT/clientapp/webapp/static/js/usersetting.txt");
        if (Settingdata.length > 0) {
            //Settingdata = $.parseJSON(Settingdata);
            var table = $('#tt').datagrid("getPanel").find('table').eq(3);
            var filterResult = Settingdata.filter( function (n) {
                return (n.cut == cut && n.pg == pg && n.ticker == company && n.source == window.gSource);
            });
            if (filterResult.length > 0) {
                for(var index=0; index<filterResult[0].expanddata.length; index++){
                    var value = filterResult[0].expanddata[index];
                    const event = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: true
                      });
                    const elem = table.find("td[field='" + value + "']").find('img')[0]
                    elem.dispatchEvent(event)
                };
            }
        }
        /*Save user Setting related functionality*/
        $('div.datagrid-body').eq(1).scrollLeft(10000);

        //save user history
        //historySettings();
        //saveRightPanelSettings();
        rowDefaults = {
            "source": window.gSource,
            "ticker": company,
            "revision": window.gRevision,
            "growthtype": window.gGrowthTypeValues,
            "lineitem": "lineitem",
            "scenario": window.gScenario
        };
        gridLoadedMEData = jQuery.extend(true, {}, window.MEData);

        if (window.gSchedule)
            gridFormattingForSchedules();
        else
            formattingHeaderLines();
        //scroll event for datagrid-view1
        $('.datagrid-view1 .datagrid-body').bind("scroll", function () {
            //Hide context menu on grid scroll
            $('.context-menu-active').css("display","none");
        });
        $(".datagrid-footer:eq(1)").css({'overflow-y':'auto'});
        $(".datagrid-footer:eq(1)").on("scroll", function () {
            $(".datagrid-footer:eq(0)").scrollTop($(this).scrollTop());
        });
        if (cut == 'SAR') {
            for(var ind=0; ind<datarows.length; ind++){
                var val = datarows[ind];
                var cellId = val.id.split('-')[0];
                var cells = $('[id="link-'+cellId+'"]');
                for(var count=0; count<cells.length; count++){
                    var cell = cells[count];
                    cell = $(cell);
                    var text = "";
                    var cap = "", com = "";
                    if (window.MEData.nmv_links[0][cellId] && window.MEData.nmv_links[0][cellId]['CAP']){
                        var heading = "<div style='white-space: nowrap;margin-top:5px'><b>Direct Mappings</b></div>";
                        var links = "";
                        for(var index=0; index<window.MEData.nmv_links[0][cellId]['CAP'].length; index++){
                            var value = window.MEData.nmv_links[0][cellId]['CAP'][index];
                            for(var tabIndex=0; tabIndex<window.MEData.nmv_links[1][value].tabs.length; tabIndex++){
                                var tabValue = window.MEData.nmv_links[1][value].tabs[tabIndex];
                                // var dpidValue = window.MEData.nmv_links[0][cellId]['CAP'][tabIndex];
                            //     var link_div = "<div style='color:blue;margin-left:15px;margin-top:3px;display:inline-block;overflow: hidden;white-space:nowrap;'>[" + tabValue[1] + "] " + window.MEData.nmv_links[1][dpidValue].name + "</div><br/>";
                            // links += "<a href='/app/mex/" + encodeURIComponent(tabValue[0]) + "/NMV/" + window.MEData.ticker + "/?&dpid=" + dpidValue + "&extras=" + dpidValue + "' target='_blank'>" + link_div + "</a>";
                            var link_div = "<div style='color:blue;margin-left:15px;margin-top:3px;display:inline-block;overflow: hidden;white-space:nowrap;'>[" + tabValue[1] + "] " + window.MEData.nmv_links[1][value].name + "</div><br/>";
                            links += "<a href="+window.projectArkUrl+"/mex/" + window.MEData.ticker + "/NMV/" + encodeURIComponent(tabValue[0]) + "/?&dpid=" + value + "&extras=" + value + "' target='_blank'>" + link_div + "</a>";
                            };
                        };
                        if (links) {
                            cap += (heading + links + "</br>");
                        }
                    }
                    if (window.MEData.nmv_links[0][cellId] && window.MEData.nmv_links[0][cellId]['COM']){
                        var heading = "<div style='white-space: nowrap;margin-top:5px'><b>Also Used in These Calculations</b></div>";
                        var links = "";
                        for(var index=0; index<window.MEData.nmv_links[0][cellId]['COM'].length; index++){
                            var value = window.MEData.nmv_links[0][cellId]['COM'][index];
                            for(var tabIndex=0; tabIndex<window.MEData.nmv_links[1][value].tabs.length; tabIndex++){
                                var tabValue = window.MEData.nmv_links[1][value].tabs[tabIndex];
                                // var dpidValue = window.MEData.nmv_links[0][cellId]['COM'][tabIndex];
                                // var link_div = "<div style='color:blue;margin-left:15px;margin-top:3px;display:inline-block;overflow: hidden;white-space:nowrap;'>[" + tabValue[1] + "] " + window.MEData.nmv_links[1][dpidValue].name + "</div><br/>";
                                //url changes required
                            // links += "<a href='/app/mex/" + encodeURIComponent(tabValue[0]) + "/NMV/" + window.MEData.ticker + "/?&dpid=" + dpidValue + "&extras=" + dpidValue + "' target='_blank'>" + link_div + "</a>";
                                var link_div = "<div style='color:blue;margin-left:15px;margin-top:3px;display:inline-block;overflow: hidden;white-space:nowrap;'>[" + tabValue[1] + "] " + window.MEData.nmv_links[1][value].name + "</div><br/>";
                            links += "<a href="+window.projectArkUrl+"/mex/" + window.MEData.ticker + "/NMV/" + encodeURIComponent(tabValue[0])  + "/?&dpid=" + value + "&extras=" + value + "' target='_blank'>" + link_div + "</a>";
                            };
                        };
                        if (links) {
                            com += (heading + links + "</br>");
                        }
                    }

                    if (cap || com){
                        text += (cap + com);
                    } else {
                        cell.css('display', 'none');
                    }

                    cell.qtip({
                        content: {
                            text: text
                        },
                        style: {
                            width: "auto"
                        },
                        show: {
                            delay: 300,
                            solo: true
                        },
                        hide: {
                            delay: 1000,
                            fixed: true
                        },
                        position: {
                            target: false
                        },
                        api: {
                            beforeShow: function () {
                                if(showSarToNmvPanel){
                                    tip_position = qtipPostioning(this, cell);
                                    this.options.position.adjust.x = tip_position.x;
                                    this.options.position.adjust.y = tip_position.y;
                                    cell.css({ opacity:'1', 'border-radius': '3px'});
                                } else {
                                    return false;
                                }
                            },
                            onShow: function () {
                                cell.css({ opacity:'1', 'border-radius': '3px'});
                            },
                            onHide: function () {
                                cell.css({border: "", opacity:'0.3'});
                            }
                        }
                    });
                    cell.on('mouseout', function(){
                        if(cell.qtip('api').elements.tooltip && !cell.qtip('api').elements.tooltip.is(':visible')){
                            cell.css({border: "", opacity:'0.3'});
                        }
                    });
                };
            };
        }
        if (cut == 'NMV' || cut == 'SCH'){
            get_links_to_nmv_and_sch();
            if(!window.dsmObj.valuesSet && window.hasDsmAccess !== null){
                const dsmAccessSet = new CustomEvent('dsmAccessSet', { detail:  { }})
                window.dispatchEvent(dsmAccessSet);
            }
               
        }

        $('.grid-holder').css({'visibility':'visible'});
        resizegridOnWindowResize();

        //Takes a list of all the row td's to expand and adds the onclick on it from the click-link attribute of the image
        var rowExpansionImages = $('.datagrid-view1 .datagrid-btable tr').find('td[field="Sources"],td[field="GrowthTypes"],td[field="Revisions"]').find("img[src*='datagrid_row_']");
        for(var count = 0; count < rowExpansionImages.length; count++){
            var linkToTeleport = $(rowExpansionImages[count]).attr('click-link');
            $(rowExpansionImages[count]).closest('td').attr('onclick',linkToTeleport);
        }
    },


    //Dataincremental: 0,
    LoadDatagridData: function (sampledata, ObjParameter) {
        var rowObj = $('#tt').datagrid('getRows');
        var objME = this;
        let periodExpansions = expandAcrossTabs.filter((val)=>val.colType === 'period');
        let expandedColData = [];
        let expandedPeriods = [];
        if(cut === 'NMV'|| cut === "STD"){
            periodExpansions.forEach((periodObj)=>{
                const expandedQuarters = FindExpansions('periods', periodObj.parameter.toUpperCase());
                const periodList = [];
                const quarterData = [];
                if(!expandedQuarters || expandedQuarters.length === 0){
                    return;
                }
                expandedPeriods.push(periodObj.parameter.toLowerCase());
                expandedQuarters.forEach((val)=>{
                    const period = Object.keys(val)[0].toLowerCase();
                    const data = sampledata.data.filter((val)=>val.period.toLowerCase() === period);
                    if(data.length)
                        quarterData.push(data[0])
                   periodList.push(period)
                });
               // sampledata.data = sampledata.data.filter((val)=>!periodList.includes(val.period.toLowerCase()));
                expandedColData.push({
                    ...periodObj,
                    data:{
                        data:quarterData,
                        status:'success'
                    }
                })
    
            })
        }
       

        arguments.callee.count = ++arguments.callee.count || 1
        //alert("Called " + arguments.callee.count + " times")
        for(var indexdata=0; indexdata<sampledata.data.length; indexdata++){
            var valuedata = sampledata.data[indexdata];
            if (valuedata.status && valuedata.status.toLowerCase() == "error") {
                console.error(valuedata.message);
                return;
            }
            //try {

                periods.push(valuedata.period);
                var fieldKey = "";
                $.each(colDimension, function (iParam, elParam) {
                    fieldKey += gSchcptDefault == true ? valuedata[elParam].replace('*', '_cpt') : valuedata[elParam];
                });
                // fieldKey = fieldKey.includes('+') ? fieldKey.toLowerCase().replace('+','plus') : fieldKey.toLowerCase();
                fieldKey = replaceConsensusPlusOperator(fieldKey);
                cutUsed = valuedata.cut.toLowerCase();
                if(cutUsed === 'nmv' || cutUsed === 'sch' || cutUsed === 'std')
                    source_participation_in_consensus[(valuedata.period + valuedata.revision).toLowerCase()] = {'available_sources' : valuedata.broker_count.available_sources, 'forecast' : valuedata.forecast};
                if(valuedata.source == 'Consensus' || valuedata.source == 'Custom' || valuedata.source == 'Consensus+') {
                    var graphId = "#countGraph_" + fieldKey;
                    brokerCountCalculator(graphId, valuedata.broker_count.available, valuedata.broker_count.total);
                }

                var baseParameterValue = {"column": fieldKey, "text": "", 'negative': false};
                if (valuedata.note) {
                    //adds surprise notes to consensus column
                    var ele = $('#tt').datagrid("getPanel").find('table').eq(3).find('td[field="' + fieldKey + '"]');
                    var note_str = "";
                    if ($(ele).attr('note')) {
                        note_str = $(ele).attr('note').split('<br/>')[0] + "<br/>";
                    }
                    $(ele).attr('note', note_str + valuedata.note.split('\n').join('<br>') + "<br/>");
                    $(ele).addClass('external_note');

                }
                objME.Dataincremental = objME.Dataincremental + 1;
                var objColField = fieldKey;
                if(valuedata.data.length != 0 && isFYDataEmpty){
                    isFYDataEmpty = false;
                }
                $.each(valuedata.data, function (indexrowdata, valuerowdata) {
                    var objRowField = "";
                    $.each(rowDimension, function (indexRow, valueRow) {
                        if (valueRow != 'link') {
                            objRowField = (objRowField == "" ? objRowField : objRowField + "-") + (valueRow == 'lineitem' ? valuerowdata.param_id : (valuedata[valueRow].toLowerCase().indexOf(objRowField) == -1 ? valuedata[valueRow].toLowerCase() : ""));
                        }
                    });


                    //objRowField = objRowField.replace(window.gSourceActual.toLowerCase(), gSourceFuture.toLowerCase());
                    var row = $.grep(rowObj, function (n) {
						return (check_list_same(n.id,objRowField));
                        //return (n.id == objRowField);
                    });
                    if (valuerowdata.param_id == window.MEData.baseparameter.id) {
                        text = valuerowdata.value;
                        var baseDpId = valuerowdata.id;
                        if (text.indexOf('-') > -1) {
                            text = text.replace('-', '');
                            text = formatBaseValue(valuerowdata.value,baseDpId,objColField, {
                                'unit': valuerowdata.unit,
                                'precision': valuerowdata.precision
                            });
                            baseParameterValue = {"column": fieldKey, "text": text, 'negative': true, "dpid": baseDpId};
                        }
                        else{
                            text = formatBaseValue(valuerowdata.value,baseDpId,objColField, {
                                'unit': valuerowdata.unit,
                                'precision': valuerowdata.precision
                            });
                            baseParameterValue = {
                                "column": fieldKey,
                                "text": text,
                                'negative': false,
                                "dpid": baseDpId
                            };
                        }
                        if (rowDimension.length > 1) {
                            obj = {
                                "column": objColField,
                                "text": text,
                                'negative': baseParameterValue.negative,
                                "dpid": baseDpId
                            };
                            obj[objRowField] = baseParameterValue;
                            baseParameterValues.push(obj);
                        }
                        else
                            baseParameterValues.push(baseParameterValue);
                    }
                    //try {
                        $.each(row, function (i, el) {
                            el["param_id"] = valuerowdata.param_id;
                            el["period"] = valuerowdata.period;
                            el[objColField] = {
                                value: formatValue(valuerowdata.value, el.id, objColField, {
                                    'unit': valuerowdata.unit,
                                    'precision': valuerowdata.precision
                                }),
                                CellId: valuerowdata.id,
                                type: valuerowdata.annotation,
                                revision: valuedata.revision,
                                revision_date: valuedata.revision_date,
                                revision_datetime: valuedata.revision_datetime,

                            };
                            if (valuerowdata.max) {
                                el[objColField]['max'] = valuerowdata.max;
                            }
                            if (valuerowdata.min) {
                                el[objColField]['min'] = valuerowdata.min;
                            }
                            if (valuerowdata.surprise != undefined) {
                                el[objColField]['surprise'] = valuerowdata.surprise;
                                el[objColField]['title'] = valuerowdata.title;
                            }
                            if (valuerowdata.dpnote)
                                el[objColField]['dpnote'] = valuerowdata.dpnote;
                        });
                    // }
                    // catch (ex) {
                    // }
                });
                objME.AppendValue(valuedata.period.toLowerCase(), rowObj,valuedata.revision.toLowerCase(), valuedata.forecast, valuedata.ticker);
				analystTitlecurrent(valuedata);

                if(expandedPeriods.length > 0 && expandedPeriods.includes(valuedata.period.toLowerCase())){
                    const dataObj = expandedColData.filter((val)=> val.parameter.toLowerCase()=== valuedata.period.toLowerCase())[0]
                    defaultPeriodExpansions(dataObj)
                }

        };
        var totalNoOfCalls = actualPlusFuturePeriods.callsToMake.reduce(function(acc, val){return acc+val;},0);
        if (arguments.callee.count == totalNoOfCalls) {
            arguments.callee.count = 0;
            setTimeout("RowCreation();", 100);
        }
        
    },
    //These method will get used for first time only when data will get loaded.
    AppendValue: function (finYear, rowData, revisionType, isForecastPeriod, currentTicker) {     
        var panelCells = $('#tt').datagrid("getPanel").find("table").eq(3 + 1).find("td");
        panelCells = $.grep(panelCells, function (n) {
            return ($(n).attr("field").indexOf(finYear) == 0);
        });
        var periodPanels = $.grep(window.MEData.panels, function (n) {
        return (n.name.toLowerCase() == "periods");
        })[0];
        if(periodPanels.period_type == 'I'){
            //interims only set class for first and last quarter
            //check period first and add class for border
            var yr = finYear.split('-')[1];
            var periodObj = $.grep(periodPanels.all_period_expansion_list, function (n) {
                return (n.year == Number(yr));
            })[0];

            if (periodObj.expansion_lst.length > 0 && Object.keys(periodObj.expansion_lst[periodObj.expansion_lst.length - 1])[0] == finYear.toUpperCase()) {
                $(panelCells).addClass('lastQ');
                var headerTd = $('#tt').datagrid("getPanel").find('table').eq(3).find('td');
                headerTd = $.grep(headerTd, function (n) {
                    return ($(n).attr("param").indexOf(finYear) == 0);
                });
                $(headerTd).addClass('lastQ');
            }
        }
        var baseParamColumns = $.grep(baseParameterValues, function (baseValue, baseIndex) {
            if (baseValue.column.indexOf(finYear) > -1)
                return baseValue;
        });
        $(panelCells).each(function (i, el) {
            if (rowData[i] != undefined) {
                eachRowData = rowData[i];
                var rowColumnData = eachRowData[$(el).attr('field')];
                var data = rowColumnData == undefined ? "" : rowColumnData.value;
                // adding dpnote to cells
                if (data == "")
                    rowColumnData = {CellId: ""};
                else {
                    if (rowColumnData.dpnote) {
                        $(el).attr('note', rowColumnData.dpnote.split('\n').join('<br>'))
                        //todo note change
                        qtipSettings(el, 'note');
                    }
                    if (rowColumnData.max) {
                        $(el).attr('max', '');
                    }
                    if (rowColumnData.min) {
                        $(el).attr('min', '');
                    }
                    if (rowColumnData.surprise != undefined) {
                        $(el).attr('surprise', rowColumnData.surprise);
                        $(el).attr('title', rowColumnData.title);
                    }
                    var baseParam = window.MEData.baseparameter;
                    var baseParamRow = (eachRowData.magnitude == baseParam.magnitude && eachRowData.unit == baseParam.unit) ? true : false;
                    if (dataInCommonsize && baseParamRow) {
                        var baseColumnData = $.grep(baseParamColumns, function (baseValue, baseIndex) {
                            if (baseValue.column == $(el).attr('field'))
                                return baseValue;
                        });
                        var baseParamValue = baseColumnData[0];
                        //getting new baseparamvalues
                        if (rowDimension.length > 1 && (!(window.MEData.baseparameter.notAvail)) && baseParamValue.length > 0) {
                            rowfield = eachRowData.id.replace(eachRowData.id.split('-')[0], window.MEData.baseparameter.id);
                            baseParamValue = baseParamValue[rowfield];
                        }
                        var valueData = data.replace(/,/g, '');
                        if (valueData.indexOf('(') > -1)
                            valueData = valueData.split('>')[1].split('<')[0];
                        cellCommonsize(el, true, baseParamValue, false, valueData + "");
                    }
                }

                var cellid = rowColumnData.CellId
                    ,cellElement = $(el)
                    ,rowDataIdArray = eachRowData.id.split('-')
                    ,sourceIndex = $.inArray('source', rowDimension) - 1
                    ,growthTypeIndex = $.inArray('growthtype', rowDimension) - 1
                    ,growthTypeFormula = growthTypeIndex > 0 ? rowDataIdArray[growthTypeIndex] : window.gGrowthTypeValues
                    ,fieldSplit = $(el).attr('field').split(/\d+/).pop()
                    ,cellSource = fieldSplit ? fieldSplit !== 'current' ? fieldSplit : rowDataIdArray[sourceIndex] : rowDataIdArray[sourceIndex]
                    ,revisionPeriod = fieldSplit;
                cellElement.attr('id', cellid);
                cellElement.attr('dapparam_id', eachRowData.param_id);
                cellElement.attr('period', eachRowData.period);
                cellElement.attr('forecast',isForecastPeriod);
                cellElement.attr('ticker', currentTicker == '' ? window.MEData.ticker : currentTicker);
                var revisionValue = $(eachRowData.Revisions).find('span').text();
                revisionValue =(revisionValue.length != 0 ? cellElement.attr('revision',revisionValue) : '');
                cellElement.attr('iscomparetopeer',(eachRowData.ops_sli !== undefined ? true : false));
                if (!(dataInCommonsize && baseParamRow)){
                    cellElement.find('.datagrid-cell').html(data);
                    // if(cellSource.includes("consensus+")){
                    //     cellElement.find('.datagrid-cell').css('width', '89px').html(data);
                    // }else{
                    //     cellElement.find('.datagrid-cell').html(data);
                    // }
                }
                cellSource = bindContextMenuEvent(cellElement, cut, cellSource, revisionPeriod);
                if(eachRowData.period){

                    var notesObj = {
                        parameterid: cut !== 'SAR' ? eachRowData.parameterid : eachRowData.param_id,
                        period:eachRowData.period,
                        source: cut !== 'SAR' ? cellSource : window.gSource.toLowerCase(),
                        revision:{
                            revision: rowColumnData.revision,
                            revision_date: rowColumnData.revision_date,
                            revision_datetime: rowColumnData.revision_datetime,
                        },
                        el: cellElement
                    }
                    bindDataPointNote(notesObj);
                }
                if (cellid != undefined && cellid != "") {
                    var dpSource;
                    if (!sourcesExist)
                        dpSource = window.gSource;
                    else {
                        if (whetherIsForecast(finYear))
                            dpSource = gSourceFuture;
                        else
                            dpSource = window.gSourceActual;
                    }
                    cellElement.off('click.datacellClick').on('click.datacellClick', function (event) {
                        
                        var tdElem = event.target;
                        while( tdElem.nodeName !== "TD" ) {
                            tdElem = tdElem.parentElement;
                        }

                        var cellSource = $(tdElem).attr('source');
                        var period = $(tdElem).attr('period');
                        // Adding an extra condition of === '' since
                        // when cut === SAR, the source attribute on the cell is blank
                        if((cellSource === undefined || cellSource === '') &&  period !== undefined) {
                            if(whetherIsForecast(period)){
                                cellSource = window.gSourceFuture;
                            }else{
                                cellSource = window.gSourceActual;
                            }
                        } 
                        // const cellData = {
                        //     id:cellElement.attr("id") || null,
                        //     field:cellElement.attr("field")  || null,
                        //     dapparam_id:cellElement.attr("dapparam_id") || null,
                        //     revision:cellElement.attr("revision") || null

                        // }
                        var paramsForFbar = prepareDpParams(cellid,cut,window.MEData.ticker,cellSource,
                            growthTypeFormula,window.MEData.panels[1]["actual-default"],
                            cellElement.attr('period'),cellElement.attr('dapparam_id'),
                            window.MEData.selectedCurrency,incl_sources,excl_sources,true,
                            cellElement)
                        const summonFBar = new CustomEvent('SummonFBar', { detail: { data: paramsForFbar} })
                         window.dispatchEvent(summonFBar);  
                        // datacellClick(cellid, cellElement.attr('field'), this, cut, dpSource, "col", growthTypeFormula, event, window.MEData.ticker, undefined, window.MEData.selectedCurrency)
                    });
                }
                else {
                    cellElement.off('click.datacellClick').on('click.datacellClick', function (event) {
                        var paramsForFbar = {};
                        const summonFBar = new CustomEvent('SummonFBar', { detail: { data: paramsForFbar} })
                        window.dispatchEvent(summonFBar);                        
                        // datacellClick("", "", this, "", "", "col", '', event, window.MEData.ticker)
                    });
                }

                getCellStyling(rowColumnData.type, el);
            }
        });
        //$(".datagrid-cell-group").removeAttr("style");
    },

    //Below Method will get used to append new columns.
    AppendColumn: function (dgRows, rowData, cellPosition, columns, appendAtBegin,columnType, preciseIdxs) {
        var baseParamValues = [];
        var rowSelector = "";
        $.each(rowDimension, function (indexRow, valueRow) {
            if (indexRow == 0) {
                rowSelector = rowSelector + window.MEData.baseparameter.id;
            } else if (cut != 'CPT' && indexRow == 1){
            } else {
                rowSelector = rowSelector + "-" + rowDefaults[valueRow].toLowerCase();
            }

        });
        $.each(columns, function (i, el) {
            var baseColumns = $.grep(baseParameterValues, function (baseValue, baseIndex) {
                if (baseValue.column == el.field){
                    return baseValue;
                }
            });
            if (baseColumns.length == 0) {
                obj = {"column": el.field, "text": "", 'negative': false, "dpid": 0};
                if (rowDimension.length > 1)
                    obj[rowSelector] = {"column": el.field, "text": "", 'negative': false, "dpid": 0};
                baseParamValues.push(obj);
                baseParameterValues.push(obj);
            }
            else
                baseParamValues.push(baseColumns[0]);
        });
        var j = 0;

        $(rowData).each(function (index, eachRowData) {
            if (eachRowData.RowAppend) {
                el = dgRows[j];
                incrementalCellPosition = cellPosition;
                var baseParam = window.MEData.baseparameter;
                var baseParamRow = (eachRowData.magnitude == baseParam.magnitude && eachRowData.unit == baseParam.unit) ? true : false;
                var panelObj = $.grep(window.MEData.column_dimensions, function (n, i) {
                    if (n.name.toLowerCase() == "periods") return true;
                });

                $.each(columns, function (indexCols, colsData) {
                    var blurThis = false;
                    if (colsData.field == 'Name')
                        return;
                    var fieldName = colsData.field = colsData.parameter.split('|').join("");
                    //To ascertain which datapoint needs blurring and which is actually blank!!
                    var justTheYearPart = colsData.parameter.split('|')[0].toUpperCase();
                    var rowColumnData = eachRowData[fieldName];
                    if (fieldName != "Name") {
                        if (rowColumnData == undefined) {
                            rowColumnData = {CellId: ""};
                            var dval = '';
                        }
                        else
                            var dval = formatValue(rowColumnData.value, eachRowData.id, fieldName, {
                                'unit': rowColumnData.unit,
                                'precision': rowColumnData.precision
                            });
                        var cell
                            ,cellElement
                            ,rowIdArray = eachRowData.id.split('-')
                            ,cellSourceIndex = $.inArray('source', rowDimension) - 1
                            ,growthTypeIndex = $.inArray('growthtype', rowDimension) - 1
                            ,cellId = rowColumnData.CellId
                            ,cellSource = cellSourceIndex > 0 ? rowIdArray[cellSourceIndex] : getDpSource(colsData.parameter, eachRowData.id)
                            ,growthTypeFormula = growthTypeIndex > 0 ? rowIdArray[growthTypeIndex] : window.gGrowthTypeValues
                            ,revisionPeriod = fieldName.split('-').pop().split(/\d+/).pop();

                        if (colsData.title == window.gSourceActual || colsData.title == gSourceFuture) {
                            cell = $("<td/>").addClass("datagrid-expanded-column").attr('field', fieldName).attr('id', cellId);
                        }
                        else {
                            cell = $("<td/>").attr('field', fieldName).attr('id', cellId);
                        }
                        cellElement = $(cell);
                        cellElement.attr('dapparam_id', eachRowData.param_id);
                        cellElement.attr('period', rowColumnData.period);
                        var industryCompsCol = $.grep(window.MEData.column_dimensions, function (n) {
                            return (n.name.toLowerCase() == "tickers");
                        });

                        var industryCompsRow = $.grep(window.MEData.row_dimensions, function (n) {
                            return (n.name.toLowerCase() == "tickers");
                        });
                        if(industryCompsCol.length > 0 || industryCompsRow.length > 0){
                            var currentTicker = colsData.parameter.split('|')[1];
                            cellElement.attr('ticker', currentTicker.toUpperCase());
                        }
                        /*if(rowColumnData.period && columnType == 'period') {
                            //check period first or last and add class for border
                            var yr = rowColumnData.period.split('-')[1];
                            var periodPanel = $.grep(panelObj[0].all_period_expansion_list, function (n) {
                                return (n.year == Number(yr));
                            })[0];
                            if (Object.keys(periodPanel.expansion_lst[0])[0] == rowColumnData.period) {
                                cellElement.addClass('firstQ')
                            } else if (Object.keys(periodPanel.expansion_lst[periodPanel.expansion_lst.length - 1])[0] == rowColumnData.period) {
                                cellElement.addClass('lastQ')
                            }
                        }*/
                        var revisionValue = $(eachRowData.Revisions).text().trim();
                        (revisionValue.length != 0 ? cellElement.attr('revision',revisionValue) : '');
                        cellElement.attr('forecast', colsData.forecast);
                        cellElement.attr('iscomparetopeer',(eachRowData.ops_sli !== undefined ? true : false));
                        $("<div/>").attr('class', 'datagrid-cell').css('text-align', 'right').css('width', '101px').css('height', 'auto').html(dval).appendTo(cell);

                        //todo change here for source
                        if ( -1 !== $.inArray(growthTypeFormula.toLowerCase(), contextMenuAllowedGrowthType) && !blurThis) {
                            cellSource = bindContextMenuEvent(cellElement, cut, colsData.source, revisionPeriod);
                        }
                        if(rowColumnData.period){
                            var notesObj = {
                                period:rowColumnData.period,
                                parameterid: cut !== 'SAR' ? eachRowData.parameterid : eachRowData.param_id,
                                source: cut !== 'SAR' ? cellSource : window.gSource.toLowerCase(),
                                revision:{
                                    revision: rowColumnData.revision,
                                    revision_date: rowColumnData.revision_date,
                                    revision_datetime: rowColumnData.revision_datetime,
                                },
                                el: cellElement
                            }
                            bindDataPointNote(notesObj);
                        }

                        if (cellId != undefined && cellId != "") {
                            // to append note to datapoint
                            if (rowColumnData['dpnote']) {
                                cellElement.attr('note', rowColumnData['dpnote'].split('\n').join('<br>'));
                                //todo note change
                                qtipSettings(cell, 'note');
                            }


                            cellElement.off('click.datacellClick').on('click.datacellClick', function () {
                                // const cellData = {
                                //     id:cellElement[0].getAttribute("id") || null,
                                //     field:cellElement[0].getAttribute("field")  || null,
                                //     dapparam_id:cellElement[0].getAttribute("dapparam_id") || null,
                                //     revision:cellElement[0].getAttribute("revision") || null
        
                                // }
                                var paramsForFbar = prepareDpParams(cellId,cut,window.MEData.ticker,colsData.source,growthTypeFormula,
                                    window.MEData.panels[1]["actual-default"],
                                    cellElement.attr('period'),cellElement.attr('dapparam_id'),window.MEData.selectedCurrency,incl_sources,excl_sources,true,cellElement)
                                const summonFBar = new CustomEvent('SummonFBar', { detail: { data: paramsForFbar} })
                                window.dispatchEvent(summonFBar);                                
                                // datacellClick(cellId, colsData.field, this, cut, colsData.source, "col", growthTypeFormula, event, window.MEData.ticker, undefined, window.MEData.selectedCurrency)
                            });
                        }
                        else {
                            $(cell).off('click.datacellClick').on('click.datacellClick', function (event) {
                                var paramsForFbar = {}
                                const summonFBar = new CustomEvent('SummonFBar', { detail: { data: paramsForFbar} })
                                window.dispatchEvent(summonFBar);                                 
                                // datacellClick("", "", this, "", "", "col", "", event, window.MEData.ticker)
                            });
                        }

                        if (rowColumnData.max) {
                           $(cell).attr('max', '');
                        }

                        if (rowColumnData.min) {
                           $(cell).attr('min', '');
                        }
                        if (rowColumnData.surprise != undefined) {
                            $(cell).attr('surprise', rowColumnData.surprise);
                            $(cell).attr('title', rowColumnData.title);
                            $(cell).attr('surprisetitle', rowColumnData.title);
                        }
                        if (dataInCommonsize && baseParamRow) {
                            var baseColumnData = $.grep(baseParamValues, function (baseValue, baseIndex) {
                                 if (baseValue.column == $(cell).attr('field')){
                                    return baseValue;
                                }
                            });

                            var baseParamValue = baseColumnData[0];

                            //getting new baseparamvalues
                            if (rowDimension.length > 1 && (!(window.MEData.baseparameter.notAvail))) {
                                rowfield = eachRowData.id.replace(eachRowData.id.split('-')[0], window.MEData.baseparameter.id);
                                baseParamValue = baseParamValue[rowfield];
                            }
                            cellCommonsize(cell, true, baseParamValue, false, $(cell).text());
                        }

                        if(preciseIdxs) {
                            incrementalCellPosition = preciseIdxs[indexCols];
                        }
                        if (appendAtBegin) {
                            $(el).closest('tr').find('td').eq(incrementalCellPosition).before(cell);
                        } else {
                            $(el).closest('tr').find('td').eq(incrementalCellPosition).after(cell);
                        }

                        getCellStyling(rowColumnData.type, cell);
                        incrementalCellPosition++;
                    }
                });
                j++;
            }

        });
    },
    AppendFooterCell: function (dgRows, rowData, cellPosition, columns, appendAtBegin) {
        if (!$('#tblIns').is(":visible") && $('.datagrid-footer').is(":visible") && inspectorType !== "Lineitem" && inspectorType !== "Comptable")
            GetLIColsExpandedValue();
    },
    AppendHeaderCell: function (rowHeader, tdField, value, cellPosition, clickevent, appendAtBegin, cellFormat, paramid, cellindex, period, revisionObj) {
        if (paramid)
            var cell = $("<td/>").attr('field', tdField).attr('param', tdField);
        else
            var cell = $("<td/>").attr('field', tdField);

        var img = "";
        var ogValue = value;
        var periodRevisionKey = '';
        if (period && revisionObj && revisionObj['revision']) {
            periodRevisionKey = period.toLowerCase() + revisionObj['revision'].toLowerCase();
        }
        if (clickevent != null) {
            //var img = $("<IMG style=\"FLOAT: right; CURSOR: pointer\" id='" + tdField + "' onclick='" + clickevent + "' src=\"/static/images/datagrid_row_expand.png\"/>");
            cell.attr('onclick',clickevent);
            //img = "<IMG style=\"CURSOR: pointer\" id='" + tdField + "' src=\"/static/images/datagrid_row_expand.png\"/>";
            // tdField = tdField.includes('+') ? tdField.toLowerCase().replace('+','plus') : tdField.toLowerCase();
            tdField = replaceConsensusPlusOperator(tdField);
            img = "<img style='cursor:pointer' id='"+tdField+"' src='"+window.assetUrl+"/datagrid_row_expand.png' />";
            // var is_excl_src = showExcludedIcon(value, periodRevisionKey);

            // if (showCCicon(value)){
            //     value = '<img src="'+window.assetUrl+'/custom_consensus.png" class="custcon"/><b>' + value + '</b>';
            // } else {
                value = value.includes('Consensus+') ? value.slice(0,-1) + " <span style='color: #f2883d;vertical-align: middle;font-size:13px;    padding: 2px 0 2px 2px;' class='fa fa-plus'></span>" : value;
                value = "<b>" + value + "</b>";
            // }
            // if (is_excl_src) {
            //     value = '<img src="'+window.assetUrl+'/icon-excluded.png" class="excluded_icon" style="display:none;"/>' + value;
            // }
            // if(showConPlusIcon(ogValue)){
            //     img += "<img class='conPlus_icon' src='"+window.assetUrl+"/consensus_plus_icon.png'/>";
            // }
        }
        else {
            //change here for header border
            //cell = cell.css('border-top-color', '#444!important');
            cell = cell.addClass('expanded_border_top');
            //cell = cell.css({'border-top-color': '#4F4F4F!important','border-top' : '2px solid #444444!important'});
            if (cellindex == 0) {
                rowHeader.find('td').eq(cellPosition - 1).css('border-right', '1px solid #ccc');
                //rowHeader.find('td').eq(cellPosition).css('border-right', '1px solid #ccc');
            }
        }
        var div;
        var estimate = "";
        if (rowHeader.index() == $.inArray('period', colDimension)) {
            //set period level header
            if (value.substring(value.length - 1, value.length) == "E") {
                estimate = "<span class='tag'>E</span>";
                value = value.substring(0, value.length - 1) + estimate;
            }

        } 

        if (showExcludedIcon(ogValue, periodRevisionKey)) {
            img += "<img class='excluded_icon' src='"+window.assetUrl+"/icon-excluded.png' style='display:none;'/>";
        } else if (notes['period'] && notes['period'].period_level_keys_for_exclude_from_consensus && period) { // adds excluded icon when notes contain excluded source
            var noteKey = value.toLowerCase() + '_' + period.toLowerCase();
            var isExcludedFromConsensus = false;
            if (notes['period'].period_level_dict[noteKey]) {
                isExcludedFromConsensus = getShowNoteFlag(revisionObj,notes['period'].period_level_dict[noteKey][0]);
            }
            if (notes['period'].period_level_keys_for_exclude_from_consensus.indexOf(noteKey) != -1 && isExcludedFromConsensus) {
                img += "<img class='excluded_icon' src='"+window.assetUrl+"/icon-excluded.png' style='display:none;/>";
            }
        }

        if (showCCicon(ogValue)){
            img += "<img class='custcon' src='"+window.assetUrl+"/custom_consensus.png'/>";
        }

        if(showConPlusIcon(ogValue)){
            img += "<img class='conPlus_icon' src='"+window.assetUrl+"/consensus_plus_icon.png'/>";
        }

        var brokercountControl = '';
        //Adding the html content for the broker count chart for only Custom and Consensus cases.
        var escapedVal = tdField.replace('$$','-').replace(' ','_');
        if(value.indexOf('Custom') > -1 || value.indexOf('Consensus') > -1 || value.indexOf('Consensus+') > -1){
            //Do not remove the inline style here, since it breaks in IE!
            // escapedVal = escapedVal.includes('+') ? escapedVal.toLowerCase().replace('+','plus') : escapedVal.toLowerCase();
            escapedVal = replaceConsensusPlusOperator(escapedVal);
            brokercountControl = $("<span style='height:5px;background-color:#E0E2E2;float:left;width:100%;margin-top:2px;'><span id='countExpandedGraph_"+escapedVal+"' class='brokerCountGraphSpan'></span></span>");
        }
        if(value.includes('Consensus+')) {
            value = value.slice(0,-1) + " <span style='color: #f2883d;vertical-align: middle;font-size:13px;    padding: 2px 0 2px 2px;' class='fa fa-plus'></span>";
        }

        switch (cellFormat) {
            case 1:
                //div = $("<div/>").attr('class', 'datagrid-cell-group').html(value).appendTo(cell);
                div = $("<div/>").attr('class', 'datagrid-cell-group').html(img + '&nbsp;' + value).appendTo(cell);
                break;
            case 2:
                //div = $("<SPAN/>").html(value).appendTo($("<div/>").attr('class',k 'datagrid-cell').css('text-align', 'right').css('width', '82px').appendTo(cell));
                var classToAdd = !cPlusConst.includes(ogValue) ? 'datagrid-cell ellipsis_source' : 'datagrid-cell';
                if($(img).length > 0){
                 div = $("<SPAN/>").html(img + '&nbsp;' + value).append(brokercountControl).appendTo($("<div/>").attr('class',classToAdd).css({'text-align': 'right','width': '101px','font-size': '11px'}).appendTo(cell));
                }else{
                    div = $("<SPAN/>").html('&nbsp;' + value).append(brokercountControl).appendTo($("<div/>").attr('class',classToAdd).css({'text-align': 'right','width': '101px','font-size': '11px'}).appendTo(cell));
                }
                 
                break;
            default:
                break;
        }

        //if (clickevent != null)
        //img.appendTo(div);
        if (appendAtBegin) {
            rowHeader.find('td').eq(cellPosition).before(cell);
        } else {
            rowHeader.find('td').eq(cellPosition).after(cell);
        }

        if (showExcludedIcon(value) && showCCicon(value)) {
            $(cell).find('span').addClass('ellipsis_class').addClass('ellipsis_column');
        }
        if (clickevent != null) {
            
            setTimeout(function() {
                clickToAddEvent();
                $("[id='"+getJQId(tdField)+"']").trigger('ExpColLoaded');
            }, 500);
        }
    },
    AppendFinancialYear: function (FYDatatoFetch, appendAtBegin) //, headercellPosition, brokerCellPosition
    {
        var objME = this;
        var hideColumn;
        var colsfrozen;
        //var rows = [];
        this.rows = GetRowsfordg(true, null, false);

        var objWebServiceCall = new WebServiceCall();
        var panelPeriods = $.grep(window.MEData.panels, function (n) {
            return (n.name.toLowerCase() == "periods");
        });
        $.each(FYDatatoFetch, function (indexFYDatatoFetch, valueFYDatatoFetch) {
            $.each(panelPeriods[0].values, function (i, el) {
                if (el.indexOf(valueFYDatatoFetch) != -1) {
                    financialYear = el;
                    return false;
                }
            });
            //financialYear = valueFYDatatoFetch;
            var parameter = {
                "appendAtBegin": appendAtBegin,
                "year": financialYear,
                "baseYear": valueFYDatatoFetch
            };
            objWebServiceCall.getSelectedGroupData(financialYear, parameter);
        });
    },
    onSuccessAppendFinancialYear: function (sampledata, parameter) {
        var objME = this;
        var quarterCellPosition = [];
        var presentYear = parameter.baseYear;
        var appendat = parameter.appendAtBegin;
        var financialYear = parameter.year;
        var table = $('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr');
        this.rows = jQuery.extend(true, [], AlldgRows);
        var rowObj = this.rows;
        var cols = [];
        var valuedata = sampledata.data[0];
        var colfield = "", parameters = "";
        var datatable_cellindex = 0;
        $.each(colDimension, function (indexcol, valuecol) {
            if (indexcol >= $.inArray("period", colDimension)) {
                var presentColumn = table.eq(indexcol);
                var presentColumnLength = presentColumn.find("td").length;
                if (appendat) {
                    for (i = 0; i < presentColumnLength; i++) {
                        var fieldName = presentColumn.find("td").eq(i).attr('field');
                        if (getYear(fieldName) > presentYear) { //substr(fieldName.indexOf('fy-'), 7).replace('fy-', "") > presentYear) {
                            datatable_cellindex = i;
                            if (indexcol == $.inArray("period", colDimension))
                                periods.splice(i + 1, 0, valuedata['period']);
                            break;
                        }
                    }
                }
                else {
                    for (i = (presentColumnLength - 1); i >= 0; i--) {
                        var fieldName = presentColumn.find("td").eq(i).attr('field');
                        if (getYear(fieldName) < presentYear) { //substr(fieldName.indexOf('fy-'), 7).replace('fy-', "") > presentYear) {
                            datatable_cellindex = i;
                            if (indexcol == $.inArray("period", colDimension))
                                periods.splice(i + 1, 0, valuedata['period']);
                            break;
                        }
                    }
                }
                var data = valuedata[valuecol];
                colfield = colfield + valuedata[valuecol].toLowerCase()//(valuecol == "period" ? financialYear : valuedata[valuecol].toLowerCase());
                parameters = parameters + (indexcol != 0 ? "|" : "") + valuedata[valuecol].toLowerCase();
                cols.push([]);
                cols[indexcol].push({
                    field: colfield,
                    title: data,
                    width: 90,
                    align: 'right',
                    color: 'red',
                    sortable: false,
                    resizable: false,
                    parameter: parameters
                });
                ExpandedColList[indexcol].push({
                    ColField: colfield,
                    parameter: parameters,
                    "appendat": appendat,
                    cellPosition: datatable_cellindex
                });
                var clickEvent = "ExpandColumnProcess(event, \"" + valuecol + "\",\"" + parameters + "\",this);"
                if (valuecol == "period") {
                    fyData = financialYear;
                    if (financialYear.indexOf('FYE-') > -1)
                        fyData = financialYear.substr(0, 7) + financialYear.substr(9, 50);
                    if (fyData.substring(fyData.length - 1, fyData.length) == "E")
                        fyData = fyData.substring(0, fyData.length - 1) + "<span class='tag'>E</span>";
                }
                objME.AppendHeaderCell(table.eq(indexcol), colfield, (valuecol == "period" ? fyData : data), datatable_cellindex, clickEvent, appendat, ((colDimension.length - 1) != indexcol ? 1 : 2), true);
            }
        });
        var baseParameterValue = {};
        var rowSelector = "";
        $.each(rowDimension, function (indexRow, valueRow) {
            if (indexRow == 0)
                rowSelector = rowSelector + window.MEData.baseparameter.id;
            else
                rowSelector = rowSelector + "-" + rowDefaults[valueRow].toLowerCase();
        });
        $.each(valuedata.data, function (indexrowdata, valuerowdata) {
            var objRowField = "";
            $.each(rowDimension, function (indexRow, valueRow) {
                objRowField = (objRowField == "" ? objRowField : objRowField + "-") + (valueRow == 'lineitem' ? valuerowdata.param_id : (valuedata[valueRow].toLowerCase().indexOf(objRowField) == -1 ? valuedata[valueRow].toLowerCase() : ""));
            });
            objRowField = objRowField.replace(window.gSourceActual.toLowerCase(), gSourceFuture.toLowerCase());
            var row = $.grep(rowObj, function (n) {
				return (check_list_same(n.id,objRowField));
                //return (n.id == objRowField);
            });
            var objColField = colfield;
            if (valuerowdata.param_id == window.MEData.baseparameter.id && (rowSelector == objRowField || $.inArray(objRowField, baseparamrows) > 1)) {
                text = valuerowdata.value;
                var baseDpId = valuerowdata.id;
                if (text.indexOf('-') > -1) {
                    text = text.replace('-', '');
                    text = formatBaseValue(valuerowdata.value,baseDpId,objColField, {
                        'unit': valuerowdata.unit,
                        'precision': valuerowdata.precision
                    });
                    baseParameterValue = {"column": objColField, "text": text, 'negative': true, "dpid": baseDpId};
                }
                else{
                    text = formatBaseValue(valuerowdata.value,baseDpId,objColField, {
                        'unit': valuerowdata.unit,
                        'precision': valuerowdata.precision
                    });
                    baseParameterValue = {"column": objColField, "text": text, 'negative': false, "dpid": baseDpId};
                }
                if (rowDimension.length > 1) {
                    baseColumns = $.grep(baseParameterValues, function (i, el) {
                        return (i.column == objColField);
                    });
                    if (baseColumns.length > 0)
                        baseColumns[0][objRowField] = baseParameterValue;
                    else {
                        obj = {
                            "column": objColField,
                            "text": text,
                            'negative': baseParameterValue.negative,
                            "dpid": baseDpId
                        };
                        obj[objRowField] = baseParameterValue;
                        baseParameterValues.push(obj);
                    }
                }
                else
                    baseParameterValues.push(baseParameterValue);
            }
            if (row.length > 0) {
                row[0][objColField] = {
                    value: valuerowdata.value,
                    Cellid: valuerowdata.id,
                    type: valuerowdata.annotation
                }
                if (valuerowdata.dpnote)
                    row[0][objColField]['dpnote'] = valuerowdata.dpnote;
                if (valuerowdata.unit)
                    row[0][objColField]['unit'] = valuerowdata.unit;
            }
        });
        var datagridbodyRows, columns;
        datagridbodyRows = $('div.datagrid-body').find('table').eq(1).find('tr')

        this.AppendColumn(datagridbodyRows, this.rows, datatable_cellindex, cols[colDimension.length - 1], appendat);
        var datagridbodyRows = $('div.datagrid-footer').find('table').eq(1).find('tr');
        objME.AppendFooterCell(datagridbodyRows, this.rows, datatable_cellindex, cols[colDimension.length - 1], appendat);
        HidePeriod(financialYear);
        if (rowDimension.length > 1 && (!(window.MEData.baseparameter.notAvail))) {
            var basePeriodString = parameter.year;
            if (basePeriodString.substring(basePeriodString.length - 1, basePeriodString.length) == "E")
                basePeriodString = basePeriodString.substring(0, basePeriodString.length - 1)
            getBaseParamData(basePeriodString, {}, []);
        }
    }
};

/* Row Creation related modification in progress*/
function RowCreation() {
    var rows = jQuery.extend(true, [], AlldgRows)

    $.each(samplecolrow.row_dimensions, function (indexrow_dimensions, valuerow_dimensions) {
        if (valuerow_dimensions.expansions != undefined) {
            MakeRowsDynamically(valuerow_dimensions.expansions, indexrow_dimensions, rows, valuerow_dimensions.name, true);
        }

        AlldgRows = rows;
    });
}

function expandLineitemColumnProcess(){
    var src = event.target;
    if(window.MEData.expandLineitem == 'true')
        window.MEData.expandLineitem = 'false';
    else
        window.MEData.expandLineitem = 'true';
    analyticsProcessor(event);
    event.stopPropagation(); // added to stop it propogating up and call this method again.
    $.each(window.MEData.panels, function(index, value){
               if(value.name == 'Display Settings'){
                   if(window.MEData.expandLineitem == 'true') {
                       value.values[0].selected = true;
                   } else {
                       value.values[0].selected = false;
                   }
               }
            if(cut == 'SAR'){
                if(value.name.toLowerCase() == "sources"){
                    value.type = 'filter';
                }
            }
        });
    reloadPanels(window.MEData);
    $.ajax({
            url: window.apiUrl + '/api/setFeature?feature=expandLineitem&feature_condition=' + window.MEData.expandLineitem + '&ticker=' + window.MEData.ticker,
            async: true,
            success: function (msg) {
                if (msg.status == 'error')
                    return;
                var col_width = 0, showResizebtn = true, longest_row = '', maxlen = 36;
                var colsfrozen = [[]];
                $.each(window.MEData.row_dimensions[0].values, function(rowindex, rowvalue){
                    var width = (rowvalue.shortname.length)*6 + (4 + (4 * rowvalue.indent))*3.8;
                    if(Math.round(width) > col_width){
                        col_width = Math.round(width);
                        longest_row = rowvalue;
                    }
                });
                if(longest_row.parameter_unit){
                    col_width += longest_row.parameter_unit.length * 7;
                }
                if(col_width > 550){
                    col_width = 550;
                }
                if(col_width <= 230){
                    col_width = 250;
                    var showResizebtn = false;
                } else {
                    var showResizebtn = true;
                }
                if(window.MEData.expandLineitem == 'false'){
                    col_width = 250;
                }

                $('#tt').datagrid('resizeColumn', {
                  field: "lineitems",
                  width: col_width
                });

                if(showResizebtn) {
                    var expandImg = $('#tt').datagrid("getPanel").find('table').eq(0).find('tr').find('td').find('div').eq(0).find('.expandlineitem');
                    if (window.MEData.expandLineitem == 'false'){
                        expandImg.attr({
                            'src': window.assetUrl+'/expand.png',
                            'title': "Show Full Name"
                        })
                    }
                    else if(window.MEData.expandLineitem == 'true'){
                        expandImg.attr({
                            'src': window.assetUrl+'/collapse.png',
                            'title': "Show Trimmed Name"
                        })
                    }
                }
                if (rowDimension.length > 1)
                    $('.datagrid-view1 .datagrid-body').find('tr').find('td:gt(0)').attr('width', '100px');
                
                $(window).trigger('resize');

                adjustInspectorTabs();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                csv_string = errorThrown;
            }
        });
}


var showSarToNmvPanel = true;

function imgControl(objDiv, paramid){
    if ($(objDiv).find('#img-'+paramid).attr('src').indexOf('unpin') > -1){
        var qTip = $('#link-'+paramid).qtip('disable');
        $(objDiv).find('#img-'+paramid).attr('src', window.assetUrl + '/pin.png');
        $(objDiv).find('#text-'+paramid).text('UNPIN');
        showSarToNmvPanel = false;
    } else {
        var qTip = $('#link-'+paramid).qtip('enable');
        $(objDiv).find('#img-'+paramid).attr('src', window.assetUrl + '/unpin.png');
        $(objDiv).find('#text-'+paramid).text('PIN');
        showSarToNmvPanel = true;
    }
}

var driverFilterData = [];
function GetFilterData(type, selectedType) {
    var filterData = [], currentDefaultValue = "";
    if (type == "Sources") {
        searchName = "Sources";
        currentDefaultValue = window.gSource;
    } else if (type == "tickers") {
        searchName = "Company Comps";
        currentDefaultValue = company;
    } else if (type == "Scenarios") {
        searchName = "Scenarios";
        currentDefaultValue = window.gScenario;
    } else if(type == "Peers"){
        searchName = "Peers";
        currentDefaultValue = window.gSource;
    }

    var defaultData = $.grep(colPanels, function (n) {
        return (n.name == searchName);
    });
    if(defaultData.length > 0){
        defaultValue = (defaultData[0]['default'] == undefined ? currentDefaultValue.toLowerCase() : defaultData[0]['default'].toLowerCase());
    }else{
        defaultValue = [];
    }
    if (type == "Sources") {

        if (defaultData.length > 0) {
            filterData = getSourceExpansion('footer');
            if(filterData.indexOf(selectedType) != -1)
                filterData.splice(filterData.indexOf(selectedType), 1);
            filterData.splice(0, 0, selectedType);

            return {FilterData: filterData, DefaultValue: defaultValue};
        }
    } else if (type == "Scenarios") {
        if (defaultData.length > 0) {
            var defaultData = $.grep(defaultData[0].values, function (n) {
                return (n.variant == window.gVariant);
            });
        }
    }

    if (defaultData.length > 0) {
        $.each(defaultData[0].values, function (index, value) {
            if (value.selected == true && value.name.toLowerCase() != defaultValue.toLowerCase()) {
                //footerrows.push({ lineitems: value.name, "id": param_id + value.name.toLowerCase() });
                filterData.push(value.name)
            }
        });
    }
    return {FilterData: filterData, DefaultValue: defaultValue};
}

var ExpandedColList = [];
function GetRowLength(indexrow_dimensions, row_dimensions, rowType) {
    if (indexrow_dimensions != null) {
        var length = 0;
        $(row_dimensions).each(function (index, value) {

            if (index > indexrow_dimensions) {
                var data;
                if (value.name != "lineitems")
                    data = value.expansions;
                else
                    data = value.values;
                if (length == 0) {
                    length = data.length;
                }
                else {
                    length = (length * data.length);
                }
            }
        });
        return length;
    } else {
        var length = 1;
        $.each(window.MEData.row_dimensions, function (indexrow_dimensions, valuerow_dimensions) {
            if ($.inArray(rowType, rowDimension) > -1 && $.inArray(rowType, rowDimension) <= indexrow_dimensions) {
                length = length * (valuerow_dimensions.expansions.length + valuerow_dimensions.values.length);
            }
        });
        return length;
    }
}
function ShowHideLI(objImg, rowIndent, sortorder) {
    var table1 = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
    var table2 = $('#tt').datagrid("getPanel").find('table').eq(3 + 1).find('tr');
    var datarows = AlldgRows;
    var cssDisplay;

    if (objImg.src.indexOf('expand') > -1) {
        objImg.src = objImg.src.replace('expand', 'collapse');
        cssDisplay = 'show';
        dummyAjaxRequest(company, cut, 'EXPLORER_SHOW_LI_SINGLE', objImg.id);
    } else {
        objImg.src = objImg.src.replace('collapse', 'expand');
        cssDisplay = 'hide';
        dummyAjaxRequest(company, cut, 'EXPLORER_HIDE_LI_SINGLE', objImg.id);
    }
    var lineArray = [];
    if (paramDisplayType == "all" || paramDisplayType == "")
        lineArray = window.MEData.row_dimensions[0].values.getKeyValues('id');
    else if (paramDisplayType == "driver")
        lineArray = window.MEData.row_dimensions[0].values.getValues('driver', true).getKeyValues('id');
    else if (paramDisplayType == "line")
        lineArray = window.MEData.row_dimensions[0].values.getValues('driver', undefined).getKeyValues('id');
    var hideflag = false;
    var rowindex = $(objImg).closest("tr").index();
    for (var i = datarows.length - 1; i > -1; i--) {
        valuerowdata = datarows[i];
        if (hideflag && valuerowdata.indent > rowIndent) {
            if (valuerowdata.RowAppend != undefined && valuerowdata.RowAppend) {
                if ($(table1).eq(rowindex).find('td').eq(0).find('img').length > 0 && cssDisplay == "show")
                    $(table1).eq(rowindex).find('td').eq(0).find('img')[0].src = $(table1).eq(rowindex).find('td').eq(0).find('img')[0].src.replace('expand', 'collapse');
                if ($(table1).eq(rowindex).find('img').length > 0 && cssDisplay == "hide") {
                    for (var j = 0; j < $(table1).eq(rowindex).find('img').length; j++) {
                        $(table1).eq(rowindex).find('img')[j].src = $(table1).eq(rowindex).find('img')[j].src.replace('collapse', 'expand');
                    }
                }
                if (cssDisplay == 'show' && $(table1).eq(rowindex).find('td').length == rowDimension.length) {
                    $(table1).eq(rowindex).find('td').eq(0).attr('rowspan', '1')
                }
                else if (cssDisplay == 'hide') {
                    for (k = 0; k < rowDimension.length - 1; k++) {
                        $(table1).eq(rowindex).find('td').eq(k).attr('rowspan', '1')
                    }
                }
                if ($.inArray(valuerowdata.id.split('-')[0], lineArray) > -1) {
                    if (cssDisplay == 'show' && $(table1).eq(rowindex).find('td').length != rowDimension.length) {
                    }
                    else {
                        eval("$(table1).eq(rowindex)." + cssDisplay + "()");
                        eval("$(table2).eq(rowindex)." + cssDisplay + "()");
                    }
                }
                rowindex--;
            }

        }
        if (valuerowdata.id == objImg.id && valuerowdata.sortorder == sortorder) {
            hideflag = true;
            rowindex--;
        } else if (valuerowdata.indent <= rowIndent) {
            hideflag = false;
        }
    };
}

function check_list_same(id,objrow){
	var resp = true;
	$.each(objrow.split('-'), function(ind,val){
		if(id.split('-').indexOf(val)<0){
			resp = false;
			return;
		}
	});
	return resp;
}

function OnSuccessShowHiderow(lineItemData, objParameter) {
    var table1 = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
    var table2 = $('#tt').datagrid("getPanel").find('table').eq(4).find('tr');
    //var rowObj = AlldgRows.getValues('sortorder', objParameter.sortorder);
    //var i = objParameter.start;
    var baseParamRow = ($.inArray(objParameter.paramid, baseParamLineitems) > -1) ? true : false;
    var expandingRowIsBaseParamRow = objParameter.paramid === MEData.baseparameter.id;
    var objColFieldNew = "", columnIndex = -1;
    var lineItemList = window.MEData.row_dimensions.filter(function(item){
        return item.name.toLowerCase() === 'lineitems'
    })[0];
    if (lineItemData && lineItemData.data != undefined) {
        $.each(lineItemData.data, function (indexdata, valuedata) {
            var objColParameter = [];
            var objColField = "";
            var objRowField = "";
            var revisionVal = valuedata.revision;
            var keyInParts = valuedata.key.split('|');
            valuedata.source = keyInParts[0];
            valuedata.period = keyInParts[2];
            valuedata.growthtype = keyInParts[5];

            if (!baseParamValue)
                var baseParamValue = {};
            $.each(rowDimension, function (indexRow, valueRow) {
                //Remove the KEY attribute here and turn all those into key values on the outside
                if (valueRow != 'link') {
                    for(var i=0;i < valuedata.data.length; i++) {
                        objRowField = (objRowField == "" ? objRowField : objRowField + "-")
                            + (valueRow == 'lineitem' ? valuedata.data[i].param_id : (valuedata[valueRow].toLowerCase().indexOf(objRowField) == -1 ? valuedata[valueRow].toLowerCase() : ""));
                    }
                }
            });

            if(!expandingRowIsBaseParamRow && objRowField.split('-')[0] === window.MEData.baseparameter.id) {
                //if we are not expanding baseParamRow but current valuedata corresponds to base parameter line
                //ref bug: CACHE-3263
                return;
            }

            var rowIndex = "";
            var appendedRows = AlldgRows.getValues('RowAppend', true);
            var row = $.grep(appendedRows, function (n) {
				return (check_list_same(n.id,objRowField));
                //return (n.id == objRowField);
            });
            if (row.length > 0) {
                rowIndex = $.inArray(row.getValues('sortorder', objParameter.sortorder)[0], appendedRows);
            }

            var formatGrowthType;
            if(valuedata.growthtype && $.inArray(valuedata.growthtype.toLowerCase(), ['analytics']) < 0) {
                formatGrowthType = GROWTHTYPES;
            }

            $.each(valuedata.data, function (indexrowdata, valuerowdata) {
                if (objColField.length == 0) {
                    $.each(colDimension, function (indexcol, valuecol) {
                        objColField = objColField + valuedata[valuecol].toLowerCase();
                        objColParameter.push(valuedata[valuecol].toLowerCase());
                    });
                    if(valuedata.source == "consensus+"){
                        objColField = objColField.toLowerCase().replace('+','plus');
                    }
                    if(sourcesExist && table2.eq(rowIndex).find("td[field='" + objColField + "']").length == 0) {
                        objColField = replaceConsensusPlusOperator(objColField.replace(gSourceFuture.toLowerCase(), window.gSourceActual.toLowerCase()));
                        objColFieldNew = replaceConsensusPlusOperator(objColField.replace(window.gSourceActual.toLowerCase(), gSourceFuture.toLowerCase()));
                    }
                    if (sourcesExist && table2.eq(rowIndex).find("td[field='" + objColField + "']").length == 0)
                        objColField = objColFieldNew;
                    columnIndex = table2.eq(rowIndex).find("td[field='" + objColField + "']").index();
                }
                appendValuesInBaseParameter(valuerowdata, baseParamValue, objColField, objRowField);
                if (row.length > 0 && columnIndex >= 0) {
                    if (objParameter.cellNo == table1.eq(rowIndex).find('td').length) {
                        var modifyrow = $.grep(appendedRows, function (n) {
                            return (n[objParameter.RowObjectName] != undefined && n[objParameter.RowObjectName].toLowerCase().indexOf($.trim(table1.eq(rowIndex).text().toLowerCase())) > -1);
                        });
                        var cell = table2.eq(rowIndex).find("td").eq(columnIndex);
                        if (dataInCommonsize && baseParamRow && valuedata.growthtype == "analytics") {
                            if (!baseParamValue.column) {
                                baseColumnData = $.grep(baseParameterValues, function (baseValue, baseIndex) {
                                    if (baseValue.column == objColField)
                                        return baseValue;
                                });
                                baseParamValue = baseColumnData[0];
                            }
                            //getting new baseparamvalues
                            if (rowDimension.length > 1 && (!(window.MEData.baseparameter.notAvail))) {
                                rowfield = objRowField.replace(valuerowdata.param_id, window.MEData.baseparameter.id);
                                baseParamValue = baseParamValue[rowfield];
                            }
                            var valueData = valuerowdata.value;
                            if (+valueData < 0)
                                valueData = "(" + valueData.replace('-', '') + ")";
                            cellCommonsize(cell, true, baseParamValue, false, valueData + "");
                        }
                        else {
                            if (valuerowdata.unit)
                                $(cell).find('div').html(formatValue(valuerowdata.value, row[0].id, objColField, {
                                    'unit': valuerowdata.unit,
                                    'precision': valuerowdata.precision,
                                    'rowDimension': formatGrowthType
                                }));
                            else
                                $(cell).find('div').html(formatValue(valuerowdata.value, row[0].id, objColField, {'precision': valuerowdata.precision}));
                        }

                        var cellElement = $(cell)
                            ,cellSource = getDpSource(objColParameter.join('|'), objRowField)
                            ,revision = valuedata.revision ? valuedata.revision: undefined
                            ,cellGrowthType = valuedata.growthtype,
                            parameterId;

                        cellElement.attr('id', valuerowdata.id);
                        cellElement.attr('dapparam_id', valuerowdata.param_id);
                        cellElement.attr('period', valuerowdata.period);
                        cellElement.attr('revision',revisionVal)
                        if(cut === 'NMV')
                            cellElement.attr('parameterid', valuerowdata.parameterid)
                        else if (cut == 'SAR' || cut == 'CPT') {
                            cellElement.attr('parameterid', valuerowdata.id);
                            parameterId = valuerowdata.id;
                        } else if(cut == 'SCH'){
                            cellElement.attr('parameterid', valuerowdata.id);
                            parameterId = valuerowdata.param_id;
                        }
                        //Comparing the dapparameterid of a line in the row_dimensions of window.MEData, with the param_id of
                        //the datapoint, once expanded in the row
                        if(cut == "NMV"){
                            var hasPeerValObj = lineItemList.values.filter(function(item){
                                return item.dapparameterid == valuerowdata.param_id
                            })[0];
                            cellElement.attr('iscomparetopeer',(hasPeerValObj.ops_sli !== undefined ? true : false));
                            parameterId = hasPeerValObj.parameterid;
                        }
                        if (-1 !== $.inArray(cellGrowthType.toLowerCase(), contextMenuAllowedGrowthType)) {
                            cellSource = bindContextMenuEvent(cellElement, cut, valuedata.source, revision);
                        
                        if(valuerowdata.period){
                            var notesObj = {
                                period: valuerowdata.period,
                                parameterid: parameterId,
                                source: cut !== 'SAR' ? cellSource : window.gSource.toLowerCase(),
                                revision:{
                                    revision: valuedata.revision,
                                    revision_date: valuedata.revision_date,
                                    revision_datetime: valuedata.revision_datetime,
                                },
                                el: cellElement
                            }
                            bindDataPointNote(notesObj);
                        }
                        
                    }

                        if (valuerowdata.id != undefined && valuerowdata.id != "" && valuerowdata.value!="NM" && valuerowdata.value != null) {
                            cellElement.off('click.datacellClick').on('click.datacellClick', function (event) {
                                // cellElement = cellElement[0]
                                if(!cellElement){
                                    cellElement = event.currentTarget
                                }
                                // const cellData = {
                                //     id:cellElement.getAttribute("id") || null,
                                //     field:cellElement.getAttribute("field")  || null,
                                //     dapparam_id:cellElement.getAttribute("dapparam_id") || null,
                                //     revision:cellElement.getAttribute("revision") || null
        
                                // }
                                var paramsForFbar = prepareDpParams(valuerowdata.id,cut,window.MEData.ticker,cellSource,cellGrowthType,window.MEData.panels[1]["actual-default"],cellElement.attr('period'),cellElement.attr('dapparam_id'),window.MEData.selectedCurrency,incl_sources,excl_sources,true,cellElement)
                                const summonFBar = new CustomEvent('SummonFBar', { detail: { data: paramsForFbar} })
                                window.dispatchEvent(summonFBar);                            
                                // datacellClick(valuerowdata.id, objColField, this, cut, cellSource, "row", cellGrowthType, event, window.MEData.ticker, undefined, window.MEData.selectedCurrency);
                            });
                            if (valuerowdata.dpnote && $(cellElement).attr('note') == undefined) {
                                bindPopoverForNotes(valuerowdata.dpnote,$(cellElement),objColField);

                                if (valuerowdata.internal_note) {
                                    cellElement.addClass('internal_note');
                                } else {
                                    cellElement.addClass('external_note');
                                }
                            }

                            getCellStyling(valuerowdata.annotation, cell);

                        } else {
                            cellElement.off('click.datacellClick').on('click.datacellClick', function (event) {
                                var paramsForFbar = {};
                                const summonFBar = new CustomEvent('SummonFBar', { detail: { data: paramsForFbar} })
                                window.dispatchEvent(summonFBar);                           
                                // datacellClick("", "", this, "", "", "row", "", event, window.MEData.ticker)
                            });
                        }

                        if (valuerowdata.max) {
                            cellElement.attr('max', '');
                        }

                        if (valuerowdata.min) {
                            cellElement.attr('min', '');
                        }
                        if (valuerowdata.surprise != undefined) {
                            $(cell).attr('surprise', valuerowdata.surprise);
                            $(cell).attr('title', valuerowdata.title);
                            $(cell).attr('surprisetitle', valuerowdata.title);
                        }
                    }

                }
            });
        });
    }
	analystTitlecolumn(lineItemData);
    //if (window.gSchedule)
    //gridFormattingForSchedules();
}

function analystTitlecurrent(valuedata){
    //todo note change
	var source = valuedata.source;
	var revisiondate = valuedata.revision_date;
	var modeldate = valuedata.modeldate
	paramdata = valuedata.data;
	$.each(paramdata, function (indexrowdata, coldata) {
		var id = coldata.param_id;
		$('#'+id).closest('tr').find('td').each(function( index ){
			if($(this).attr('field')=='Revisions'){
				var rev_ele = $( this );
                rev_ele.attr('qttitle', 'Date: ' + revisiondate);
                var popoverobj = {
                    content: function(){
                        return '<span>'+$(this).attr('qttitle')+'</span>';
                    },
                    width:'auto',
                    style:"column-level",
                    placement: "auto-bottom",
                    "closeable": false,
                    cache:false,
                    arrow:true,
                    trigger:'hover'
        
                };
                rev_ele.webuiPopover(popoverobj);
			}
			if($(this).attr('field')=='Sources' || $(this).attr('field')=='Scenarios'){
				var rev_ele = $( this );
				rev_ele.attr('qttitle', 'Date: ' + modeldate);
				var popoverobj = {
                    content: function(){
                        return '<span>'+$(this).attr('qttitle')+'</span>';
                    },
                    width:'auto',
                    style:"column-level",
                    placement: "auto-bottom",
                    "closeable": false,
                    cache:false,
                    arrow:true,
                    trigger:'hover'
        
                };
                rev_ele.webuiPopover(popoverobj);
			}
		});
	});
}

function analystTitlecolumn(msg){//todo note change
	paramdata = msg.data;
	$.each(paramdata, function (indexrowdata, coldata) {
		var id = coldata.param;
		id = $('#'+id).closest('tr').attr('id');
		$('.expanded-row#'+id).each(function( index ) {
			$( this ).find('td').each(function( index ){
				var title_str = '';
				if (typeof coldata.analyst != 'undefined' && coldata.analyst)
					title_str = title_str + 'Analyst : ' + coldata['analyst'] + ' <br> ';
				if (typeof coldata.modeldate != 'undefined' && coldata.modeldate)
					title_str = title_str + 'Date : ' + coldata['modeldate'];
				if (title_str.length > 0 && $( this ).attr('field')!='Revisions'){
					if(($( this ).find('b').length>0 && $( this ).find('b').html()== coldata.source) || ($( this ).find('span').length>0 && $( this ).find('span').html()== coldata.source)){
						if (showCCicon(coldata.source) && showExcludedIcon(coldata.source) && coldata.source.length > 6) {
                            title_str = coldata.source + '<br>' + title_str;
                        }
                        if(coldata.source.toLowerCase()!='filings'){
							var rev_ele = $( this );
							rev_ele.attr('qttitle', title_str);
							qtipSettings(rev_ele,'qttitle');
						}
						else if(coldata.revision.toLowerCase() =='current' && coldata.source.toLowerCase()=='filings'){
							var rev_ele = $( this );
							rev_ele.attr('qttitle', title_str + '<br> This is the latest filing date');
							qtipSettings(rev_ele,'qttitle');
						}
					} else if(($( this ).find('b').length>0 && $( this ).find('b').html()== coldata.scenario) || ($( this ).find('span').length>0 && $( this ).find('span').html()== coldata.scenario)){
                        var rev_ele = $( this );
                        rev_ele.attr('qttitle', title_str);
                        qtipSettings(rev_ele,'qttitle');
                    }

				}
				if (typeof coldata.revision_date != 'undefined' && coldata.revision_date && $( this ).attr('field')=='Revisions'){
					if(($( this ).find('b').length>0 && $( this ).find('b').html()== coldata.revision) || ($( this ).find('span').length>0 && $( this ).find('span').html()== coldata.revision)){
						var rev_ele = $( this );
						if(coldata.revision.toLowerCase()=='preq')
							rev_ele.attr('qttitle', 'Date: ' + coldata['revision_date'] + '<br> This date is derived from the latest filing received and is only applicable for Estimates');
						else
							rev_ele.attr('qttitle', 'Date: ' + coldata['revision_date']);
						qtipSettings(rev_ele,'qttitle');
					}
				}
			});
		});
	});
}
/*Below function modification is in progress*/
function ShowHiderow(event, rowType, param_id, selectedTd, RowObjectName, Parameter) {
    if(rowType.toLowerCase() == "growthtype" && typeof(event.button) == "number"){ // checking if mouse click event
        // saving rows expansions for Analytics
        var action = $(selectedTd).attr("class") === "expanded-row-header" ? "collapse" : "expand";
        ExpandRowProcess(rowType, param_id, action);
    }
    var textRowExpandedType = rowType;
    var textRowExpandedValue = Parameter.split('&&')[0];
    var objImg = $(selectedTd).find("img[src*='datagrid_row_']")[0];
	if(!objImg || objImg.className == "custcon" || objImg.className == "excluded_icon" ) {
		// this event is fired when custom consensus icon is clicked, handling it here.
		return false;
	}
    var defaultData = window.MEData.row_dimensions.filter(function(item){
        return item.name == RowObjectName
    });
    //var expansions = defaultData.expansions;
/*    if(RowObjectName == 'GrowthTypes' && $.inArray(Parameter, dataExpandField) != -1 && objImg.src.indexOf('expand') > -1)
        dataExpandField.splice($.inArray(Parameter, dataExpandField), 1);*/
    var sortOrder = Parameter.split("&&")[1];
    var cellNo = window.MEData.row_dimensions.length;
    var start = $(selectedTd).closest('tr').index() + 1;
    var end = $(selectedTd).closest('tr').index() + GetRowLength(null, null, rowType) - 1;
    var defaultrowspan = 1;
    if($.inArray(Parameter, dataExpandField) == -1){
        var expandedRow = {
            rowParameter : Parameter,
            rowType : rowType,
            expanded : rowType + 's',
            objImg : objImg
        };
        expandedRowList.push(expandedRow);
    }
    var table4 = $('#tt').datagrid("getPanel").find('table').eq(4);
    var table1 = $('#tt').datagrid("getPanel").find('table').eq(1);
    var incrementallength = 1;
    var paramid = param_id.split('-')[0];
    var rows = jQuery.extend(true, [], AlldgRows);
    var rowObj;
    rowObj = GetSpecifiedRows(rows, param_id).getValues('sortorder', sortOrder);
    // filter(remove % lines) here
    //note: below if condition. breaking on row-analytics expand because baseparameter.magnitude might not be present
    //note: if condition is put to check if baseparameter.magnitude is present and only then allowed to execute, breaks the whole view
    if(!(window.MEData.baseparameter && window.MEData.baseparameter.magnitude == rowObj[0].magnitude && window.MEData.baseparameter.unit == rowObj[0].unit) && rowType == "growthtype"){
        rowObj = rowObj.filter(function(val, i){
            return val.id.indexOf("-%") == -1;
        });
    }
    rowObj = [...new Map(rowObj.map(item =>[item['id'], item])).values()];
    $.each(rowDimension, function (indexrowDimension, valuerowDimension) {
        if ($.inArray(rowType, rowDimension) < indexrowDimension) {
            incrementallength = incrementallength * (window.MEData.row_dimensions[indexrowDimension].expansions.length + 1)
        }
    });

    incrementallength = (incrementallength == 0 ? 1 : incrementallength);
    if ($.inArray(Parameter, dataExpandField) == -1) {


        analytics_helper.add(ANALYTICS_EVENT_TYPES.ROW_EXPAND.SINGLE, Parameter);
        dataExpandField.push(Parameter);
        var rowPosition = -1;
        var rowDimensionWithOutLinks = rowDimension.filter(function(item){
            return item.toLowerCase() !== 'link'
        });
        //var rowDimensionWithOutLinks=$.grep(rowDimension, function (n) {
        //    return (n.toLowerCase() != "link");
        //});
        $.each(window.MEData.row_dimensions, function (indexrowDimension, valuerowDimension) {
            if (valuerowDimension.name != RowObjectName)
                return;
            //var table4 = $('#tt').datagrid("getPanel").find('table').eq(4);
            var i = $(selectedTd).closest('tr').index();
            var j = i;
            table1.find('tr').eq(i).addClass('datagrid-row-expanded');
            table4.find('tr').eq(i).addClass('datagrid-row-expanded');
            var expandedRowObject = AlldgRows.getValues('RowAppend', true)[i];
            var dgRowIndex = 0;
            if(!(expandedRowObject.magnitude == window.MEData.baseparameter.magnitude && expandedRowObject.unit == window.MEData.baseparameter.unit) && rowType == "growthtype"){
                // removing % analytics
                if(valuerowDimension.expansions.indexOf("%") > -1){
                    valuerowDimension.expansions.splice(valuerowDimension.expansions.indexOf("%"), 1)
                }
            }
            var expansions = valuerowDimension.expansions;
            $.each(expansions, function (index, value) {
                var rowArray = expandedRowObject.id.replace(/-/g, '|').replace('||','|-').split('|');
                rowArray[$.inArray(rowType,rowDimensionWithOutLinks)] = value.toLowerCase();

                if(AlldgRows.getValues('id',rowArray.join('-')).getValues('sortorder',sortOrder)[0]) {
                    AlldgRows.getValues('id',rowArray.join('-')).getValues('sortorder',sortOrder)[0]['RowAppend'] = true;
                }

				dgRowIndex = dgRowIndex + incrementallength;
                var $table1TR = table1.find('tr').eq(i).clone(false);
                $table1TR.removeClass("datagrid-row").removeClass("datagrid-row-over").removeClass('datagrid-row-expanded').addClass('expanded-row');
                var $tr = table4.find('tr').eq(i).clone(false);

                //row header styling revert
                $tr.removeClass("datagrid-row").removeClass("datagrid-row-over").removeClass('datagrid-row-expanded').addClass('expanded-row');

                //$tr.removeClass("datagrid-row").removeClass("row-expanded-last");

                var celldifference = window.MEData.row_dimensions.length - $table1TR.find('td').length;

                $.each(window.MEData.row_dimensions, function (indexRD, valueRD) {
                    try {
                        if (indexRD == 0)
                            rowId = $table1TR.find("td").eq(0).attr('id')
                        if (indexRD > 0 && rowObj[dgRowIndex] && rowObj[dgRowIndex][valueRD.name] != undefined) {
                            var tempTD = $table1TR.find("td").eq(indexRD - celldifference);
                            var tempTdDiv = tempTD.find('div');
                            if(valueRD.name != 'Sources') {
                                if (valueRD.name.toLowerCase().indexOf(rowType.toLowerCase()) > -1)
                                    tempTD.addClass("row-expanded-header").removeClass('current-change').find('div').html(rowObj[dgRowIndex][valueRD.name]);
                                else
                                    tempTdDiv.html(rowObj[dgRowIndex][valueRD.name]);
                                tempTdDiv.html(rowObj[dgRowIndex][valueRD.name]);
                            } else {
                                var showCCIcon = showCCicon(value);
                                var showExIcon = showExcludedIcon(value);
                                var showCPlusIcon = showConPlusIcon(value);
                                tempTdDiv.html('');
                                var imgValue = "";

                                tempTD.addClass("row-expanded-header").removeClass('current-change').find('div').append(rowObj[dgRowIndex][valueRD.name])
                                if (showCCIcon || showExIcon || showCPlusIcon){
                                    tempTdDiv.find('span').addClass('ellipsis_class ellipsis_source').addClass('ellipsis_row');
                                }
                                if (showExIcon) {
                                    imgValue += "<img class='excluded_icon' style='' src='"+window.assetUrl+"/icon-excluded.png'/>";
                                }
                                if (showCCIcon) {
                                    imgValue += "<img class='custcon' style='' src='"+window.assetUrl+"/custom_consensus.png'/>";
                                }
                                if(showCPlusIcon && !(showCCIcon && showExIcon && showCPlusIcon)){
                                    imgValue += "<img class='conPlus_icon' src='"+window.assetUrl+"/consensus_plus_icon.png'/>";
                                }
                                tempTdDiv.append(imgValue);
                            }
                            var imgParameter = tempTD.find('img');
                            if (imgParameter.length > 0) {
                                var imgParam;
                                var revIndex = indexRD;
                                var idArray = rowObj[dgRowIndex]['id'].split('-');

                                if (idArray.indexOf("") === -1) {
                                    revIndex = revIndex - 1;
                                }

                                var rowParameter = idArray.slice(0, revIndex);

                                rowParameter = rowParameter.join('-');
                                var imgParam = idArray.slice(0, indexRD+1).join('-').toUpperCase().replace(/-/g, '|').replace('||','|-');

                                tempTD.find('img').eq(0).removeAttr('click-link');

                                //When a new row is expanded, it removes the existing function bound on the td and just binds the below click
                                //$table1TR.find("td").eq(indexRD - celldifference).removeAttr('onclick').unbind('onclick').bind('click', function () {
                                //    ShowHiderow(rowDimension[indexRD], rowParameter, this, valueRD.name, imgParam + "&&" + sortOrder)
                                //});

                                tempTD.removeAttr('onclick');
                                tempTD.removeAttr('clickbinding');
                                tempTD.attr("onclick","ShowHiderow(event,'" + rowDimension[indexRD] + "','" + rowParameter + "', this ,'" + valueRD.name + "','" + (imgParam + "&&" + sortOrder) + "');")
                                tempTdDiv.addClass('ellipsis_source')
                            }
                        }
                    } catch (ex) {
                        console.error(ex);

                    }
                });
                 /*var t1 = Date.now();
                    console.log('start row_dimensions2 : ',t1);*/

                $table1TR.find("td:lt(" + (indexrowDimension - celldifference) + ")").remove();
                if (rowPosition == -1) {
                    for (rowPosition = j + 1; j + 1 <= rowPosition;) {
                        if (table1.find("tr").eq(rowPosition).length == 0) {
                            j = (rowPosition - 1);
                            break;
                        }
                        if (table1.find("tr").eq(rowPosition).find('td').length <= $table1TR.find("td").length) {
                            rowPosition++;
                        } else {
                            j = (rowPosition - 1);
                            break;
                        }
                    }
                }
                // row header styling
                //                if (index == valuerowDimension.expansions.length - 1) {
                //                    $tr.addClass("row-expanded-last");
                //                    $table1TR.addClass("row-expanded-last");
                //                }
                table1.find("tr").eq(j).after($table1TR);
                //$tr.removeAttr("id").removeAttr("datagrid-row-index");
                $tr.removeAttr("id");
                $tr.attr("datagrid-row-index", $tr.attr("datagrid-row-index") + "-" + index);
                $tr.find('div').html("");

                var lastQClass = $tr.find('td.lastQ');
                $tr.find('td').css('background-color', '').attr('cellvalue', '').removeAttr('title min max class id note').unbind('click').bind('click', function (event) {
                    var paramsForFbar = {};
                    const summonFBar = new CustomEvent('SummonFBar', { detail: { data: paramsForFbar} })
                    window.dispatchEvent(summonFBar);              
                    // datacellClick("", "", this, "", "", "row", '', event, window.MEData.ticker, undefined, window.MEData.selectedCurrency)
                });
                if (lastQClass.length > 0) {
                    lastQClass.addClass('lastQ');
                }

                $table1TR.find('td').removeAttr("style");
                table4.find("tr").eq(j).after($tr);
                j++;
                //console.log('end row_dimensions2: ',Date.now() - t1);
            });
        });
        defaultData = window.MEData.row_dimensions.filter(function(item){
            return item.name == RowObjectName
        });
    }
    //    return;
    $.each(window.MEData.row_dimensions, function (indexrow_dimensions, valuerow_dimensions) {
        if ($.inArray(rowType, rowDimension) > indexrow_dimensions) {
            cellNo--;
        }
    });
    var extraExpandData = {};
    extraExpandData['Type'] = '';
    extraExpandData['Value'] = '';
    extraExpandData['Type'] = textRowExpandedType;
    extraExpandData['Value'] = textRowExpandedValue;

    if (param_id.indexOf("-") > -1){
        extraExpandData['lineItemId'] = param_id.substring(0,param_id.indexOf("-"));
    }else{
        extraExpandData['lineItemId'] = param_id;
    }
    /*var t2 = Date.now();
    console.log('start secondloop: ',t2);*/
    if (defaultData.length > 0) {
        defaultData = defaultData[0];

        if(rowType.toLowerCase() === "growthtype" && defaultData.expansions){
            var expansionsLength = rowObj.length - 1;
        }else{
            if(defaultData.expansions){
                var expansionsLength = defaultData.expansions.length;
            }
        }

        extraExpandData['IncludedValues'] = defaultData.expansions;
        var table1 = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
        var table2 = $('#tt').datagrid("getPanel").find('table').eq(3 + 1).find('tr');
        //var datarows = $('#tt').datagrid("getRows");
        var cssDisplay;
        if (objImg.src.indexOf('expand') > -1) {
            $(selectedTd).addClass("expanded-row-header");
            objImg.src = objImg.src.replace('expand', 'collapse');
            cssDisplay = 'show';
            if(rowType == 'source') { //if rowtype is source, we also log the list of sources included in the custom consensus calculations
                var includedSourcesinCC = getIncludedBrokers();
                extraExpandData['IncludedinCC'] = [];
                extraExpandData['IncludedinCC'] = includedSourcesinCC;
                var unentitledSourceInfo = getUnentitledSourceInfo();
                $.extend(extraExpandData, unentitledSourceInfo);
            }
            dummyAjaxRequest(company, cut, 'EXPLORER_ROW_EXPAND_SINGLE', extraExpandData,'');
            var dimension_traverse = [];
            var index = rowDimension.indexOf(textRowExpandedType);
            var startIndex = index == 2 ? 0: index-1;
            var row = $(selectedTd).closest('tr').find('td');
            row.removeAttr('rowspanSet');
            var cellId = index == 2 ? 0:row.index(selectedTd) - 1;       
            for(var cellIndex = startIndex; cellIndex<window.MEData.row_dimensions.length; cellIndex++) {
                if ($.inArray(rowType, rowDimension) > cellIndex) {
                    var valuerow_dimensions = window.MEData.row_dimensions[cellIndex];
                    var parentcell = row.eq(cellId);
                    
                    if (expansionsLength > 0 && (!parentcell.attr("field") || parentcell.attr("field")==valuerow_dimensions.name)) {
                        parentcell.attr('rowspan', parseInt((parentcell.attr('rowspan') == undefined ? defaultrowspan :
                                parentcell.attr('rowspan'))) + expansionsLength);
                        parentcell.attr('rowspanSet', true);
                    }
                    dimension_traverse.push(rowDimension[cellIndex]);
                    cellId++;
                }
            }


            var rootCell = param_id.split('-');
            var sOrder = Parameter.split('&&')[1];
            rootCell = $('#' + rootCell[0] + "--" + sOrder);
            var rootRow = $(selectedTd).closest('tr').find('td');
            var endIndex = rootRow.index(selectedTd);
            var rowspan = defaultrowspan;
            if (rowDimension.length != $(selectedTd).closest('tr').find('td').length) {// check for adding rowspan to links td
                var cellIndex = 0;
                rootCell.removeAttr('rowspanSet');
            } else {
                var cellIndex = 2;
            }
            //adds rowspan to links td
            if(!rootCell.attr('rowspanSet')) {
                rowspan = parseInt((rootCell.attr('rowspan') == undefined ? defaultrowspan : rootCell.attr('rowspan'))) + expansionsLength;
                rootCell.attr('rowspan', rowspan);
                rootCell.next("td").attr('rowspan', rootCell.attr('rowspan'));
            }
            //adds rowspan to parent of parentCell. required for 3 levels in rows expansion
            var id = textRowExpandedValue.toLowerCase().split('|').slice(0, 2).join('-').replace(' ', '-') + "--" + sOrder;
            rootCell = $('#' + id).closest('td');
            if(!rootCell.is(parentcell) && !rootCell.is(selectedTd)) {
                rowspan = parseInt((rootCell.attr('rowspan') == undefined ? defaultrowspan : rootCell.attr('rowspan'))) + expansionsLength;
                rootCell.attr('rowspan', rowspan).attr('rowspanSet', true);
            }
            //loop through current expanded row and add rowspan
            for(; cellIndex < endIndex; cellIndex++) {
                if(!rootRow.eq(cellIndex).is(parentcell) && !rootRow.eq(cellIndex).is(rootCell) && !rootRow.eq(cellIndex).is(selectedTd)) {
                    rowspan = parseInt((rootRow.eq(cellIndex).attr('rowspan') == undefined ? defaultrowspan : rootRow.eq(cellIndex).attr('rowspan'))) + expansionsLength;
                    rootRow.eq(cellIndex).attr('rowspan', rowspan);
                }
            }

        } else {
            $(selectedTd).removeClass("expanded-row-header");
            objImg.src = objImg.src.replace('collapse', 'expand');
            cssDisplay = 'hide';

            dummyAjaxRequest(company, cut, 'EXPLORER_ROW_COLLAPSE_SINGLE', extraExpandData,'');

            var dimension_traverse = []    
            $.each(window.MEData.row_dimensions.slice(window.MEData.row_dimensions.length - $(selectedTd).closest('tr').find('td').length), function (indexrow_dimensions, valuerow_dimensions) {
                if ($.inArray(rowType, rowDimension) > indexrow_dimensions) {
                    var parentcell = $(selectedTd).closest('tr').find('td').eq(indexrow_dimensions);
                    if ($(selectedTd).closest('tr').find('td').eq(indexrow_dimensions).index() < $(selectedTd).index()
                        && parentcell.attr("field") == valuerow_dimensions.name)
                        if (parentcell.attr('rowspan') != undefined)
                            parentcell.attr('rowspan', parseInt(parentcell.attr('rowspan')) - expansionsLength);
                    dimension_traverse.push(rowDimension[indexrow_dimensions])
                }
            });
            if (rowDimension.length != $(selectedTd).closest('tr').find('td').length) {
                var rootCell = param_id.split('-');
                var sOrder = Parameter.split('&&')[1];
                rootCell = $('#' + rootCell[0] + "--" + sOrder);
                rootCell.attr('rowspan', parseInt((rootCell.attr('rowspan') == undefined ? defaultrowspan : rootCell.attr('rowspan'))) - expansionsLength);

                if (window.MEData.row_dimensions[1].name.toLowerCase()=="links") {
                    rootCell.next("td").attr('rowspan', rootCell.attr('rowspan'));
                }

                if ($.inArray('revision', rowDimension) > -1 && $.inArray('revision', dimension_traverse)==-1) {
                    rootCell = $('#' + textRowExpandedValue.toLowerCase().split('|').slice(0, 2).join('-').replace(' ', '-') + "--" + sOrder).closest('td');
                    var rowSpan = parseInt((rootCell.attr('rowspan') == undefined ? defaultrowspan : rootCell.attr('rowspan'))) - expansionsLength

                    rootCell.attr('rowspan', rowSpan > 0? rowSpan: 1);
                }
            }
        }


        var ObjWebServiceCall = new WebServiceCall();

            //TO-DO: Will clean all this up!! param 3 calls on row expansion
            var setCallSize = 4;
            var i, j;
            var tempPeriodArr = [];          

            var periods = window.MEData.column_dimensions[0].values.map(function(val){return val.period});
            for (i = 0, j = periods.length; i < j; i += setCallSize) {
                tempPeriodArr = periods.slice(i, i + setCallSize);
                var periodsByForecast = [];
                var periodsByActual = [];

                for(var t = 0; t < tempPeriodArr.length; t++){
                    if(whetherIsForecast(tempPeriodArr[t])){
                        periodsByForecast.push(tempPeriodArr[t]);
                    }
                    else{
                        periodsByActual.push(tempPeriodArr[t]);
                    }
                }

                if(periodsByForecast.length > 0) {
                    var anotherPeriodForecastArr = [];
                    for (var z = 0; z < periodsByForecast.length; z++) {
                        if ($.inArray(Parameter + "-" + periodsByForecast[z], dataExpandField) == -1) {
                            anotherPeriodForecastArr.push(periodsByForecast[z]);
                            dataExpandField.push(Parameter + "-" + periodsByForecast[z]);
                        }
                    }

                    if (anotherPeriodForecastArr.length !== 0) {
                        ObjWebServiceCall.getparameterData(paramid, anotherPeriodForecastArr, Parameter, '', RowObjectName,
                            {
                                "sortorder": sortOrder,
                                "paramid": paramid,
                                "start": start,
                                "end": end,
                                "cellNo": cellNo,
                                "RowObjectName": RowObjectName
                            });
                    }
                }

                if(periodsByActual.length > 0) {
                    var anotherPeriodActualArr = [];
                    for (var z = 0; z < periodsByActual.length; z++) {
                        if ($.inArray(Parameter + "-" + periodsByActual[z], dataExpandField) == -1) {
                            anotherPeriodActualArr.push(periodsByActual[z]);
                            dataExpandField.push(Parameter + "-" + periodsByActual[z]);
                        }
                    }

                    if (anotherPeriodActualArr.length !== 0) {
                        ObjWebServiceCall.getparameterData(paramid, anotherPeriodActualArr, Parameter, '', RowObjectName,
                            {
                                "sortorder": sortOrder,
                                "paramid": paramid,
                                "start": start,
                                "end": end,
                                "cellNo": cellNo,
                                "RowObjectName": RowObjectName
                            });
                    }
                }
            }

            if (objImg.src.indexOf('expand') == -1) {
               //make param calls for expanded columns
                var expandedPeriodSourcesList = window.MEData.extras.expandedColumns.slice();
                for (var index = 0; index < expandedPeriodSourcesList.length; index++) {
                    var value = expandedPeriodSourcesList[index];
                    var period = value.parameter.split('|')[0];
                   // var sourceList = FindExpansions("Sources", period);

                    //if value.parameter not available as field in grid td's
                    //do not try to call param3 call for that column
                    //ref bug: CACHE-2321
                    var fieldValue = value.parameter.replaceAll('|', '');
                    if( $('td[field="' + fieldValue +  '"]').length === 0) {
                        continue;
                    }

                   if(value.colType == 'period'){
                    var periods =getPeriodQuarters(period);
                    
                    if(periods.future.length > 0){
                        period = periods.future;
                        ObjWebServiceCall.getparameterData(paramid, period, Parameter, value.parameter, RowObjectName,
                            {
                                "sortorder": sortOrder,
                                "paramid": paramid,
                                "start": start,
                                "end": end,
                                "cellNo": cellNo,
                                "RowObjectName": RowObjectName
                            });
                    }
                    if(periods.past.length > 0){
                        period = periods.past;
                        ObjWebServiceCall.getparameterData(paramid, period, Parameter, value.parameter, RowObjectName,
                            {
                                "sortorder": sortOrder,
                                "paramid": paramid,
                                "start": start,
                                "end": end,
                                "cellNo": cellNo,
                                "RowObjectName": RowObjectName
                            });
                    }
                    
                   } else if(value.colType == 'revision') {

                  
                    var periodsObj = getPeriodQuarters('fy-'+period.split('-')[1]);
                    if(periodsObj.past.includes(period.toUpperCase()) || periodsObj.all === 'past') {
                        // check source and send param call accordingly
                        var dataObj = {
                            paramid: paramid,
                            period:period,
                            parameter:Parameter,
                            rowObjName: RowObjectName,
                            key:value.parameter,
                            objColParameter:{
                                "sortorder": sortOrder,
                                "paramid": paramid,
                                "start": start,
                                "end": end,
                                "cellNo": cellNo,
                                "RowObjectName": RowObjectName,
                                expand:value.colType,
                                "skipPreq": true
                            }
                        }
                        checkHistoricalSourceForRevision(dataObj, ObjWebServiceCall);
                        

                    } else {
                        ObjWebServiceCall.getparameterData(paramid, [period], Parameter, value.parameter, RowObjectName,
                        {
                            "sortorder": sortOrder,
                            "paramid": paramid,
                            "start": start,
                            "end": end,
                            "cellNo": cellNo,
                            "RowObjectName": RowObjectName,
                            expand:value.colType
                        });
                    }
                 } else { 
                    ObjWebServiceCall.getparameterData(paramid, [period], Parameter, value.parameter, RowObjectName,
                    {
                        "sortorder": sortOrder,
                        "paramid": paramid,
                        "start": start,
                        "end": end,
                        "cellNo": cellNo,
                        "RowObjectName": RowObjectName,
                        expand:value.colType
                    });
                 }
                }
            }

        j = 0;
        var actionFlag = false;
        
        for (i = start; i <= end; i++) {
            var table1Tr = table1.eq(i);
            var table2Tr = table2.eq(i);
            var tdLength = table1Tr.find('td').length;

            var dimensionTypeIndex = $.inArray(rowType, rowDimension);
            var dimensionLength = rowDimension.length;

            if (tdLength == dimensionLength || (tdLength == dimensionLength - (dimensionTypeIndex >= 3 ? (dimensionTypeIndex - 1) : 0))) {
                break;
            }

            if (cssDisplay == 'show') {
                if (cellNo == tdLength) {
                    table1Tr.find('td').attr('rowspan', 1).removeClass('expanded-row-header');
                    table1Tr.find("img[src*='collapse']").attr('src', window.assetUrl + "/datagrid_row_expand.png");
                    table1Tr.show();
                    table2Tr.show();
                }
            } else {
                if ($(table1Tr).is(":visible") == true) {
                    if (tdLength >= cellNo || actionFlag) {
                        actionFlag = true;
                        table1Tr.hide()
                        table2Tr.hide();
                        j++;

                        if (j > defaultData.expansions.length) {
                            var rootCell = param_id.split('-');
                            var sOrder = Parameter.split('&&')[1];
                            rootCell = $('#' + rootCell[0] + "--" + sOrder);
                            rootCell.attr('rowspan', parseInt((rootCell.attr('rowspan') == undefined ? defaultrowspan : rootCell.attr('rowspan'))) - 1);


                            if (window.MEData.row_dimensions[1].name.toLowerCase() == "links") {
                                rootCell.next("td").attr('rowspan', rootCell.attr('rowspan'));
                            }

                            if (window.MEData.row_dimensions.length > 4 && window.MEData.row_dimensions[2].name == "Revisions" && rowType != 'revision') {
                                rootCell = $('#' + textRowExpandedValue.toLowerCase().split('|').slice(0, 2).join('-').replace(' ', '-') + "--" + Parameter.split('&&')[1]).closest('td');
                                var rowSpan = parseInt((rootCell.attr('rowspan') == undefined ? defaultrowspan : rootCell.attr('rowspan'))) - 1;

                                rootCell.attr('rowspan', rowSpan > 0 ? rowSpan : 1);
                            }

                        }
                    }
                }
            }
        }
    }
    // reverting row_dimensions because growthtype values changed
    window.MEData.row_dimensions = jQuery.extend(true, [], gridLoadedMEData.row_dimensions);
    // row header styling changes
    //$(objImg).closest('td').toggleClass('row-expanded-header');
    //var rowIndex = $(selectedTd).closest('tr').index();
    //alert(rowIndex);
    //var rowExpaned = $('#tt').datagrid("getPanel").find('table').eq(3 + 1).find('tr').eq(rowIndex);
    //rowExpaned.toggleClass('row-expanded-previous');
    //rowExpaned.prev().toggleClass('row-expanded-last');
    clickToAddEvent();

    if (window.gSchedule)
        gridFormattingForSchedules(param_id);
}

function checkHistoricalSourceForRevision(dataObj, ObjWebServiceCall){

    var revDateList = FindExpansions("Revisions");
    var actualsList = [];
    var consensusList = [];
    var revisionPanelData = window.MEData.panels.filter(function(value) { return value.name == "Revisions" })[0];
    for (var i = 0; i < revDateList.length; i++) {
        var revisionDateToApply = revDateList[i];
        var periodsFilingDate = new Date(filingsPerPeriodDict[dataObj.period.toUpperCase()]);
        if(!isNaN(periodsFilingDate)) {
            var actualPosition = revisionPanelData.values.indexOf(revisionDateToApply);
            var originalRevisionDate = new Date(revisionPanelData.revision_date_list[actualPosition]);
            var formattedDate = $.datepicker.formatDate("mm-dd-yy", originalRevisionDate);
        }
        if (revDateList[i].toLowerCase() !== 'preq' && revDateList[i].toLowerCase() !== 'current') {
            if (!isNaN(periodsFilingDate) && originalRevisionDate > periodsFilingDate) {
                
                actualsList.push(revisionDateToApply + "|" + formattedDate);
                //source=VA Actuals
            }
            else {
                consensusList.push(revisionDateToApply + "|" + formattedDate);
                //source=Consensus
            }
        }
        else if (revDateList[i].toLowerCase() === 'preq') {
            consensusList.push("PreQ|PreQ");
        }
       // ObjWebServiceCall.getPgData(data, parameterList, event);
    }
    if(actualsList.length){
        //call for actuals
        dataObj.objColParameter.source = cut && cut.toLowerCase() !== "sar" ? "VA Actuals": window.gSource;
        dataObj.objColParameter.revisionList = actualsList.slice();
        ObjWebServiceCall.getparameterData(dataObj.paramid, [dataObj.period], dataObj.parameter, dataObj.key,
             dataObj.rowObjName, dataObj.objColParameter
        );

    }
    if(consensusList.length){
        //call for consensus
        var sourceToSend = window.isConsensusPlusUser ? "Consensus+" : "Consensus"
        dataObj.objColParameter.source = cut && cut.toLowerCase() !== "sar" ? sourceToSend : window.gSource;
        dataObj.objColParameter.revisionList = consensusList.slice();
        ObjWebServiceCall.getparameterData(dataObj.paramid, [dataObj.period], dataObj.parameter, dataObj.key,
             dataObj.rowObjName, dataObj.objColParameter
        );
    }

}

function GetSpecifiedRows(rows, param_id) {
    var filteredRows = [];
    $(rows).each(function (index, value) {
        if (value.id.includes(param_id) && !value.id.includes("dummy")) {
            // if(!(filteredRows.some(v =>  v.id === value.id))){
                filteredRows.push(value);
            // }
        }
    });
    return filteredRows;
}

var sourceShowInRow = false;

/*Functions get triggered on based of control events Events */

function datagridChanges(financialYear, objimage) {
    var objME = new ModelExplorer();
    objME.AppendQFY(financialYear, objimage);
}

//TODO can be moved to right panel

//TODO can be moved to right panel
function PeriodAppend(appenAtBegin) {
    var periodsPanel = rightPanelChanges.panels.getValues('name', 'periods')[0];
    //TODO change here
    //change Meta on changes in period panel
    var EndFY = startFY = periodsPanel.selected_from;
    if ($('#rdmulti').is(':checked') == true) {
        periodsPanel.multi_period = true;
        EndFY = periodsPanel.selected_to;
    }
    else
        periodsPanel.multi_period = false;
    //changeInSections("periods");
    if (explicitRefresh)
        return;
    var objModelExplorer = new ModelExplorer();
    $(rightPanelChanges.column_dimensions).each(function (index, value) {
        $("#" + value.name).attr('src', $("#" + value.name).attr('src').replace('collapse', 'expand'));
    });
    if ($('#rdmulti').is(':checked') == true) {
        EndFY = periodsPanel.selected_to;
    }
    else {
        periodsPanel.selected_to = periodsPanel.selected_from;
        EndFY = periodsPanel.selected_to;
        appenAtBegin = false;
    }
    var table = $('#tt').datagrid("getPanel").find('table').eq(2 + 1);
    var FYDatatoFetch = [];
    if (calendarYears)
        var periodString = 'FYE-' + window.fiscalEnd;
    else
        var periodString = 'FY-';
    headerCells = collapseAllColumns();
    $(headerCells).each(function (cellsIndex, cellsValue) {
        cells = headerCells[cellsIndex]
        $(cells).each(function (i, el) {
            var cell = $(el);
            var fieldName = cell.attr('field');
            if (getYear(startFY) <= getYear(fieldName) && getYear(fieldName) <= getYear(EndFY)) {
                if (fieldName.toUpperCase().indexOf(periodString + getYear(fieldName)) == 0)
                    $('#tt').datagrid('showColumn', fieldName);
            }
            else {
                $('#tt').datagrid('hideColumn', fieldName);
            }
        });
    });
    for (i = getYear(startFY); i <= getYear(EndFY); i++) {
        if ($.inArray(periodString + i, periods) == -1)
            FYDatatoFetch.push(i.toString());
    }

    if (FYDatatoFetch.length > 0)
        objModelExplorer.AppendFinancialYear(FYDatatoFetch, appenAtBegin); //, headercellPosition, brokerCellPosition

    $.each(FYDatatoFetch, function (index, value) {
        HidePeriod(periodString + value);
    });
    if (FYDatatoFetch.length == 0) {
        HidePeriod();
    }

    DivScrolling();
}

function collapseAllColumns() {
    headerCells = [];
    $.each(colDimension, function (index, value) {
        visibisleCells = [];
        columnCells = $('#tt').datagrid("getPanel").find('table').eq(3).find('tr').eq(colDimension.length - 1 - index).find('td');
        $.each(columnCells, function (i, el) {
            if ($(el).find('img').length > 0) {
                if ($(el).find('img').attr('src').indexOf('collapse') > -1 && $(el).is(":visible") == true && $(el).css('display') != 'none')
                    $(el).find('img').trigger('click');
                visibisleCells.push(el);
            }
        });
        headerCells.push(visibisleCells);
    });
    return headerCells;
}

function HidePeriod(value) {
    if ($('#rdsingle').is(':checked') == true) {
        //        $.each(FYDatatoFetch, function (index, value) {
        var colIndex = colDimension.length - 1;
        if (value != undefined) {
            if (value.indexOf($("#periodstart").val()) == -1) {
                //            value = 'FY-' + value;
                //                alert(value)
                var cells = $('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr').eq(colIndex).find('td');
                var filteredCells = $.grep(cells, function (n) {
                    return ($(n).attr('field').indexOf(value.toLowerCase()) != -1);
                });
                var parentcells = [];
                colIndex--;
                action = "";
                //                alert(filteredCells.length);
                $(filteredCells).each(function (i, el) {
                    if ($(el).css('display') != 'none') {
                        $('#tt').datagrid('hideColumn', $(el).attr('field'));
                        action = "hide";
                        parentcells.push($('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr').eq(colIndex).find("td[field='" + $(el).attr('field').replace($.trim($(el).text().toLowerCase()), '') + "']"));
                    }
                });
                ActionOnCloumns(parentcells, colIndex, action);
            }
        }
    }
    $.each(rowDimension, function (indexrowDimension, valuerowDimension) {
        if (valuerowDimension != "lineitem") {
            var table1 = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
            $.each(table1, function (index, el) {

                if ($(el).find('td').length == window.MEData.row_dimensions.length)
                    diff = window.MEData.row_dimensions.length - $.inArray(valuerowDimension, rowDimension);
                var main = $(el).find('td').length - diff;
                if ($(el).find('td').eq(main).find('img').attr('src') != undefined)
                    if ($(el).find('td').eq(main).find('img').attr('src').indexOf('collapse') > -1 && $(el).find('td').eq(main).is(":visible"))
                        $(el).find('td').eq(main).find('img').trigger('click');
            });
        }
    });
}

/*Additonal functions in usage*/
function formatValue(val, rowId, fieldName, obj) {
    var precision = 2;
    var styleCol = '">';
    if (obj) {
        precision = (obj.precision == undefined || obj.precision == null) ? precision : obj.precision;
    }

    if (!val) {
        return "";
    }

    if(val==="NM"){
        return '<span style="' + styleCol + val+ '</span>';
    }

    if (!rowId) {
        if (val < 0) {
            return '<span style="color:red;">(' + number_format(val, precision) + ')</span>';
        } else {
            return number_format(val, precision);
        }
    }

    rowId = "" + rowId;
    rowId = rowId.split('-')[0];
    var originalPercentLines = paramsByUnitnames['%'];
    var percentLines = jQuery.extend(true, [], originalPercentLines);
    var rowIdIndexInPercentLines = $.inArray(rowId, percentLines);

    if (obj && obj.unit) {
        if (rowIdIndexInPercentLines > -1) {
            if (obj.unit != "%") {
                percentLines.splice(rowIdIndexInPercentLines, 1);
            }
        } else if (obj.unit == "%") {
            percentLines.push(rowId);
        }
    }

    var periodString = fieldName.split(getYear(fieldName))[0] + getYear(fieldName);
    var unit;

    if (obj.rowDimension && obj.rowDimension == GROWTHTYPES && obj.unit == "%") {
        rowIdIndexInPercentLines > -1 ? unit = " bps" : unit = " %";
    } else {
        $.inArray(rowId, percentLines) > -1 ? unit = " %" : unit = "";
    }

    if(val < 0) {
        styleCol = 'color:red">(' ;
        unit = unit + ")";
        //val = val.substring(1); // Substring is done to remove the minus sign
    }

    if ($.inArray(rowId, driverLines) > -1 && whetherIsForecast(periodString)) {
        return '<div class="driver" ><span style="' + styleCol + number_format(val, precision) + unit + '</span></div>';
    } else {
        //Added this to remove the -ve sign in display, not in the actual calculation
        var formattedFinalVal = '';
        if(styleCol.indexOf('red') > -1){
            formattedFinalVal = '<span style="' + styleCol + number_format(val, precision).replace('-','') + unit + '</span>'
        }
        else{
            formattedFinalVal = '<span style="' + styleCol + number_format(val, precision) + unit + '</span>';
        }
        return formattedFinalVal;
    }
}

function formatBaseValue(valuerowdata,baseDpId,objColField,obj){
	text = formatValue(valuerowdata,baseDpId,objColField,obj);
	text = $(text).text();
	if(text.includes(",")){
		text = text.replace(/,/g,'');
	}
	return text;
}

function GetRowsfordg(getdgRowFlag, lineitems, sourcesFlag) {
    var rows = [];
    if (getdgRowFlag) {
        var dgrowData = $('#tt').datagrid("getRows");

        $.each(dgrowData, function (index, value) {
            rows.push({
                "expanded": value.expanded,
                "indent": value.indent,
                "name": value.name,
                "id": value.id
            });
        });
    } else {
        $.each(lineitems, function (index, value) {
            var row = $.grep(rows, function (n) {
                return (n.Name == value[0]);
            });

            if (row.length == 0) {
                rowData = new Object();
                rowData["Name"] = value[0];
                if (sourcesFlag)
                    rowData["BrokerSource"] = value[0] + value[3];

                rows.push(rowData);
            }
        });

    }
    return rows;
}


function DivScrolling() {
    //$('div.datagrid-body').eq(1).scrollTop(300);
    //$('div.datagrid-body').eq(1).scrollTop(0);
    $('div.datagrid-body').eq(1).scrollTop($('div.datagrid-body').eq(1).scrollTop() - 1);
}

function RepresentComps(showIn) {
    var objME = new ModelExplorer();
    var panelData = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Company Comps");
    });
    if (showIn == panelData[0].type) {
        alert(showIn + " action is already implemented on Company Comps");
        return;
    }
    analytics_helper.add(ANALYTICS_EVENT_TYPES.PANELS.TICKER.DIMENSION, showIn);

    var coldimensionData = $.grep(window.MEData.column_dimensions, function (n) {
        return (n.name == "tickers");
    });

    var rowdimensionData = $.grep(window.MEData.row_dimensions, function (n) {
        return (n.name == "tickers");
    });
    panelData[0].type = showIn;
    if (showIn == "off") {
        if (coldimensionData.length != 0) {
            window.MEData.column_dimensions.splice($.inArray("ticker", colDimension), 1)

        } else if (rowdimensionData.length != 0) {
            window.MEData.row_dimensions.splice($.inArray("ticker", rowDimension), 1)
        }
        //return;
    } else {
        if (coldimensionData.length == 0 && rowdimensionData.length == 0) {
            var defaultData = $.grep(samplecolrow.panels, function (n) {
                return (n.name == "Company Comps");
            });
            var object = {
                "expansions": [],
                "values": [
                    {
                        "expanded": false,
                        "name": defaultData[0]['default']
                    }
                ],
                "name": "tickers"
            }
            $.each(defaultData[0].values, function (index, value) {
                //                if ($('#' + value.name).is(':checked') == true)
                object.expansions.push(value.name);
            });
            if (showIn == "row") {
                window.MEData.row_dimensions.push(object);

            } else {
                window.MEData.column_dimensions.push(object);
            }
        }
        else {

            if (showIn == "row") {
                window.MEData.column_dimensions.splice($.inArray("ticker", colDimension), 1)
                if ($.inArray("ticker", defaultrowDimension) == -1) {
                    window.MEData.row_dimensions.push(coldimensionData[0]);
                } else {
                    window.MEData.row_dimensions.splice($.inArray("ticker", defaultrowDimension), 0, coldimensionData[0]);
                }
            } else {
                window.MEData.row_dimensions.splice($.inArray("ticker", rowDimension), 1)
                if ($.inArray("ticker", defaultcolDimension) == -1) {
                    window.MEData.column_dimensions.push(rowdimensionData[0]);
                } else {
                    window.MEData.column_dimensions.splice($.inArray("ticker", defaultcolDimension), 0, rowdimensionData[0]);
                }
            }
        }
    }
    objME.LoadDataGrid(window.MEData, false);
    if ($('.datagrid-footer').is(":visible") == false) {
        setTimeout(reziseGridPanel, 100);
    }

}


function HideSources(action) {
    var defaultSource = $.grep(colPanels, function (n) {
        return (n.name == "Sources");
    });
    if (sourcePresentation == "column") {
        $.each(getSourceExpansions(defaultSource[0]), function (index, value) {
            if (defaultSource[0]['default'] != value) {
                var colIndex = colDimension.length - 1;
                var table = $('#tt').datagrid("getPanel").find('table').eq(2 + 1);
                var cells = $('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr').eq(colIndex).find('td');
                var filteredCells = $.grep(cells, function (n) {
                    return ($(n).attr('field').indexOf($('#' + value).val().toLowerCase()) != -1);
                });
                var parentcells = [];
                colIndex--;
                //        action = "";
                if ($('#allBroker').is(':checked') == false && $('#' + value).is(':checked') == false) {

                    $(filteredCells).each(function (i, el) {
                        var actionFlag = GetActionFlag($(el).attr('field'));
                        if (actionFlag) {
                            if ($(el).css('display') != 'none' && action == 'hide') {
                                if ($('#' + value).is(':checked') == false) {
                                    $('#tt').datagrid(action + 'Column', $(el).attr('field'));
                                    //action = "hide";
                                }
                                parentcells.push($('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr').eq(colIndex).find("td[field='" + $(el).attr('field').replace($.trim($(el).text().toLowerCase()), '') + "']"));
                            }
                        }
                    });

                } else {
                    $(filteredCells).each(function (i, el) {
                        var actionFlag = GetActionFlag($(el).attr('field'));
                        if (actionFlag) {
                            if ($(el).css('display') == 'none' && action == 'show') {
                                if ($('#' + value).is(':checked') == true) {
                                    $('#tt').datagrid(action + 'Column', $(el).attr('field'));
                                    //action = "hide";
                                }
                                parentcells.push($('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr').eq(colIndex).find("td[field='" + $(el).attr('field').replace($.trim($(el).text().toLowerCase()), '') + "']"));
                            }
                        }
                    });

                }
                ActionOnCloumns(parentcells, colIndex, action);
            }
        });
        DivScrolling();
    }
    else {
        var table1 = $('#tt').datagrid("getPanel").find('table').eq(1);
        var table2 = $('#tt').datagrid("getPanel").find('table').eq(3 + 1);
        $.each(getSourceExpansions(defaultSource[0]), function (index, value) {
            if (defaultSource[0]['default'] != value) {

                var rows = table1.find("div:contains('" + value.toLowerCase() + "')").closest('tr');
                if ($('#allBroker').is(':checked') == false && $('#' + value).is(':checked') == false) {

                    $(rows).each(function (i, el) {
                        if ($(el).is(":visible") == true && action == 'hide') {
                            eval("$(el)." + action + "()");
                            eval("table2.find('tr').eq($(el).index())." + action + "()");
                        }
                    });
                } else {
                    $(rows).each(function (i, el) {
                        if (table2.find("tr").eq($(el).index()).text() != "" && action == 'show') {
                            eval("$(el)." + action + "()");
                            eval("table2.find('tr').eq($(el).index())." + action + "()");
                        }
                    });
                }
            }
        });


    }
}
function basisIntialization(basis) {
    var defaultData = $.grep(rightPanelChanges.panels, function (n) {
        return (n.name == 'Accounting basis');
    });
    defaultData[0].selected = basis;
}

function onBasisLoadGrid() {
    if (explicitRefresh)
        return;
    rightPanelChanges.row_dimensions[0] = basisMeta;
    var objME = new ModelExplorer();
    objME.LoadDataGrid(window.MEData, false);
    if ($('.datagrid-footer').is(":visible") == false)
        setTimeout(reziseGridPanel, 100);
}

function onBasis(basisID) {
    if (window.gBasis == $(basisID).attr('id').split('-')[1])
        return;
    window.gBasis = $(basisID).attr('id').split('-')[1];
    analytics_helper.add(ANALYTICS_EVENT_TYPES.PANELS.BASIS.CHANGE, window.gBasis);
    basisIntialization(window.gBasis);
    if (!explicitRefresh) {
        var objWebServiceCall = new WebServiceCall();
        objWebServiceCall.basisMetaData(false, null);
    }
}

function RepresentScenario(showIn) {
    var defaultData = $.grep(window.MEData.panels, function (n) {
        return (n.name == "Scenarios");
    });
    if (defaultData[0].type == showIn) {
        alert(showIn + " action is already implemented on Revisions");
        return;
    }
    var coldimensionData = $.grep(window.MEData.column_dimensions, function (n) {
        return (n.name == "Scenarios");
    });

    var rowdimensionData = $.grep(window.MEData.row_dimensions, function (n) {
        return (n.name == "Scenarios");
    });
    defaultData[0].type = showIn;
    var scenarioValues = defaultData[0].values.getValues('variant', window.gVariant)[0].values;
    if (showIn == "off") {
        if (coldimensionData.length != 0) {
            window.MEData.column_dimensions.splice($.inArray("scenario", colDimension), 1)

        } else if (rowdimensionData.length != 0) {
            window.MEData.row_dimensions.splice($.inArray("scenario", rowDimension), 1)
        }
        $.each(scenarioValues, function (i, el) {
            if (el.name != window.gScenario)
                el.selected = false;
        });

    } else {
        if (coldimensionData.length == 0 && rowdimensionData.length == 0) {
            $.each(scenarioValues, function (i, el) {
                el.selected = true;
            });
            var object = ScenarioDimension();
            if (showIn == "row") {
                window.MEData.row_dimensions.push(object);

            } else {
                window.MEData.column_dimensions.push(object);
            }
        }
        else {

            if (showIn == "row") {
                window.MEData.column_dimensions.splice($.inArray("scenario", colDimension), 1)
                if ($.inArray("scenario", defaultrowDimension) == -1) {
                    window.MEData.row_dimensions.push(coldimensionData[0]);
                } else {
                    window.MEData.row_dimensions.splice($.inArray("scenario", defaultrowDimension), 0, coldimensionData[0]);
                }
            } else {
                window.MEData.row_dimensions.splice($.inArray("scenario", rowDimension), 1)
                if ($.inArray("scenario", defaultcolDimension) == -1) {
                    window.MEData.column_dimensions.push(rowdimensionData[0]);
                } else {
                    window.MEData.column_dimensions.splice($.inArray("scenario", defaultcolDimension), 0, rowdimensionData[0]);
                }
            }
        }
    }
    scenarioBySettings(defaultData[0], window.MEData, true);
    var objME = new ModelExplorer();
    objME.LoadDataGrid(window.MEData, false);
    if ($('.datagrid-footer').is(":visible") == false) {
        setTimeout(reziseGridPanel, 100);
    }
}

function ScenarioDimension() {
    var defaultDataVaraints = $.grep(samplecolrow.panels, function (n) {
        return (n.name == "Scenarios");
    });
    window.gScenario = defaultDataVaraints[0]['default'];
    var defaultData = $.grep(defaultDataVaraints[0].values, function (n) {
        return (n.variant == window.gVariant);
    });

    var object = {
        "expansions": [],
        "values": [
            {
                "expanded": false,
                "name": window.gScenario
            }
        ],
        "name": "Scenarios"
    }
    $.each(defaultData[0].values, function (index, value) {
        if (value.entitled && value.selected && value.name != window.gScenario)
            object.expansions.push(value.name);
    });
    return object;
}



function GrowthTypeDimension() {
     if (typeof(samplecolrow)=="undefined"){
         return {}
     }

     var defaultData = MEData.panels.filter( function(n){
         return (n.name == GROWTHTYPES)
     });

     var object = {
         "expansions": [],
         "values": [
             {
                 "expanded": false,
                 "name": defaultData[0]['default']
             }
         ],
         "name": GROWTHTYPES
     };


    for(var index=0; index<defaultData[0].values.length; index++){
        var value = defaultData[0].values[index];
        if (value) {
            object.expansions.push(value);

            if (value === TREND) {
                object['trendYear'] = defaultData[0].trendYear
            }
        }
    };
    return object;
}

function GetActionFlag(ColField) {
    var actionFlag = true;
    var data = $.grep(dynamicGeneratedField, function (n) {
        return (n.Field == ColField);
    });
    if (data.length > 0 && data[0].Flag == false)
        actionFlag = false;
    return actionFlag;
}

function ActionOnCloumns(filteredCells, colIndex, action) {
    var parentcells = [];
    colIndex--;
    $(filteredCells).each(function (i, el) {
        colspan = $(el).prop('colspan') ? parseInt($(el).prop('colspan')) : 1;
        if (action == 'hide') //&& $(el).css('display') != 'none'
        {
            if (colspan == 1) {
                $('#tt').datagrid('hideColumn', $(el).attr('field'));
            }
            else {
                $(el).prop('colspan', (colspan - 1));
            }
        }
        else {
            if (colspan == 1 && $(el).css('display') == 'none') {
                $('#tt').datagrid('showColumn', $(el).attr('field'));
            }
            else {
                $(el).prop('colspan', (colspan + 1));
            }
        }
        if (colIndex >= 0) {
            if ($(el).attr('field') != undefined)
                parentcells.push($('#tt').datagrid("getPanel").find('table').eq(2 + 1).find('tr').eq(colIndex).find("td[field='" + $(el).attr('field').replace(RegExp($.trim($(el).text().toLowerCase()) + "$"), '') + "']"));
        }
    });
    if (parentcells.length > 0)
        ActionOnCloumns(parentcells, colIndex, action);
}
/*Source Panel Related functionality(End)*/


function GetLength(colType) {
    var dict = {'period': 'periods', 'source': 'Sources', 'ticker': 'Company Comps', 'revision': 'Revisions'};
    var columnObj = window.MEData.column_dimensions.getValues('name', dict[colType])[0];
    if (columnObj)
        return columnObj.expansions.length;
    else
        return;
}

function FindExpansions(type, financialYear) {
    if (type != 'periods') {
        var coldimensionData = window.MEData.column_dimensions.filter(function (n) {
            return (n.name.toLowerCase() == type.toLowerCase());
        });
    } else {
         var coldimensionData = window.MEData.column_dimensions[0].values.filter(function (n) {
            return (n.period.toLowerCase() == financialYear.toLowerCase());
        });
        if (coldimensionData.length > 0) {
            return coldimensionData[0].expansion_lst;
        }
    }
    var rowdimensionData = window.MEData.row_dimensions.filter(function (n) {
        return (n.name.toLowerCase() == type.toLowerCase());
    });
    if(type.toLowerCase() == 'sources' && financialYear && financialYear!=''){
        var forecast = whetherIsForecast(financialYear);
        var isConsensusFocus = checkIfFoucsConseusHasData(financialYear, company);


        if (coldimensionData.length > 0) {
            if (forecast) {
                //Future periods
                return coldimensionData[0].expansions[1];
            } else {
                //Historical periods
                var expan = coldimensionData[0].expansions[0];
                var indexOfFilings = expan.indexOf('Filings');

                if(window.gSourceActual == 'Consensus' && !isConsensusFocus  && indexOfFilings > -1) {
                    expan.splice(expan.indexOf('Filings'), 1)
                }
                return expan;
            }
        }
    }
    if (coldimensionData.length > 0)
        return coldimensionData[0].expansions;
    else if (rowdimensionData.length > 0)
        return rowdimensionData[0].expansions;
    else
        return ;
}

/*Validation related name*/
var companyList = [];
var companyInfo = [];

function createShareURLDialog(url) {
    var container = $('#shareable-link-container');
    var inputElement = document.getElementById('shareable-link');
    var clipboard = new Clipboard('#copy-to-clipboard-button');
    var shareableEle = document.getElementById('shareId');

    container.show();
    inputElement.value = url;
    shareableEle.className += ' shareId-hover';

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.copy-to-clipboard-container').length) {
            container.hide();
            shareableEle.classList.remove("shareId-hover");
        }
    })

    clipboard.on('success', function (e) {
        var tooltiptextEle = document.getElementsByClassName('tooltiptext')[0];
        tooltiptextEle.innerHTML = 'Copied!!';

        document.getElementsByClassName('tooltip')[0].addEventListener('mouseleave', function () {
            tooltiptextEle.innerHTML = 'Copy to clipboard';
        })
    })
}


/*ShareURL */
function ShareableUrl(ele, view) {
    if (cut) {
        var csrftoken = getCookie('csrftoken');
        var postData = {
            'right_panel_settings': rightPanelSettings().jsonData
        }

        $.ajax({
            type: "POST",
            url: "/api/shareableurl",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(postData),
            headers: {"X-CSRFToken": csrftoken},
            success: function (msg) {
                var originUrl;
                var queryParameters;
                var shareableUrl;

                originUrl = window.location.origin
                    || window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

                queryParameters = "/" + pg + "/" + cut + "/" + company

                if (cut == 'SAR') {
                    queryParameters = queryParameters + "/" + window.gSource
                }

                shareableUrl = originUrl + "/app/mex" + queryParameters + "?pinnedPanel=" + msg["panel_id"]

                if (!$("#ShareURLDialog").is(":visible")) {
                    createShareURLDialog(encodeURI(shareableUrl));
                }
            }
        })
    }
}


/*Save Setting related functionality*/
var userSetting = [];
function SaveSetting() {
    if ($("#settingDialog").length < 1)
        createDialog();
    else
        openDialog();
    $('#settingDialog #dialog-name').focus();
}

function createDialog() {
    var div = $('#container');
    var dialogMessage = "<label class='dialog-message' id='dialog-message-1' style='display:none;margin-left:5px'>view name should be atleast 3 alpha-numeric chars <br></label><label class='dialog-message' id='dialog-message-2' style='display:none;margin-left:5px'>view name should be alpha-numeric only<br></label><br>";
    var dialogName = "<label for='dialog-name' style='margin-left:7px;'>&nbsp;&nbsp;Enter the view name :&nbsp;&nbsp;</label><input type='text' name='dialog-name' id='dialog-name' style='width:175px; height:20px; margin-right:5px;' >&nbsp;&nbsp;</input><br><br>";
    var dialogCheckbox = "<span><input type='checkbox' value='addFavourites' id='addFavourites' style='opacity:0;filter:alpha(opacity=0)' /><label for='addFavourites' style='padding-left:15px;'>&nbsp;&nbsp;Add to Favourites</label></span>";
    $("<div id='settingDialog' title='Save settings as Custom View'>" + dialogMessage + dialogName + dialogCheckbox + "</div>").appendTo(div);

    $("#settingDialog").dialog({
        draggable: true, resizable: false, modal: true, dialogClass: "prompt", minHeight: 300,
        buttons: []//{text:"SAVE"},{text:"CANCEL"}]
    });
    var dialogDiv = $('#settingDialog .dialog-button');
    var cancelImage = "<img id='cancelDialog' src='"+window.assetUrl+"/dialog-cancel.png' style='height:28px; width:80px' onclick='dialogControl(\"CANCEL\")' />";
    var saveImage = "<img id='saveDialog' src='"+window.assetUrl+"/dialog-save.png' style='margin-left:20px; height:29px; width:80px' onclick='dialogControl(\"SAVE\")' />";
    $(cancelImage + saveImage).appendTo(dialogDiv);
}

function openDialog() {
    $('#settingDialog .dialog-message').hide();
    $('#addFavourites').attr('checked', false);
    $('#settingDialog').dialog('open');
    $('#settingDialog #dialog-name').val("");
}

function panelSettings() {
    if (window.MEData == undefined)
        return {}
    var data = {}, sourceSettings = {}, periodSettings = {}, tickerSettings = {}, revisionSettings = {}, accountBasisSettings = {}, adjustmentSettings = {}, scenarioSettings = {};
    $.each(window.MEData.panels, function (i, el) {
        data[el.name] = el;
    });
    var userData = {
        'username': $('#userspan').attr('name'),
        'variant': window.gVariant,
        'viewname': $('#settingDialog #dialog-name').val(),
        'cut': cut,
        'pg': escape(pg),
        'ticker': company,
        'source': window.gSource,
        'addToFavourite': $('#addFavourites').attr('checked') == undefined ? false : true
    };
    if (data['Sources'])
        sourceSettings = {
            'source': (sourcesExist) ? window.gSourceActual + "|" + gSourceFuture : window.gSource,
            'brokers': getSourceExpansions(data['Sources']),
            'type': data.Sources.type,
            'expanded': ""
        };
    var peerCompanies = [], revisionSelected = [];
    if (data['Company Comps']) {
        $.each(data['Company Comps'].values, function (i, el) {
            peerCompanies.push(el.name);
        });
        tickerSettings = {'company': company, 'type': data['Company Comps'].type, 'peers': peerCompanies};
    }
    if (data['Revisions']) {
        $.each(data['Revisions'].values, function (i, el) {
            if (el.selected) {
                revisionSelected.push(el.name);
            }
        });
        revisionSettings = {
            'type': data.Revisions.type,
            'revisions': revisionSelected,
            'revision': window.gRevision != "" ? window.gRevision : revisionSelected[0]
        };
    }
    if (data['periods']) {
        var start_period = get_fiscal_period($('#periodstart').val());
        start_period = start_period.substr(start_period.length - 4);
        var end_period = get_fiscal_period($('#periodend').val());
        end_period = end_period.substr(end_period.length - 4);
        periodSettings = {
            'type': data.periods.type,
            'multi_period': data.periods.multi_period,
            'period_type': data.periods.period_type,
            'start': start_period,
            'end': end_period
        };
    }
    if (data['Accounting basis'])
        accountBasisSettings = {'type': data['Accounting basis'].type, 'basis': window.gBasis};
    if (data.Adjustments)
        adjustmentSettings = {'type': data.Adjustments.type, 'depth': window.gAdjust};
    if (data.Scenarios) {
        if (data.Scenarios.type == 'off')
            scenarioSettings = {'type': data.Scenarios.type, 'Scenarios': [], 'default': window.gScenario};
        else
            scenarioSettings = {
                'type': data.Scenarios.type,
                'Scenarios': FindExpansions('Scenarios'),
                'default': window.gScenario
            };
    }
    var expanded = {'columns': ExpandedColList};
    Edata = {
        'userData': userData,
        'sourceSettings': sourceSettings,
        'scenarioSettings': scenarioSettings,
        'tickerSettings': tickerSettings,
        'periodSettings': periodSettings,
        'revisionSettings': revisionSettings,
        'accountBasisSettings': accountBasisSettings,
        'adjustmentSettings': adjustmentSettings,
        'expanded': expanded,
        'overwrite': false,
        'panel': false
    };
    return Edata;
}

function get_fiscal_period(period) {
    return period.replace("E", "")
}

function dialogControl(ele, type) {
    $('.dialog-message').hide();
    if( ele == 'SAVE') {
        // if(type == 'scenario'){
        //     var dialogName = $('#saveScenarioDialog #dialog-name1').val();
		// 	heap_tracking(company, {'action':'SaveScenario', 'ticker': window.MEData.ticker, 'name': dialogName});
		// }
        // else if(type == 'variant'){
        //     var dialogName = $('#saveVariantDialog #dialog-name1').val();
		// 	heap_tracking(company, {'action':'SaveVariant','ticker': window.MEData.ticker, 'name': dialogName});
		// }
        // else{
        //     var dialogName = $('#settingDialog #dialog-name').val();
		// 	heap_tracking(company, {'action':'SaveView', 'ticker': window.MEData.ticker, 'name': dialogName});
		// }
        if(type == 'scenario' || type == 'variant'){
            if (dialogName.length > 8) {
                $('#dialog-message-1').show();
                return;
            }
            if (type == 'scenario')
                var dialogName1 = $('#saveScenarioDialog #dialog-name').val();
            else
                var dialogName1 = $('#saveVariantDialog #dialog-name').val();
            if (!(/^[a-zA-Z0-9]+$/.test(dialogName)) || !(/^[a-zA-Z0-9]+$/.test(dialogName1))) {
                $('#dialog-message-2').show();
                return;
            }
        }
        else {
            if (dialogName.length < 3) {
                $('#dialog-message-1').show();
                return;
            }
            if (!(/^[a-zA-Z0-9]+$/.test(dialogName))) {
                $('#dialog-message-2').show();
                return;
            }
        }
        $('.dialog-message').hide();
        if (type == 'scenario' || type == 'variant') {
            //to do save scenario
            var ObjWebServiceCall = new WebServiceCall();
            if ($('#recal_button').is(":visible")) {
                if (type == 'scenario')
                    ObjWebServiceCall.postScenarioChanges(false, {'savescenario': true});
                else
                    ObjWebServiceCall.postScenarioChanges(false, {'savevariant': true});
            }
            else {
                if (type == 'scenario')
                    ObjWebServiceCall.saveScenarioByName();
                else
                    ObjWebServiceCall.saveVariantByName();
            }
        }
        else {
            analytics_helper.add(ANALYTICS_EVENT_TYPES.SAVE_VIEW, dialogName);
            var data = "settings=" + JSON.stringify(panelSettings());
            var csrftoken = getCookie('csrftoken');
            var ObjWebServiceCall = new WebServiceCall();
            ObjWebServiceCall.postSaveSettings(data, csrftoken);
        }
    }
    if (type == "scenario")
        $('#saveScenarioDialog').dialog('close');
    else if (type == "variant")
        $('#saveVariantDialog').dialog('close');
    else
        $('#settingDialog').dialog('close');
}

/*Save Setting related functionality*/

function createLog(id, value) {
    try {
        if (window.console)
            console.error(id + value);
    } catch (e) {

    }
}

function addToFavourites() {
    if ($(favoriteButton).attr('src').indexOf('added') > -1)
        return;
    analytics_helper.add(ANALYTICS_EVENT_TYPES.ADD_FAVORITE, company + " #" + cut + " ." + pg + " !" + window.gSource);
    var ObjW = new WebServiceCall();
    ObjW.addFavourites();
}
var dataToBind = {};
function analystTitle(msg) {

    var pgData = msg.data;
    var table = $('.datagrid-header-inner').eq(1);
    var col = colDimension;
    $.each(pgData, function (i, el) {
        var selected = true;
        if (rowDimension.length > 1) {
            $.each(rowDimension, function (index, value) {
                if (value == "lineitem") {
                }
                else if (value == 'source') {
                    if (el.source != (whetherIsForecast(el.period) ? gSourceFuture : window.gSourceActual))
                        selected = false;
                }
                //commented since rowDefaults is no longer updated since PER-49
                /*else if (rowDefaults[value] != el[value])
                    selected = false;*/
            });
        }
        if (!selected)
            return;
        var selector = "";
        var revision_selector = "";
        var period_selector = "";
        $.each(col, function (index, value) {
            revision_selector += el[value];
            if(value == 'revision') {
                return false;
            }
        });

        $.each(["period"], function (index, value) {
            period_selector += el[col[index]];
        });
        $.each(col, function (index, value) {
            selector += el[col[index]];
        });
        // selector = selector.includes('+') ? selector.toLowerCase().replace('+','plus') : selector.toLowerCase();
        selector = replaceConsensusPlusOperator(selector);
        var ele = table.find("td[field='" + selector.toLowerCase() + "']")
        var title_str = '';
        if(ele.length>0){
            var eleInnerText = ele[0].innerText.trim();

            if(showExcludedIcon(eleInnerText,(period_selector + el.revision).toLowerCase())){
                var conEle = ele.find("img.excluded_icon");
                if(conEle.length)
                    conEle.css('display','inline-block');
            }
            if (showCCicon(eleInnerText) && showExcludedIcon(eleInnerText,(period_selector + el.revision).toLowerCase()) && ele[0].innerText.trim().length > 6) {
                title_str = ele[0].innerText + '<br>';
            }

            if(showExcludedIcon(eleInnerText,(period_selector + el.revision).toLowerCase()) && showCCicon(eleInnerText) && showConPlusIcon(eleInnerText)){
            // handing for 3 icons in source header
            var conEle = ele.find("img.conPlus_icon");
                if(conEle.length)
                    conEle.css('display','none');
            }
        }

        var bindSourcelevelPopover = true;
         dataToBind = {};
        if (bindSourcelevelPopover) {
            if(el.analyst) {
                title_str = title_str + 'Analyst : ' + el['analyst'] + ' <br> ';
                dataToBind.analyst = el.analyst;
                dataToBind.analystemail = el.analystemail;
                dataToBind.analystid = el.analystid;
            }
            dataToBind.broker = el.source;
            dataToBind.pg = el.sar_pg_name;
            dataToBind.cut = el.cut;
            dataToBind.ticker = el.ticker;
            dataToBind.fiscalyear = el.fiscalyear;
            dataToBind.source = el.source;
            dataToBind.sourcefullname = el.sourcefullname;
            dataToBind.noteText = '';
            dataToBind.consensusText = '';
            if(ele.attr('note')){
                dataToBind.noteText = ele.attr('note');
            }
        }
        //Added this to show the broker count on the qtip hover
        if (el.modeldate != ''  && el.broker_count != undefined && (el.source =='Consensus' || el.source =='Consensus+')) {
            if(el.broker_count.total != 0) {
                if (el.broker_count.available > el.broker_count.total) {
                    //Added this condition to handle the case in historical periods where this is possible
                    title_str = title_str + el.broker_count.available + ' sources available';
                }
                else {
                    title_str = title_str + el.broker_count.available + ' of ' + el.broker_count.total + ' sources available';
                }
            }
            else{
                title_str = title_str + 'Date: ' + el.modeldate;
            }

            // consensus+ column hover tooltip
            // add condition for NMV and SCH
            if(el.source =='Consensus+' && (el.cut == "NMV" || el.cut== "SCH" || el.cut == "STD")) {
                title_str = title_str + "<br/><br/><span><b>" + el.source.slice(0, -1) + "</b> <span style='color: #f2883d;vertical-align: middle;font-size:13px;    padding: 2px 0 2px 2px;' class='fa fa-plus'></span></span> includes additional brokers not available in Visible Alpha’s standard consensus"
            }

            dataToBind.consensusText = title_str;
        }
        else if(el.modeldate == '' && el.broker_count != undefined && el.source =='Custom'){
            //For the custom td hover title
            let sourcePanelObj = window.MEData.panels.filter( function (n) {
                return (n.name.toLowerCase() == 'sources');
            })[0];
            var str = '';

            //'previouslyAppliedByBroker' and 'previouslyAppliedByDate' are only for handling cases where user settings were saved
            //before cc 2.0 was developed and so does not contain key 'custom_consensus_mode'
            //usage of 'previouslyAppliedByBroker' and 'previouslyAppliedByDate' can safely be reomoved from below conditions in future
            //ref bug: CACHE-3181
            var previouslyAppliedByBroker = !sourcePanelObj.date_custom_consensus && !sourcePanelObj.relative_days;
            var previouslyAppliedByDate = !!sourcePanelObj.date_custom_consensus;
            if(previouslyAppliedByBroker || sourcePanelObj.custom_consensus_mode === 'byBroker') {
                str = `<strong>Custom Consensus by Broker</strong> <br/> Number of Brokers: ${el.broker_count.available}  of ${el.broker_count.total} available`
            }
            else if(previouslyAppliedByDate || sourcePanelObj.custom_consensus_mode === 'byDate') {
                let formattedDate = "";
                if(sourcePanelObj.date_custom_consensus != undefined &&  sourcePanelObj.date_custom_consensus != "" ) {
                    let ccdate  = sourcePanelObj.date_custom_consensus;
                    formattedDate = new Date(ccdate.substr(0,4),ccdate.substr(4,2) - 1,ccdate.substr(6,2));                
                }
                if(sourcePanelObj.relative_days) {
                    var reldays = sourcePanelObj.relative_days;
                    var currDate = new Date();
                    currDate.setDate(currDate.getDate() - Number(reldays));
                    let ccdate = convertDateToString(currDate, "yyyymmdd");
                    formattedDate = new Date(ccdate.substr(0,4),ccdate.substr(4,2) - 1,ccdate.substr(6,2));
                }
                str = `<strong>Custom Consensus by Date</strong> <br/> Revisions since: ${$.datepicker.formatDate("dd MM, yy", formattedDate)}`;
                str = `${str} <br/> Number of brokers: ${el.broker_count.available}  of ${el.broker_count.total} available`;
                str = `${str} <br/> <br/> ${sourcePanelObj.inc_non_current_brokers ?  "Includes current brokers only" : "Includes current and non-current brokers" }` ;
            }            
            title_str = `${title_str} <span class='custom-consensus-style'> ${str}</span>` ;            
            dataToBind.consensusText = title_str;
        }

        if (title_str.length > 0) {
            ele.attr('qttitle', title_str);
        }

        if (typeof el.revision_date != 'undefined' && el.revision_date && col.indexOf('revision') > -1) {
            //todo revision date qtip
            var rev_ele = table.find("td[field='" + revision_selector.toLowerCase() + "']");
            rev_ele.attr('qttitle', 'Date: ' + el['revision_date']);
            var popoverobj = {
                content: function(){
                    return '<span>'+$(this).attr('qttitle')+'</span>';
                },
                width:'auto',
                style:"column-level",
                placement: "auto-bottom",
                "closeable": false,
                cache:false,
                arrow:true,
                trigger:'hover'
    
            };
            rev_ele.webuiPopover(popoverobj);
        }
        if (typeof el.period_date != 'undefined' && el.period_date) {
            var per_ele = table.find("td[field='" + period_selector.toLowerCase() + "']");
            var period_tooltip = [el['period_date']];
            var modify_tooltip = true;
            dataToBind.modeldate = el.modeldate;
            if (el.cut == "SAR") {
                if (el.revision == "Current") {
                    period_tooltip.push(el.modeldate);
                } else {
                    modify_tooltip = false;
                }
            }
            if (modify_tooltip) {
                bindPopoverForNotes(period_tooltip, per_ele,'','periodNotes');
            }
        }
         if (bindSourcelevelPopover) {
            bindPopoverForNotes(dataToBind, ele,'','sourceNotes');
        } else if(ele.attr('note')){//todo note change
            ele.attr('note', ele.attr('note') + title_str);
            qtipSettings(ele, 'note');
        } else {
            qtipSettings(ele, 'qttitle');
        }

        /*Find a list of all the column td's and apply an onclick attribute to them
          from the expand/collapse image's click-title attribute*/
        var columnTdList = $('.datagrid-view2 .datagrid-header .datagrid-header-row td');
        for(var index = 0; index < columnTdList.length; index++){
            var clickFunction = $(columnTdList[index]).find("img[src*='datagrid_row_']").attr('click-title');
            var titleClass = $(columnTdList[index]).find("img[src*='datagrid_row_']").attr('title-class');
            // $(columnTdList[index]).attr('onclick',clickFunction).addClass(titleClass);
            $(columnTdList[index]).addClass(titleClass);
        }
    });
}

function historySettings() {
    var ObjW = new WebServiceCall();
    var csrftoken = getCookie('csrftoken');
    var data = "settings=" + JSON.stringify(panelSettings());
    ObjW.postHistorySettings(data, csrftoken);
}

function SourceFilterSAR(chkBox, type) {
    window.gSource = chkBox.value;
    for(var idx = 0; idx < window.MEData.panels.length ; idx++){
        if(window.MEData.panels[idx].name == "Sources"){
            pg = window.MEData.panels[idx].sarTabDict[window.gSource];
            break;
        }
    }
    var Url = {"mainUrl": "/mex/?"};
    window.location = escaping(makeUrl(Url, window.gSource)).replace('ticker', 'company');
}

function viewOverWrite(flag, cutName) {
    if (flag) {
        //var r = confirm("View name already Exist :do you want to overwrite");
        saveError = 'viewExist';
        if ($('#' + saveError).length < 1) {
            var lbl = "<label style='padding-left:10px;padding-right:10px;'> View name already Exist :Do you want to overwrite </label>";
            createErrorPrompt(saveError, lbl)
        }
        else
            $('#' + saveError).dialog('open');
    }
    else {
        //var r = confirm("panels already Exist to this view: do you want to overwrite existing view name");
        saveError = 'panelsExist';
        if ($('#' + saveError).length < 1) {
            var lbl = "<label style='padding-left:10px;padding-right:10px;'> This view is already saved as a custom view <b>" + cutName + "</b><br/>&nbsp;&nbsp;&nbsp;Do you want to change its name?</label>";
            createErrorPrompt(saveError, lbl)
        }
        else
            $('#' + saveError).dialog('open');
    }
}

function createErrorPrompt(dialogName, lbl, flag) {
    var div = $('#container');
    if (flag && flag.type) {
        titleName = flag.action + " " + flag.type;
        flag = "confirmation";
    }
    else if (flag == 'scenario')
        var titleName = "Customize scenarios";
    else if (flag == 'variant')
        var titleName = "Customize variants";
    else {
        flag = "savesettings";
        var titleName = "Save Settings";
    }
    $("<div id='" + dialogName + "' title='" + titleName + "'>" + lbl + "</div>").appendTo(div);

    $("#" + dialogName).dialog({
        draggable: true, resizable: false, modal: true, dialogClass: "prompt", minHeight: 300,
        buttons: []
    });
    //$("#" + dialogName + ' .l-btn').attr('onclick','errorDialogControl(this,"'+ dialogName +'");');
    var dialogDiv = $("#" + dialogName + ' .dialog-button');
    var yesImage = "<img id='yesDialog' src='"+window.assetUrl+"/dialog-yes.png' style='height:28px; width:80px' \
    onclick='errorDialogControl(\"YES\"," + '"' + dialogName + '","' + flag + '"' + ")' />";
    var noImage = "<img id='noDialog' src='"+window.assetUrl+"/dialog-no.png' style='margin-left:20px; height:29px; width:80px'\
    onclick='errorDialogControl(\"NO\"," + '"' + dialogName + '","' + flag + '"' + ")' />";
    $(yesImage + noImage).appendTo(dialogDiv);
}

function errorDialogControl(ele, dialogName, flag) {
    if (ele == 'YES') {
        if (flag == "confirmation") {
            var action = dialogName.split('-')[0];
            var type = dialogName.split('-')[1];
            var objWebServiceCall = new WebServiceCall();
            var eleId = $("#" + dialogName).find('label').attr('value');
            if (type == 'scenario') {
                if (action == 'save')
                    saveScenario();
                else
                    objWebServiceCall.edit_scenario({'scenario': eleId, 'action': action});
            }
            else
                objWebServiceCall.edit_variant({'variant': eleId, 'action': action});
            $('#' + dialogName).dialog('close');
            return;
        }
        else if (flag == 'scenario') {
            var ObjWebServiceCall = new WebServiceCall();
            ObjWebServiceCall.saveScenarioByName(dialogName);
            $('#' + dialogName).dialog('close');
            return;
        } else if (flag == 'variant') {
            var ObjWebServiceCall = new WebServiceCall();
            ObjWebServiceCall.saveVariantByName(dialogName);
            $('#' + dialogName).dialog('close');
            return;
        }
        var panelData = panelSettings();
        if (dialogName == 'viewExist')
            panelData['overwrite'] = true;
        else
            panelData['panel'] = true;
        var data = "settings=" + JSON.stringify(panelData);
        var csrftoken = getCookie('csrftoken');
        var ObjWebServiceCall = new WebServiceCall();
        ObjWebServiceCall.postSaveSettings(data, csrftoken);
    }
    else {
        if (dialogName.split('-')[1] == 'scenario' && dialogName.split('-')[0] == 'save') {
            customScenarioMode = false;
            window.gScenario = "";
        }
        if (flag == "confirmation" && dialogName.split('-')[0] == 'save')
            $('#ptype').trigger('change');
    }
    $('#' + dialogName).dialog('close');
}

function getCurrentQuarters(financialYear, companys) {
    var resp = {};
    var cFuture = [], cPast = [];
    var forecast = whetherIsForecast(financialYear);

    $.each(companys, function (i, el) {
        if (forecast)
            cFuture.push(el);
        else
            cPast.push(el);
    });
    if (cPast.length == 0) {
        resp.divide = false;

    } else {
        resp.divide = true;
    }
    if (forecast)
        resp.all = "future";
    else
        resp.all = "past";
    resp.past = cPast;
    resp.future = cFuture;

    return resp;
}

function getPeriodQuarters(year, company) {
    var quarters = [];
    var cFuture = [], cPast = [];
    var displayQuarters = {};
    var resp = {
        all:"",
        future:cFuture,
        past:cPast,
        displayQuarters:displayQuarters
    }

    var coldimensionData = window.MEData.column_dimensions[0].values.filter(function (n) {
        return (n.period.toLowerCase() == year.toLowerCase());
    })[0];
    if(!coldimensionData){
        return resp;
    }
    var panelObj = window.MEData.panels.filter(function (n, i) {
        if (n.name == "periods") return true;
    });
    var actualsEstimatesList = panelObj[0].actual_estimates;
    var newActualEstimates = {};

    $.each(coldimensionData.expansion_lst, function (i, el) {
        var val = Object.keys(el)[0];
        quarters.push(val);

        if(actualsEstimatesList[val] != undefined) {
            newActualEstimates[val] = actualsEstimatesList[val]
        }

        displayQuarters[val] = el[val];
    });

    if (newActualEstimates
        && Object.keys(newActualEstimates).length > 0
        && Object.keys(newActualEstimates)[0].split('-')[1] == year.split('-')[1]) {

        for (var eachActualEstimates in newActualEstimates) {
            if (!newActualEstimates[eachActualEstimates]) {
                cPast.push(eachActualEstimates);
            } else {
                cFuture.push(eachActualEstimates);
            }
        }
    } else {
        var periodObjForcast = whetherIsForecast(year);
        if (periodObjForcast) {
            $.each(quarters, function (i, el) {
                cFuture.push(el);
            });
        } else {
            $.each(quarters, function (i, el) {
                cPast.push(el);
            });
        }
    }

    if (cPast.length == 0 || cPast.length == quarters.length) {
        resp.divide = false;
        if (periodObjForcast)
            resp.all = "future";
        else
            resp.all = "past";
    } else {
        resp.divide = true;
    }

    resp.past = cPast;
    resp.future = cFuture;
    resp.displayQuarters = displayQuarters;
    return resp;
}

function expandCollapse(filteredCells, colIndex) {
    var parentcells = [];
    $(filteredCells).each(function (i, el) {
        var imgchange = $(el).find("img");
        if (imgchange.length > 0 && el.closest('tr').index() > colIndex)
            imgchange.attr('src', imgchange.attr('src').replace('collapse', 'expand'));
    });
}

function getDpSource(colparameter, rowparameter) {
    if (window.gScenario != "")
        return window.gScenario;
    var dpSource = "", dpTicker = "";
    var sourceAtColumn = false;
    var dpPeriod = colparameter.split('|')[0]
    var dpRevision;
    if ($.inArray('revision', colDimension) != -1) {
        dpRevision = colparameter.split('|')[$.inArray('revision', colDimension)].toLowerCase()
    } else {
        dpRevision = 'current'
    }
    if ($.inArray('source', colDimension) > -1) {
        dpSource = colparameter.split('|')[$.inArray('source', colDimension)];
        if (dpSource.length > 0)
            sourceAtColumn = true;
    }
    if($.inArray('source', rowDimension) > -1)
        dpSource = rowparameter.replace(/-/g,'|').replace('||','|-').split('|')[$.inArray('source', rowDimension) - 1];
    if(dpSource.toLowerCase() == gSourceFuture.toLowerCase() || dpSource.toLowerCase() == window.gSourceActual.toLowerCase()) {
        if ($.inArray('ticker', colDimension) > -1)
            dpTicker = colparameter.split('|')[$.inArray('ticker', colDimension)];
        else if ($.inArray('ticker', rowDimension) > -1)
            dpTicker = rowparameter.replace(/-/g, '|').replace('||', '|-').split('|')[$.inArray('ticker', rowDimension)];
        else
            dpTicker = company;
        if (sourceAtColumn) {
            var colparams = colparameter.split('|');
            var columnField = ""
            $.each(colDimension, function (i, el) {
                columnField += colparams[i];
                if (el == 'source')
                    return false;
            });
            if ($('td[field="' + columnField + '"]').find('img').length == 0)
                return dpSource;
        }
        else {
            rowParam = $.grep(AlldgRows, function (i) {
                return (check_list_same(i.id, rowparameter));
            })[0];
            if (rowParam['Sources'] && rowParam['Sources'].indexOf('<img') == -1)

                return dpSource;
        }
        if (whetherIsForecast(dpPeriod)) {
            return gSourceFuture;
        } else {
            // below condition was added against #CA-6299
            // if (dpRevision != 'current') {
            //     return gSourceFuture;
            // } else {
            //     return window.gSourceActual;
            // }
            if (dpRevision != 'current' && dpSource.toLowerCase() !== 'va actuals') {
                return gSourceFuture;
            } else {
                return window.gSourceActual;
            }
        }
    }
    else if (dpSource != "")
        return dpSource;
    if (sourcesExist) {
        if ($.inArray('ticker', colDimension) > -1)
            dpTicker = colparameter.split('|')[$.inArray('ticker', colDimension)];
        else if($.inArray('ticker', rowDimension) > -1)
            dpTicker = rowparameter.replace(/-/g,'|').replace('||','|-').split('|')[$.inArray('ticker', rowDimension)];
        else
            dpTicker = company;
        if (whetherIsForecast(dpPeriod))
            return gSourceFuture;
        else
            return window.gSourceActual;
    }
    else
        return window.gSource;
}

function italicRows() {
    var appendedRows = AlldgRows.filter( function (i, el) {
        return (i.RowAppend);
    });
    lineItemTable = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
    //dataTable = $('#tt').datagrid("getPanel").find('table').eq(4).find('tr');
    for(var i=0; i<appendedRows.length; i++){
        var el = appendedRows[i];
        if (driverLines.indexOf(el.id.split('-')[0]) > -1) {
            $(lineItemTable[i]).addClass('driver');
            //$(dataTable[i]).addClass('driver');
        }
    };
}

function get_title_panels(values, panel_val) {
    var title_list = [];
    $.each(values, function (index, value) {
        if (value && value.selected == true)
            title_list.push(value.name);
    });
    if (values && values.length == title_list.length && panel_val != 'Variant')
        var title = '<b>' + panel_val + '</b>: All';
    else if (title_list.length == 0 && panel_val == "Missing Data")
        var title = '<b>' + panel_val + '</b>: Exclude inferred data';
    else if (title_list.length == 0 && panel_val == "Historical Estimates")
        var title = '<b>' + panel_val + '</b>: ' + values.join(', ');
    else if (title_list.length == 0 && panel_val != 'Variant')
        var title = '<b>' + panel_val + '</b>: None';
    else
        var title = '<b>' + panel_val + '</b>: ' + title_list.join(', ');
    return title;
}

var account_basis_object = {
    'all': 'Select this option to display all available accounts regardless of accounting basis.',
    'operating': 'Select this view to display the financial statements on an operating basis which typically excludes stock based compensation, non-operating items and non-recurring/one-time items.',
    'gaap': 'Select this view to display the financial statements on a GAAP basis.'
}

function orderRevisions(revArr, isRow) {
    //TODO change for revision
    //var revisionOrder = ["-6Month", "-3Month", "-1Month" , "-1Week", "PreQ"];
	var revisionOrder = revArr;
	var output = [];
	// add all the revisions which are there in revArr, but the order is defined in revisionOrder
	if(isRow) {
		// reversed to show row wise.
		var rowRevisionOrder = revisionOrder.reverse();
	}else{
        var rowRevisionOrder = revisionOrder;
    }
	for(var idx=0; idx<rowRevisionOrder.length; idx++){
        var rev = rowRevisionOrder[idx];
        if(revArr.indexOf(rev) > -1) {
            output.push(rev);
        }
    }

	return output;
}

function checkMEData(sectionName) {
    var EndFY = "", startFY = "";
    var sectionDetailData = $.map(window.MEData.panels, function (obj, ind) {
        if (obj.name == sectionName) {
            var tempObj = {};
            tempObj["index"] = ind;
            tempObj["obj"] = obj;
            return tempObj;
        }
    });

    return JSON.stringify(rightPanelChanges.panels[sectionDetailData[0].index]) == JSON.stringify(sectionDetailData[0].obj)
}

/**
 * 
 * commenting below redundant function and its call occurences
 */
// function panelHideShow() {
//     //hiding all panels
//     $('#collapseOption').find('tr').eq(1).nextUntil($('#collapseOption').find('tr').last()).hide();
//     $('#mm').children().hide();
//     //showPanel("legend");
// }

function get_paramsByUnitnames(lineitemsData, baseParamObject) {
    baseParamLineitems = [];
    paramsByUnitnames = {};
    driverLines = [];
    highLevelDrivers = [];
    for(var i=0; i<lineitemsData.values.length; i++){
        var val = lineitemsData.values[i];
        var unit = val.unit;
        if (paramsByUnitnames[unit] == undefined) {
            paramsByUnitnames[unit] = [];
            paramsByUnitnames[unit].push(val.id);
        }
        else
            paramsByUnitnames[unit].push(val.id);
        if (baseParamObject && val.magnitude == baseParamObject.magnitude && val.unit == baseParamObject.unit)
            baseParamLineitems.push(val.id);
        //driver lineitems
        if (val.driver)
            driverLines.push(val.id);
        if (val.highleveldriver) {
            driverLines.push(val.id);
            highLevelDrivers.push(val.id);
        }
    };
}

function GetSelectedExpansionForSources(sourcePanel) {
    var panelType = sourcePanel.type;
    if (panelType != 'off') {
        //change for angular
        //Uncommented the code. As there was issue with custom consensus. Need to Sharvari
        //$('#offsource').trigger('click');
        //$('#' + panelType.substr(0, 3) + 'source').trigger('click');
    }
}

function order_dimensions(MEData){
    for(var i=0; i<MEData.column_dimensions.length; i++){
        var el = MEData.column_dimensions[i]
		if(el.name == 'Sources'){
			delete MEData.column_dimensions.splice(i, 1);
			MEData.column_dimensions.push(el);
		}
    };
    var rowDims= [];
    rowDims.length = ROW_DIM_ORDER.length;
    for(var i=0; i<MEData.row_dimensions.length; i++){
        var el = MEData.row_dimensions[i];
        if(el!==undefined){
            var newIndex = ROW_DIM_ORDER.indexOf(el.name);
            rowDims[newIndex] = el;
        }
    };
    
    MEData.row_dimensions = rowDims.filter(function(val){
        return val != void 0;
    });
}

function GetExpansionsForAllPanels(){
    var colum_Dimension = window.MEData.column_dimensions;
    var PanelData = window.MEData.panels.filter( function (n) {
        return (n.name == "Sources");
    });
    if (PanelData.length > 0) {
        RepresentSource(PanelData[0].type);
        setMEDataOnApply("Sources");
    }
    var PanelData = window.MEData.panels.filter( function (n) {
        return (n.name == "Company Comps");
    });
    if ($.inArray('ticker', rowDimension) > 0) {
        var defaultData = window.MEData.row_dimensions.filter( function (n) {
            return (n.name == "tickers");
        });
        GetSelectedExpansion(defaultData, PanelData);
        //                sources = jQuery.extend(true, [], defaultData[0].expansions)
    }
    else if ($.inArray('ticker', colDimension) > 0) {
        var defaultData = colum_Dimension.filter( function (n) {
            return (n.name.toLowerCase() == "tickers");
        });
        GetSelectedExpansion(defaultData, PanelData);
        //                sources = jQuery.extend(true, [], defaultData[0].expansions);
    }
    var defaultDataVaraints = window.MEData.panels.filter( function (n) {
        return (n.name == "Scenarios");
    });
    if (defaultDataVaraints.length > 0) {
        PanelData = defaultDataVaraints[0].values.filter( function (n) {
            return (n.variant == window.gVariant);
        });
        if ($.inArray('scenario', rowDimension) > 0) {
            var defaultData = window.MEData.row_dimensions.filter( function (n) {
                return (n.name == "Scenarios");
            });
            GetSelectedExpansion(defaultData, PanelData);
        }
        else if ($.inArray('scenario', colDimension) > 0) {
            var defaultData = colum_Dimension.filter( function (n) {
                return (n.name == "Scenarios");
            });
            GetSelectedExpansion(defaultData, PanelData);
        }
    }
    order_dimensions(window.MEData);
}

function variantChange(ele) {
    if ($(ele).attr('id') == window.gVariant)
        return;
    window.gVariant = $(ele).attr('id');
    variantObj = window.MEData.panels.getValues('name', 'Variants')[0];
    variantObj['default'] = window.gVariant;
    $.each(variantObj.values, function (i, el) {
        el.selected = (el.name == window.gVariant);
    });
}

//TO-DO: Check if this is getting called at all
function scenarioBySettings(valuepanels, meta, flag) {
    var div = $('#scenario').empty();
    boxtype = (valuepanels.type == "off") ? 'radio' : 'checkbox';
    var scenarioValues = $.grep(valuepanels.values, function (n) {
        return (n.variant.toLowerCase() == meta.variant.toLowerCase());
    });
    scenarioValues = scenarioValues[0]['values'];
    $.each(scenarioValues, function (indexRev, valueScenario) {
        if (valueScenario.custom && $('#scenario #savedScenarios').length == 0)
            $('<span id="savedScenarios" style="width: 100%;float: left;"><div style="height:80%;background:#efefef;">Saved Scenarios</div></span>').appendTo(div);
        if (valueScenario.name == valuepanels['default'])
            valueScenario.selected = true;
        var bgimg = "off.png";
        if (valueScenario.selected) bgimg = "on.png";
        if (boxtype == 'checkbox')
            $("<span style=\"width: 100%;float: left;\"><input type='" + boxtype + "' style='opacity:0;filter:alpha(opacity=0)' name='chknamescenario' value='" + valueScenario.name + "' id='" + valueScenario.name + "' " + (valueScenario.selected == true ? "checked='checked'" : "") + "  onclick='return SourceFilter(this,\"Scenarios\");'/><label  id='lbl" + valueScenario.name + "' style='background: url("+window.assetUrl+"/" + bgimg + ") left center no-repeat;' for='" + valueScenario.name + "'>" + valueScenario.name + "</label></span>").appendTo(div);
        else
            $("<span style=\"width: 100%;float: left;\"><input type='" + boxtype + "' name='chknamescenario' value='" + valueScenario.name + "' id='" + valueScenario.name + "' " + (valueScenario.selected == true ? "checked='checked'" : "") + " onclick='return ScenarioFilter(this,\"Scenarios\");'/><label id='lbl" + valueScenario.name + "' for='" + valueScenario.name + "'>" + valueScenario.name + "</label></span>").appendTo(div);
        if (!valueScenario.entitled) {
            $('#scenario #' + valueScenario.name).attr('disabled', 'disabled');
            $('#scenario #' + valueScenario.name).next().css('color', 'DarkGray');
        }
    });
    if (valuepanels.type == "off") {
        selectedScenario = scenarioValues.getValues('selected', true)[0];
        window.gScenario = selectedScenario.name;
        $('#' + window.gScenario).attr('checked', 'checked');
    }
    else {
        if (!flag)
            window.gScenario = valuepanels['default'];
        $('#' + valuepanels['default']).attr('disabled', 'disabled');
        $('#lbl' + valuepanels['default']).css('font-weight', 'bold');
    }
    SetPanelType('scenariosection', valuepanels.type);
    appendCustomScenarioSettings();
    if (window.compositeEdit) {
        $('#scenario').find('input[type="radio"]').attr("disabled", "disabled");
        $('.setDefaultImg').hide();
        $('#customScenarioSpan').css('opacity', '0.5');
        $('#createCustomImg').attr("onclick", "");
        $('#scenario-selection').attr('disabled', 'disabled');
    }
}

function ScenarioFilter(chkBox, type) {
    if (chkBox.type == "radio") {
        if (window.gScenario != chkBox.id) {
            window.gScenario = chkBox.id;
            var scenarioValues = window.MEData.panels.getValues('name', 'Scenarios')[0];
            scenarioValues['default'] = window.gScenario;
        }
        else
            return;
    }
    SourceFilter(chkBox, type);
}

function toogleDriver(ele, flag) {
    if (flag) {
    }
    else if ($(ele).attr('value') == paramDisplayType)
        return;
    var allImgs = $('#tt').datagrid("getPanel").find('table').eq(1).find('td[field="lineitems"]').find('img')
    var ScenarioImgs = $('#tt').datagrid("getPanel").find('table').eq(1).find('.diver-selection-div, .drive-here-div').find('img');
    allImgs.not(ScenarioImgs).attr('src', window.assetUrl + '/datagrid_row_collapse.png');
    if ($(ele).attr('id').indexOf('all') != -1) {
        paramDisplayType = "all";
        toggleLineitems('driver', 'show');
        toggleLineitems('non-driver', 'show');
        $('#driverToggleTable').removeClass().addClass('all-active');
    }
    else if ($(ele).attr('id').indexOf('driver') != -1) {
        paramDisplayType = "driver";
        toggleLineitems('driver', 'show');
        toggleLineitems('non-driver', 'hide');
        $('#driverToggleTable').removeClass().addClass('driver-active');

    }
    else if ($(ele).attr('id').indexOf('line') != -1) {
        paramDisplayType = "line";
        toggleLineitems('driver', 'hide');
        toggleLineitems('non-driver', 'show');
        $('#driverToggleTable').removeClass().addClass('line-active');
    }
    if (!flag && hideDisabled)
        showHideDisabledLines();
}

function toggleLineitems(type, action, obj) {
    var appendedRows = $.grep(AlldgRows, function (i, el) {
        return i.RowAppend;
    });
    var lineList = [];
    var liObjects = $('#emptyobject');
    var dataTableTr = $('#tt').datagrid("getPanel").find('table').eq(4).find('tr');
    var liTr = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
    if (type == 'driver')
        lineList = driverLines;
    else if (type == 'non-driver')
        lineList = window.MEData.row_dimensions[0].values.getValues('driver', undefined).getKeyValues('id');
    if (obj)
        lineList = obj.lines;
    $.each(appendedRows, function (i, el) {
        var lineId = el.id.split('-')[0];
        if ($.inArray(lineId, lineList) > -1) {
            if (action == 'show' && (liTr.eq(i).find('td').length != rowDimension.length))
                return;
            lineitemTd = liTr.eq(i).find('td[field="lineitems"]');
            lineitemTdDiv = lineitemTd.find('.datagrid-cell');
            if (action == 'hide') {
                lineitemTdDiv.find('img').attr('src', window.assetUrl + '/datagrid_row_expand.png');
                liTr.eq(i).find('td.expanded-row-header').removeClass('expanded-row-header');
                liTr.eq(i).find('td[field!="lineitems"]').find('img').attr('src', window.assetUrl + '/datagrid_row_expand.png');
                lineitemTd.attr('rowspan', '1');
            }
            if (action == 'show' && paramDisplayType == 'driver' && lineitemTdDiv.html().indexOf(el.name) == -1) {
                lineitemTdDiv.html(lineitemTdDiv.html().replace(el.shortname, el.name))
                if (el.name.length > 25) {
                    lineitemTdDiv.attr('qttitle', el.name);
                    qtipSettings(lineitemTdDiv, "qttitle");
                }
            }
            if (action == 'show' && paramDisplayType != 'driver' && type == 'driver')
                lineitemTdDiv.html(lineitemTdDiv.html().replace(el.name, el.shortname)).removeAttr('qttitle').unbind();
            liObjects = liObjects.add(liTr.eq(i));
            liObjects = liObjects.add(dataTableTr.eq(i));
            if (action == 'disableStyle') {
                if (liTr.eq(i).find('.diver-selection-div').attr('display') == 'none')
                    createLog(lineId, " is already disabled");
            }
            if (action == 'enableStyle') {
                if (liTr.eq(i).find('.diver-selection-div').attr('display') != 'none' && lineId != obj.resp.paramid)
                    createLog(lineId, " is already enabled");
                liTr.eq(i).find('.diver-selection-div').find('input').linkselect("val", obj.resp.selectedValue);
            }
        }
    });
    if (action == 'show')
        liObjects.show();
    else if (action == 'hide')
        liObjects.hide();
    else if (action == 'disableStyle') {
        if (obj.onlyhighlevel)
            liObjects.addClass('highlevel-row');
        else
            liObjects.addClass('disabled-row');
        liObjects.find('.diver-selection-div').hide();
        liObjects.find('.drive-here-div').show();
    } else if (action == 'enableStyle') {
        liObjects.removeClass('disabled-row').removeClass('highlevel-row');
        liObjects.find('.diver-selection-div').show();
        liObjects.find('.drive-here-div').hide();
    }
}

function toggleDisabled() {
    var liTr = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr.disabled-row');
    var lineList = liTr.find('td[field="lineitems"]').map(function (i, ele) {
        return ele.id
    });
    var ele = $('#hideDisabledImg');
    if ($(ele).attr('value') == "hide disabled") {
        toggleLineitems('', 'hide', {'lines': lineList});
        $(ele).attr('value', "show disabled");
        hideDisabled = true;
    }
    else {
        toggleLineitems('', 'show', {'lines': lineList});
        $(ele).attr('value', "hide disabled");
        hideDisabled = false;
    }
    if (!hideDisabled)
        toogleDriver($('#toggle-' + paramDisplayType), true)
}

function showHideDisabledLines() {
    if (hideDisabled && $('#hideDisabledImg').length > 0)
        $('#hideDisabledImg').attr('value', "hide disabled");
    else if (!hideDisabled && $('#hideDisabledImg').length > 0)
        $('#hideDisabledImg').attr('value', "show disabled");
    $('#hideDisabledImg').trigger('click');
}



function intializeBaseValues(meta) {
    if (meta.panels.length != 0) {
        if (meta.panels.getValues('name', "Sources").length == 0 && cut != 'SAR') {
            window.gSource = "";
            window.gFocusSource = "";
            window.gSourceActual = "";
        }
        if (meta.panels.getValues('name', "Variants").length == 0 && !jQuery.isEmptyObject(meta.inspector))
            window.gVariant = "";
        if (meta.panels.getValues('name', "Revisions").length == 0)
            window.gRevision = "";
        if (meta.panels.getValues('name', "Accounting basis").length == 0)
            window.gBasis = "";
        if (meta.panels.getValues('name', "Adjustments").length == 0)
            window.gAdjust = "";
        if (meta.panels.getValues('name', "Scenarios").length == 0)
            window.gScenario = "";
        if (meta.panels.getValues('name', GROWTHTYPES).length == 0)
            window.gGrowthTypeValues = "";
    }
}


function removeEmptyPeriods(seriesData, periodTicks) {
    var periodTicks = $.grep(periodTicks, function (i, el) {
        var everyValueNull = true;
        $.each(seriesData, function (index, value) {
            if (value[el] != null)
                everyValueNull = false;
        });
        if (everyValueNull)
            $.each(seriesData, function (index, value) {
                value.splice(el, 1)
            });
        else
            return i;
    });
    return {'series': seriesData, 'periods': periodTicks};
}

function digitsOfNumber(num) {
    num = Math.abs(num);
    var i = 0;
    while (Math.floor(num) != 0) {
        num = Math.floor(num / 10)
        i = i + 1;
    }
    return i;
}

function roundingNumber(number, increment) {
    var LIMIT_OF_DIGITS = 2;
    var res = number;
    var digits = digitsOfNumber(number);
    if (digits - LIMIT_OF_DIGITS > 0) {
        var factor = Math.pow(10, digits - LIMIT_OF_DIGITS);
        if (increment)
            res = Math.ceil(number / factor) * factor;
        else
            res = Math.floor(number / factor) * factor;
    }
    else if (digits - LIMIT_OF_DIGITS == 0) {
        if (increment)
            res += 1;
        else
            res -= 1;
    }
    if (increment)
        return Math.ceil(res);
    else
        return Math.floor(res);
}





var plot2 = {};


var PERIOD_MAX_LENGTH = 25;
var chartDataObject = {};


function quarterPeriodFormat(value) {
    if (calendarYears)
        return value.substr(0, 3) + "-" + getYear(value).substr(2, 2);
    else
        return value.substr(0, 2) + "-" + getYear(value).substr(2, 2);
}

function addCommonSizeToggle(flag) {
    var yoyTd;
    var toptab = $('#topTab');
    var boxPosition = toptab.children('td').last();
    $('<td class="fstd_duplicate" id="commonsize" style="padding-right:5px"></td>').insertAfter(boxPosition);
    var toggleTd = $('#commonsize');
    var tableStart = '<table border="0" align="right" id="commonsizeToggleTable"><tbody><tr>';
    var normalTd = '<td class="toggleTd" id="toggle-normal" value="normal" qttitle="Values" onclick="dataTranform(this);"><div class="miniButtonsUnselected miniButtonsSelected" style="border-top-right-radius:0;border-bottom-left-radius:3px;">123</div></td>';
    var commonsizeTd = '<td class="toggleTd" id="toggle-commonsize" value="commonsize" qttitle="Percent of total" onclick="dataTranform(this);"><div class="miniButtonsUnselected" style="border-top-left-radius:0;border-bottom-right-radius:3px;border-left:1px solid #ECF0F1;">%</div></td>';

    var tableEnd = '</tr></tbody></table>';
    if(flag){
        // yoyTd = '<td class="toggleTd" id="toggle-yoy" value="yoypct" qttitle="Year over year growth in %. Click on Analytics in the Options bar for more options." onclick="dataTranform(this);"><div class="miniButtonsUnselected"  style="border-top-left-radius:0;border-bottom-right-radius:3px;">YoY%</div></td>';
        $(tableStart + normalTd + commonsizeTd + tableEnd).appendTo(toggleTd);

    }
    // else{
    //     yoyTd = '<td class="toggleTd" id="toggle-yoy" value="yoypct" qttitle="Year over year growth in %. Click on Analytics in the Options bar for more options." onclick="dataTranform(this);"><div class="miniButtonsUnselected"  style="border-top-left-radius:3px;border-bottom-left-radius:3px;border-bottom-right-radius:3px;">YoY%</div></td>';
    //     $(tableStart + yoyTd + tableEnd).appendTo(toggleTd);
    // }

    dataInCommonsize = false;
    //qtipSettings($('#toggle-normal'), "qttitle", true);
    //qtipSettings($('#toggle-commonsize'), "qttitle", true);
    // qtipSettings($('#toggle-yoy'), "qttitle", true);

}


function getSelected(values) {
    var val = '';
    $.each(values, function (i, el) {
        if (el.selected == true)
            val = el.name;
    });
    return val;
}



function addScenarioSelectionMode() {
    var lastTd = $('#topTab').find('td').first();
    var saveScenarioImg = '<td class="fstd_duplicate" id="saveScenarioTd" style="padding-right:5px"><input id="saveScenarioImg" class="tab-buttons" type="button" value="save" \
        onclick="saveScenario();" qttitle="Save the custom view"></td>';
    if ($('#saveScenarioTd').length == 0) {
        $(saveScenarioImg).insertAfter(lastTd);
        qtipSettings($('#saveScenarioImg'), "qttitle", true);
    }
    var WIDTH_TO_INCREASE = 80;
    var newLeftGridWidth = $('.datagrid-view1').width() + WIDTH_TO_INCREASE;
    var newRightGridWidth = $('.datagrid-view2').width() - WIDTH_TO_INCREASE;
    $('.datagrid-view1').width(newLeftGridWidth);
    $('.datagrid-view2').width(newRightGridWidth);
    $('.datagrid-view2').css('left', newLeftGridWidth + 'px');
    $('.datagrid-view2').children().width(newRightGridWidth);
    $('.datagrid-view1').children().width(newLeftGridWidth);
    $('.datagrid-view1').children().find('table').width(newLeftGridWidth);
    $('.datagrid-custom-div').css('width', 'auto');
    if ($('.datagrid-view1 .datagrid-header-row').find('td').length == 1)
        $('.datagrid-view1 .datagrid-header-row').find('td').children('div').width(newLeftGridWidth - 9);
    else
        $('.datagrid-view1 .datagrid-header-row').find('td').eq(0).nextAll().width(WIDTH_TO_INCREASE);
    var lineitemTd = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr').find('td[field="lineitems"]');
    lineitemTd.eq(0).width($('.datagrid-view1 .datagrid-header-row').find('td').eq(0).width());
    lineitemTd.children().css('float', 'left');
    var headerDiv = $('.datagrid-view1 .datagrid-header-row').find('td').eq(0).find('div').eq(0);
    var inputButton = '<img id="recal_button" class="driverChange-buttons" src="'+window.assetUrl+'/recalc_btn.png" onclick="userScenarioAction(this);">';
    $(inputButton).appendTo(headerDiv);
    if (colDimension.length == 1) {
        $(headerDiv).css('width', '100%');
    }
    var divStart = '<div class="diver-selection-div"><select title="Select Scenario" id="';
    var divstart2 = '" class="required selectElements" style="width: 10px;margin: 0px;height: 22px;">';
    var options = "";
    var driveHereDivEnd = 'class="drive-here-div" >\
            <img src="'+window.assetUrl+'/down_arrow.png" style="opacity:1;margin:3px;margin-top:8px;float:right;">\
            <span class="linkselect-link-text driveHere" style="float:right">drive here</span></div>';
    $.each(window.MEData.row_dimensions[0].driver_types.allvalues, function (i, el) {
        options += '<option value="' + el.shortname + '">' + el.name + '</option>';
    });
    var divEnd = '</select></div>';
    $.each(lineitemTd, function (i, el) {
        if ($.inArray($(el).attr('id'), driverLines) > -1 || $.inArray($(el).attr('id'), highLevelDrivers) > -1) {
            $(divStart + 'param-' + $(el).attr('id') + divstart2 + options + divEnd + '<div id="drive-' + $(el).attr('id') + '"' + driveHereDivEnd).appendTo(el);
            $(el).find('.driveHere').closest('div').bind('click', function () {
                return false;
            }).bind('click', function () {
                toggleDriveHere(this, false);
            });
        }
    });
    $('.diver-selection-div').bind('click', function () {
        return false;
    });
    //$('.drive-here-div').bind('click',function(){ return false;});
    $('.selectElements').linkselect({
        titleAlign: 'right',
        style: 'linkselect',
        change: function (li, value, text) {
            lineScenarioChange(this.id, this.val(), text);
            this.blur();
        },
        open: function (li, value) {
            $('.linkselect-container').hide();
            $(li).show();
            if ($(li).offset().top + $(li).height() > $('body').height() - 30)
                $(li).offset({'top': $(li).offset().top - $(li).height() - $(value).height()});
            document.onmousedown = function (e) {
                setTimeout(function () {
                    if (document.activeElement.id != value[0].id)
                        $(li).hide();
                }, 100);
            };
        }
    });

    $.each(window.MEData.row_dimensions[0].driver_types.values, function (i, el) {
        defaultScenarioChanges[el.paramid] = el.shortname;
    });
    scenarioChanges = jQuery.extend(true, {}, defaultScenarioChanges);
    selectDriverScenarios(scenarioChanges)
    //$('#customScenarioSpan').hide();
}

function toggleDriveHere(element, flag) {
    $(element).closest('div').hide();
    $(element).closest('td').find("div.diver-selection-div").show().find(".linkselect-link-text").text("drive here");
    $(element).closest('td').find('#' + $(element).attr('id').replace('drive', 'param')).linkselect("open");
}

function saveScenario() {
    if (editScenarioMode) {
        var ObjWebServiceCall = new WebServiceCall();
        if ($('#recal_button').is(":visible"))
            ObjWebServiceCall.postScenarioChanges(false, {'savescenario': true});
        else
            ObjWebServiceCall.saveScenarioByName();
        return;
    }
    if ($("#saveScenarioDialog").length < 1)
        createScenarioDialog();
    else
        openScenarioDialog();
    $('#saveScenarioDialog #dialog-name').focus();
}

function saveVariant() {
    if (editVariantMode) {
        var ObjWebServiceCall = new WebServiceCall();
        ObjWebServiceCall.saveVariantByName();
        return;
    }
    if ($("#saveVariantDialog").length < 1)
        createVariantDialog();
    else
        openVariantDialog();
	$('#saveVariantDialog #dialog-name').focus();
	// heap_tracking(company, {'action':'Save Variant'});
}

function createVariantDialog() {
    var div = $('#container');
    var dialogMessage = "<label class='dialog-message' id='dialog-message-1' style='display:none;margin-left:5px'>variant shortname can be atmost\
    8 alpha-numeric chars <br></label><label class='dialog-message' id='dialog-message-2' style='display:none;margin-left:5px'>\
    variant name should be alpha-numeric only<br></label><br>";
    var dialogName = "<label for='dialog-name' style='margin-left:7px;'>&nbsp;&nbsp;Name the model :&nbsp;&nbsp;</label>\
    <input type='text' name='dialog-name' id='dialog-name' style='width:175px; height:20px; margin-right:15px;float:right;' ></input><br><br>";
    var dialogName1 = "<label for='dialog-name1' style='margin-left:7px;'>&nbsp;&nbsp;Shortname :&nbsp;&nbsp;</label>\
    <input type='text' name='dialog-name1' id='dialog-name1' style='width:175px; height:20px; margin-right:15px;float:right;' ></input><br><br>";
    $("<div id='saveVariantDialog' title='Customize variants'>" + dialogMessage + dialogName + dialogName1 + "</div>").appendTo(div);

    $("#saveVariantDialog").dialog({
        draggable: true, resizable: false, modal: true, dialogClass: "prompt", minHeight: 300,
        buttons: []
    });
    var dialogDiv = $('#saveVariantDialog .dialog-button');
    var cancelImage = "<img id='cancelDialog' src='"+window.assetUrl+"/dialog-cancel.png' style='height:28px; width:80px' \
    onclick='dialogControl(\"CANCEL\",\"variant\")' />";
    var saveImage = "<img id='saveDialog' src='"+window.assetUrl+"/dialog-save.png' style='margin-left:20px; height:29px; width:80px' \
    onclick='dialogControl(\"SAVE\",\"variant\")' />";
    $(cancelImage + saveImage).appendTo(dialogDiv);
}

function createScenarioDialog() {
    var div = $('#container');
    var dialogMessage = "<label class='dialog-message' id='dialog-message-1' style='display:none;margin-left:5px'>scenario shortname can be atmost\
    8 alpha-numeric chars <br></label><label class='dialog-message' id='dialog-message-2' style='display:none;margin-left:5px'>\
    scenario name should be alpha-numeric only<br></label><br>";
    var dialogName = "<label for='dialog-name' style='margin-left:7px;'>&nbsp;&nbsp;Name the custom scenario :&nbsp;&nbsp;</label>\
    <input type='text' name='dialog-name' id='dialog-name' style='width:175px; height:20px; margin-right:15px;float:right;' ></input><br><br>";
    var dialogName1 = "<label for='dialog-name1' style='margin-left:7px;'>&nbsp;&nbsp;Shortname :&nbsp;&nbsp;</label>\
    <input type='text' name='dialog-name1' id='dialog-name1' style='width:175px; height:20px; margin-right:15px;float:right;' ></input><br><br>";
    $("<div id='saveScenarioDialog' title='Customize scenarios'>" + dialogMessage + dialogName + dialogName1 + "</div>").appendTo(div);

    $("#saveScenarioDialog").dialog({
        draggable: true, resizable: false, modal: true, dialogClass: "prompt", minHeight: 300,
        buttons: []
    });
    var dialogDiv = $('#saveScenarioDialog .dialog-button');
    var cancelImage = "<img id='cancelDialog' src='"+window.assetUrl+"/dialog-cancel.png' style='height:28px; width:80px' \
    onclick='dialogControl(\"CANCEL\",\"scenario\")' />";
    var saveImage = "<img id='saveDialog' src='"+window.assetUrl+"/dialog-save.png' style='margin-left:20px; height:29px; width:80px' \
    onclick='dialogControl(\"SAVE\",\"scenario\")' />";
    $(cancelImage + saveImage).appendTo(dialogDiv);
}

function openVariantDialog() {
    $('#saveVariantDialog .dialog-message').hide();
    $('#saveVariantDialog').dialog('open');
    $('#saveVariantDialog #dialog-name').val("");
    $('#saveVariantDialog #dialog-name1').val("");
}

function openScenarioDialog() {
    $('#saveScenarioDialog .dialog-message').hide();
    $('#saveScenarioDialog').dialog('open');
    $('#saveScenarioDialog #dialog-name').val("");
    $('#saveScenarioDialog #dialog-name1').val("");
}

function variantOverWrite(flag, variantName) {
    if (flag) {
        saveError = 'variantExist';
        var lbl = "<label style='padding-left:10px;padding-right:10px;'> Variant name already Exist :Do you want to overwrite </label>";
    }
    else {
        saveError = 'selectionsExist';
        var lbl = "<label style='padding-left:10px;padding-right:10px;'> Variant selections already Exist for - <b>" + variantName
            + "</b>: do you want to overwrite existing scenario name </label>";
    }
    if ($('#' + saveError).length < 1)
        createErrorPrompt(saveError, lbl, 'variant')
    else
        $('#' + saveError).dialog('open');
}

function confirmationDialog(type, action, value) {
    var saveError = action + '-' + type;
    if (!value)
        value = "";
    var labelMessage = "Do you want to " + action + " this " + type + " : " + value;
    var lbl = "<label value='" + value + "'style='padding-left:10px;padding-right:10px;'> " + labelMessage + "</label>";
    if ($('#' + saveError).length < 1)
        createErrorPrompt(saveError, lbl, {type: type, action: action});
    else {
        $('#' + saveError).dialog('open');
        $('#' + saveError).find('label').html(labelMessage).attr('value', value);
    }
}

function scenarioOverWrite(flag, scenarioName) {
    if (flag) {
        saveError = 'scenarioExist';
        if ($('#' + saveError).length < 1) {
            var lbl = "<label style='padding-left:10px;padding-right:10px;'> Scenario name already Exist :Do you want to overwrite </label>";
            createErrorPrompt(saveError, lbl, 'scenario')
        }
        else
            $('#' + saveError).dialog('open');
    }
    else {
        saveError = 'selectionsExist';
        if ($('#' + saveError).length < 1) {
            var lbl = "<label style='padding-left:10px;padding-right:10px;'> scenario selections already Exist for - <b>" + scenarioName + "</b>: do you want to overwrite existing scenario name </label>";
            createErrorPrompt(saveError, lbl, 'scenario')
        }
        else
            $('#' + saveError).dialog('open');
    }
}

function removeScenarioSelectionMode() {
    objME = new ModelExplorer();
    objME.LoadDataGrid(gridLoadedMEData, true);
    if ($('.datagrid-footer').is(":visible") == false)
        setTimeout(reziseGridPanel, 100);
}

function appendCustomScenarioSettings() {
    var scenarioDiv = $('#scenario');
    var scenarioObj = window.MEData.panels.getValues('name', 'Scenarios')[0];
    var scenarioValues = scenarioObj.values.getValues('variant', window.gVariant)[0].values;
    //add default scenario option
    $.each(scenarioValues, function (i, el) {
        if (!el.entitled)
            return;
        var parentEle = $('#' + el.name).parent();
        //$('<input type="button" value="set default" id="default-'+ el.name +'" style="opacity:0;" onclick="setDefaultScenario(this)" >').appendTo($('#' + el.name).parent());
        $('<img class="setDefaultImg" src="'+window.assetUrl+'/set_default_btn.png" id="default-' + el.name + '" onclick="setDefaultScenario(this)" >').appendTo(parentEle);
        if (el.name == window.gScenario)
            $('#default-' + el.name).hide();
        if (el.custom && el.name.toLowerCase() != 'custom') {
            $('<img class="del_scenario" src="'+window.assetUrl+'/minus.png" id="del-' + el.name + '" onclick="editScenario(this)" >').appendTo(parentEle);
            $('<img class="edit_scenario" src="'+window.assetUrl+'/edit.gif" id="edit-' + el.name + '" onclick="editScenario(this)" >').appendTo(parentEle);
        }
    });
    var select1 = '<select id="scenario-selection" class="required" style="margin:0px;vertical-align:middle;">';
    var options = "";
    $.each(scenarioValues, function (i, el) {
        if ((!el.entitled) || el.custom)
            return;
        else
            options += '<option value="' + el.name + '">' + el.name + '</option>';
    });
    //var inputButton = '<input type="button" value="Create Custom" style="font-size:12px;" onclick="customScenarioMeta();">'
    var imgCustom = '<img id="createCustomImg" src="'+window.assetUrl+'/create_custom_btn.png" qttitle="Create custom allows you to select a different broker for each assumption. \
	Once you are done, click save to store your custom assumptions." style="vertical-align: middle;width:90px;" onclick="customScenarioMeta();">';
    $('<span id="customScenarioSpan">' + imgCustom + '  from  ' + select1 + options + '</select>' + '</span>').appendTo(scenarioDiv);
    if (scenarioObj.type == "off")
        $('.setDefaultImg').hide();
    else {
        $('.setDefaultImg').css("display", "");
        $('#default-' + window.MEData.panels.getValues('name', 'Scenarios')[0]['default']).hide();
    }
    
    qtipSettings($('#createCustomImg'), "qttitle", true);
}

function lineScenarioChange(eleId, value, textValue) {
    var lineId = eleId.split('-')[1];
    if (value)
        scenarioChanges[lineId] = value;
    //$('.' + ele.className).val(ele.value);
    if (JSON.stringify(defaultScenarioChanges) == JSON.stringify(scenarioChanges)) {
        $('.datagrid-view1 .datagrid-header-row').find('td').eq(0).removeClass('recalcTd');
        $('.driverChange-buttons').hide();
    }
    else {
        $('.datagrid-view1 .datagrid-header-row').find('td').eq(0).addClass('recalcTd');
        $('.driverChange-buttons').show();
    }
    var liTr = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
    $.each(liTr, function (i, el) {
        var newEle = $(el).find('#param-' + lineId);
        if (newEle.length > 0) {
            newEle.closest('div').show();
            $(el).find('.drive-here-div').hide();
            if (newEle.linkselect("val") != value)
                newEle.linkselect("val", value);
        }
    });
    divEle = $('#param-' + lineId).closest('div').find('.linkselect-link-text');
    if (divEle.text().indexOf("drive here") > -1) {
        var objWebServiceCall = new WebServiceCall();
        objWebServiceCall.getImpactedDriverLines({id: lineId, scenario: value});
    }
}

function actionOnImpactedLines(response) {
    toggleLineitems("", "disableStyle", {"lines": response.highlevel, resp: response, "onlyhighlevel": true});
    toggleLineitems("", "disableStyle", {"lines": response.disabled, resp: response});
    toggleLineitems("", "enableStyle", {"lines": response.enabled, resp: response});
    if (hideDisabled)
        showHideDisabledLines();
}

function selectDriverScenarios(data) {
    var liTr = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
    $.each(liTr, function (i, el) {
        if ($(el).find('.diver-selection-div').length > 0) {
            var lineId = $(el).find('.diver-selection-div').find('input').attr('id').split('-')[1];
            if (data[lineId])
                $(el).find('.diver-selection-div').find('input').linkselect("val", data[lineId]);
            if ($.inArray(lineId, highLevelDrivers) > -1) {
                $(el).find('.drive-here-div').show();
                $(el).find('.diver-selection-div').hide();
            }
            else {
                $(el).find('.diver-selection-div').show();
                $(el).find('.drive-here-div').hide();
            }
        }
    });
    toggleLineitems("", "disableStyle", {"lines": highLevelDrivers, "onlyhighlevel": true});
    var disabledLines = window.MEData.row_dimensions[0].values.getValues('disable', true).getKeyValues('id');
    toggleLineitems("", "disableStyle", {"lines": disabledLines});
}

function scenarioMode(ele) {
    var a = 10;
    if ($(ele).closest('table').hasClass($(ele).attr('value') + '-active'))
        return;
    if ($(ele).attr('value') == 'off') {
        $('#customscenariotable').removeClass().addClass('off-active');
        removeScenarioSelectionMode();
    }
    else {
        $('#customscenariotable').removeClass().addClass('on-active');
        customScenarioMeta();
    }
}

function customScenarioMeta(ele) {
    var options = undefined;
    if ($(ele).attr('id') == "editCompositeImg") {
        window.compositeEdit = true;
        options = {'editRefresh': true};
		// heap_tracking(company, {'action':'Edit Composite'});
    }
    else {
        window.compositeEdit = false;
    }
    var ObjWebServiceCall = new WebServiceCall();
    ObjWebServiceCall.postScenarioChanges(true, options);
}

function userScenarioAction(ele) {
    if ($(ele).attr('value') == 'cancel') {
        selectDriverScenarios(defaultScenarioChanges);
    }
    else {
        var ObjWebServiceCall = new WebServiceCall();
        ObjWebServiceCall.postScenarioChanges(false);
    }
    $('.driverChange-buttons').hide();
}

function setDefaultScenario(ele) {
    var eleId = ele.id.split('-')[1];
    window.gScenario = eleId;
    if (editScenarioMode) {
        editScenarioMode = false;
        customScenarioMode = false;
        $('#ptype').trigger('change');
    }
    var scenarioObj = window.MEData.panels.getValues('name', 'Scenarios')[0];
    $("#" + scenarioObj['default'])[0].disabled = false;
    $("#lbl" + scenarioObj['default']).css('font-weight', 'normal');
    $("#default-" + scenarioObj['default']).css("display", "");
    scenarioObj['default'] = eleId;
    window.gScenario = eleId;
    if (!$('#' + eleId).is(':checked'))
        //$('#' + eleId).trigger('click');
    var PanelData = scenarioObj.values.getValues('variant', window.gVariant)
    if ($.inArray('scenario', rowDimension) > 0) {
        var defaultData = window.MEData.row_dimensions.getValues('name', 'Scenarios');
        defaultData[0].values[0].name = eleId;
        GetSelectedExpansion(defaultData, PanelData);
    }
    else if ($.inArray('scenario', colDimension) > 0) {
        var defaultData = window.MEData.column_dimensions.getValues('name', 'Scenarios');
        defaultData[0].values[0].name = eleId;
        GetSelectedExpansion(defaultData, PanelData);
    }
    $("#" + eleId)[0].disabled = true
    $("#default-" + eleId).hide();
    $('#lbl' + eleId).css('font-weight', 'bold');
}



function hideDisabledExpansions(metadata) {
    var disabledList = metadata.disabled_expansions;
    if (disabledList && disabledList.length > 0) {
        $.each(disabledList, function (i, el) {
            var ele = $('#' + el.id);
            if (ele.length > 0) {//todo note change
                ele.parent().attr('note', el.note);
                qtipSettings(ele.parent(), 'note');
                ele.remove();
            }
        });
    }
}

function gridFormattingForSchedules(ExpandedParam_id) {
    $('.datagrid-view2 .datagrid-header').find('tr').find('td').css('border-right', '1px dotted transparent');
    $('#tt').datagrid("getPanel").addClass('schedule-grid-lines');
    var allLineItems = window.MEData.row_dimensions[0].values;
    var appendedRows = AlldgRows.getValues('RowAppend', true);
    var rowIndex = -1;
    var datatable = $('#tt').datagrid("getPanel").find('table').eq(4).find('tr');
    var lineitemTable = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
    datatable.find('td').css('border-right', '1px dotted transparent');
    for(var i=0; i<allLineItems.length; i++){
        var el= allLineItems[i];
        if (el.format != undefined || (el.header)) {
            var rowId = makeRowId(el.id)
            //$('img#' + rowId).remove();
            // $.each(appendedRows, function (index, value) {
            for(var index=0; index<appendedRows.length; index++){
                var value = appendedRows[index];
                if (String(rowId).toLowerCase() == String(value.id).toLowerCase() && value.sortorder == el.sortorder) {
                    rowIndex = index;
                    break;
                }
            };
            var lineitemTr = lineitemTable.eq(rowIndex);
            var dataTr = datatable.eq(rowIndex);
            if (el.header) {
                lineitemTr.find('img').remove();
                lineitemTr.find('td').not('[field="lineitems"]').find('b').remove();
                if (el.format == undefined)
                    return;
            }
            lineitemTr.find('td').addClass(el.format.join(" "));
            dataTr.find('td').addClass(el.format.join(" "));

            if (ExpandedParam_id == el.id) {
                //var expanded_trs = [];
                //var expanded_rows_index = [];
                var expandrow_list = $('.expanded-row');
                var expanded_row_index = $(lineitemTr).attr('datagrid-row-index');
                for(var index=0; index<expandrow_list.length; index++){
                    var eachlineitemTr = expandrow_list[index];
                    eachlineitemTrIndex = $(eachlineitemTr).attr('datagrid-row-index').split('-');
                    if (expanded_row_index == eachlineitemTrIndex[0]) {
                        $(eachlineitemTr).find('td').addClass(el.format.join(" "));
                    }
                };
            }
        }
    };
}

function makeRowId(paramId) {
    var rowSelector = "";
    if (rowDimension.length == 1)
        return paramId;
    for(var indexRow=0; indexRow<rowDimension.length; indexRow++){
        var valueRow = rowDimension[indexRow];
        if (indexRow == 0) {
            rowSelector = rowSelector + paramId;
        } else if (cut != 'CPT' && indexRow == 1) {
        } else {
            rowSelector = rowSelector + "-" + rowDefaults[valueRow].toLowerCase();
        }
    };
    return rowSelector.toLowerCase();
}

function formattingHeaderLines() {
    var headers = window.MEData.row_dimensions[0].values.getValues('header', true);
    var appendedRows = AlldgRows.getValues('RowAppend', true);
    var rowIndex = -1;
    var datatable = $('#tt').datagrid("getPanel").find('table').eq(4).find('tr')
    var lineitemTable = $('#tt').datagrid("getPanel").find('table').eq(1).find('tr');
    for(var i=0; i<headers.length; i++){
        var el= headers[i];
        var rowId = makeRowId(el.id)
        //$('img#' + rowId).remove();
        for(var index=0; index<appendedRows.length; index++){
            var value = appendedRows[index];
            if (rowId.toLowerCase() == value.id.toLowerCase() && value.sortorder == el.sortorder) {
                rowIndex = index;
                break;
            }
        };
        var lineitemTr = lineitemTable.eq(rowIndex);
        var dataTr = datatable.eq(rowIndex);
        lineitemTr.addClass('headerTr');
        dataTr.addClass('headerTr');
        dataTr.find('td:last').addClass('headerLastTd');
        if (el.shortname == ' ') {
            lineitemTr.addClass('emptytr');
            dataTr.addClass('emptytr');
        }
        lineitemTr.find('img, .trend-icon, .research-icon').remove();
        lineitemTr.find('td').not('[field="lineitems"]').find('b').remove();
    };
}

function getAnnotationType(annotationType) {
    if (annotationType == undefined)
        return 5;
    var annSubStr = annotationType.substring(0, 2);
    if (annSubStr == "37")
        return 4;
    else if (annSubStr == "27")
        return 3;
    else if (annSubStr == "17")
        return 1;
    else if (annotationType.charAt(2) == "1")
        return 6;
    else if (annotationType.charAt(0) == "1")
        return 2;
    else
        return 5;
}

function getCellStyling(annotation, ele) {

    if (annotation == 'modelRestedMode') {
        $(ele).addClass('mode-restated-mode-match');
        return
    }

    var typeValue = getAnnotationType(annotation);
    switch (typeValue) {
        case 1:
            $(ele).addClass('type-1');
            break;
        case 2:
            $(ele).addClass('type-2');
            break;
        case 3:
            $(ele).addClass('type-3');
            break;
        case 4:
            $(ele).addClass('type-4');
            break;
        case 6:
            $(ele).addClass('type-6');
            getCellStyling(annotation.substr(0, 2), ele);
            break;
        default:
            break;
    }
}

function displayLineitem(selected) {
    var lineitem_name = selected.shortname;
    if (selected.parameter_unit){
        lineitem_name += selected.parameter_unit;
    }

    $('.tblInsSpan').text(lineitem_name);
}

function editVariant(ele) {
    var eleId = $(ele).attr('id').split('-');
    if (eleId[0] == 'del') {
        var action = 'delete';
        confirmationDialog('varaint', action, eleId[1]);
        return;
    }
    else
        var action = 'edit';
    var objWebServiceCall = new WebServiceCall();
    objWebServiceCall.edit_variant({'variant': eleId[1], 'action': action, 'element': ele});
}

function editScenario(ele){
    var eleId = $(ele).attr('id').split('-');
    if(eleId[0] == 'del'){
        var action = 'delete';
        confirmationDialog('scenario', action, eleId[1]);
        return;
    }
    else
        var action = 'edit';
    window.compositeEdit = false;
    editVariantMode = false;
    var objWebServiceCall = new WebServiceCall();
    objWebServiceCall.edit_scenario( {'scenario':eleId[1], 'action':action});
}

function hidePinnedPanels(){
    $.each(window.MEData.row_dimensions[0].values, function(index, value){
        $('[id="link-' + value.id +'"]').qtip("hide");
    });
}


function get_links_to_nmv_and_sch() {
    $.ajax({
        type: "GET",
        async: true,
        url: window.apiUrl + '/api/get_links_to_nmv_sch/?ticker=' + escape(window.MEData.ticker) + '&cut=' + escape(cut) + '&pg=' + escape(pg) + (window.gBasis ? '&basis=' + escape(window.gBasis) : ''),
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        beforeSend: function (xhr) {
        },
        success: function (msg) {
            if (msg.status == 'success') {
                $.each(msg.line_ids, function (index, value) {
                    var linkCells= $('[id="link-'+value+'"]').css('visibility', 'visible');
                    $.each(linkCells, function (count, cell) {
                        cell = $(cell);
                        var content = "";
                        if ($.inArray(value.toString(), Object.keys(msg.nmv_links)) > -1) {
                            content += "<div style='white-space: nowrap;margin-top:5px'><b>Company</b></div>";
                            $.each(Object.keys(msg.nmv_links[value]), function (ind, val) {
                                var link_div = "<div style='color:blue;margin-left:15px;margin-top:3px;display:inline-block;overflow: hidden;white-space:nowrap;'>[" + msg.nmv_links[value][val].tab_name + "] " + msg.nmv_links[value][val].line_name + "</div><br/>";
                            var links = "<a href="+window.projectArkUrl+"/mex/" + window.MEData.ticker  + "/NMV/" + encodeURIComponent(msg.nmv_links[value][val].tab_shortname) + "/?&dpid=" + msg.nmv_links[value][val].line_id + " target='_blank'>" + link_div + "</a>";
                                content += links;
                            });
                            content += "<br/>";
                        }
                        if ($.inArray(value.toString(), Object.keys(msg.sch_links)) > -1) {
                            $.each(Object.keys(msg.sch_links[value]), function (ind, val) {
                                content += "<div style='white-space: nowrap;margin-top:5px'><b>" + msg.sch_links[value][val].header + "</b></div>";
                                $.each(Object.keys(msg.sch_links[value][val].links), function (i, v) {
                                    var link_div = "<div style='color:blue;margin-left:15px;margin-top:3px;display:inline-block;overflow: hidden;white-space:nowrap;'>[" + msg.sch_links[value][val].links[v].tab_name + "] " + msg.sch_links[value][val].links[v].line_name + "</div><br/>";
                                var links = "<a href="+window.projectArkUrl+"/mex/" + window.MEData.ticker + "/SCH/" + encodeURIComponent(msg.sch_links[value][val].links[v].tab_shortname) + "/?&dpid=" + msg.sch_links[value][val].links[v].line_id + " target='_blank'>" + link_div + "</a>";
                                    content += links;
                                });
                                content += "<br/>";
                            });
                        }
                        //todo links qtip
                        cell.qtip({
                            content: {
                                text: content
                            },
                            style: {
                                width: "auto"
                            },
                            show: {
                                delay: 300,
                                solo: true
                            },
                            hide: {
                                delay: 1000,
                                fixed: true
                            },
                            position: {
                                target: false
                            },
                            api: {
                                beforeShow: function () {
                                    if (showSarToNmvPanel) {
                                        tip_position = qtipPostioning(this, cell);
                                        this.options.position.adjust.x = tip_position.x;
                                        this.options.position.adjust.y = tip_position.y;
                                        cell.css({
                                            opacity: '1',
                                            'border-radius': '3px'
                                        });
                                    } else {
                                        return false;
                                    }
                                },
                                onShow: function () {
                                    cell.css({
                                        opacity: '1',
                                        'border-radius': '3px'
                                    });
                                },
                                onHide: function () {
                                    cell.css({border: "", opacity: '0.3'});
                                }
                            }
                        });
                        cell.on('mouseout', function () {
                            if (!cell.qtip('api').elements.tooltip.is(':visible')) {
                                cell.css({border: "", opacity: '0.3'});
                            }
                        });
                    });
                });
            }
        },
        error: function (msg) {
            console.error(msg.responseText);
        }
    });
}

function get_research_snippets () {
    if(!window.hasDsmAccess || window.cut !== 'NMV'){
        window.dsmObj = {
            dapValues: [],
            valuesSet: true
        };
        return
    }
    if(!window.MEData.panels){
        return
    }
    if( $('.research-icon').length===0){
        return
    }
    var account_basis_object =  window.MEData.panels.find(
        (panel) => panel.name.toLowerCase() === "accounting basis"
      );
    $.ajax({
        type: "GET",
        async: true,
        url: window.apiUrl + '/api/get_deep_semantic_dapparameters/?ticker=' + escape(window.MEData.ticker) + '&cut=' + escape(cut) + '&pg=' + escape(pg) +  '&accbasis=' + escape(account_basis_object.selected) ,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        beforeSend: function (xhr) {
            window.dsmObj = {
                dapValues: [],
                valuesSet: true
            }
        },
        success: function (msg) {
            if (msg.status == 'success') {
                window.dsmObj = {
                    dapValues: msg.values,
                    valuesSet: true
                }
                showDsmIcon(msg.values)
            }
        },
        error: function (msg) {
            console.log(msg.statusCode());
        }
    });
}

function showDsmIcon(values){
    $.each(values, function (index, value) {
        const dapparameterid = value.dapparameterid
         $('.research-icon[dapparameterid="'+dapparameterid+'"]').css('visibility', 'visible');
       
    });
}

function getFirstEstimatedYear(meData){
    var panelObj = meData.panels.filter(function (n, i) {
        if (n.name.toLowerCase() == "periods") return true;
    });
    if(panelObj) {
        for(var index=0; index < panelObj[0].all_period_expansion_list.length; index++){
            var value = panelObj[0].all_period_expansion_list[index];
            if (value.forecast && !firstEstimatedYear) {
                firstEstimatedYear = value.period;
                return;
            }
        }
    }
}

function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

function showFormulaForFirstCellBase(financialYear){
    var firstEstimatedYear = window.MEData.panels.filter(function (n, i) {
        return n.name.toLowerCase() === 'periods';
    })[0].first_estimated_year;

    if (firstEstimatedYear && financialYear.toLowerCase() == firstEstimatedYear.toLowerCase()) {
        var fieldName = "";
        $.each(colDimension, function (ind, val) {
            if (val == 'period') {
                fieldName += firstEstimatedYear;
            } else if (val == 'source') {
                fieldName += replaceConsensusPlusOperator(window.gSource);
            } else if (val == 'revision') {
                fieldName += window.gRevision;
            } else if (val == 'ticker') {
                fieldName += window.MEData.ticker;
            } else if (val == 'scenario') {
                fieldName += window.gScenario;
            }
        });
        $.each($('td[field="' + fieldName.toLowerCase() + '"][id]'), function (ind, val) {
            if ($(val).attr('id') && $(val).text()) {
                var elem = $("#" + $(val).attr('id').replace('|', "\\|").replace(/\/+/g, '\\/').replace(':', '\\:'));
                if (elem.length == 0) {
                    elem = $(val);
                }
                //TODO trigger click needed here
                elem.trigger('click');
                return false;
            }
        });
    }
}

function showFormulaForFirstCell(financialYear) {
    if (Array.isArray(financialYear) == true) {
        // if periods in array show formula for 1st cell
        for(var i=0; i< financialYear.length; i++){
            var fYear = financialYear[i];
            showFormulaForFirstCellBase(fYear);
        }
    }else{
        showFormulaForFirstCellBase(financialYear);
    }
}

function highlightHighLowValue(data) {
    $.each(data, function(index, value){
        $.each(value.data, function(i, ele){
            if (ele.max && high){
                $("td[id='" + ele.id + "']").addClass('high');
            }
            if (ele.min && low){
                $("td[id='" + ele.id + "']").addClass('low');
            }
        });
    });
}
function getDivisionFactorForSurprise(sliderValue) {
    var divisionFactor = 1;
    if (sliderValue == 1) {
        divisionFactor = 1;
    } else if (sliderValue == 2) {
        divisionFactor = 2;
    } else if (sliderValue == 3) {
        divisionFactor = 4;
    } else if (sliderValue == 4) {
        divisionFactor = 10;
    } else if (sliderValue == 5) {
        divisionFactor = 20;
    }
    return divisionFactor;
}

function surpriseColoring(ele, surprise, divisionFactor, isSliderChange) {
    if(isSliderChange){
        $(ele).removeClass('surprise-bin-1').removeClass('surprise-bin-2').removeClass('surprise-bin-3')
            .removeClass('surprise-bin-4').removeClass('surprise-bin-5').removeClass('surprise-bin-6').removeClass('surprise-bin-7')
            .removeClass('surprise-bin-8').removeClass('surprise-bin-9').removeClass('surprise-bin-10');
    }
    var surpriseValue = surprise / divisionFactor;
    // ele.addClass('surprise-text-color');
    $(ele).addClass('surprise-text-color');
    if (surpriseValue < -1.00) {
        // ele.addClass('surprise-bin-10');
        $(ele).addClass('surprise-bin-10');
    } else if (surpriseValue <= -0.75 && surpriseValue >= -1.00) {
        // ele.addClass('surprise-bin-9');
        $(ele).addClass('surprise-bin-9');
    } else if (surpriseValue <= -0.50 && surpriseValue > -0.75) {
        // ele.addClass('surprise-bin-8');
        $(ele).addClass('surprise-bin-8');
    } else if (surpriseValue <= -0.25 && surpriseValue > -0.50) {
        // ele.addClass('surprise-bin-7');
        $(ele).addClass('surprise-bin-7');
    } else if (surpriseValue < 0.00 && surpriseValue > -0.25) {
        // ele.addClass('surprise-bin-6');
        $(ele).addClass('surprise-bin-6');
    } else if (surpriseValue > 0.00 && surpriseValue <= 0.25) {
        // ele.addClass('surprise-bin-5');
        $(ele).addClass('surprise-bin-5');
    } else if (surpriseValue > 0.25 && surpriseValue <= 0.50) {
        // ele.addClass('surprise-bin-4');
        $(ele).addClass('surprise-bin-4');
    } else if (surpriseValue > 0.50 && surpriseValue <= 0.75) {
        // ele.addClass('surprise-bin-3');
        $(ele).addClass('surprise-bin-3');
    } else if (surpriseValue > 0.75 && surpriseValue <= 1.00) {
        // ele.addClass('surprise-bin-2');
        $(ele).addClass('surprise-bin-2');
    } else if (surpriseValue > 1.00) {
        // ele.addClass('surprise-bin-1');
        $(ele).addClass('surprise-bin-1');
    }
}

function highlightSurpriseValue(data) {

    var panelObj = window.MEData.panels.filter(function(value) { return value.name == 'Analysis' });
    if(panelObj.length > 0){
        panelObj = panelObj[0];
        var surprise = panelObj.values.filter(function(value) { return value.name == "Surprise" })[0];
        var sliderValue = surprise.slider;
        var divisionFactor = getDivisionFactorForSurprise(sliderValue);
        $.each(data, function(index, value){
            var fieldName = getFieldName(value)
            $.each(value.data, function(i, ele) {
                if (ele.surprise != undefined) {
                    var eleTD= $("td[id='" + ele.id + "'][field='" + fieldName + "'][source='" + value['source']+ "']");
                    if(eleTD.length == 0){
                        eleTD = $("td[id='" + ele.id + "']");
                    }
                    for(var i=0; i<eleTD.length; i++){
                        // handling for consensus+ 
                        // commented to enable surprise coloring feature for C+ user
                        // if($(eleTD[i]).attr("field").indexOf("consensusplus") !== -1){
                        //     eleTD.splice(i, 1);
                        // }
                    }
                    surpriseColoring(eleTD, ele.surprise, divisionFactor);
                }
            });        
        });
    }
}

// suppress the revision and variance coloring in inspector because both are not implemented in inspector
function clearRevisionColoringInspector(){
    if (crdrevision || cva) {
        var table1 = $('#tt').datagrid("getPanel").find('table').eq(5).find('tr');
        table1.find('td.dummyForSliderVariation').removeAttr('title').css("background-color", "").removeClass('dummyForSliderVariation').removeClass('revision-color');
        table1.find('td.dummyForSliderRevision').removeAttr('title').css("background-color", "").removeClass('dummyForSliderRevision').removeClass('revision-color');
    }
}

function setWidthForPanels(gridHt) {
    var winH = $(window).height();
    var winW = $(window).width();
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE") > 0 || ua.indexOf("Edge/") > 0 || ua.indexOf("Trident") > 0;
    var leftPanelVisible = (window.MEData.panel_state) ? window.MEData.panel_state.leftPanel : false;
    var leftPanelWidth = leftPanelVisible ? 224 : 26;
    var rightPanelVisible = (window.MEData.panel_state) ? window.MEData.panel_state.rightPanel : false;
    var rightPanelWidth = rightPanelVisible ? 268 : 26;
    if (winW < parseInt($('body').css('min-width').replace('px', ''))) {
        winW = $('body').width();
    } else if($("html").hasVerticalScrollBar()){
        winW = winW + 11;
    }

    // If Internet Explorer, reduce by 17
    if (msie) {
        winW = winW - 17;
    }
    winW = winW - leftPanelWidth - rightPanelWidth;
   
    $('.rightpanel-seperator, #leftpanel, .panel-white-bg,.right-panel-content').height(winH - gridHt + 75);
    return winW;
}

function removeHighLowAndSurpriseColoring(ele) {
    if (high || low || high_low_src) {
        ele.removeClass('high').removeClass('low').removeAttr('max').removeAttr('min');
    }
    if (surprise) {
        ele.removeClass('surprise-bin-1').removeClass('surprise-bin-2').removeClass('surprise-bin-3')
            .removeClass('surprise-bin-4').removeClass('surprise-bin-5').removeClass('surprise-bin-6').removeClass('surprise-bin-7')
            .removeClass('surprise-bin-8').removeClass('surprise-bin-9').removeClass('surprise-bin-10')
            .removeAttr('surprise').removeAttr('title');
    }
}

function getChunkingPeriods(){
    periodDimensions = window.MEData.column_dimensions.filter(function(data){
        return data.name == 'periods'
    })[0];

    var actualPeriods = [], futurePeriods = [];

    for(var p=0; p<periodDimensions.values.length; p++){
        var val = periodDimensions.values[p];
        if(val.forecast == false){
            actualPeriods.push(val.period);
        }else if(val.forecast == true){
            futurePeriods.push(val.period);
        }
    }

    actualPlusFuturePeriods["list"] = [actualPeriods, futurePeriods];
    actualPlusFuturePeriods["callsToMake"] = [];
    actualPlusFuturePeriods["setOfPeriods"] = [];

    for(var i=0; i<actualPlusFuturePeriods.list.length; i++){
        var periodList = actualPlusFuturePeriods.list[i];
        var chunks = createChunksFromArray(periodList, 5, 2);
        // getting number of api calls to fire
        var noOfCalls = chunks.length;
        actualPlusFuturePeriods["callsToMake"].push(noOfCalls);
        actualPlusFuturePeriods["setOfPeriods"].push(noOfCalls && chunks[0].length);
    }
}


function getFieldName(valueData) {
    var field = '';
    $.each(colDimension, function(index, value){
        field += valueData[value].toLowerCase();
    });
    return field;
}

function replaceConsensusPlusOperator(cPlusText){
    if(cPlusText.includes('+')){
        return cPlusText.toLowerCase().replace('+','plus');
    }
    return cPlusText.toLowerCase();
}

function saveExtraPanelSetting() {
    // TODO -- move this to angular code
    return new Promise(function(resolve, reject) {
        var panelData = {
            "company": window.company,
            "cut": window.cut == 'SAR'? window.cut : null,
            "source": window.cut == 'SAR'? window.gSource : null,
            "jsonData": {
                "Extras": {},
                "PanelState": {}
            }
        };
        if ($(".leftSider.ant-layout-sider-collapsed").length === 0) {
            panelData.jsonData.PanelState['leftPanel'] = true;
        } else {
            panelData.jsonData.PanelState['leftPanel'] = false;
        }
        if ($(".rightSider.ant-layout-sider-collapsed").length === 0) {
            panelData.jsonData.PanelState['rightPanel'] = true;
        } else {
            panelData.jsonData.PanelState['rightPanel'] = false;
        }
        panelData.jsonData.Extras['expandedColumns'] = expandAcrossTabs;
        if((window.cut === "STD" || window.cut === "NMV") && window.MEData.selectedCurrency && window.MEData.selectedCurrency != "Base"){
            panelData.jsonData.Extras['currency'] = window.MEData.selectedCurrency;
        }
        var ObjW = new WebServiceCall();
        var csrftoken = getCookie('csrftoken');
        window.MEData.panel_state = panelData.jsonData.PanelState;
        window.MEData.extras.expandedColumns = expandAcrossTabs;
        var storePanelSettings = ObjW.storePanelSettings(JSON.stringify(panelData), csrftoken);
        storePanelSettings.then(function(res){
            resolve();
        })
    })
}

function clearInspectorDictionary() {
    selectedLineStdAndCompDict = {};
}

function clickToAddEvent(context){
    if(context){
        var elems = context.find('[onclick][clickBinding!="true"]');
    } else
        var elems = $('[onclick][clickBinding!="true"]');
    for (var index = 0; index < elems.length; index++) {
        var element = elems[index];
        var tmpFunc = new Function($(element).attr('onclick'));
        $(element).attr('onclick',null)
        element.addEventListener('click',tmpFunc);
        $(element).attr('clickBinding', 'true')
    }
}

function convertDateToString(dateToFormat, format) {
    var date = new Date(dateToFormat);
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear().toString();
    switch(format){
        case "yyyymmdd":
            return `${year}${month}${day}`;
        default:
            return `${day}${month}${year}`;
    }
}


$.fn.hasVerticalScrollBar = function () {
    if (this[0].clientHeight < this[0].scrollHeight) {
      return true
    } else {
      return false
    }
  };

function Unblock(blk) {
    const showHideLoader = new CustomEvent('ShowHideLoader', { detail: { showLoader: blk} })
    window.dispatchEvent(showHideLoader);

    // if (blk) {
    //     $('body').block();
    // } else {
    //     $('body').unblock();
    // }
}

function convertDateToString(dateToFormat, format) {
    var date = new Date(dateToFormat);
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear().toString();
    switch (format) {
        case "yyyymmdd":
            return `${year}${month}${day}`;
        default:
            return `${day}${month}${year}`;
    }
}

// debounce function to prevent multiple calls 
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
// usage example --> $scope.searchLineKey = debounce(function(params) { --- }, 250);

debouncedBlock = function(flag){
    Unblock(flag)
}

function getYear(string){
    return string.toUpperCase().split('-')[1].replace(window.fiscalEnd.toUpperCase(),'').substr(0,4);
}


